export const translations = {
  uz: {
    // Navigation
    navFeatures: 'Imkoniyatlar',
    navSolutions: 'Yechimlar',
    navPricing: 'Tariflar',
    navAIAnalytics: 'AI',
    navContact: 'Bog\'lanish',
    
    // Header buttons
    btnLogin: 'Kirish',
    btnStartFreeTrial: 'Bepul sinovdan o\'tish',
    
    // Hero section
    heroTitle: 'AI asosidagi yaxlit biznes boshqaruv platformasi',
    heroSubtitle: 'Sotuv, ombor, xodimlar, moliya va tahlilni bitta tizimda boshqaring. Biznesingizni avtomatlashtiring va samaradorligini oshiring.',
    heroDemoBadge: 'Bepul demo',
    demoDays: '14',
    demoFree: 'kunlik bepul',
    demoDescription: 'Oldindan to\'lov talab qilinmaydi. Barcha funksiyalarni to\'liq sinab ko\'ring.',
    btnRequestDemo: 'Bepul sinovdan o\'tish',
    btnViewFeatures: 'Batafsil ma\'lumot',
    
    // Trust Stats
    statRealTime: 'Vaqtinchalik tahlil',
    statAIPowered: 'AI tahlili',
    statMultiBranch: 'Ko\'p filialli boshqaruv',
    statOfflineSync: 'Internet bilan va internetsiz ishlash',
    
    // Core Features
    sectionCoreFeatures: 'Asosiy funksiyalar',
    featureSales: 'Sotuv va buyurtmalarni avtomatlashtirish',
    featureWarehouse: 'Ombor va inventar boshqaruvi',
    featureStaff: 'Xodimlar KPI va maosh hisobi',
    featureAIForecast: 'AI prognozi va tahlili',
    featureCRM: 'Mijozlar bazasi va segmentatsiya',
    featureReports: 'Hisobotlar va boshqaruv paneli',
    
    // AI Power
    aiTitle: 'Kuchli AI tahlili bilan jihozlangan',
    aiSubtitle: 'AI texnologiyalari yordamida biznesingiz uchun aniq prognozlar va tavsiyalar oling. Qarorlarni ma\'lumotlar asosida qabul qiling.',
    aiSalesPredictions: 'Sotuv prognozlari',
    aiStockOptimization: 'Ombor optimallashtirish',
    aiStaffScoring: 'Xodimlar ish samaradorligini baholash',
    aiSmartReminders: 'Aqlli eslatmalar',
    aiSalesPredictionsDesc: 'O‘tgan savdo va mavsumiyat bo‘yicha talabni bashorat qiladi, rejalashtirishni aniqroq qiladi.',
    aiStockOptimizationDesc: 'Qoldiq va aylanmani tahlil qilib, ortiqcha yoki tanqislik xavfini oldini oladi.',
    aiStaffScoringDesc: 'Sotuv va operatsion KPI bo‘yicha xodimlar samaradorligini shaffof baholash.',
    aiSmartRemindersDesc: 'To‘lov, qoldiq va muddatlar bo‘yicha muhim voqealar uchun o‘z vaqtida eslatmalar.',
    statRealTimeDesc: 'Savdo va ombor ko‘rsatkichlari tez yangilanadi, holatni bir zumda ko‘rasiz.',
    statAIPoweredDesc: 'Ma’lumotlardan avtomatik tahlil va yo‘naltiruvchi tavsiyalar.',
    statMultiBranchDesc: 'Barcha filiallar va kassalar bitta boshqaruv oynasida.',
    statOfflineSyncDesc: 'Internet uzilganda ham kassa ishlaydi, keyin xavfsiz sinxronlanadi.',
    coreFeaturesSubtitle: 'Savdo, ombor, xodimlar va hisobotlar — bitta platformada, bir-biri bilan bog‘liq.',
    featureSalesDesc: 'Buyurtma va to‘lovlarni avtomatlashtirib, kundalik xatolarni kamaytiring.',
    featureWarehouseDesc: 'Qoldiq, partiya va harakatlar — shaffof inventar nazorati.',
    featureStaffDesc: 'KPI, smenalar va hisob-kitoblar — tartibli jamoa boshqaruvi.',
    featureAIForecastDesc: 'Trend va talab bo‘yicha yordamchi tahlil va bashoratlar.',
    featureCRMDesc: 'Mijoz segmentlari va aloqa tarixini markazlashtiring.',
    featureReportsDesc: 'Filial va davr bo‘yicha tayyor hisobotlar va grafiklar.',
    businessTypesSubtitle: 'Biznes hajmiga mos tarifni tanlang — barcha rejalar asosiy modullarni qamrab oladi.',
    tariffCardDescription: 'Tanlangan rejada asosiy modullar, yangilanishlar va qo‘llab-quvvatlash mavjud.',
    teamMemberDesc1: 'Strategiya va hamkorlik: platforma yo‘l xaritasi va mijoz muvaffaqiyati.',
    teamMemberDesc2: 'Texnologiya arxitekturasi va xavfsizlik — barqaror va masshtablanuvchi tizim.',
    teamMemberDesc3: 'Loyiha va yetkazib berish jarayonlari — aniq muddat va sifat.',
    teamMemberDesc4: 'Mijozlar muvaffaqiyati va trening — tez qabul qilish, kam qo‘llanma.',
    teamMemberDesc5: 'O‘sish va brend — bozorda aniq pozitsiya va kommunikatsiya.',
    teamMemberDesc6: 'Moliya nazorati va shaffoflik — byudjet va hisobotlar tartibi.',
    testimonial_1_text: 'Kassa va ombor bir joyda bo‘lgani uchun filiallar kesimida chalkashlik deyarli yo‘qoldi.',
    testimonial_1_name: 'Sardor Karimov',
    testimonial_1_role: 'Direktor, chakana tarmog‘i',
    testimonial_1_initials: 'SK',
    testimonial_2_text: 'Nasiya va qaytarishlar endi jadvalda aniq ko‘rinadi, kundalik nazorat osonlashdi.',
    testimonial_2_name: 'Madina Yusupova',
    testimonial_2_role: 'Moliya menejeri',
    testimonial_2_initials: 'MY',
    testimonial_3_text: 'Ombor qoldiqlari real vaqtga yaqin yangilanadi, sekin aylanayotgan tovarni tez ko‘ramiz.',
    testimonial_3_name: 'Jahongir Toshmatov',
    testimonial_3_role: 'Ombor boshlig‘i',
    testimonial_3_initials: 'JT',
    testimonial_4_text: 'Hisobotlar tayyor shablonda — rahbariyat uchun har hafta saralangan ko‘rsatkichlar.',
    testimonial_4_name: 'Nilufar Rahimova',
    testimonial_4_role: 'Operatsion menejer',
    testimonial_4_initials: 'NR',
    testimonial_5_text: 'Bir nechta do‘konni bitta paneldan boshqarish vaqt tejalishini sezilarli kamaytirdi.',
    testimonial_5_name: 'Bobur Ergashev',
    testimonial_5_role: 'Tarmoq egasi',
    testimonial_5_initials: 'BE',
    testimonial_6_text: 'Qo‘llab-quvvatlash javoblari tez keladi, joriy qilish jarayoni sokin o‘tdi.',
    testimonial_6_name: 'Shirin Azimova',
    testimonial_6_role: 'IT va jarayonlar',
    testimonial_6_initials: 'SA',
    
    // Business Types
    sectionBusinessTypes: 'Har qanday o\'lchamdagi biznes uchun',
    businessSmall: 'Kichik biznes',
    businessMedium: 'O\'rta biznes',
    biz_retail: 'Savdo',
    biz_food: 'Oziq-ovqat',
    biz_logistics: 'Logistika',
    biz_services: 'Xizmatlar',
    biz_manufacturing: 'Sanoat',
    biz_construction: 'Qurilish',
    region_toshkent: 'Toshkent',
    region_samarqand: 'Samarqand',
    region_fargona: "Farg'ona",
    region_andijon: 'Andijon',
    region_namangan: 'Namangan',
    region_buxoro: 'Buxoro',
    region_qashqadaryo: 'Qashqadaryo',
    region_surxondaryo: 'Surxondaryo',
    region_navoiy: 'Navoiy',
    region_jizzax: 'Jizzax',
    region_sirdaryo: 'Sirdaryo',
    region_qoraqalpoq: "Qoraqalpog'iston",
    region_toshkent_shahri: "Toshkent shahri",
    region_toshkent_viloyati: "Toshkent viloyati",
    region_xorazm: "Xorazm",
    region_qoraqalpokiston: "Qoraqalpog'iston",
    businessEnterprise: 'Yirik korporatsiyalar',
    badgeMostPopular: 'Eng ko\'p sotilgan',
    btnGetStarted: 'Boshlash',
    benefitUpTo10Users: '10 tagacha foydalanuvchi',
    benefitBasicCRM: 'Asosiy CRM va inventar hisobi',
    benefitEssentialReports: 'Asosiy hisobotlar',
    benefitEmailSupport: 'Elektron pochta orqali qo\'llab-quvvatlash',
    benefitAILocation: 'AI lokatsiya',
    benefitOnlineSalesExtra: 'Online sotuvga alohida to\'lov',
    benefitUpTo50Users: '50 tagacha foydalanuvchi',
    benefitFullCRM: 'To\'liq CRM va ERP funksiyalari',
    benefitAdvancedAnalytics: 'Kengaytirilgan tahlil',
    benefitPrioritySupport: 'Ustuvor qo\'llab-quvvatlash',
    benefitUnlimitedUsers: 'Cheksiz foydalanuvchilar',
    benefitCustomIntegrations: 'Maxsus integratsiyalar',
    benefitAISuite: 'AI tahlil to\'plami',
    benefitDedicatedManager: 'Shaxsiy menejer',
    benefitAILocation: 'AI lokatsiya',
    benefitOnlineSalesFree: 'Online sotuv bepul',
    benefit24x7Support: '24/7 yordam',
    benefitMonthlyDiscount: 'Oylik to\'lovga 20% chegirma',
    benefitOneBranch: '1 ta filial',
    benefitOneCashier: '1 ta kassir',
    benefitProducts1000: '1000 tagacha mahsulot',
    benefitRetailClients1000: '1000 tagacha chakana mijoz',
    benefitBranches3: '3 tagacha filial',
    benefitCashiers10: '10 tagacha kassir',
    benefitUnlimitedProducts: 'Cheksiz mahsulot',
    benefitRetailClients5000: '5000 tagacha chakana mijoz',
    benefitAIAdvisor: 'AI yordamchi',
    benefitMarketingOnlinePaidAddon: 'Marketing + onlayn savdo (tarifdan tashqari to‘lov)',
    benefitBranches5: '5 tagacha filial',
    benefitCashiers20: '20 tagacha kassir',
    benefitRetailClients20000: '20000 tagacha chakana mijoz',
    benefitMarketingTools: 'Marketing asboblari',
    benefitOnlineOrdersFree: 'Onlayn buyurtmalar (tarifda)',
    benefitUnlimitedBranches: 'Cheksiz filial',
    benefitUnlimitedCashiers: 'Cheksiz kassir',
    benefitUnlimitedRetailClients: 'Cheksiz chakana mijoz',
    
    // Pricing
    pricingMonthly: 'Oylik',
    pricingAnnual: 'Yillik',
    pricingDiscount: '20% arzon',
    pricingSave: 'Tejaldingiz',
    pricingCurrency: 'UZS',
    pricingPerMonth: 'oyiga',
    pricingPerYear: 'yiliga',
    pricingMonth: 'oy',
    pricingTryFree: 'Sinab ko\'rish',
    pricingAnnualDiscountHint: '10–25% gacha',
    pricingRevealStartCta: '99 000 so‘mdan boshlab ko‘ramizmi?',
    pricingRevealStartClose: 'Start tarifini yashirish',
    
    // Contact
    sectionContact: 'Bog\'lanish',
    contactSubtitle: 'Savollaringiz bormi? Biz bilan bog\'laning va biznesingizni rivojlantirishda yordam oling.',
    contactEmail: 'Elektron pochta',
    contactPhone: 'Telefon',
    contactOffice: 'Ofis',
    contactOfficeAddress: 'Toshkent shahri, Yunusobod tumani, Amir Temur ko\'chasi, 123-uy',
    formName: 'Ism',
    formNamePlaceholder: 'Ismingizni kiriting',
    formEmail: 'Elektron pochta',
    formEmailPlaceholder: 'email@example.com',
    formPhone: 'Telefon',
    formPhonePlaceholder: '+998 90 123 45 67',
    formCompany: 'Kompaniya',
    formCompanyPlaceholder: 'Kompaniya nomi (ixtiyoriy)',
    formBusinessType: 'Biznes turi',
    formBusinessTypePlaceholder: 'Tanlang (ixtiyoriy)',
    formTariff: 'Tarif',
    formTariffPlaceholder: 'Tarifni tanlang (ixtiyoriy)',
    formMessage: 'Xabar',
    formMessagePlaceholder: 'Xabaringizni yozing (ixtiyoriy)...',
    formOptional: 'ixtiyoriy',
    btnSendMessage: 'Xabar yuborish',
    contactSubmitSuccess: 'Xabaringiz qabul qilindi. Tez orada siz bilan bog\'lanamiz.',
    contactSubmitError: 'Xabar yuborilmadi. Keyinroq urinib ko\'ring.',
    contactSending: 'Yuborilmoqda…',

    // CTA
    ctaTitle: 'Biznesingizni bugundan samaraliroq boshqaring',
    ctaSubtitle: 'Minglab kompaniyalar bizning platformamizdan foydalanib, o\'z faoliyatini optimallashtirmoqda. Siz ham bugun qo\'shiling.',
    ctaDemoBadge: 'Bepul demo',
    btnGetStartedFree: 'Bepul boshlash',
    
    // Footer
    footerDescription: 'AI asosidagi yaxlit biznes boshqaruv platformasi. Sotuv, ombor, xodimlar, moliya va tahlilni bitta tizimda boshqaring.',
    footerEmail: 'Email',
    footerPhone: 'Telefon',
    footerAddress: 'Manzil',
    footerAddressValue: 'Toshkent shahri, Yunusobod tumani, Amir Temur ko\'chasi, 123-uy',
    footerFollowUs: 'Bizni kuzatib boring',
    footerProduct: 'Mahsulot',
    footerCompany: 'Kompaniya',
    footerLegal: 'Huquqiy hujjatlar',
    footerPrivacy: 'Maxfiylik siyosati',
    footerTerms: 'Foydalanish shartlari',
    footerRights: 'Barcha huquqlar himoyalangan.',
    
    // Statistics
    statUsers: 'Foydalanuvchilar',
    statOrders: 'Buyurtmalar',
    statBranches: 'Filiallar',
    statSatisfaction: 'Mamnunlik darajasi',
    
    // Testimonials
    sectionTestimonials: 'Mijozlarimiz fikrlari',
    testimonialsSubtitle: 'Bizning platformadan foydalanayotgan kompaniyalar bizning yechimlarimiz haqida nima deyishmoqda.',
    
    // Integrations
    sectionIntegrations: 'Integratsiyalar',
    integrationsSubtitle: 'Sevimli xizmatlaringiz bilan integratsiya qiling va barcha jarayonlarni bitta joyda boshqaring.',
    btnViewAllIntegrations: 'Barcha integratsiyalarni ko\'rish',
    
    // Comparison
    sectionComparison: 'Raqobatchilar bilan taqqoslash',
    comparisonSubtitle: 'Bizning platforma boshqa yechimlar bilan qanday farq qiladi va qanday afzalliklar beradi.',
    comparisonFeature: 'Funksiya',
    comparisonUs: 'Bizning platforma',
    comparisonCompetitor: 'Raqobatchilar',
    compFeature1: 'AI tahlili',
    compFeature2: 'Vaqtinchalik sinxronlash',
    compFeature3: 'Ko\'p filialli boshqaruv',
    compFeature4: 'Internetsiz ishlash rejimi',
    compFeature5: 'CRM moduli',
    compFeature6: 'Avtomatik hisobotlar',
    compFeature7: 'Mobil ilova',
    compFeature8: 'Kundalik qo\'llab-quvvatlash',
    
    // Dashboard
    dashboardTitle: 'Dashboard',
    dashboardRevenue: 'Oylik foyda',
    dashboardOrders: 'Oylik daromad',
    dashboardSalesOverview: 'Sotuvlar ko\'rinishi',
    dashboardNewOrder: 'Yangi buyurtma',
    dashboardPaymentReceived: 'To\'lov qabul qilindi',
    dashboardStockUpdated: 'Ombor yangilandi',
    dashboardMinAgo: 'min oldin',
    
    // Team
    sectionTeam: 'Bizning jamoa',
    teamSubtitle: 'Bizning professional jamoamiz sizning biznesingizni rivojlantirishda yordam beradi.',
    teamPosition1: 'Bosh direktor',
    teamPosition2: 'Texnik direktor',
    teamPosition3: 'Loyiha menejeri',
    teamPosition4: 'Mijozlar bilan ishlash menejeri',
    teamPosition5: 'Marketing menejeri',
    teamPosition6: 'Moliya menejeri',

    // Login modal
    loginModalTitle: 'Kirish',
    loginModalPhoneSubtitle: 'Tizimga kirish uchun telefon raqamingizni kiriting.',
    loginModalPhoneLabel: 'Telefon raqami',
    loginModalPhonePlaceholder: '90 123 45 67',
    loginModalPhoneError: 'To\'liq raqamni kiriting (9 ta raqam).',
    loginModalPhoneNotAllowed: 'Bu raqam tizimda ro\'yxatdan o\'tmagan. Faqat ro\'yxatdagi raqamlar bilan kirish mumkin.',
    loginModalPasswordSubtitle: 'Telefon raqamingiz va parolingiz bilan tizimga kiring.',
    loginModalPasswordLabel: 'Parol',
    loginModalPasswordPlaceholder: 'Parolingizni kiriting',
    loginModalPasswordError: 'Parol kamida 4 ta belgidan iborat bo\'lishi kerak.',
    loginModalPasswordInvalid: 'Noto\'g\'ri parol yoki server javobi. Qayta urinib ko\'ring.',
    loginModalSignIn: 'Kirish',
    loginModalSigningIn: 'Kirilmoqda…',
    loginModalAuth_invalid_credentials: 'Telefon yoki parol noto\'g\'ri, yoki hisobda parol hali o\'rnatilmagan.',
    loginModalAuth_phone_invalid: 'Telefon raqami formati noto\'g\'ri.',
    loginModalAuth_missing_or_invalid_fields: 'Telefon yoki parol to‘liq kiritilmagan.',
    loginModalSendSms: 'SMS yuborish',
    loginModalSending: 'Yuborilmoqda...',
    loginModalChecking: 'Tekshirilmoqda...',
    loginModalSmsTitle: 'SMS tasdiqlash',
    loginModalSmsSubtitle: 'Raqamingizga yuborilgan 4 xonali kodni kiriting.',
    loginModalSmsLabel: 'SMS kodi',
    loginModalSmsPlaceholder: '0000',
    loginModalSmsPlaceholderHint: 'Kodni kiriting',
    loginModalSmsError: '4 xonali kodni kiriting.',
    loginModalBack: 'Orqaga',
    loginModalConfirm: 'Tasdiqlash',
    loginModalSuccessTitle: 'Muvaffaqiyatli kirish',
    loginModalSuccessGuest: 'Siz tizimga kirdingiz.',
    loginModalClose: 'Yopish',
    loginModalForgotPassword: 'Parolni unutdingizmi?',
    loginModal2FATitle: 'SMS tasdiqlash',
    loginModal2FASubtitle: 'Parol to\'g\'ri! Telefoningizga 4 xonali kod yuborildi.',
    loginModalOtpLabel: 'SMS kodi',
    loginModalOtpPlaceholder: '0000',
    loginModalOtpError: '4 xonali kodni kiriting.',
    loginModalOtpInvalid: 'Kod noto\'g\'ri yoki muddati o\'tgan.',
    loginModalResend: 'Qayta yuborish',
    loginModalResendIn: 'Qayta yuborish ({{n}} s)',
    loginModalResetTitle: 'Parol tiklash',
    loginModalResetSubtitle: 'Telefon raqamingizga SMS kod yuboriladi.',
    loginModalResetSendCode: 'Kod yuborish',
    loginModalResetOtpSubtitle: 'Raqamingizga yuborilgan 4 xonali kodni kiriting.',
    loginModalNewPasswordTitle: 'Yangi parol o\'rnating',
    loginModalNewPasswordLabel: 'Yangi parol',
    loginModalNewPasswordPlaceholder: 'Kamida 6 belgi',
    loginModalNewPasswordConfirmLabel: 'Parolni takrorlang',
    loginModalNewPasswordConfirmPlaceholder: 'Parolni takrorlang',
    loginModalSavePassword: 'Parolni saqlash',
    loginModalSaving: 'Saqlanmoqda...',
    loginModalResetSuccess: 'Parol muvaffaqiyatli yangilandi! Endi yangi parol bilan kiring.',
    loginModalPasswordMinError: 'Parol kamida 6 ta belgidan iborat bo\'lishi kerak.',
    loginModalPasswordMismatch: 'Parollar mos emas.',

    // Roles (static) – yangi struktura: Ega, Bosh/Viloyat menejer, Dispecher, Mijoz, Kassir
    roleTitle_platform_owner: 'Ega (Loyiha egasi)',
    roleDesc_platform_owner: 'Tizimning umumiy sozlamalarini boshqarish, tarif paketlarini belgilash va barcha ma\'lumotlarga to\'liq kirish. Statistika va menejerlar qo\'shish. Tizimni rivojlantiruvchilar yoki yuqori darajadagi administratorlar uchun.',
    roleTitle_general_manager: 'Bosh menejer',
    roleDesc_general_manager: 'Barcha viloyatlar bo\'yicha statistika, viloyat menejerlarini boshqarish, filiallar va hisobotlar. Hamma viloyat uchun javobgar.',
    roleTitle_regional_manager: 'Viloyat menejer',
    roleDesc_regional_manager: 'O\'z viloyati: filiallar va omborlar, xodimlar va rollar, mahsulotlar katalogi, savdo va hisobotlar. Kompaniya ichki faoliyatini boshqarish.',
    roleTitle_dispatcher: 'Dispecher',
    roleDesc_dispatcher: 'Kelayotgan sotuvlar va buyurtmalarni boshqarish, yetkazib berish statuslari va bildirishnomalar.',
    roleTitle_warehouse_clerk: 'Omborchi',
    roleDesc_warehouse_clerk: 'Kirim-chiqim operatsiyalari, inventarizatsiya, shtrix-kod orqali mahsulotlar. Qoldiqlar va harakatlarni real vaqt rejimida kuzatish.',
    roleTitle_accountant: 'Buxgalter',
    roleDesc_accountant: 'Soliq tizimlari va 1C bilan integratsiya, to\'lovlar va moliyaviy hujjatlar, hisobotlar va soliq deklaratsiyalari.',
    roleTitle_analyst: 'Analitik',
    roleDesc_analyst: 'Kampaniya va sotuv tahlili, mijoz segmentlari, hisobotlar va tavsiyalar.',
    roleTitle_kuryer: 'Kuryer / Field agent',
    roleDesc_kuryer: 'Offline rejimda ishlash, yetkazib berish statuslarini yangilash, marshrutlarni kuzatish. Mobil qurilmalar orqali real vaqt rejimida.',
    roleTitle_tenant_owner: 'Joy egasi (dastur sotib olgan)',
    roleDesc_tenant_owner: 'O\'z joyining boshqaruvi: kassirlar, filiallar, savdo, nasiya, moliya va hisobotlar. Chakana mijozlar va Telegram orqali xabarlar.',
    roleTitle_cashier: 'Kassir',
    roleDesc_cashier: 'POS va buyurtmalar, to\'lovlarni qabul qilish. Joy egasi tomonidan boshqariladi.',

    // Admin panel
    adminTitle: 'Boshqaruv paneli',
    adminWelcome: 'Quyidagi bo\'limlar sizning rolingiz uchun ochiq.',
    adminLogout: 'Chiqish',
    adminSidebarHeading: 'Menyu',
    adminSidebar_collapse: 'Menyuni toraytirish (faqat ikonkalar)',
    adminSidebar_expand: 'Menyuni kengaytirish',
    adminCurrentRole: 'Joriy rol',
    adminLanguageLabel: 'Tilni tanlash',
    adminMore: 'Boshqa',
    adminActivityLog: 'Faoliyat jurnali',
    adminNotifications: 'Bildirishnomalar',
    adminProfileSettings: 'Profil sozlamalari',
    adminProfile: 'Profil',
    adminSettings_login_password: 'Kirish paroli',
    adminProfile_password_current: 'Joriy parol',
    adminProfile_name_label: 'Ism',
    adminProfile_name_placeholder: 'Ism va familiya',
    adminProfile_name_required: 'Ism kiriting',
    adminProfile_phone_already_exists: 'Bu telefon raqami boshqa foydalanuvchida ro\'yxatdan o\'tgan',
    adminProfile_password_new: 'Yangi parol',
    adminProfile_password_confirm: 'Yangi parolni tasdiqlang',
    adminProfile_password_current_required: 'Joriy parolni kiriting',
    adminProfile_password_min: 'Yangi parol kamida 6 belgi bo\'lishi kerak',
    adminProfile_password_mismatch: 'Yangi parol tasdiqlash bilan mos emas',
    adminProfile_password_invalid: 'Joriy parol noto\'g\'ri',
    adminProfile_password_set_first: 'Kirish parolini o\'rnating',
    save: 'Saqlash',
    saving: 'Saqlanmoqda...',
    saved: 'Saqlandi',
    edit: 'Tahrirlash',
    cancel: 'Bekor qilish',
    roleSwitch_title: 'Ro\'l almashtirish',
    roleSwitch_desc: 'Hozirgi ro\'l',
    roleSwitch_target: 'Yangi ro\'l',
    roleSwitch_current: 'Hozirgi ro\'l',
    roleSwitch_pin_label: 'PIN kiriting',
    roleSwitch_pin_required: 'PIN kiriting',
    roleSwitch_pin_invalid: 'PIN noto\'g\'ri',
    roleSwitch_pin_min: 'PIN kamida 4 belgi',
    roleSwitch_pin_mismatch: 'PIN mos emas',
    roleSwitch_pin_new: 'Yangi PIN',
    roleSwitch_pin_confirm: 'PIN takrorlang',
    roleSwitch_pin_current: 'Joriy PIN',
    roleSwitch_set_pin: 'Saqlash',
    roleSwitch_set_pin_first: 'PIN o\'rnating',
    roleSwitch_enter_pin_tenant_owner: 'Joy egasi ro\'liga o\'tish uchun PIN kiriting',
    roleSwitch_enter_pin_kassir: 'Kassir ro\'liga o\'tish uchun PIN kiriting',
    roleSwitch_choose_kassir: 'Kassir ro\'liga o\'tish (PIN kerak emas)',
    roleSwitch_choose_cashier: 'Kassir ro\'liga o\'tish (kassirning PIN\'i kerak)',
    roleSwitch_choose_target: 'Qaysi ro\'lga o\'tmoqchisiz?',
    roleSwitch_no_cashiers: 'Kassirlar topilmadi',
    roleSwitch_no_pin: 'PIN o\'rnatilmagan',
    roleSwitch_enter_tenant_owner_pin: 'Joy egasi PIN\'ini kiriting',
    roleSwitch_enter_kassir_pin: 'Kassirning PIN\'ini kiriting',
    roleSwitch_pin_profile_label: 'Rol almashtirish PIN',
    roleSwitch_pin_change: 'O\'zgartirish',
    roleSwitch_confirm: 'Ro\'lni almashtirish',
    adminImpersonate_title: 'Boshqa akkaunt sifatida kirish',
    adminImpersonate_desc: 'Pastdagi roldagi foydalanuvchini tanlang, keyin o‘z akkaunt parolingizni kiriting.',
    adminImpersonate_search: 'Qidiruv (ism, telefon)',
    adminImpersonate_search_ph: 'Ism yoki telefon...',
    adminImpersonate_empty: 'Foydalanuvchilar topilmadi',
    adminImpersonate_your_password: 'O‘z akkauntingiz paroli (tasdiqlash)',
    adminImpersonate_submit: 'Kirish',
    adminImpersonate_failed: 'Amal bajarilmadi',
    adminImpersonate_select_user: 'Foydalanuvchini tanlang',
    adminImpersonate_password_required: 'Parolni kiriting',
    adminImpersonate_banner: 'Siz boshqa foydalanuvchi sifatidasiz. O‘z akkauntingizga qaytishingiz mumkin.',
    adminImpersonate_exit: 'O‘z akkauntimga qaytish',
    adminImpersonate_exit_error: 'Qaytarib bo‘lmadi. Qayta urinib ko‘ring.',
    adminImpersonate_nested_blocked: 'Avval joriy "boshqa akkaunt" seansidan chiqing.',
    sidebar_impersonation_section: 'Rollarga kirish',
    sidebar_impersonation_load_error: 'Ro\'yxat yuklanmadi. Internetni tekshiring.',
    sidebar_impersonation_empty: 'Hozircha pastdagi rollarda tizimga kirgan akkauntlar yo\'q. Menejerlar yoki boshqa foydalanuvchilarni qo\'shganingizdan keyin yangilang.',
    sidebar_impersonation_role_empty: 'Bu rol uchun akkaunt yo\'q',
    sidebar_impersonation_refresh: 'Yangilash',
    role_access_page_subtitle: 'Tanlangan akkaunt sifatida tizimga kirish uchun ro‘yxatdan foydalanuvchini tanlang va o‘z parolingizni tasdiqlang.',
    role_access_accounts_total: 'Jami akkauntlar:',
    role_access_denied: 'Bu sahifani ko‘rish uchun huquqingiz yo‘q.',
    role_access_row_action: 'Kirish',
    role_access_filters_label: 'Filtrlar',
    role_access_search_placeholder: 'Ism yoki raqam bo‘yicha qidirish...',
    role_access_region_filter: 'Viloyat bo‘yicha saralash',
    role_access_region_all: 'Barcha viloyatlar',
    adminSettings: 'Sozlamalar',
    adminNoActivity: 'So\'nggi faoliyat yo\'q',
    adminNoNotifications: 'Bildirishnomalar yo\'q',
    adminTopbar_chat_notifications: 'Chat xabarlari',
    adminTopbar_currency_title: 'Kurs',
    adminTopbar_currency_updated: 'Yangilangan',
    adminTopbar_currency_select: 'Valyutani tanlang',
    notif_chat_from_tenant_owner: 'Joy egasidan yangi xabar',
    notif_chat_from_support: 'Qo‘llab-quvvatlashdan javob',
    support_new_message_title: 'Mijozdan yangi xabar',
    support_new_message_body: 'Chatda yangi xabar bor — ochib javob bering.',
    support_reply_title: 'Menejerdan javob',
    support_reply_body: 'Qo‘llab-quvvatlash chatida yangi javob.',
    notif_chat_meta_tenant: 'Mijoz',
    adminTheme: 'Tema',
    adminThemeLight: 'Yorug\' rejim',
    adminThemeDark: 'Qorong\'u rejim',
    adminMenuOpen: 'Menyuni ochish',
    adminMenuClose: 'Menyuni yopish',
    adminGoToPanel: 'Panelga o\'tish',
    adminComingSoon: 'Tez kunda',
    adminPlaceholderFeature1: 'To\'liq boshqaruv paneli va hisobotlar',
    adminPlaceholderFeature2: 'Sozlamalar va integratsiyalar',
    adminPlaceholderFeature3: 'Eksport va batafsil tahlil',
    adminStat_period: 'Joriy oy (statik ma\'lumot)',
    adminStat_tenants: 'Mijozlar',
    adminStat_tenants_active_short: 'faol',
    adminStat_tenants_suspended_short: 'to‘xtatilgan',
    adminStat_tenants_trial_short: 'sinov',
    adminStat_tariffCustomers: 'Tarif bo‘yicha mijozlar',
    adminStat_tariffDistribution: 'Tariflar taqsimoti',
    adminStat_tariff_other: 'Boshqa tariflar',
    adminStat_activeUsers: 'Faol foydalanuvchilar',
    adminStat_ordersMonth: 'Buyurtmalar (oylik)',
    adminStat_dispatcherOrdersCard: 'Dispecherga tushgan buyurtmalar',
    adminStat_dispatcherOrdersConvertedShort: 'mijozga aylangan',
    adminStat_dispatcherOrdersRejectedShort: 'rad etilgan',
    adminStat_revenueMonth: 'Daromad (oylik, UZS)',
    adminStat_growth: 'O\'sish (o\'tgan oyga nisbatan)',
    adminStat_summaryTitle: 'Qisqacha',
    adminStat_topRegion: 'Eng faol viloyat',
    adminStat_fastestGrowingRegion: 'Eng tez o\'sayotgan viloyat',
    adminStat_newTenantsWeek: 'Yangi mijozlar (haftalik)',
    adminStat_empty: 'Ma\'lumot yo\'q',
    adminStat_note: 'Eslatma',
    adminStat_noteText: 'Ma\'lumotlar namuna ko\'rsatkichlar. To\'liq hisobotlar keyingi yangilanishlarda qo\'shiladi.',
    adminStat_bm_overview: 'Boshqaruv paneli',
    adminStat_bm_page_sub: 'Barcha viloyatlar, menejerlar va mijozlar bo\'yicha yig\'ma ko\'rsatkichlar.',
    adminStat_bm_hero_eyebrow: 'Bosh menejer',
    adminStat_bm_hero_title: 'Operatsion ko\'rsatkichlar',
    adminStat_bm_regions_short: 'viloyat',
    adminStat_chartTitle_bm: 'Buyurtmalar — barcha viloyatlar (8 hafta)',
    adminStat_bm_managers: 'Menejerlar',
    adminStat_bm_dispatchers: 'Dispecherlar',
    adminStat_bm_regions: 'Viloyatlar',
    adminStat_bm_totalBranches: 'Filiallar (jami)',
    adminStat_bm_topManager: 'Yetakchi menejer',
    adminStat_bm_topDispatcher: 'Yetakchi dispecher',
    adminStat_bm_bestRatingRegion: 'Eng yaxshi reyting (viloyat)',
    adminStat_bm_newLeadsMonth: 'Yangi leadlar (oy)',
    adminStat_vm_overview: 'Viloyat bo\'yicha ko\'rsatkichlar',
    adminStat_vm_region: 'Viloyat',
    adminStat_vm_topBranch: 'Yetakchi filial',
    adminStat_vm_topClientCategory: 'Eng ko\'p buyurtma bergan kategoriya',
    adminStat_vm_tenants: 'Mijozlar',
    adminStat_vm_operational_title: 'Viloyat operatsion ko\'rsatkichlari',
    adminStat_vm_monthlyRevenue: 'Viloyat bo\'yicha 6 oylik tushum',
    adminStat_chartTitle_vm: 'Buyurtmalar — oxirgi 8 hafta (viloyat)',
    adminStat_chart_axis_week: 'Hafta',
    adminStat_disp_overview: 'Shaxsiy ko\'rsatkichlar (sotuvlar va buyurtmalar)',
    adminStat_disp_leadsToday: 'Bugungi yangi sotuvlar',
    adminStat_disp_leadsWeek: 'Haftalik tayinlangan sotuvlar',
    adminStat_disp_ordersInProgress: 'Jarayondagi buyurtmalar',
    adminStat_disp_ordersCompletedToday: 'Bugun topshirilgan',
    adminStat_disp_ordersCompletedWeek: 'Haftada topshirilgan',
    adminStat_disp_leadsMonth: 'Oylik sotuvlar',
    adminStat_disp_topManager: 'Hamkor menejer',
    adminStat_disp_topLeadSource: 'Eng ko\'p sotuv manbai',
    adminStat_hours_short: 'soat',
    adminStat_analitik_overview: 'Tahlil ko\'rsatkichlari (tashriflar, konversiya, daromad)',
    adminStat_analitik_visitors: 'Unikal tashriflar (30 kun)',
    adminStat_analitik_sessions: 'Sessiyalar',
    adminStat_analitik_top_channel: 'Eng samarali kanal',
    adminStat_analitik_new_customers: 'Yangi mijozlar (oy)',
    adminStat_analitik_avg_session: 'O\'rtacha sessiya (min)',
    adminStat_analitik_bounce: 'Bounce rate (%)',
    adminStat_chartTitle_analitik: 'Haftalik tashriflar',
    adminStat_overview: 'Asosiy ko\'rsatkichlar',
    adminStat_tenant_owner_overview: 'Kompaniya bo\'yicha ko\'rsatkichlar',
    adminStat_selected_period_prefix: 'Tanlangan davr',
    adminStat_davr_today: 'Bugun',
    adminStat_davr_week: 'Hafta',
    adminStat_davr_month: 'Oy',
    adminStat_davr_year: 'Yil',
    adminStat_davr_custom: 'Maxsus davr',
    adminStat_custom_from: 'Dan',
    adminStat_custom_to: 'Gacha',
    adminStat_tenant_owner_section_kpi: 'Savdo va rentabellik',
    adminStat_tenant_owner_scope_period: 'Davr',
    adminStat_tenant_owner_revenue_today: 'Bugungi savdo (kirim)',
    adminStat_tenant_owner_revenue_week: 'Haftalik savdo (kirim)',
    adminStat_tenant_owner_revenue_month: 'Oylik savdo (kirim)',
    adminStat_tenant_owner_revenue_year: 'Yillik savdo (kirim)',
    adminStat_tenant_owner_net_today: 'Bugungi sof foyda',
    adminStat_tenant_owner_net_week: 'Haftalik sof foyda',
    adminStat_tenant_owner_net_month: 'Oylik sof foyda',
    adminStat_tenant_owner_net_year: 'Yillik sof foyda',
    adminStat_tenant_owner_orders_today: 'Bugungi operatsiyalar',
    adminStat_tenant_owner_orders_week: 'Haftalik operatsiyalar',
    adminStat_tenant_owner_orders_month: 'Oylik operatsiyalar',
    adminStat_tenant_owner_orders_year: 'Yillik operatsiyalar',
    adminStat_tenant_owner_orders_period: 'Operatsiyalar (tanlangan davr)',
    adminStat_tenant_owner_revenue_period: 'Savdo / kirim (tanlangan davr)',
    adminStat_tenant_owner_net_period: 'Sof foyda (tanlangan davr)',
    adminStat_tenant_owner_chart_custom_daily: 'Tanlangan davr — kunlik savdo',
    adminStat_tenant_owner_trend_custom: 'o\'sish (hisobot bo\'yicha)',
    adminStat_tenant_owner_trend_mom: 'o\'tgan oyga nisbatan (oylik dinamika)',
    adminStat_tenant_owner_trend_recent: 'oxirgi oylar dinamikasi',
    adminStat_tenant_owner_trend_yoy: 'o\'tgan yilga nisbatan (yillik dinamika)',
    adminStat_tenant_owner_last7_title: 'Oxirgi 7 kun — kunlik savdo',
    adminStat_tenant_owner_weekday_title: 'Hafta kunlari bo\'yicha taqsimot',
    adminStat_tenant_owner_payments_hint: 'Tanlangan davr va filial filtriga mos kelgan kirimlar bo\'yicha.',
    adminStat_expense_paid_title: 'Xarajatlar (qoplangan)',
    adminStat_expense_paid_badge: 'xarajat',
    adminStat_expense_paid_split: 'Xarajat to‘lovi turlari',
    adminStat_expense_paid_cash: 'Naqd (kassadan)',
    adminStat_expense_paid_product: 'Tovar bilan',
    adminStat_expense_paid_other: 'Boshqa',
    adminStat_expenses_title: 'Xarajatlar tafsiloti',
    expenseMeta_productId: 'Mahsulot ID',
    expenseMeta_qty: 'Miqdor',
    expenseMeta_supplier: "Ta'minotchi",
    expenseMeta_supplierId: "Ta'minotchi ID",
    expenseMeta_purchasePrice: 'Sotib olish narxi',
    adminStat_expenses_all: 'Barchasi',
    adminStat_expenses_active: 'Faol',
    adminStat_expenses_archived: "To'liq qoplangan",
    adminStat_expenses_total: 'Jami xarajat',
    adminStat_expenses_paid: "To'langan",
    adminStat_expenses_remaining: 'Qolgan',
    adminStat_expenses_count: 'Soni',
    adminStat_expenses_product: 'Tovar',
    adminStat_expenses_active_badge: 'Faol',
    adminStat_expenses_archived_badge: "To'liq qoplangan",
    adminStat_mijoz_branch_leaders: 'Filiallar bo‘yicha savdo yetakchilari',
    adminStat_nasiya_portfolio: 'Nasiya holati',
    adminStat_nasiya_repaid_label: 'Qoplangan',
    adminStat_nasiya_remaining_label: 'Qolgan',
    adminStat_tenant_owner_monthly_revenue: 'Oxirgi 6 oy — filial kesimida savdo',
    adminStat_top_products: 'Mahsulotlar — sotuv reytingi',
    adminStat_top_products_unit: 'birlik',
    adminStat_top_sellers: 'Sotuvchilar — savdo reytingi',
    adminStat_chartTitle: 'Haftalik buyurtmalar',
    adminStat_insights: 'Qisqacha tahlil',
    adminStat_unifiedRatingTitle: 'Umumiy reyting statistikasi',
    adminStat_regionRatingTitle: 'Viloyatlar reytingi',
    adminStat_dispatcherRatingTitle: 'Dispecherlar reytingi',
    adminStat_managerRatingTitle: 'Menejerlar reytingi',
    adminStat_byRegion_title: 'Statistika viloyatlar bo\'yicha',
    adminStat_byRegion_region: 'Viloyat',
    adminStat_byRegion_tenants: 'Mijozlar',
    adminStat_byRegion_orders: 'Buyurtmalar (oy)',
    adminStat_byRegion_revenue: 'Daromad (oy)',
    adminStat_byRegion_growth: 'O\'sish %',
    adminStat_byRegion_branches: 'Filiallar',
    adminStat_byRegion_users: 'Faol foydalanuvchilar',
    adminStat_byRegion_avgCheck: 'O\'rtacha check',
    adminStat_byManager_title: 'Statistika menejerlar bo\'yicha',
    adminStat_byManager_name: 'Menejer',
    adminStat_byManager_region: 'Viloyat',
    adminStat_byManager_role: 'Rol',
    adminStat_byManager_orders: 'Buyurtmalar (oy)',
    adminStat_byManager_revenue: 'Daromad (oy)',
    adminStat_byManager_rating: 'Reyting',
    adminStat_byManager_satisfaction: 'Qoniqish %',
    adminStat_byManager_trend: 'Trend',
    adminStat_byManager_branches: 'Filiallar',
    adminStat_byManager_dispatchers: 'Dispecherlar',
    adminStat_prevMonth: 'o\'tgan oyga nisbatan',
    adminStat_avgOrderValue: 'O\'rtacha check (UZS)',
    adminStat_conversionPercent: 'Konversiya (lead → buyurtma)',
    adminStat_ordersToday: 'Bugungi buyurtmalar',
    adminStat_cancelledMonth: 'Bekor qilingan (oylik)',
    adminStat_supportTicketsOpen: 'Ochiq support tiketlari',
    adminStat_newRegistrationsMonth: 'Yangi ro\'yxatdan o\'tgan (oylik)',
    adminStat_monthlyRevenue: 'Oylik savdo hajmi (6 oy)',
    adminStat_weeklySalesByDay: 'Haftalik savdo hajmi',
    adminStat_weeklysalesbyday: 'Haftalik savdo hajmi',
    adminStat_topProductCategory: 'Eng sotiladigan kategoriya',
    adminStat_avgResponseHours: 'O\'rtacha javob vaqti (soat)',
    adminStat_repeatOrdersPercent: 'Takroriy buyurtmalar (%)',
    adminStat_branch_rating: 'Filiallar bo\'yicha reyting',
    adminStat_branch_rank_label: 'Reyting',
    month_jan: 'Yanvar',
    month_feb: 'Fevral',
    month_mar: 'Mart',
    month_apr: 'Aprel',
    month_may: 'May',
    month_jun: 'Iyun',
    month_jul: 'Iyul',
    month_aug: 'Avgust',
    month_sep: 'Sentabr',
    month_oct: 'Oktabr',
    month_nov: 'Noyabr',
    month_dec: 'Dekabr',
    adminAdvice_subtitle: 'Biznes boshqaruvi, CRM va ERP bo\'yicha qisqacha qo\'llanma va tavsiyalar. Quyida asosiy sohalar bo\'yicha amaliy maslahatlar.',
    adminAdvice_subtitle_mijoz: 'Mijoz roli uchun amaliy tavsiyalar: savdo, foyda, qoldiq va nasiya nazoratini yaxshilashga yo\'naltirilgan.',
    adminAdvice_subtitle_kassir: 'Kassir roli uchun tezkor amaliy tavsiyalar: chek, to\'lov, printer va smena intizomi.',
    adminAdvice_subtitle_cashier: 'Kassir roli uchun tezkor amaliy tavsiyalar: chek, to\'lov, printer va smena intizomi.',
    adminAdvice_subtitle_viloyat: 'Viloyat bo\'yicha operativ boshqaruv: buyurtmalar, dispecherlar, mijozlar, hisobotlar va jamoaviy samaradorlik.',
    maslahat_viloyat_title: 'Viloyat menejeri uchun amaliy maslahatlar',
    maslahat_viloyat_1: 'Lead va buyurtmalarni har kuni tekshiring: yangi, jarayondagi va kechikkanlar — statuslarni o‘z vaqtida yangilang.',
    maslahat_viloyat_2: 'Dispecherlar bilan qisqa kunlik reja: ochiq leadlar, kechikkan javoblar va ustuvor buyurtmalar ro‘yxati.',
    maslahat_viloyat_3: 'Mijozlar (tenant) bo‘yicha oylik ko‘rinish: yangi ulanishlar, faollik va zarurat bo‘yicha qo‘llab-quvvatlash.',
    maslahat_viloyat_4: 'Ichki chatdan operativ masalalar uchun foydalaning — qaror va mas‘ullik bitta kanalda aniq bo‘lsin.',
    maslahat_viloyat_5: 'Hisobotlar bo‘limidan Excel eksport — fayllarni sana va viloyat nomi bilan tartibli arxivlang.',
    maslahat_viloyat_6: 'Hududiy KPI: buyurtma qabul vaqti, dispecher reytingi, mijoz murojaatlari — haftalik taqqoslash.',
    maslahat_viloyat_7: 'Yirik summa yoki maxsus shartnomalarni ikki bosqichda tasdiqlash xavfni kamaytiradi.',
    maslahat_viloyat_8: 'Rollar va kirish huquqlari: yangi xodim yoki filial uchun faqat kerakli bo‘limlar ochiq bo‘lsin.',
    adminAdvice_sales_title: 'Sotuv va buyurtmalar',
    adminAdvice_sales_1: 'Lead va buyurtmalarni status bo\'yicha tez-tez tekshiring: yangi, qayta aloqa, shartnoma tayyor, yopilgan. Status o\'zgarishini kuniga kamida bir marta yangilang.',
    adminAdvice_sales_2: 'Buyurtma qabul qilish vaqtini qisqartiring: dispecher leadni menejerga 15 daqiqa ichida yo\'naltiring, menejer mijoz bilan 24 soat ichida bog\'lansin.',
    adminAdvice_sales_3: 'Har bir buyurtma uchun mas\'ul shaxs va muddat belgilang. Muddati o\'tayotgan buyurtmalar bo\'yicha kunlik hisobot oling.',
    adminAdvice_sales_4: 'Takroriy buyurtmalarni ajratib ko\'ring — eng sodiq mijozlar uchun maxsus shartlar yoki chegirmalar rejalashtiring.',
    adminAdvice_sales_5: 'Sotuv funnelini tahlil qiling: qaysi bosqichda ko\'p mijozlar qolayapti, shu joyda savdo jarayonini yaxshilang.',
    adminAdvice_warehouse_title: 'Ombor va inventar',
    adminAdvice_warehouse_1: 'Har bir mahsulot uchun minimal (safety stock) va maksimal qoldiq normasi belgilang. Tizim orqali avtomatik ogohlantirishlarni yoqing.',
    adminAdvice_warehouse_2: 'Inventarizatsiyani rejalashtiring: kam harakatlanadigan pozitsiyalar uchun oylik, tez aylanadiganlar uchun haftalik yoki kunlik tekshiruv.',
    adminAdvice_warehouse_3: 'Shtrix-kod va SKU standartlashtiring — kirim-chiqim va qidiruvni tezlashtiradi, xatolarni kamaytiradi.',
    adminAdvice_warehouse_4: 'Muddati tugaydigan mahsulotlarni alohida kuzating: FEFO (avval tugash muddati bo\'lgani chiqadi) tamoyiliga amal qiling.',
    adminAdvice_warehouse_5: 'O\'tkazmalar va chiqimlarni hujjat raqami va sana bilan ro\'yxatga oling — audit va hisobotlar uchun zarur.',
    adminAdvice_finance_title: 'Moliya va hisobotlar',
    adminAdvice_finance_1: 'Tranzaksiyalarni to\'lov turi va kontragent bo\'yicha guruhlang. Har hafta kassa va bank balansini hisobot bilan solishtiring.',
    adminAdvice_finance_2: 'Hisob-faktura va to\'lovlarni juftlashtiring: har bir to\'lov aniq hujjatga bog\'langan bo\'lsin, ochiq qarzlar ro\'yxatini kuzating.',
    adminAdvice_finance_3: 'Soliq va 1C integratsiyasini sozlang — hisobotlarni avtomatik yuklash va xatolarni kamaytiradi.',
    adminAdvice_finance_4: 'Foyda va zarar, balans hisobotlarini oylik tahlil qiling. Anomaliyalar (keskin o\'sish yoki tushish) bo\'lsa, sababini aniqlang.',
    adminAdvice_finance_5: 'Eksport va arxivni muntazam saqlang — soliq tekshiruvi va ichki audit uchun barcha hujjatlar tayyor bo\'lsin.',
    adminAdvice_staff_title: 'Xodimlar va samaradorlik',
    adminAdvice_staff_1: 'Har bir rol uchun aniq KPI belgilang: sotuv menejeri — savdo hajmi va yangi mijozlar, dispecher — buyurtma vaqtlari va shikoyatlar soni.',
    adminAdvice_staff_2: 'Reytinglarni ochiq va adolatli qiling: haftalik yoki oylik natijalar bo\'yicha jamoani rag\'batlantiring.',
    adminAdvice_staff_3: 'O\'qitish va instruktajlarni rejalashtiring — yangi xodimlar tezroq mustaqil ishlashi uchun standart proseduralar tuzing.',
    adminAdvice_staff_4: 'Vazifalarni ro\'l bo\'yicha taqsimlang: bitta shaxsga juda ko\'p javobgarlik yuklamang, "bottleneck" lar paydo bo\'lmasin.',
    adminAdvice_staff_5: 'Feedback va shikoyatlarni yozma qabul qiling va tez javob bering — jamoa ishonchi va samaradorlik oshadi.',
    adminAdvice_crm_title: 'Mijozlar (CRM) va marketing',
    adminAdvice_crm_1: 'Mijozlarni segmentlashtiring: VIP, muntazam, yangi, "uyqudagi". Har bir segment uchun alohida kommunikatsiya va takliflar.',
    adminAdvice_crm_2: 'Kampaniyalar (SMS, push, email) natijalarini o\'lchang: ochilish, bosish, konversiya. Samarasiz kanallarni optimallashtiring.',
    adminAdvice_crm_3: 'Saqlash (retention) va chiqish (churn) tahlilini oylik qiling — nima uchun mijozlar ketayapti va qanday qaytarish mumkin.',
    adminAdvice_crm_4: 'AI tavsiyalaridan foydalaning: tizim taklif qiladigan segmentlar va aksiyalarni sinab ko\'ring.',
    adminAdvice_crm_5: 'Mijoz shikoyatlarini bitta kanalda (masalan, support) to\'plash va 24 soat ichida javob berish standartini belgilang.',
    adminAdvice_general_title: 'Umumiy tavsiyalar',
    adminAdvice_general_1: 'Ma\'lumotlarni muntazam yedeklang va tizim yangilanishlarini vaqtida o\'tkazing — xavfsizlik va barqarorlik uchun.',
    adminAdvice_general_2: 'Sozlamalar va integratsiyalarni hujjatlashing: kim qanday API kalit va limitlardan foydalanadi, barchasi aniq bo\'lsin.',
    adminAdvice_general_3: 'Audit va foydalanish hisobotlarini oylik ko\'rib chiqing — noqonuniy yoki noto\'g\'ri foydalanishni vaqtida aniqlang.',
    adminAdvice_general_4: 'Yangi funksiyalarni bosqichma-bosqich joriy qiling: avval kichik guruhda test qiling, keyin barchaga yoqing.',
    adminAdvice_general_5: 'Foydalanuvchilar fikrini so\'rang va yordam bo\'limini rivojlantiring — platformadan to\'liq foydalanish uchun qo\'llanma va qo\'llab-quvvatlash muhim.',
    adminAdvice_footer: 'Yuqoridagi maslahatlar statik qo\'llanma sifatida taqdim etilgan. Har bir biznes uchun sozlamalar va ustuvorliklar farq qilishi mumkin. Keyingi yangilanishlarda AI asosidagi shaxsiy maslahatlar qo\'shiladi.',
    adminAdvice_developing: 'Ishlanmoqda',
    maslahat_top10_title: 'Top 10 maslahat',
    maslahat_mijoz_title: 'Mijoz roli uchun tavsiyalar',
    maslahat_mijoz_1: 'Har kuni sotuv, foyda va nasiya qoldig\'ini bir joyda tekshirib chiqing.',
    maslahat_mijoz_2: 'Muddati 3 kundan kam qolgan tovarlarni birinchi navbatda sotuvga chiqaring.',
    maslahat_mijoz_3: 'Filiallar kesimida qoldiq va sotuvni solishtirib, sekin aylanayotgan tovarni aniqlang.',
    maslahat_mijoz_4: 'Katta chek uchun tezkor chegirma qo\'llashdan oldin marjani tekshiring.',
    maslahat_mijoz_5: 'Kunlik xulosa vaqtida kassa, nasiya va ombor holatini yopib boring.',
    maslahat_kassir_title: 'Kassir roli uchun tavsiyalar',
    maslahat_kassir_1: 'Sotuvdan oldin tovar nomi, narxi va miqdorni savatchada qayta tekshiring.',
    maslahat_kassir_2: 'Chek chiqarishdan avval to\'lov turini aniq tanlang va mijozdan tasdiq oling.',
    maslahat_kassir_3: 'Kun davomida favorit tovarlar bilan tez ishlang, qoldiq tugasa darhol omborga xabar bering.',
    maslahat_kassir_4: 'Printer xato bersa ulash bo\'limidan tekshirib, test chek chiqaring.',
    maslahat_kassir_5: 'Smena oxirida tranzaksiyalar va qaytimlarni bir marta taqqoslab yoping.',
    maslahat_level_zarur: 'Zarur',
    maslahat_level_muhim: 'Muhim',
    maslahat_level_keyinroq: 'Keyinroq qilsa bo\'ladi',
    maslahat_top_1: 'Lead va buyurtmalarni status bo\'yicha kuniga kamida bir marta tekshiring. Status o\'zgarishini vaqtida yangilang.',
    maslahat_top_2: 'Dispecher leadni menejerga 15 daqiqa ichida yo\'naltiring, menejer mijoz bilan 24 soat ichida bog\'lansin.',
    maslahat_top_3: 'Har bir mahsulot uchun minimal va maksimal qoldiq belgilang. Tizim orqali avtomatik ogohlantirishlarni yoqing.',
    maslahat_top_4: 'Hisob-faktura va to\'lovlarni juftlashtiring. Ochiq qarzlar ro\'yxatini haftalik kuzating.',
    maslahat_top_5: 'Har bir rol uchun aniq KPI belgilang. Reytinglarni ochiq va adolatli qiling.',
    maslahat_top_6: 'Mijozlarni segmentlashtiring: VIP, muntazam, yangi. Har bir segment uchun alohida takliflar.',
    maslahat_top_7: 'Ma\'lumotlarni muntazam yedeklang va tizim yangilanishlarini vaqtida o\'tkazing.',
    maslahat_top_8: 'Sotuv funnelini tahlil qiling — qaysi bosqichda mijozlar qolayapti, shu joyni yaxshilang.',
    maslahat_top_9: 'Yangi funksiyalarni avval kichik guruhda sinab ko\'ring, keyin barchaga yoqing.',
    maslahat_top_10: 'Foydalanuvchilar fikrini so\'rang va yordam bo\'limini rivojlantiring.',
    maslahat_chat_title: 'AI dan so\'rang',
    maslahat_ai_quota_monthly: 'Oylik savollar: {used} / {max}',
    maslahat_ai_quota_exceeded: 'Oylik AI savollar limiti tugadi. Keyingi oyda yoki yuqori tarifda davom eting.',
    maslahat_chat_placeholder: 'Savolingizni yozing… Maslahat, hisobot yoki boshqa mavzuda savol bering.',
    maslahat_chat_send: 'Yuborish',
    maslahat_chat_you: 'Siz',
    maslahat_chat_demo_reply: 'Savolingiz qabul qilindi. AI javobi keyingi yangilanishda ulanganida ko\'rsatiladi.',
    maslahat_chat_history_loading: 'Suhbat tarixini yuklash…',
    maslahat_chat_thinking: 'Tahlil qilinyapti…',
    maslahat_chat_sending: 'Yuborilmoqda…',
    maslahat_chat_footer_hint: 'Javoblar sizning ERP maʼlumotlaringiz (sotuvlar, buyurtmalar, qoldiq) asosida shakllanadi.',
    maslahat_chat_footer_hint_owner:
      'Javoblar platforma maʼlumotlari (mijozlar, xodimlar, nasiya, buyurtmalar) bo‘yicha SQL agent va JSON kontekst asosida. Maxfiy maʼlumotlarni chatga yozmang.',
    maslahat_quick_platform_tenants: 'Faol mijozlar + tarif',
    maslahat_quick_platform_tenants_prompt:
      'Faol obuna mijozlar (tenants jadvali, status=active) ro‘yxatini ko‘rsat: Mijoz ID, Mijoz nomi, Tarif va Holat ustunlari bilan SQL jadval.',
    maslahat_quick_platform_by_tariff: 'Tarif bo‘yicha soni',
    maslahat_quick_platform_by_tariff_prompt:
      'Faol mijozlarni tarif bo‘yicha guruhlab ko‘rsat: har bir tarif uchun Mijozlar soni (faqat raqam) jadvali.',
    maslahat_quick_platform_overview: 'Platforma xulosasi',
    maslahat_quick_platform_overview_prompt:
      'Platforma umumiy ko‘rsatkichlari: faol mijozlar, sinov, viloyat menejerlari va ochiq nasiya — SQL jadval.',
    maslahat_top10_loading: 'Tavsiyalar yuklanmoqda…',
    maslahat_top10_error: 'Tavsiyalar yuklanmadi. Quyida zaxira ro\'yxat.',
    maslahat_top10_fallback_hint: 'Oflayn / zaxira rejim.',
    maslahat_chat_reply_empty: 'Javob bo\'sh keldi. Qayta yuborib ko\'ring.',
    maslahat_chat_new: 'Yangi suhbat',
    maslahat_chat_reload_history: 'Tarixni yangilash',
    maslahat_chat_load_more: 'Ko\'proq yuklash',
    maslahat_chat_offline: 'Internet aloqasi yo\'q. Chat yuborilmaydi.',
    maslahat_quick_sales: 'Oxirgi 7 kun savdosi va o\'sish',
    maslahat_quick_stock: 'Nol yoki kam qoldiqdagi mahsulotlar',
    maslahat_quick_inventory_cost: 'Sotib olish narxi + qoldiq',
    maslahat_quick_inventory_cost_prompt:
      'Omborda mahsulotlar bo‘yicha sotib olish narxi, joriy qoldiq va eng past marjali 10 ta mahsulotni ko‘rsat.',
    maslahat_quick_debt: 'Qarzdorlik va ochiq buyurtmalar haqida',
    maslahat_quick_orders: 'So\'nggi 30 kundagi buyurtmalar',
    maslahat_quick_summary: 'Bugungi holat — qisqa xulosa',
    maslahat_quick_data_scope: 'Bu chatda qanday maʼlumotlar bor?',
    maslahat_quick_stock_disabled_hint: 'Hozir nol yoki manfiy qoldiq pozitsiyalari sizda ko\'rinmayapti.',
    maslahat_quick_summary_disabled_hint: 'Tahlil uchun maʼlumot yetarli emas.',
    maslahat_discuss_ai: 'AI bilan muhokama',
    maslahat_discuss_prefill: '№{rank} maslahatni batafsil tushuntirib ber: «{text}». Faqat mening ERP JSON maʼlumotim asosida javob ber.',
    maslahat_snapshot_title: 'Javob uchun maʼlumotlar',
    maslahat_snapshot_sales: '7 kun savdo (UZS)',
    maslahat_snapshot_growth: 'Haftadan-haftaga o\'sish',
    maslahat_snapshot_orders: '30 kun buyurtmalar soni',
    maslahat_snapshot_top: 'Top mahsulotlar',
    maslahat_snapshot_oos: 'Nol qoldiq',
    maslahat_snapshot_at: 'Yangilangan',
    maslahat_snapshot_none: '—',
    maslahat_chat_typing: 'AI yozmoqda…',
    maslahat_chat_loading_overlay: 'Maʼlumot va javob tayyorlanmoqda…',
    maslahat_structured_reasons: 'Signallar',
    maslahat_structured_actions: 'Keyingi qadamlar',
    maslahat_sql_query_btn: 'SQL so\'rovini yuborish',
    maslahat_sql_query_placeholder: 'Aniq savol bering: «Oxirgi 7 kunda qaysi mahsulot eng ko\'p sotildi?»',
    maslahat_sql_badge: 'DB dan jonli ma\'lumot',
    maslahat_sql_rows: 'qator qaytarildi',
    maslahat_sql_sending: 'Ma\'lumot bazasida izlanyapti…',
    maslahat_sql_error_scope: 'Bu savol uchun SQL agenti qo\'llanilmaydi. Oddiy chat orqali so\'rang.',
    adminAdvice_subtitle_dispatcher: 'Sotuvlar, buyurtmalar va AI yordamida tezkor javob.',
    adminAdvice_subtitle_warehouse: 'Qoldiq, aylanma va AI tavsiyalari.',
    adminAdvice_subtitle_accountant: 'Moliya ko\'rsatkichlari va hisobotlar bo\'yicha savollar.',
    adminAdvice_subtitle_analyst: 'Tahlil, segmentlar va funnel bo\'yicha AI yordam.',
    adminAdvice_subtitle_gm: 'Boshqaruv KPI va jamoa bo\'yicha strategik maslahat.',
    adminAdvice_subtitle_platform: 'Platforma va loyiha bo\'yicha maslahat.',
    adminAdvice_subtitle_owner_ai:
      'AI chat: mijozlar (tenant), tarif va obuna, menejerlar, dispecherlar, nasiya va to‘lovlar — maʼlumotlar bazasidan xavfsiz SELECT va JSON kontekst asosida javob.',
    adminAdvice_subtitle_tenant_owner: 'Joy egasi (tenant) uchun amaliy tavsiyalar: filiallar, kassirlar, savdo, ombor, marketing va moliya jarayonlarini tartibga solish.',
    adminDashboard_subtitle: 'Asosiy bo\'limlarga bir bosishda o\'ting. Tizim ko\'rsatkichlari server ma\'lumotlari bo\'yicha (mavjud bo\'lsa) yangilanadi.',
    adminDashboard_status_title: 'Tizim holati',
    adminDashboard_label_version: 'Versiya',
    adminDashboard_label_uptime: 'Ishlash vaqti',
    adminDashboard_label_backup: 'Oxirgi backup',
    adminDashboard_label_db: 'Ma\'lumotlar bazasi',
    adminDashboard_quick_statistics_desc: 'Savdo, filial va KPI bo\'yicha umumiy ko\'rinish.',
    adminDashboard_quick_messages_desc: 'Mijozlar bilan yozishmalar va xabarlar.',
    adminDashboard_quick_managers_desc: 'Viloyat va boshqa menejerlar boshqaruvi.',
    adminDashboard_metrics_empty: 'Hozircha tizim holati kartochkalari uchun serverdan ma\'lumot kelmadi. Sozlamalar va boshqa bo\'limlar odatdagidek ishlaydi.',
    adminDashboard_help_hint: 'Buyruqlar va tez-tez beriladigan savollar — Yordam bo\'limida.',
    adminDashboard_quick_title: 'Tezkor kirish',
    adminDashboard_quick_settings_title: 'Sozlamalar',
    adminDashboard_quick_settings_desc: 'Umumiy sozlamalar, til, vaqt mintaqasi va tizim parametrlari.',
    adminDashboard_quick_tariffs_title: 'Tariflar',
    adminDashboard_quick_tariffs_desc: 'Tarif rejalari, narxlar va limitlar boshqaruvi.',
    adminDashboard_quick_tenants_title: 'Mijozlar',
    adminDashboard_quick_tenants_desc: 'Loyiha mijozlari ro\'yxati, qo\'shish va sozlash.',
    adminDashboard_quick_integrations_title: 'Integratsiyalar',
    adminDashboard_quick_integrations_desc: 'Tashqi xizmatlar, API va to\'lov tizimlari ulash.',
    adminDashboard_quick_audit_title: 'Audit jurnali',
    adminDashboard_quick_audit_desc: 'Foydalanuvchi harakatlari va tizim hodisalari tarixi.',
    adminDashboard_quick_apikeys_title: 'API kalitlari',
    adminDashboard_quick_apikeys_desc: 'API kalitlari yaratish, yangilash va cheklovlar.',
    adminDashboard_activity_title: 'So\'nggi faoliyat',
    adminDashboard_activity_1: 'Tizimga kirish — 2025-02-05 09:15',
    adminDashboard_activity_2: 'Sozlamalar yangilandi — tarif limitlari (2025-02-04 16:22)',
    adminDashboard_activity_3: 'Yangi mijoz qo\'shildi — "ABC MChJ" (2025-02-04 14:00)',
    adminDashboard_activity_4: 'Integratsiya yoqildi — 1C (2025-02-03 11:30)',
    adminDashboard_activity_5: 'API kalit yaratildi — production (2025-02-02 10:15)',
    adminDashboard_activity_6: 'Audit eksporti yuklab olindi — 2025-02-01 17:45',
    adminDashboard_activity_7: 'Backup muvaffaqiyatli tugadi — 2025-02-05 03:00',
    adminDashboard_usage_title: 'Foydalanish',
    adminDashboard_usage_requests: 'API so\'rovlari (bugun)',
    adminDashboard_usage_sessions: 'Faol sessiyalar',
    adminDashboard_usage_storage: 'Saqlash hajmi',
    adminDashboard_security_title: 'Xavfsizlik',
    adminDashboard_security_last_login: 'Oxirgi kirish',
    adminDashboard_security_failed: 'Muvaffaqiyatsiz urinishlar',
    adminDashboard_security_2fa: 'Ikki bosqichli autentifikatsiya (2FA) qo\'llab-quvvatlanadi. Barcha administratorlar uchun yoqish tavsiya etiladi.',
    adminDashboard_docs_title: 'Qo\'llanma va qo\'llab-quvvatlash',
    adminDashboard_docs_text: 'To\'liq administrator qo\'llanmasi va API hujjatlari keyingi yangilanishlarda qo\'shiladi. Savollar uchun qo\'llab-quvvatlash xizmatiga murojaat qiling.',
    adminHealth_subtitle: 'Tizim xizmatlari, resurslar va so\'nggi hodisalar bo\'yicha batafsil ma\'lumot. Barcha ko\'rsatkichlar statik namuna.',
    adminHealth_status_operational: 'Ishlamoqda',
    adminHealth_status_degraded: 'Cheklangan',
    adminHealth_status_outage: 'Ishlamayapti',
    adminHealth_overview_title: 'Umumiy ko\'rsatkichlar',
    adminHealth_version: 'Versiya',
    adminHealth_uptime: 'Ishlash vaqti (uptime)',
    adminHealth_uptime_days: 'kun davomida',
    adminHealth_last_backup: 'Oxirgi backup',
    adminHealth_last_deploy: 'Oxirgi deploy',
    adminHealth_services_title: 'Xizmatlar holati',
    adminHealth_service_api: 'API server',
    adminHealth_service_database: 'Ma\'lumotlar bazasi',
    adminHealth_service_cache: 'Cache (Redis)',
    adminHealth_service_queue: 'Navbat (Queue)',
    adminHealth_service_storage: 'Fayl saqlash',
    adminHealth_service_cdn: 'CDN',
    adminHealth_resources_title: 'Resurslar',
    adminHealth_resource_cpu: 'Protsessor (CPU)',
    adminHealth_resource_memory: 'Xotira (RAM)',
    adminHealth_resource_disk: 'Disk',
    adminHealth_incidents_title: 'So\'nggi incidentlar',
    adminHealth_incidents_none: 'So\'nggi 30 kun ichida incidentlar qayd etilmadi. Barcha tizimlar barqaror ishlayapti.',
    adminHealth_resolved: 'Hal qilindi',
    adminHealth_recommendations_title: 'Tavsiyalar',
    adminHealth_recommend_1: 'Backuplarni kunlik tekshirib turing va test restore amalga oshiring.',
    adminHealth_recommend_2: 'Xavfsizlik yangilanishlarini vaqtida o\'tkazing va loglarni monitoring qiling.',
    adminHealth_recommend_3: 'Disk va xotira hajmini reja asosida kuzatib boring; limitlardan oldin xabar sozlang.',
    adminHealth_recommend_4: 'Incidentlar yuzaga kelsa, Audit jurnalida va xatoliklar bo\'limida tekshiring.',
    adminHealth_footer: 'Ma\'lumotlar statik namuna. Haqiqiy monitoring backend ulanganida yangilanadi.',
    adminUsage_subtitle: 'API so\'rovlari, faol foydalanuvchilar, saqlash va tarif limitlari bo\'yicha batafsil ko\'rsatkichlar. Barcha ma\'lumotlar statik namuna.',
    adminUsage_period: 'So\'nggi 30 kun',
    adminUsage_kpi_title: 'Asosiy ko\'rsatkichlar',
    adminUsage_kpi_requests_total: 'API so\'rovlari (jami)',
    adminUsage_kpi_requests_today: 'Bugun',
    adminUsage_kpi_active_users: 'Faol foydalanuvchilar',
    adminUsage_kpi_storage: 'Saqlash hajmi',
    adminUsage_kpi_tenants: 'Mijozlar',
    adminUsage_kpi_avg_response: 'O\'rtacha javob vaqti',
    adminUsage_limits_title: 'Tarif limitlari',
    adminUsage_limit_api: 'API so\'rovlari (oylik)',
    adminUsage_limit_storage: 'Saqlash',
    adminUsage_limit_users: 'Foydalanuvchilar',
    adminUsage_trend_title: 'Kunlik trend',
    adminUsage_trend_caption: 'So\'nggi 15 kun uchun nisbiy foydalanish (foiz).',
    adminUsage_endpoints_title: 'Eng ko\'p chaqiriladigan endpointlar',
    adminUsage_endpoint_path: 'Endpoint',
    adminUsage_endpoint_method: 'Metod',
    adminUsage_endpoint_count: 'So\'rovlar',
    adminUsage_footer: 'Ko\'rsatkichlar statik namuna. Haqiqiy hisobotlar va eksport backend ulanganida qo\'shiladi.',
    adminError_subtitle: 'Tizim xatoliklari, ularning darajasi va manbai. Barcha yozuvlar statik namuna.',
    adminError_filter_all: 'Barchasi',
    adminError_severity_critical: 'Kritik',
    adminError_severity_warning: 'Ogohlantirish',
    adminError_severity_info: 'Ma\'lumot',
    adminError_summary_title: 'Qisqacha (so\'nggi 24 soat)',
    adminError_summary_24h: 'Xatolar (24 soat)',
    adminError_total: 'yozuv',
    adminError_time: 'Vaqt',
    adminError_severity: 'Daraja',
    adminError_message: 'Xabar',
    adminError_source: 'Manba',
    adminError_endpoint: 'Endpoint',
    adminError_request_id: 'Request ID',
    adminError_status: 'Holat',
    adminError_resolved: 'Hal qilindi',
    adminError_new: 'Yangi',
    adminError_source_api: 'API',
    adminError_source_auth: 'Auth',
    adminError_source_database: 'Ma\'lumotlar bazasi',
    adminError_source_worker: 'Worker',
    adminError_source_integration: 'Integratsiya',
    adminError_msg_rate_limit: 'So\'rovlar limiti oshib ketdi (rate limit). Mijoz vaqtincha cheklangan.',
    adminError_msg_validation: 'Validatsiya xatosi: noto\'g\'ri maydon qiymatlari yuborilgan.',
    adminError_msg_db_connection: 'Ma\'lumotlar bazasiga ulanish vaqti tugadi. Qayta ulanish muvaffaqiyatli amalga oshirildi.',
    adminError_msg_token_expired: 'Access token muddati tugagan. Foydalanuvchi qayta autentifikatsiya qilindi.',
    adminError_msg_integration_timeout: 'Tashqi xizmat (1C) javob bermadi. Timeout 30 soniya.',
    adminError_msg_queue_delay: 'Navbatda kechikish: worker overload. Keyinroq qayta ishlandi.',
    adminError_msg_file_size: 'Yuklangan fayl hajmi limitdan oshdi (maks. 10 MB).',
    adminError_msg_payment_gateway: 'To\'lov shlyuzi (Payme) vaqtincha javob bermadi. To\'lov keyinroq tasdiqlandi.',
    adminError_msg_memory_high: 'Server xotira foydalanishi yuqori (85%+). Cache tozalandi.',
    adminError_msg_deprecated_api: 'Eski API versiyasi (v0) chaqirildi. v1 ga o\'tish tavsiya etiladi.',
    adminError_footer: 'Xatoliklar statik namuna. Haqiqiy monitoring va bildirishnomalar backend ulanganida ishlaydi.',
    adminApiKey_subtitle: 'API kalitlari yaratish, tahrirlash va cheklovlar. Tashqi tizimlar va integratsiyalar uchun kirish.',
    adminApiKey_add: 'Yangi qo\'shish',
    adminApiKey_name: 'Nomi',
    adminApiKey_key: 'Kalit',
    adminApiKey_environment: 'Muhit',
    adminApiKey_scopes: 'Huquqlar',
    adminApiKey_created: 'Yaratilgan',
    adminApiKey_expires: 'Muddati',
    adminApiKey_status: 'Holat',
    adminApiKey_actions: 'Amallar',
    adminApiKey_edit: 'Tahrirlash',
    adminApiKey_delete: 'O\'chirish',
    adminApiKey_empty: 'API kalitlari hali yo\'q. "Yangi qo\'shish" orqali birinchi kalitni yarating.',
    adminApiKey_modal_add_title: 'Yangi API kalit',
    adminApiKey_modal_edit_title: 'API kalitni tahrirlash',
    adminApiKey_name_placeholder: 'Masalan: Production — asosiy',
    adminApiKey_expires_placeholder: 'YYYY-MM-DD yoki bo\'sh (cheksiz)',
    adminApiKey_cancel: 'Bekor qilish',
    adminApiKey_save: 'Saqlash',
    adminApiKey_confirm_delete_title: 'API kalitni o\'chirish',
    adminApiKey_confirm_delete_text: 'Quyidagi kalitni o\'chirib tashlashni xohlaysizmi',
    adminApiKey_env_production: 'Production',
    adminApiKey_env_staging: 'Staging',
    adminApiKey_status_active: 'Faol',
    adminApiKey_status_revoked: 'Bekor qilingan',
    adminApiKey_scope_read: 'O\'qish',
    adminApiKey_scope_write: 'Yozish',
    adminApiKey_scope_admin: 'Admin',
    adminManager_subtitle: 'Bosh menejer va viloyat menejerlari ro\'yxati. Filiallar, buyurtmalar va hisobotlar bo\'yicha javobgar shaxslar.',
    adminManager_add: 'Yangi qo\'shish',
    adminManager_total: 'menejer',
    adminManager_name: 'F.I.O.',
    adminManager_role: 'Rol',
    adminManager_region: 'Viloyat',
    adminManager_contact: 'Aloqa',
    adminManager_territory: 'Hudud / filiallar',
    adminManager_status: 'Holat',
    adminManager_joined: 'Qo\'shilgan sana',
    adminManager_actions: 'Amallar',
    adminManager_edit: 'Tahrirlash',
    adminManager_delete: 'O\'chirish',
    adminManager_empty: 'Menejerlar ro\'yxati bo\'sh. "Yangi qo\'shish" orqali qo\'shing.',
    adminManager_modal_add_title: 'Yangi menejer',
    adminManager_modal_edit_title: 'Menejerni tahrirlash',
    adminManager_name_placeholder: 'To\'liq ism familiya',
    adminManager_region_placeholder: 'Masalan: Toshkent, Samarqand',
    adminManager_territory_placeholder: 'Masalan: Toshkent sh. — 12 filial',
    adminManager_note_placeholder: 'Qo\'shimcha eslatma',
    adminManager_cancel: 'Bekor qilish',
    adminManager_save: 'Saqlash',
    adminManager_confirm_delete_title: 'Menejerni o\'chirish',
    adminManager_confirm_delete_text: 'Quyidagi menejerni ro\'yxatdan o\'chirishni xohlaysizmi',
    adminManager_role_bosh_menejer: 'Bosh menejer',
    adminManager_role_viloyat_menejer: 'Viloyat menejeri',
    adminManager_role_general_manager: 'Bosh menejer',
    adminManager_role_regional_manager: 'Viloyat menejeri',
    adminManager_status_active: 'Faol',
    adminManager_status_inactive: 'Faol emas',
    adminManager_phone: 'Telefon',
    adminManager_note: 'Eslatma',
    adminBranch_subtitle: 'Filiallar ro\'yxati. Qo\'shish, tahrirlash va o\'chirish.',
    adminBranch_add: 'Filial qo\'shish',
    adminBranch_total: 'filial',
    adminBranch_name: 'Filial nomi',
    adminBranch_tenant: 'Mijoz (korxona) va raqami',
    adminBranch_region: 'Viloyat',
    adminBranch_address: 'Manzil',
    adminBranch_responsible_name: 'Mas\'ul hodim ismi',
    adminBranch_responsible_phone: 'Mas\'ul hodim raqami',
    adminBranch_actions: 'Amallar',
    adminBranch_edit: 'Tahrirlash',
    adminBranch_delete: 'O\'chirish',
    adminBranch_empty: 'Filiallar ro\'yxati bo\'sh. "Filial qo\'shish" orqali qo\'shing.',
    adminBranch_modal_add_title: 'Yangi filial',
    adminBranch_modal_edit_title: 'Filialni tahrirlash',
    adminBranch_name_placeholder: 'Masalan: Toshkent filiali',
    adminBranch_address_placeholder: 'Manzilni kiriting',
    adminBranch_responsible_name_placeholder: 'Mas\'ul shaxs F.I.O.',
    adminBranch_responsible_phone_placeholder: '+998 90 123 45 67',
    adminBranch_cancel: 'Bekor qilish',
    adminBranch_save: 'Saqlash',
    adminBranch_confirm_delete_title: 'Filialni o\'chirish',
    adminBranch_confirm_delete_text: 'Quyidagi filialni ro\'yxatdan o\'chirishni xohlaysizmi',
    adminBranch_error_tenant_required: 'Mijoz (tenant) aniqlanmadi. Profilni yangilang yoki qayta kiring.',
    adminBranch_yes: 'Ha',
    adminBranch_no: 'Yo\'q',
    adminBranch_region_placeholder: 'Viloyatni tanlang',
    adminBranch_tenant_placeholder: 'Mijoz (korxona) ni tanlang',
    adminBranch_view: 'Filialni ko‘rish',
    adminBranch_view_title: 'Filial ma\'lumotlari',
    adminBranch_detail_info: 'Asosiy ma\'lumotlar',
    adminBranch_detail_stats: 'Sotuv statistikasi',
    adminBranch_detail_cashiers: 'Filial kassirlari',
    adminBranch_detail_warehouse: 'Ombor holati',
    adminBranch_stat_orders_month: 'Oy bo‘yicha buyurtmalar soni',
    adminBranch_stat_revenue_month: 'Oy bo‘yicha tushum',
    adminBranch_stat_revenue_total: 'Umumiy tushum',
    adminBranch_stat_last_order: 'Oxirgi buyurtma vaqti',
    adminBranch_cashier_name: 'Kassir',
    adminBranch_cashier_phone: 'Telefon',
    adminBranch_cashier_status: 'Holat',
    adminBranch_cashier_orders_month: 'Oy buyurtmalari',
    adminBranch_cashier_revenue_month: 'Oy tushumi',
    adminBranch_cashier_last_shift: 'Oxirgi smena',
    adminBranch_warehouse_products: 'Mahsulotlar soni',
    adminBranch_warehouse_stock: 'Jami qoldiq',
    adminBranch_warehouse_stock_value: 'Qoldiq summasi',
    adminBranch_close: 'Yopish',
    adminCashier_subtitle: 'Kassirlar ro\'yxati. Qo\'shish, tahrirlash va o\'chirish. Kassir raqami — tizimga kirish uchun ishlatiladi.',
    adminCashier_add: 'Kassir qo\'shish',
    adminCashier_total: 'kassir',
    adminCashier_name: 'Kassir ism-familiyasi',
    adminCashier_fullName: 'Kassir',
    adminCashier_surname: 'Familiya',
    adminCashier_phone: 'Kassir raqami',
    adminCashier_name_placeholder: 'To\'liq ism va familiya',
    adminCashier_phone_placeholder: '+998 90 123 45 67',
    adminCashier_modal_add_title: 'Yangi kassir',
    adminCashier_modal_edit_title: 'Kassirni tahrirlash',
    adminCashier_confirm_delete_title: 'Kassirni o\'chirish',
    adminCashier_confirm_delete_text: 'Quyidagi kassirni ro\'yxatdan o\'chirishni xohlaysizmi',
    adminCashier_empty: 'Kassirlar ro\'yxati bo\'sh. "Kassir qo\'shish" orqali qo\'shing.',
    adminCashier_branch_placeholder: 'Filialni tanlang (majburiy)',
    adminCashier_branches_empty_hint: 'Filiallar topilmadi. Avval «Filiallar» bo‘limida filial qo‘shing yoki mijoz bilan qayta kiring.',
    adminCashier_my_branch: 'Mening filialim',
    adminCashier_branch_products_scope: 'Qo‘shish va tahrirlash shu filial uchun amal qiladi.',
    adminMarketing_cashier_lead:
      'Sizning filialingiz: onlayn do‘kon havolasi va shu filialga tushgan onlayn buyurtmalar.',
    adminMarketing_cashier_no_branch:
      'Hisobingizga filial biriktirilmagan. Administratorga murojaat qiling — marketing buyurtmalari filial bo‘yicha ko‘rsatiladi.',
    adminMarketing_cashier_settings_note: 'Marketing sozlamalari (do‘kon nomi, Telegram) — joy egasi orqali.',
    adminMarketing_your_branch: 'Sizning filial',
    adminMarketing_no_branches: 'Filiallar topilmadi.',
    adminMarketing_orders_branch_title: 'Onlayn buyurtmalar (sizning filial)',
    adminMarketing_orders_hint_cashier: 'Faqat ushbu filialga tushgan onlayn (marketing) buyurtmalar. Sana bo‘yicha filtrlash.',
    adminStaffWorkers_subtitle:
      'Ishchilar: fix oylik, filial va lavozim. Har oy uchun KPI ma’lumotlari AI tahlili orqali bonus foizi avtomatik hisoblanadi (backend).',
    adminStaffWorkers_add: 'Ishchi qo‘shish',
    adminStaffWorkers_total: 'ishchi',
    adminStaffWorkers_name: 'F.I.Sh.',
    adminStaffWorkers_position: 'Lavozim',
    adminStaffWorkers_position_placeholder: 'Masalan: sotuvchi, katta sotuvchi',
    adminStaffWorkers_monthly_salary: 'Fix oylik (so‘m)',
    adminStaffWorkers_phone: 'Telefon',
    adminStaffWorkers_phone_placeholder: '+998 …',
    adminStaffWorkers_modal_add: 'Yangi ishchi',
    adminStaffWorkers_modal_edit: 'Ishchini tahrirlash',
    adminStaffWorkers_confirm_delete_title: 'Ishchini o‘chirish',
    adminStaffWorkers_confirm_delete_text: 'Quyidagi ishchini ro‘yxatdan olib tashlamoqchimisiz',
    adminStaffWorkers_empty: 'Ishchilar ro‘yxati bo‘sh. «Ishchi qo‘shish» orqali qo‘shing.',
    adminStaffWorkers_empty_cashiers:
      'Kassirlar topilmadi. Kassirlar bo‘limida xodim qo‘shing — ishchilar ro‘yxati shu kassirlardan tuziladi.',
    adminStaffWorkers_branch_placeholder: 'Filialni tanlang (majburiy)',
    adminStaffWorkers_bonus_section: 'Oylik bonus (AI tahlil)',
    adminStaffWorkers_bonus_hint:
      'Tanlangan oy uchun tizim KPI (sotuv, chiqishlar, davomat va hokazo) ni yig‘adi, LLM yoki qoida motori har bir ishchiga bonus foizini taklif qiladi. «AI bilan hisoblash» tugmasi backendda qayta ishga tushadi.',
    adminStaffWorkers_year: 'Yil',
    adminStaffWorkers_month: 'Oy',
    adminStaffWorkers_run_ai: 'AI bilan hisoblash',
    adminStaffWorkers_run_ai_loading: 'Hisoblanmoqda…',
    adminStaffWorkers_col_bonus_pct: 'Bonus %',
    adminStaffWorkers_col_bonus_amount: 'Bonus summasi',
    adminStaffWorkers_col_monthly_sales: 'Oy savdosi',
    adminStaffWorkers_ai_rationale: 'AI / tahlil qisqacha',
    adminStaffWorkers_status: 'Holat',
    adminStaffWorkers_status_pending: 'Kutilmoqda',
    adminStaffWorkers_status_ready: 'Tayyor',
    adminStaffWorkers_no_eval_yet: 'Bu oy uchun hali baholash yo‘q. «AI bilan hisoblash» ni bosing.',
    adminDispatcher_subtitle: 'Leadlar va buyurtmalarni qabul qiluvchi dispecherlar ro\'yxati. Menejerga bog\'langan, reyting va smena ma\'lumotlari.',
    adminDispatcher_subtitle_vm: 'O\'z viloyatingizdagi dispecherlar. Telefon raqam tizimga kirish logini sifatida ishlatiladi.',
    adminDispatcher_phone_login: ' (tizimga kirish)',
    adminDispatcher_login_required: 'Dispecher telefon raqamini kiriting — u login bo\'ladi.',
    adminDispatcher_add: 'Yangi qo\'shish',
    adminDispatcher_total: 'dispecher',
    adminDispatcher_name: 'F.I.O.',
    adminDispatcher_zone: 'Zona / hudud',
    adminDispatcher_contact: 'Aloqa',
    adminDispatcher_manager: 'Menejer',
    adminDispatcher_orders: 'Buyurtmalar (oy)',
    adminDispatcher_status: 'Holat',
    adminDispatcher_joined: 'Qo\'shilgan sana',
    adminDispatcher_actions: 'Amallar',
    adminDispatcher_edit: 'Tahrirlash',
    adminDispatcher_delete: 'O\'chirish',
    adminDispatcher_empty: 'Dispecherlar ro\'yxati bo\'sh. "Yangi qo\'shish" orqali qo\'shing.',
    adminDispatcher_modal_add_title: 'Yangi dispecher',
    adminDispatcher_modal_edit_title: 'Dispecherni tahrirlash',
    adminDispatcher_name_placeholder: 'To\'liq ism familiya',
    adminDispatcher_zone_placeholder: 'Masalan: Toshkent — markaz',
    adminDispatcher_manager_placeholder: 'Tegishli menejer F.I.O.',
    adminDispatcher_note_placeholder: 'Smena, vazifa va boshqa eslatma',
    adminDispatcher_cancel: 'Bekor qilish',
    adminDispatcher_save: 'Saqlash',
    adminDispatcher_confirm_delete_title: 'Dispecherni o\'chirish',
    adminDispatcher_confirm_delete_text: 'Quyidagi dispecherni ro\'yxatdan o\'chirishni xohlaysizmi',
    adminDispatcher_status_active: 'Faol',
    adminDispatcher_status_inactive: 'Faol emas',
    adminDispatcher_phone: 'Telefon',
    adminDispatcher_firstName: 'Ism',
    adminDispatcher_lastName: 'Familiya',
    adminDispatcher_firstName_ph: 'Masalan: Sanjar',
    adminDispatcher_lastName_ph: 'Masalan: Rahimov',
    adminDispatcher_select_manager: 'Viloyat menejer',
    adminDispatcher_select_manager_ph: 'Menejerni tanlang',
    adminDispatcher_select_region: 'Viloyat',
    adminDispatcher_select_region_ph: 'Viloyatni tanlang',
    adminDispatcher_manager_required: 'Avval viloyat menejerni tanlang.',
    adminDispatcher_region_required: 'Dispecherni bog‘lash uchun viloyatni tanlang.',
    adminDispatcher_region_col: 'Viloyat',
    adminDispatcher_note: 'Eslatma',
    adminOrder_subtitle: 'Barcha viloyatlar bo\'yicha buyurtmalar ro\'yxati. Mijoz, menejer, dispecher va status bo\'yicha kuzatish.',
    adminOrder_subtitle_vm: 'Sizning viloyatingiz bo\'yicha buyurtmalar. Mijoz, dispecher va status bo\'yicha kuzatish.',
    adminOrder_subtitle_disp: 'Status: Yangi, Rad etildi yoki Menejerga yuborildi. «Mijozga aylantirish» menejerga yuborilgan deb belgilanadi; boshqa holatda faqat rad etish.',
    adminOrder_number: 'Raqam',
    adminOrder_client: 'Mijoz',
    adminOrder_region: 'Viloyat',
    adminOrder_manager: 'Menejer',
    adminOrder_dispatcher: 'Dispecher',
    adminOrder_business_type: 'Biznes turi',
    adminOrder_tariff: 'Tarif',
    adminOrder_amount: 'Summa',
    adminOrder_status: 'Status',
    adminOrder_created: 'Sana',
    adminOrder_note: 'Eslatma',
    adminOrder_summary_total: 'Jami summa',
    adminOrder_summary_count: 'buyurtma',
    adminOrder_period: 'Oxirgi 30 kun',
    adminOrder_empty: 'Buyurtmalar yo\'q.',
    adminOrder_actions: 'Amallar',
    adminOrder_convert_to_tenant: 'Mijozga aylantirish',
    adminOrder_convert_title: 'Buyurtmani mijozga aylantirish',
    adminOrder_convert_subtitle: 'Asosiy saytdan kelgan buyurtma ma’lumotlari asosida platforma mijozi yaratiladi.',
    adminOrder_convert_submit: 'Mijoz yaratish',
    adminOrder_convert_validation: 'Email, manzil va kamida 6 belgili parolni kiriting.',
    adminOrder_disp_status_new: 'Yangi',
    adminOrder_disp_status_rejected: 'Rad etildi',
    adminOrder_disp_status_sent: 'Menejerga yuborildi',
    adminOrder_reject_btn: 'Rad etish',
    adminOrder_reject_confirm: 'Bu buyurtmani rad etishni tasdiqlaysizmi?',
    adminOrder_company_short: 'Tashkilot',
    cashierKassa_subtitle: 'Mahsulot qo‘shing, to‘lovni tanlang, chop eting.',
    cashierKassa_search_placeholder: 'Shtrix-kod, markirovka yoki mahsulot nomi',
    cashierKassa_pos_qty_active: 'Miqdor rejimi',
    cashierKassa_pos_amount_active: 'Erkin narx rejimi',
    cashierKassa_pos_press_enter: 'Enter bosing',
    cashierKassa_pos_search_then_enter: 'avval tovar qidiring, keyin Enter',
    cashierKassa_pos_prefix_hint: 'Avval tovar qidiring (masalan choy), keyin 15+ yoki 19.000* yozib Enter bosing',
    cashierKassa_pos_prefix_apply_failed: 'Oxirgi qatorni yangilab bo‘lmadi. Miqdor yoki narxni tekshiring.',
    cashierKassa_pos_not_found: 'Mahsulot topilmadi. Nomni tekshiring yoki ro‘yxatdan tanlang.',
    cashierKassa_scan_barcode: 'Shtrix-kod skanerlash',
    cashierKassa_scan_title: 'Shtrix-kod skanerlash',
    cashierKassa_scan_close: 'Yopish',
    cashierKassa_choose_variant: 'O‘lchov yoki variant tanlang',
    cashierKassa_scan_added: 'Savatga qo\'shildi',
    cashierKassa_cart: 'Savatcha',
    cashierKassa_cart_empty: 'Savatcha bo‘sh.',
    cashierKassa_cart_default: 'Savatcha 1',
    cashierKassa_cart_tab: 'Savatcha',
    cashierKassa_cart_current: 'Joriy savatcha',
    cashierKassa_col_variant_measure: "Variant / o‘lchov",
    cashierKassa_new_cart: 'Yangi savatcha',
    cashierKassa_other_carts: 'Boshqa savatchalar',
    cashierKassa_cart_select: 'Tanlash',
    cashierKassa_more: 'boshqa',
    cashierKassa_stock_empty: 'Omborda qoldiq yo‘q.',
    cashierKassa_stock_limit: 'Ombor qoldig‘i yetarli emas. Mavjud: ',
    cashierKassa_stock_available: 'Mavjud',
    cashierKassa_stock_total: 'Umumiy qoldiq',
    cashierKassa_stock_total_short: 'Qoldiq',
    cashierKassa_stock_pcs: 'dona',
    cashierKassa_cart_tap_edit_weighted: 'Bosing: miqdor, birlik narxi yoki jami summani tahrirlash',
    cashierKassa_cart_edit_title: 'Pozitsiyani tahrirlash (kg / m)',
    cashierKassa_cart_edit_hint: 'Miqdor, birlik narxi yoki jami — biri o‘zgarsa, qolganlari avtomatik moslanadi.',
    cashierKassa_cart_edit_qty: 'Miqdor',
    cashierKassa_cart_edit_unit_price: 'Birlik narxi (UZS)',
    cashierKassa_cart_edit_line_total: 'Jami (UZS)',
    cashierKassa_cart_edit_apply: 'Saqlash',
    cashierKassa_cart_edit_invalid_qty: 'Miqdor noto‘g‘ri yoki juda kichik.',
    cashierKassa_total: 'Jami',
    cashierKassa_no_discount: 'Chegirmasiz',
    cashierKassa_discount_applied: 'Chegirma',
    cashierKassa_favorites_title: 'Tanlangan tovarlar',
    cashierKassa_favorites_empty: 'Tanlangan tovar yo‘q. Omborda yulduzcha bosing.',
    cashierKassa_search_results_title: 'Qidiruv natijalari',
    cashierKassa_search_empty: 'Qidiruv bo\u2019yicha mahsulot topilmadi.',
    cashierKassa_amount_qty_no_price: 'Summa bo\u2018yicha miqdor uchun narx mavjud emas.',
    cashierKassa_amount_free_price_only: 'Summa (*) faqat erkin narxli mahsulotlar uchun ishlatiladi.',
    cashierKassa_remove: 'O‘chirish',
    cashierKassa_to_payment: 'To‘lovga o‘tish',
    cashierKassa_print_before_payment: 'Chekni chop etish',
    cashierKassa_draft_receipt: 'Oldindan chek',
    cashierKassa_select_payment: 'To‘lov turini tanlang',
    cashierKassa_cash: 'Naqd',
    cashierKassa_card: 'Karta',
    cashierKassa_click: 'Click',
    cashierKassa_discount_profit_blocked: "Bunday chegirma berib bo'lmaydi (foydadan oshadi, tannarxdan pastga tushadi).",
    cashierKassa_nasiya: 'Nasiya',
    cashierKassa_aralash: 'Aralash to\'lov',
    cashierKassa_nasiya_client: 'Nasiya: mijoz ismi va telefoni (savatdan o‘tkaziladi)',
    cashierKassa_client_name: 'Mijoz ismi',
    cashierKassa_client_phone: 'Telefon raqami',
    cashierKassa_buyer_block_title: 'Savatdagi mijoz',
    cashierKassa_buyer_hint: 'Ism yoki telefon bo‘yicha qidiring; ro‘yxatdan tanlansa shu mijozga bog‘lanadi.',
    cashierKassa_buyer_new: 'Yangi mijoz (telefon bilan saqlanadi)',
    cashierKassa_supplier: "Ta'minotchi",
    cashierKassa_supplier_suggest: "Ta'minotchilar",
    cashierKassa_supplier_phone_missing: 'Telefon raqami yo\'q',
    cashierKassa_supplier_found: "Ta'minotchi topildi",
    cashierKassa_supplier_balance: 'Qoldiq xarajat',
    cashierKassa_supplier_cover_expense: 'Xarajatdan qoplash',
    cashierKassa_expense_cover_btn: 'Xarajat qoplash',
    cashierKassa_supplier_as_retail: 'Chakana mijoz sifatida',
    cashierKassa_supplier_no_account: "Ta'minotchi kartasi topilmadi: xarajatdan qoplash uchun mahsulotni tahrirlab ta'minotchini bog'lang.",
    cashierKassa_free_trade: 'Erkin savdo',
    cashierKassa_free_trade_hint: 'Yoniq bo‘lsa, tovar tanlanganda narx alohida kiritiladi (miqdor o‘zgarmaydi).',
    cashierKassa_price_modal_title: 'Sotish narxi',
    cashierKassa_price_modal_label: 'Narx (UZS)',
    cashierKassa_price_modal_add: 'Savatga',
    cashierKassa_line_discount_label: 'Qator chegirmasi (%)',
    cashierKassa_cart_edit_title_piece: 'Pozitsiya: miqdor, narx, chegirma',
    cashierKassa_cart_edit_piece_hint: 'Dona tovar: miqdor, kerak bo‘lsa erkin narx (erkin savdo), qator bo‘yicha chegirma (UZS).',
    cashierKassa_variable_price_total: "O'zgaruvchan narx",
    cashierKassa_cart_line_discount_badge: 'chegirma',
    cashierKassa_line_discount_too_high: 'Chegirma miqdori (brutto) jami summadan oshmasligi kerak.',
    cashierKassa_back: 'Orqaga',
    cashierKassa_confirm: 'Tasdiqlash',
    cashierKassa_confirm_print: 'Tasdiqlash va chop etish',
    cashierKassa_payment_method: 'To‘lov turi',
    cashierKassa_confirm_and_print: 'Tasdiqlash va chop etish',
    cashierKassa_printing: 'Chop etilmoqda…',
    cashierKassa_order_saved: 'Buyurtma saqlandi (offline).',
    cashierKassa_order_saved_synced: 'Buyurtma saqlandi.',
    cashierKassa_sync_failed_title: 'Sinxronlash muvaffaqiyatsiz tugadi',
    cashierKassa_sync_failed_body: 'Buyurtma offline rejimda saqlandi. Internetni tekshirib, keyinroq yana sinxronlashtiring.',
    cashierKassa_sync_error_403:
      'Server sizning rolingizda bu buyurtmani qabul qilmayapti (403). Administratordan POST /api/sync/orders uchun kassir ruxsatini tekshiring.',
    cashierKassa_sync_error_detail: 'Batafsil',
    cashierOrderHistory_subtitle: 'So‘ngi tranzaksiyalar. Sinxronlash holati.',
    cashierOrderHistory_refresh: 'Yangilash',
    cashierOrderHistory_empty: 'Hozircha buyurtmalar yo‘q.',
    cashierOrderHistory_synced: 'Sinxron',
    cashierOrderHistory_pending: 'Kutilmoqda',
    cashierPayments_subtitle: 'Kunlik smena, X/Z hisobotlar, naqd va karta.',
    cashierPayments_today: 'Bugungi smena',
    cashierPayments_reports: 'Hisobotlar',
    cashierPayments_x_report_hint: 'X-Report — smena yopilmagan holda vaqtinchalik hisobot.',
    cashierPayments_z_report_hint: 'Z-Report — smena yopilganda yakuniy hisobot.',
    cashierPayments_backend_note: 'Backend ulanganda haqiqiy ma\'lumotlar ko\'rsatiladi.',
    cashierZReport_subtitle: 'Kunlik smena yakuniy hisoboti — faqat sizning savdolaringiz',
    cashierZReport_sales_total: 'Jami savdo',
    cashierZReport_sales_count: 'ta savdo',
    cashierZReport_average_check: 'O\'rtacha chek',
    cashierZReport_payment_types: 'To\'lov turlari',
    cashierZReport_operations: 'ta operatsiya',
    cashierZReport_nasiya_issued: 'Bugun berilgan',
    cashierZReport_nasiya_repaid: 'Bugun qoplangan',
    cashierZReport_active_credits: 'ta faol nasiya',
    cashierZReport_footnote: 'Z-Report — smena yakuniy hisoboti. Ma\'lumotlar faqat joriy kassir savdolariga tegishli.',
    cashierZReport_send_to_owner: 'Boshliqqa yuborish',
    cashierZReport_sent_success: 'Z-Report mijozga yuborildi',
    ownerZReport_subtitle: 'Kassirlar yuborgan kunlik Z-Reportlar — sana bo\'yicha filtr',
    ownerZReport_reports_count: 'Yuborilgan hisobotlar',
    ownerZReport_empty: 'Tanlangan sana uchun yuborilgan Z-Report topilmadi.',
    adminNav_owner_z_reports: 'Z-Report',
    adminRefresh: 'Yangilash',
    adminCashier_permissions: 'Kassir ruxsatlari',
    adminCashier_perm_products: 'Mahsulot qo\'shish / tahrirlash / o\'chirish',
    adminCashier_perm_barcode: 'Mavjud mahsulotga shtrix-kod qo\'shish',
    adminCashier_perm_add_only: 'Faqat tovar qo\'shish (yangi + mavjudga qoldiq)',
    adminCashier_add_to_existing_product: 'Mavjud mahsulotga qo\'shish',
    adminNav_product_audit: 'Audit tovar',
    adminProductAudit_subtitle: 'Kassirlar qo\'shgan, tahrirlagan va o\'chirgan mahsulotlar tarixi',
    adminProductAudit_action_created: 'Qo\'shildi',
    adminProductAudit_action_updated: 'Tahrirlandi',
    adminProductAudit_action_deleted: 'O\'chirildi',
    adminProductAudit_filter_action: 'Amal turi',
    adminProductAudit_all_actions: 'Barcha amallar',
    adminProductAudit_summary_added: 'Qo\'shilgan',
    adminProductAudit_summary_updated: 'Tahrirlangan',
    adminProductAudit_summary_deleted: 'O\'chirilgan',
    adminProductAudit_col_product: 'Mahsulot',
    adminProductAudit_col_action: 'Amal',
    adminProductAudit_col_cashier: 'Kassir',
    adminProductAudit_col_branch: 'Filial',
    adminProductAudit_col_date: 'Sana',
    adminProductAudit_empty: 'Tanlangan filtr bo\'yicha yozuv topilmadi',
    adminProductAudit_date_from: 'Boshlanish sanasi',
    adminProductAudit_date_to: 'Tugash sanasi',
    adminProductAudit_total: 'Jami yozuvlar',
    adminProductAudit_filter_branch: 'Filial nomi',
    adminProductAudit_filter_cashier: 'Kassir ism-familiyasi',
    adminProductAudit_col_details: 'Tafsilotlar',
    adminProductAudit_qty: 'Miqdor',
    adminProductAudit_purchase: 'Xarid narxi',
    adminProductAudit_sale: 'Sotish narxi',
    adminTrans_all_branches: 'Barcha filiallar',
    adminTrans_all_cashiers: 'Barcha kassirlar',
    cashierKassa_mixed_remaining: 'Qolgan summa',
    cashierKassa_cashback_use: 'Cashback balansdan',
    cashierKassa_cashback_balance: 'Balans',
    cashierKassa_cashback_amount_ph: 'Summa',
    cashierKassa_cashback_use_all: 'Hammasi',
    cashierKassa_cashback_applied: 'Cashback',
    cashierKassa_cashback_pay_remaining: 'To‘lov',
    cashierKassa_mixed_after_cashback: 'Qolgan to‘lov',
    adminCashier_branch_products_view_only: 'Faqat ko\'rish — qoldiqlar shu filial bo\'yicha',
    adminOmbor_tenant_fav_select_all: 'Barchasini tanlash',
    adminOmbor_tenant_fav_clear_all: 'Barchasini tanlanganlardan olib tashlash',
    adminOmbor_col_free_price: 'Erkin narx',
    adminOmbor_free_price_enable_all: 'Barchasida erkin narxni yoqish',
    adminOmbor_free_price_disable_all: 'Barchasida erkin narxni o‘chirish',
    adminOmbor_free_price_enable_row: 'Erkin narxni yoqish',
    adminOmbor_free_price_disable_row: 'Erkin narxni o‘chirish',
    adminOmbor_free_price_toggle_error: 'Erkin narxni yangilab bo‘lmadi',
    adminOmbor_free_price_bulk_partial: 'Qisman yangilandi',
    adminOmbor_free_price_bulk_skipped_hint: '{updated} ta yangilandi. {skipped} tasida sotuv narxi yo‘qligi uchun o‘chirib bo‘lmadi.',
    cashierProducts_subtitle: 'Mahsulotlar: qo‘shish, tahrirlash, o‘chirish. Shtrix-kod bo‘sh qoldirilsa avtomatik yaratiladi.',
    cashierProducts_search_placeholder: 'Mahsulot nomi, shtrix-kod, markirovka, ID bo‘yicha qidirish',
    cashierProducts_add: 'Mahsulot qo‘shish',
    cashierProducts_edit: 'Tahrirlash',
    cashierProducts_name: 'Nomi',
    cashierProducts_name_placeholder: 'Mahsulot nomi',
    cashierProducts_quantity: 'Miqdor',
    cashierProducts_purchase_price: 'Olingan narx',
    cashierProducts_sale_price: 'Sotish narxi',
    cashierProducts_barcode: 'Shtrix-kod',
    cashierProducts_marking_code: 'Markirovka',
    cashierProducts_marking_hint: 'ixtiyoriy; kassada Data Matrix / GS1 skanerlash',
    cashierProducts_barcode_auto: 'bo‘sh qoldirilsa avtomatik',
    cashierProducts_empty: 'Mahsulotlar yo‘q.',
    cashierProducts_free_trade_suffix: 'erkin savdo',
    cashierProducts_free_price: 'Erkin narx',
    cashierProducts_sale_modes: "Qo'shimcha o'lchovlar va variantlar",
    cashierProducts_additional_sale_options: "Qo'shimcha o'lchovlar",
    cashierProducts_additional_unit_title: "Qo'shimcha o'lchov",
    cashierProducts_variant_title: 'Variant',
    cashierProducts_add_sale_option: "Qo'shimcha o'lchov qo'shish",
    cashierProducts_size_label: 'Razmer (masalan: 41)',
    cashierProducts_option_label_optional: 'Label (ixtiyoriy)',
    cashierProducts_add_variant: "Variant qo'shish",
    cashierProducts_color_label: 'Rang (masalan: qora)',
    cashierProducts_variant_barcode: 'Variant shtrix-kod (ixtiyoriy)',
    cashierProducts_expense_paid: "To'langan",
    cashierProducts_unit_factor: "1 ta sotilganda nechta kamayadi (asosiy o'lchovda)",
    adminSettings_pwa_cashier: 'PWA / Kassa sozlamalari',
    adminSettings_pwa_cashier_desc: 'Printer va til — mahalliy sozlamalar.',
    adminSettings_printer: 'Printer',
    adminSettings_printer_browser: 'Brauzer (Chop etish)',
    adminSettings_printer_default: 'Tizim default',
    adminHelp_telegram: 'Telegram',
    adminHelp_telegram_link: 'Qo‘llab-quvvatlash boti',
    adminLead_subtitle: 'Sizga tayinlangan leadlar. Manba, status va menejerga yo\'naltirish.',
    adminLead_subtitle_dispatcher: 'Mijozlarni qidiring (telefon va boshqalar), murojaat (shikoyat, taklif) yuboring — viloyat menejerning «Murojaatlar» bo‘limiga tushadi.',
    adminLead_subtitle_regional: 'Viloyatingiz bo\'yicha sotuvlar. Dispecher xabarlari va murojaat statuslarini shu yerda boshqaring.',
    adminLead_summary_total: 'Jami leadlar',
    adminLead_summary_total_dispatcher: 'Jami yozuvlar',
    adminLead_summary_count: 'lead',
    adminLead_code: 'Kod',
    adminLead_client: 'Mijoz',
    adminLead_region: 'Viloyat',
    adminLead_source: 'Manba',
    adminLead_status: 'Status',
    adminLead_priority: 'Ustuvorlik',
    adminLead_manager: 'Menejer',
    adminLead_estimated: 'Taxminiy summa',
    adminLead_created: 'Sana',
    adminLead_note: 'Izoh',
    adminLead_create_title: 'Lead yaratish',
    adminLead_create_subtitle: 'Yaratilganda avtomatik buyurtmaga ham yuboriladi.',
    adminLead_create_submit: 'Lead yaratish',
    adminLead_create_submitting: 'Yaratilmoqda...',
    adminLead_create_error: 'Lead yaratishda xatolik.',
    adminLead_empty: 'Leadlar yo\'q.',
    adminLead_empty_dispatcher: 'Murojaatlar ro\'yxati bo\'sh.',
    adminLead_filter_empty: 'Filter bo\'yicha lead topilmadi.',
    adminLead_filter_empty_dispatcher: 'Qidiruv yoki filter bo\'yicha yozuv topilmadi.',
    adminLead_empty_regional: 'Viloyat bo\'yicha sotuv yozuvlari yo\'q.',
    adminLead_actions: 'Amallar',
    adminLead_escalate_btn: 'Murojaat',
    adminLead_escalate_modal_title: 'Viloyat menejerga xabar',
    adminLead_escalate_message_label: 'Muammo yoki xabar matni',
    adminLead_escalate_message_ph: 'Mijoz holati, qidiruv natijasi yoki yechim talab qilinadigan savol...',
    adminLead_search_placeholder: 'Telefon, kod, mijoz ismi, izoh, viloyat bo\'yicha qidirish',
    adminLead_escalate_kind_label: 'Murojaat turi',
    adminLead_escalate_kind_general: 'Boshqa / xabar',
    adminLead_escalate_kind_complaint: 'Shikoyat',
    adminLead_escalate_kind_suggestion: 'Taklif',
    adminLead_escalate_kind_tariff_plan_change: 'Tarif o‘zgartirish so‘rovi',
    adminLead_tariff_change_intro: 'Mijoz tarif rejasini o‘zgartirish so‘rovi yubordi.',
    adminLead_tariff_change_current: 'Joriy tarif',
    adminLead_tariff_change_desired: 'So‘ralgan tarif',
    adminLead_tariff_change_note: 'Izoh',
    adminLead_tariff_change_company: 'Tashkilot',
    adminLead_tariff_change_phone: 'Telefon',
    adminLead_tariff_change_dispatcher_note: 'Dispecher izohi',
    adminLead_forward_tariff_hint: 'Mijoz tarif o‘zgartirish so‘rovi. Tekshiring va viloyat menejeriga yuboring.',
    adminLead_forward_to_manager: 'Menejerga yuborish',
    adminLead_forward_note_label: 'Menejerga izoh (ixtiyoriy)',
    adminLead_forward_note_ph: 'Masalan: mijoz bilan bog‘landim, tasdiqlash kerak…',
    notif_tenant_tariff_change_dispatcher_title: 'Mijozdan tarif o‘zgartirish so‘rovi',
    notif_tenant_tariff_change_dispatcher_body: '«Leadlar» bo‘limida ko‘rib, menejerga yuboring.',
    adminLead_escalate_cancel: 'Bekor qilish',
    adminLead_escalate_submit: 'Menejerga yuborish',
    adminLead_escalate_sending: 'Yuborilmoqda...',
    adminLead_escalations_review: 'Murojaatlar',
    adminLead_escalations_modal_title: 'Murojaatlar',
    adminLead_escalations_loading: 'Yuklanmoqda...',
    adminLead_escalations_none: 'Bu sotuv bo\'yicha murojaatlar yo\'q.',
    adminLead_escalation_status_select: 'Murojaat statusi',
    adminLead_escalation_resolution_ph: 'Yechim yoki izoh',
    adminLead_escalation_save: 'Saqlash',
    adminLead_escalation_status_open: 'Yangi',
    adminLead_escalation_status_in_progress: 'Jarayonda',
    adminLead_escalation_status_resolved: 'Hal qilindi',
    adminLead_escalation_status_declined: 'Rad etildi',
    adminLead_escalation_status_closed: 'Yopildi',
    adminLead_escalation_col_latest: 'So\'nggi murojaat',
    adminLead_escalation_view: 'Ko\'rish',
    adminLead_escalation_view_title: 'Murojaatlar va menejer javoblari',
    adminLead_escalation_view_close: 'Yopish',
    adminLead_escalation_dp_msg: 'Dispecher',
    adminLead_escalation_manager_reply: 'Menejer javobi',
    adminLead_escalation_resolved_at: 'Yopilgan',
    adminLead_escalation_no_manager_reply_yet: 'Menejer hali javob yozmagan.',
    adminLead_escalation_open_hint: 'Ochiq murojaatlar soni',
    adminLead_escalation_pending_banner:
      'Diqqat: ochiq yoki jarayondagi murojaat bor. Yangi xabar yozishdan oldin pastdagi tarixni va menejer javobini tekshiring.',
    adminLead_escalation_prior_title: 'Oldingi murojaatlar',
    adminLead_status_new: 'Yangi',
    adminLead_status_contacted: 'Aloqa qilindi',
    adminLead_status_qualified: 'Kvalifikatsiyadan o\'tdi',
    adminLead_status_assigned: 'Tayinlangan',
    adminLead_status_converted: 'Buyurtmaga aylandi',
    adminLead_status_cancelled: 'Bekor qilindi',
    adminLead_source_site: 'Sayt',
    adminLead_source_phone: 'Telefon',
    adminLead_source_telegram: 'Telegram',
    adminLead_source_referral: 'Tavsiya',
    adminLead_source_other: 'Boshqa',
    adminLead_priority_low: 'Past',
    adminLead_priority_normal: 'O\'rta',
    adminLead_priority_high: 'Yuqori',
    adminOrder_status_new: 'Yangi',
    adminOrder_status_contacted: 'Aloqa qilindi',
    adminOrder_status_negotiation: 'Kelishuv',
    adminOrder_status_confirmed: 'Tasdiqlandi',
    adminOrder_status_in_delivery: 'Yetkazilmoqda',
    adminOrder_status_completed: 'Bajarildi',
    adminOrder_status_cancelled: 'Bekor qilindi',
    adminNotif_subtitle: 'Tizim va biznes bildirishnomalari. Buyurtmalar, hisobotlar va tizim xabarlari.',
    adminNotif_subtitle_vm: 'Viloyatingiz bo\'yicha bildirishnomalar. Buyurtmalar va hisobotlar.',
    adminNotif_subtitle_disp: 'Sizga tayinlangan sotuvlar va buyurtmalar bo\'yicha bildirishnomalar.',
    adminNotif_subtitle_mijoz: 'Chat va tizim bildirishnomalari. Qo‘llab-quvvatlash javoblari shu yerda ham ko‘rinadi.',
    adminNotif_unread: 'o\'qilmagan',
    adminNotif_total: 'jami',
    adminNotif_empty: 'Bildirishnomalar yo\'q.',
    notif_order_new_title: 'Yangi buyurtma',
    notif_order_new_body: 'Yangi buyurtma qabul qilindi. Tekshirish va menejerga yo\'naltirish talab qilinadi.',
    notif_order_status_title: 'Buyurtma statusi o\'zgardi',
    notif_order_status_body: 'Buyurtma yetkazib berish bosqichiga o\'tdi. Mijoz bilan aloqani davom ettiring.',
    notif_lead_escalation_title: 'Dispecherdan mijoz murojaati',
    notif_lead_escalation_body: 'Yangi murojaat xabari. «Murojaatlar» bo\'limida statusni yangilang.',
    notif_lead_assigned_title: 'Lead menejerga yo\'naltirildi',
    notif_lead_assigned_body: 'Yangi lead mas\'ul menejerga tayinlandi. 24 soat ichida aloqa qiling.',
    notif_report_title: 'Hisobot tayyor',
    notif_report_body: 'Oylik hisobot yuklab olish uchun tayyor. Batafsil ko\'rish uchun Hisobotlar bo\'limiga o\'ting.',
    notif_system_title: 'Tizim xabari',
    notif_system_body: 'Kundalik backup muvaffaqiyatli yakunlandi. Ma\'lumotlar xavfsiz saqlandi.',
    notif_reminder_title: 'Eslatma: reyting hisoboti',
    notif_reminder_body: 'Haftalik menejerlar va dispecherlar reytingi tayyor. Reyting bo\'limini ko\'rib chiqing.',
    notif_alert_title: 'Buyurtma bekor qilindi',
    notif_alert_body: 'Mijoz buyurtmani bekor qildi. Sababni aniqlash va hisobotga kiritish tavsiya etiladi.',
    notif_order_completed_title: 'Buyurtma topshirildi',
    notif_order_completed_body: 'Buyurtma muvaffaqiyatli yetkazib berildi va mijoz tomonidan qabul qilindi.',
    adminReports_subtitle: 'Sotuv, buyurtmalar, menejerlar va dispecherlar bo\'yicha hisobot shablonlari va yuklab olish tarixi.',
    adminReports_subtitle_vm: 'Viloyatingiz bo\'yicha hisobot shablonlari: sotuv, buyurtmalar, dispecherlar va KPI.',
    adminReports_subtitle_bm: 'Barcha viloyatlar bo\'yicha yig\'ma hisobotlar: savdo, buyurtmalar, menejerlar va dispecherlar.',
    adminReports_subtitle_mijoz: 'Savdo, marja, filial va mahsulotlar bo‘yicha tahliliy hisobot — tanlangan davr uchun.',
    adminReports_templates_title: 'Hisobot shablonlari',
    adminReports_templates_count: 'Shablonlar',
    adminReports_last: 'Oxirgi yuklab olish',
    adminReports_period: 'Davr',
    adminReports_last_generated: 'Oxirgi yaratilgan',
    adminReports_status_ready: 'Tayyor',
    adminReports_status_generating: 'Yaratilmoqda',
    adminReports_status_failed: 'Xato',
    adminReports_history_title: 'So\'nggi hisobotlar',
    adminReports_history_report: 'Hisobot',
    adminReports_history_period: 'Davr',
    adminReports_history_format: 'Format',
    adminReports_history_generated: 'Yaratilgan',
    adminReports_history_by: 'Kim tomonidan',
    adminReports_history_size: 'Hajm',
    adminReports_em_dash: '—',
    adminReports_region_unknown: 'Viloyat (profildan aniqlanmadi)',
    adminReports_vm_region_label: 'Sizning viloyatingiz:',
    adminReports_summary_vm_scope: 'Barcha shablonlar va tarix faqat sizning viloyatingiz bo\'yicha filtrlangan. Ma\'lumotlar backend bilan avtomatik yangilanadi.',
    report_vm_period_last_month: 'o\'tgan oy',
    report_vm_period_last_week: 'o\'tgan hafta',
    report_vm_period_current_month: 'joriy oy',
    report_vm_period_active_tenants: 'faol mijozlar',
    report_vm_period_last_30_days: 'oxirgi 30 kun',
    adminReports_period_today: 'Bugun',
    adminReports_period_week: 'Hafta',
    adminReports_period_month: 'Oy',
    adminRating_period_label: 'Davr',
    adminReports_period_custom: 'Maxsus davr',
    adminReports_mijoz_snapshot_hint: 'Tanlangan davr va filial bo‘yicha savdo, marja va mahsulotlar — ma’lumotlar server bilan mos filtrlangan.',
    adminReports_branch_unassigned: 'Filial aniqlanmagan',
    adminReports_payment_terminal: 'Terminal / o‘tkazma',
    adminReports_filter_all_branches: 'Barcha filiallar',
    adminReports_download_excel: 'Excel (XLSX)',
    adminReports_download_pdf: 'PDF',
    adminReports_download_csv: 'CSV',
    adminReports_download_unavailable: 'Bu format uchun yuklab olish mavjud emas',
    adminReports_download_pdf_only: 'Bu shablon hozircha faqat PDF — Excel tez orada qo‘shiladi',
    adminReports_mijoz_download_csv: 'Hisobotni CSV yuklab olish (Excelda ochiladi)',
    adminReports_mijoz_download_xlsx: 'Hisobotni Excel (XLSX) yuklab olish',
    adminReports_mijoz_xlsx_title: 'Tahliliy hisobot',
    adminReports_filter_period_aria: 'Hisobot davri',
    adminReports_filter_branch_aria: 'Filial bo‘yicha filtr',
    adminReports_filter_date_from: 'Boshlanish sanasi',
    adminReports_filter_date_to: 'Tugash sanasi',
    adminReports_product_subtitle: 'O‘lchov / variant',
    adminReports_total_sales: 'Umumiy savdo',
    adminReports_net_profit: 'Jami sof foyda',
    adminReports_net_profit_hint: 'Xarajatlar hisobga olinmagan',
    adminReports_net_profit_hint_nasiya: 'Nasiya savdosi marjasi',
    adminReports_net_profit_hint_all: 'Barcha to\'lov turlari bo\'yicha marja',
    adminReports_nasiya_total: 'Nasiya savdo',
    adminReports_nasiya_covered: 'Qoplangan',
    adminReports_items_sold: 'Qancha tovar sotilgani',
    adminReports_branch_cashiers: 'Kassirlar',
    adminReports_sales_amount: 'Savdo hajmi',
    adminReports_by_payment: 'To\'lov turlari bo\'yicha',
    report_sales_monthly_name: 'Oylik sotuv hisoboti',
    report_sales_monthly_desc: 'Viloyat va kategoriya bo\'yicha sotuvlar, daromad va o\'sish.',
    report_sales_monthly_region_desc: 'Sizning viloyatingiz bo\'yicha oylik sotuvlar, daromad va o\'sish.',
    report_orders_region_name: 'Buyurtmalar viloyat bo\'yicha',
    report_orders_region_desc: 'Viloyatlar bo\'yicha buyurtmalar soni, summa va status taqsimoti.',
    report_orders_region_vm_desc: 'Viloyat bo\'yicha buyurtmalar soni, summa va status taqsimoti.',
    report_managers_name: 'Menejerlar ish samaradorligi',
    report_managers_desc: 'Menejerlar reytingi, buyurtmalar va mijozlar qoniqishi ko\'rsatkichlari.',
    report_dispatchers_name: 'Dispecherlar ish samaradorligi',
    report_dispatchers_desc: 'Dispecherlar reytingi, javob vaqti va bajarilgan buyurtmalar.',
    report_dispatchers_region_desc: 'Viloyatdagi dispecherlar reytingi, javob vaqti va bajarilgan buyurtmalar.',
    report_revenue_name: 'Daromad xulosasi',
    report_revenue_desc: 'Oylik daromad, xarajatlar va foyda bo\'yicha qisqacha hisobot.',
    report_revenue_region_desc: 'Viloyat bo\'yicha oylik daromad va qisqacha hisobot.',
    report_kpi_name: 'KPI dashboard',
    report_kpi_desc: 'Asosiy KPI ko\'rsatkichlari: buyurtmalar, daromad, konversiya va boshqalar.',
    report_kpi_region_desc: 'Viloyat bo\'yicha KPI: buyurtmalar, daromad, konversiya.',
    report_leads_region_name: 'Leadlar (viloyat)',
    report_leads_region_desc: 'Viloyat bo\'yicha leadlar: manba, status, dispecher.',
    report_tenants_dir_name: 'Mijozlar reyestri',
    report_tenants_dir_desc: 'Viloyat tenantlari: kompaniya, kontakt, holat.',
    report_orders_detail_vm_name: 'Buyurtmalar batafsil',
    report_orders_detail_vm_desc: 'Viloyat buyurtmalari: mijoz, dispecher, summa, holat.',
    adminRating_subtitle: 'Menejerlar bo\'yicha ish natijalari va mijozlar qoniqishi reytingi. Ball, buyurtmalar va o\'zgarish trendi.',
    adminRating_summary_title: 'Qisqacha ko\'rsatkichlar',
    adminRating_best_score: 'Eng yaxshi ball',
    adminRating_average_score: 'O\'rtacha ball',
    adminRating_total_evaluated: 'Baholanganlar',
    adminRating_managers: 'menejer',
    adminRating_top_region: 'Yetakchi viloyat',
    adminRating_out_of: '100 balldan',
    adminRating_table_title: 'Menejerlar reytingi',
    adminRating_rank: 'O\'rin',
    adminRating_name: 'Menejer',
    adminRating_region: 'Viloyat',
    adminRating_score: 'Ball',
    adminRating_orders: 'Buyurtmalar',
    adminRating_satisfaction: 'Qoniqish',
    adminRating_change: 'O\'zgarish',
    adminRating_trend_up: 'O\'sish',
    adminRating_trend_down: 'Tushish',
    adminRating_trend_neutral: 'O\'zgarmadi',
    adminRating_footer: 'Reyting statik namuna. Haqiqiy balllar va hisobotlar backend ulanganida yangilanadi.',
    adminRatingTenants_subtitle: 'Mijozlarning savdo hajmi bo\'yicha reyting',
    adminRatingTenants_summary_title: 'Umumiy statistika',
    adminRatingTenants_total_sales: 'Jami savdo hajmi',
    adminRatingTenants_average_sales: 'O\'rtacha savdo hajmi',
    adminRatingTenants_total_tenants: 'Jami mijozlar',
    adminRatingTenants_companies: 'kompaniya',
    adminRatingTenants_top_region: 'Eng yaxshi viloyat',
    adminRatingTenants_top_tenant: 'Eng yaxshi mijoz',
    adminRatingTenants_table_title: 'Mijozlar reytingi',
    adminRatingTenants_rank: 'O\'rin',
    adminRatingTenants_company: 'Kompaniya',
    adminRatingTenants_region: 'Viloyat',
    adminRatingTenants_district: 'Tuman',
    adminRatingTenants_sales_volume: 'Savdo hajmi',
    adminRatingTenants_orders_count: 'Buyurtmalar soni',
    adminRatingTenants_avg_order: 'O\'rtacha buyurtma',
    adminRatingTenants_growth: 'O\'sish',
    adminRatingTenants_footer: 'Reyting savdo hajmi bo\'yicha hisoblanadi',
    adminRatingDisp_subtitle: 'Dispecherlar bo\'yicha lead va buyurtma ishlashi, javob vaqti va mijozlar qoniqishi reytingi.',
    adminRatingDisp_summary_title: 'Qisqacha ko\'rsatkichlar',
    adminRatingDisp_best_score: 'Eng yaxshi ball',
    adminRatingDisp_average_score: 'O\'rtacha ball',
    adminRatingDisp_total_evaluated: 'Baholanganlar',
    adminRatingDisp_dispatchers: 'dispecher',
    adminRatingDisp_top_zone: 'Yetakchi zona',
    adminRatingDisp_out_of: '100 balldan',
    adminRatingDisp_table_title: 'Dispecherlar reytingi',
    adminRatingDisp_rank: 'O\'rin',
    adminRatingDisp_name: 'Dispecher',
    adminRatingDisp_zone: 'Zona',
    adminRatingDisp_manager: 'Menejer',
    adminRatingDisp_score: 'Ball',
    adminRatingDisp_orders: 'Buyurtmalar (oy)',
    adminRatingDisp_response: 'Javob vaqti',
    adminRatingDisp_satisfaction: 'Qoniqish',
    adminRatingDisp_change: 'O\'zgarish',
    adminRatingDisp_min: 'daq',
    adminRatingDisp_trend_up: 'O\'sish',
    adminRatingDisp_trend_down: 'Tushish',
    adminRatingDisp_trend_neutral: 'O\'zgarmadi',
    adminRatingDisp_footer: 'Dispecherlar reytingi statik namuna. Haqiqiy ko\'rsatkichlar backend ulanganida yangilanadi.',
    adminFinance_subtitle: 'Daromad, xarajat, kassa va bank balansi, to\'lov turlari va so\'nggi tranzaksiyalar. Barcha ma\'lumotlar statik namuna.',
    adminFinance_overview_title: 'Umumiy ko\'rsatkichlar',
    adminFinance_revenue: 'Oylik daromad',
    adminFinance_expenses: 'Oylik xarajat',
    adminFinance_profit: 'Sof foyda',
    adminFinance_cash: 'Kassa balansi',
    adminFinance_bank: 'Bank balansi',
    adminFinance_vs_prev: 'o\'tgan oyga nisbatan',
    adminFinance_payment_title: 'To\'lov turlari bo\'yicha',
    adminFinance_payment_cash: 'Naqd',
    adminFinance_payment_card: 'Karta',
    adminFinance_payment_transfer: 'O\'tkazma',
    adminFinance_transactions_title: 'So\'nggi tranzaksiyalar',
    adminFinance_date: 'Sana',
    adminFinance_type: 'Turi',
    adminFinance_counterparty: 'Kontragent',
    adminFinance_amount: 'Summa',
    adminFinance_payment_type: 'To\'lov turi',
    adminFinance_description: 'Izoh',
    adminFinance_income: 'Kirim',
    adminFinance_expense: 'Chiqim',
    adminFinance_footer: 'Moliya ma\'lumotlari statik namuna. 1C integratsiyasi va eksport backend ulanganida ishlaydi.',
    adminTrans_subtitle: 'Barcha kirim va chiqim tranzaksiyalar, filtrlash va qisqa hisobot. Ma\'lumotlar statik namuna.',
    adminTrans_subtitle_live: 'Barcha kirim va chiqim tranzaksiyalar, filtrlash va qisqa hisobot. Ma\'lumotlar serverdan.',
    adminTrans_filter_all: 'Barcha',
    adminTrans_income: 'Kirim',
    adminTrans_expense: 'Chiqim',
    adminTrans_status_all: 'Barcha holat',
    adminTrans_status_completed: 'Bajarilgan',
    adminTrans_status_pending: 'Kutilmoqda',
    adminTrans_status_failed: 'Muvaffaqiyatsiz',
    adminTrans_summary_title: 'Qisqa hisobot',
    adminTrans_total_income: 'Jami kirim',
    adminTrans_total_expense: 'Jami chiqim',
    adminTrans_count: 'Tranzaksiyalar soni',
    adminTrans_transactions: 'ta tranzaksiya',
    adminTrans_shown: 'ta ko\'rsatilmoqda',
    adminTrans_group_legacy: 'Avvalgi savdolar',
    adminTrans_group_today: 'Bugun',
    adminTrans_filter_all_branches: 'Barcha filiallar',
    adminTrans_filter_all_cashiers: 'Barcha kassirlar',
    adminTrans_number: '№',
    adminTrans_date: 'Sana',
    adminTrans_date_from: 'Boshlanish sanasi',
    adminTrans_date_to: 'Tugash sanasi',
    adminTrans_total: 'Jami',
    adminTrans_type: 'Turi',
    adminTrans_counterparty: 'Kontragent',
    adminTrans_amount: 'Summa',
    adminTrans_payment: 'To\'lov turi',
    adminTrans_view_receipt: 'Kvitansiyani ko‘rish',
    adminTrans_receipt_title: 'Faktura',
    adminTrans_receipt_branch: 'Filial nomi',
    adminTrans_receipt_datetime: 'Sana va vaqt',
    adminTrans_receipt_cashier: 'Kassir ism-familiyasi',
    adminTrans_receipt_invoice_no: 'Faktura raqami',
    adminTrans_receipt_products: 'Tovarlar',
    adminTrans_receipt_qty: 'Miqdor',
    adminTrans_receipt_price: "Narx (so'm)",
    adminTrans_receipt_sum: "Summa (so'm)",
    adminTrans_receipt_items_count: 'Tovarlar soni',
    adminTrans_receipt_total_qty: 'Jami miqdor',
    adminTrans_receipt_discount: 'Chegirma',
    adminTrans_receipt_vat: 'QQS',
    adminTrans_receipt_grand_total: 'Jami summa',
    adminTrans_receipt_subtotal: 'Oraliq jami',
    adminTrans_receipt_client_number: 'Chakana mijoz raqami',
    adminTrans_receipt_print: 'Chop etish',
    adminTrans_receipt_telegram: 'Telegramga yuborish',
    adminTrans_receipt_telegram_sending: 'Yuborilmoqda…',
    adminTrans_receipt_telegram_hint: 'Faktura PDF ni mijozning Telegram botiga yuborish',
    adminTrans_receipt_telegram_not_linked: 'Mijoz hali chakana botiga telefon orqali ulanmagan',
    adminTrans_receipt_telegram_ok: 'Faktura PDF Telegram orqali yuborildi',
    adminTrans_receipt_telegram_failed: 'Telegram orqali yuborib bo‘lmadi',
    adminTrans_receipt_load_error: 'Kvitansiya yuklanmadi',
    adminTrans_receipt_unavailable: 'Kvitansiya mavjud emas',
    receiptBlock_retail_client: 'Chakana mijoz',
    receiptPreview_retail_client: 'Chakana mijoz',
    receiptSettings_text_placeholder_tin: 'Masalan: STIR 307123456',
    receiptSettings_text_placeholder_legal_name: 'Masalan: "OOO …" yuridik nomi',
    receiptSettings_text_placeholder_header_work_hours: 'Masalan: 09:00 — 21:00',
    receiptSettings_text_placeholder_contacts: 'Filial mas\'ul hodim raqami',
    adminTrans_invoice: 'Hisob-faktura',
    adminTrans_description: 'Izoh',
    adminTrans_status: 'Holat',
    adminTrans_payment_card: 'Karta',
    adminTrans_payment_cash: 'Naqd',
    adminTrans_payment_transfer: 'O\'tkazma',
    adminTrans_payment_click: 'Click',
    adminTrans_payment_nasiya: 'Nasiya',
    adminTrans_payment_refund: 'Vozvrat (qaytarish)',
    adminTrans_retail_client: 'Chakana mijoz',
    adminTrans_actions: 'Amal',
    adminTrans_refund_btn: 'Vozvrat',
    adminTrans_refund_modal_title: 'Tovarlarni vozvrat qilish',
    adminTrans_refund_modal_lead: 'Har bir qatordan qaytariladigan miqdorni kiriting (butun son).',
    adminTrans_refund_max: 'Maks.',
    adminTrans_refund_qty: 'Miqdor',
    adminTrans_refund_ok: 'Vozvrat muvaffaqiyatli bajarildi.',
    adminTrans_refund_qty_required: 'Kamida bitta qatordan miqdor kiriting.',
    adminTrans_refund_from_order: 'Asosiy savdo',
    adminTrans_refund_confirm: 'Vozvrat qilish',
    adminTrans_search_placeholder: 'Mahsulot, barcode, chakana mijoz (ism, telefon), narx…',
    adminStat_refund_lines_title: 'Batafsil: chek, vaqt, tovar, miqdor, summa',
    adminTrans_product_name: 'Mahsulot nomi',
    adminTrans_barcode: 'Barcode',
    adminTrans_empty: 'Tanlangan filtrlarga mos tranzaksiya topilmadi.',
    adminTrans_footer: 'Tranzaksiyalar statik namuna. Backend va 1C ulanganida haqiqiy ma\'lumotlar ko\'rsatiladi.',
    adminTrans_footer_live:
      'Ma\'lumotlar backenddan keladi. Filial bo\'yicha to\'lov nomlari mijoz sozlamalaridagi operatsion parametrlarga moslanadi.',
    adminInv_subtitle: 'Barcha hisob-fakturalar, to\'lov holati, muddat va QQS. Ma\'lumotlar aniq va batafsil, statik namuna.',
    adminInv_filter_all: 'Barcha',
    adminInv_status_paid: 'To\'langan',
    adminInv_status_partial: 'Qisman to\'langan',
    adminInv_status_overdue: 'Muddat o\'tgan',
    adminInv_status_draft: 'Qoralama',
    adminInv_summary_title: 'Qisqa hisobot',
    adminInv_total_invoiced: 'Jami hisob-faktura',
    adminInv_total_paid: 'Jami to\'langan',
    adminInv_total_outstanding: 'Qoldiq (to\'lanmagan)',
    adminInv_count: 'Hisob-fakturalar soni',
    adminInv_invoices: 'ta',
    adminInv_shown: 'ta ko\'rsatilmoqda',
    adminInv_number: '№',
    adminInv_date: 'Sana',
    adminInv_due_date: 'Muddat',
    adminInv_client: 'Mijoz',
    adminInv_amount: 'Summa (QQS siz)',
    adminInv_vat: 'QQS',
    adminInv_total: 'Jami',
    adminInv_paid: 'To\'langan',
    adminInv_status: 'Holat',
    adminInv_description: 'Izoh',
    adminInv_empty: 'Tanlangan filtrga mos hisob-faktura topilmadi.',
    adminInv_footer: 'Hisob-fakturalar statik namuna. 1C va backend ulanganida haqiqiy hujjatlar ko\'rsatiladi.',
    adminTax_subtitle: 'Soliq majburiyatlari, muddatlar, to\'lov holati va deklaratsiyalar. Ma\'lumotlar aniq va batafsil, statik namuna.',
    adminTax_filter_all: 'Barcha',
    adminTax_type_vat: 'QQS',
    adminTax_type_income: 'Daromad solig\'i',
    adminTax_type_simplified: 'Soddalashtirilgan',
    adminTax_type_property: 'Mulk solig\'i',
    adminTax_type_land: 'Yer solig\'i',
    adminTax_type_transport: 'Transport',
    adminTax_type_other: 'Boshqa',
    adminTax_status_all: 'Barcha holat',
    adminTax_status_paid: 'To\'langan',
    adminTax_status_pending: 'Kutilmoqda',
    adminTax_status_overdue: 'Muddat o\'tgan',
    adminTax_summary_title: 'Qisqa hisobot',
    adminTax_total_due: 'Jami majburiyat',
    adminTax_total_paid: 'Jami to\'langan',
    adminTax_total_outstanding: 'Qoldiq (to\'lanmagan)',
    adminTax_next_due: 'Keyingi muddat',
    adminTax_shown: 'ta ko\'rsatilmoqda',
    adminTax_code: 'Kod',
    adminTax_type: 'Soliq turi',
    adminTax_period: 'Davr',
    adminTax_due_date: 'To\'lov muddati',
    adminTax_amount: 'Summa',
    adminTax_paid: 'To\'langan',
    adminTax_status: 'Holat',
    adminTax_description: 'Izoh',
    adminTax_period_monthly: 'oylik',
    adminTax_period_quarterly: 'choraklik',
    adminTax_period_annual: 'yillik',
    adminTax_empty: 'Tanlangan filtrga mos yozuv topilmadi.',
    adminTax_footer: 'Soliq ma\'lumotlari statik namuna. 1C va soliq tizimi ulanganida haqiqiy deklaratsiyalar ko\'rsatiladi.',
    admin1c_subtitle: '1C: Buxgalteriya va Korxona bilan ulanish, sinxronlash va sozlamalar. Ma\'lumotlar aniq va batafsil, statik namuna.',
    admin1c_connection_connected: 'Ulangan',
    admin1c_connection_disconnected: 'Ulanmagan',
    admin1c_connection_title: 'Ulanish',
    admin1c_base_url: 'Baza manzili',
    admin1c_version: '1C versiyasi',
    admin1c_database: 'Baza nomi',
    admin1c_last_checked: 'Oxirgi tekshiruv',
    admin1c_entities_title: 'Sinxronlash ob\'ektlari',
    admin1c_entity_products: 'Mahsulotlar',
    admin1c_entity_invoices: 'Hisob-fakturalar',
    admin1c_entity_transactions: 'Tranzaksiyalar',
    admin1c_entity_contacts: 'Kontaktlar',
    admin1c_entity_stock: 'Ombordagi qoldiq',
    admin1c_entity_prices: 'Narxlar',
    admin1c_records: 'yozuv',
    admin1c_entity_status_synced: 'Sinxron',
    admin1c_entity_status_pending: 'Kutilmoqda',
    admin1c_entity_status_error: 'Xato',
    admin1c_sync_log_title: 'Sinxronlash tarixi',
    admin1c_date: 'Sana',
    admin1c_direction: 'Yo\'nalish',
    admin1c_entity: 'Ob\'ekt',
    admin1c_status: 'Holat',
    admin1c_message: 'Xabar',
    admin1c_direction_import: 'Import',
    admin1c_direction_export: 'Eksport',
    admin1c_direction_both: 'Ikki tomonlama',
    admin1c_sync_status_success: 'Muvaffaqiyatli',
    admin1c_sync_status_partial: 'Qisman',
    admin1c_sync_status_failed: 'Xato',
    admin1c_settings_title: 'Sozlamalar',
    admin1c_sync_interval: 'Sinxronlash oraliği',
    admin1c_auth_type: 'Autentifikatsiya',
    admin1c_export_format: 'Eksport formati',
    admin1c_auto_sync: 'Avto sinxronlash',
    admin1c_yes: 'Ha',
    admin1c_no: 'Yo\'q',
    admin1c_footer: '1C integratsiya ma\'lumotlari statik namuna. Haqiqiy ulanish backend va 1C sozlanganda ishlaydi.',
    adminPL_subtitle: 'Daromad, xarajatlar, yalpi va sof foyda — batafsil P&L hisobot. Ma\'lumotlar statik namuna.',
    adminPL_summary_title: 'Qisqa ko\'rsatkichlar',
    adminPL_total_revenue: 'Jami daromad',
    adminPL_gross_profit: 'Yalpi foyda',
    adminPL_margin: 'marja',
    adminPL_operating_profit: 'Operatsion foyda',
    adminPL_net_profit: 'Sof foyda',
    adminPL_net_margin: 'sof foyda marjasi',
    adminPL_detail_title: 'Foyda va zarar tarkibi',
    adminPL_block_revenue: 'Daromad',
    adminPL_block_cogs: 'Sotilgan tovarlar tannarxi',
    adminPL_block_operating: 'Operatsion xarajatlar',
    adminPL_block_other: 'Boshqa daromad va xarajatlar',
    adminPL_revenue_sales: 'Sotuvdan daromad',
    adminPL_revenue_services: 'Xizmatlar',
    adminPL_revenue_orders: 'Buyurtmalar daromadi',
    adminPL_revenue_invoices: 'Hisob-fakturalar daromadi',
    adminPL_revenue_other: 'Boshqa daromad',
    adminPL_revenue_total: 'Jami daromad',
    adminPL_cogs_goods: 'Tovarlar tannarxi',
    adminPL_cogs_delivery: 'Yetkazib berish',
    adminPL_cogs_total: 'Jami tannarx',
    adminPL_op_salary: 'Ish haqi',
    adminPL_op_rent: 'Ijara',
    adminPL_op_utilities: 'Kommunal',
    adminPL_op_marketing: 'Marketing',
    adminPL_op_depreciation: 'Amortizatsiya',
    adminPL_op_operating: 'Operatsion xarajatlar',
    adminPL_op_other: 'Boshqa xarajatlar',
    adminPL_op_total: 'Jami operatsion',
    adminPL_other_interest_income: 'Foiz daromadi',
    adminPL_other_interest_expense: 'Foiz xarajati',
    adminPL_other_currency: 'Valyuta farqi',
    adminPL_other_taxes: 'Soliqlar',
    adminPL_other_invoices_expenses: 'Hisob-faktura xarajatlari',
    adminPL_other_net: 'Boshqa (netto)',
    adminPL_footer: 'Foyda va zarar ma\'lumotlari statik namuna. 1C va buxgalteriya ulanganida haqiqiy hisobot ko\'rsatiladi.',
    adminBS_subtitle: 'Aktiv, passiv va kapital — balans hisoboti. Ma\'lumotlar aniq va batafsil, statik namuna.',
    adminBS_summary_title: 'Qisqa ko\'rsatkichlar',
    adminBS_total_assets: 'Jami aktiv',
    adminBS_total_liabilities: 'Jami majburiyat',
    adminBS_total_equity: 'Jami kapital',
    adminBS_balance_check: 'Balans tekshiruvi (Passiv + Kapital = Aktiv)',
    adminBS_detail_title: 'Balans tarkibi',
    adminBS_assets: 'Aktiv',
    adminBS_liabilities_equity: 'Passiv va kapital',
    adminBS_assets_current: 'Joriy aktivlar',
    adminBS_assets_noncurrent: 'Uzoq muddatli aktivlar',
    adminBS_liab_current: 'Qisqa muddatli majburiyatlar',
    adminBS_liab_longterm: 'Uzoq muddatli majburiyatlar',
    adminBS_equity: 'Kapital',
    adminBS_total_liab_equity: 'Jami passiv va kapital',
    adminBS_cash: 'Kassa',
    adminBS_bank: 'Bank',
    adminBS_receivables: 'Debitorlik qarzdorlik',
    adminBS_inventory: 'Tovar-materiallar',
    adminBS_prepaid: 'Oldindan to\'langan',
    adminBS_current_total: 'Jami joriy aktivlar',
    adminBS_fixed_assets: 'Asosiy vositalar',
    adminBS_intangible: 'Nomoddiy aktivlar',
    adminBS_investments: 'Investitsiyalar',
    adminBS_noncurrent_total: 'Jami uzoq muddatli',
    adminBS_payables: 'Kreditorlik qarz',
    adminBS_short_term_debt: 'Qisqa muddatli qarz',
    adminBS_tax_payable: 'Soliq majburiyati',
    adminBS_other_current: 'Boshqa qisqa muddatli',
    adminBS_current_liab_total: 'Jami qisqa muddatli',
    adminBS_long_term_loans: 'Uzoq muddatli kreditlar',
    adminBS_long_term_total: 'Jami uzoq muddatli',
    adminBS_share_capital: 'Ustav kapitali',
    adminBS_retained_earnings: 'Taqsimlanmagan foyda',
    adminBS_current_year_profit: 'Joriy yil foydasi',
    adminBS_equity_total: 'Jami kapital',
    adminBS_footer: 'Balans ma\'lumotlari statik namuna. 1C va buxgalteriya ulanganida haqiqiy balans ko\'rsatiladi.',
    adminExport_subtitle: 'Hisobotlarni Excel, CSV va PDF da eksport qilish. Turlar, formatlar va so\'nggi eksportlar — statik namuna.',
    adminExport_report_types_title: 'Hisobot turlari',
    adminExport_type_transactions: 'Tranzaksiyalar',
    adminExport_type_invoices: 'Hisob-fakturalar',
    adminExport_type_taxes: 'Soliqlar',
    adminExport_type_profit_loss: 'Foyda va zarar',
    adminExport_type_balance_sheet: 'Balans',
    adminExport_formats: 'format',
    adminExport_transactions_desc: 'Barcha kirim va chiqim tranzaksiyalar, filtrlash bo\'yicha eksport.',
    adminExport_invoices_desc: 'Hisob-fakturalar ro\'yxati, to\'lov holati va muddatlar.',
    adminExport_taxes_desc: 'Soliq majburiyatlari va to\'lovlar ro\'yxati.',
    adminExport_profit_loss_desc: 'P&L hisoboti — daromad, xarajat va foyda.',
    adminExport_balance_sheet_desc: 'Balans hisoboti — aktiv, passiv va kapital.',
    adminExport_max_rows: 'Maks. qatorlar',
    adminExport_history_title: 'Oxirgi eksportlar',
    adminExport_date: 'Sana',
    adminExport_report_type: 'Hisobot',
    adminExport_format: 'Format',
    adminExport_rows: 'Qatorlar',
    adminExport_status: 'Holat',
    adminExport_file: 'Fayl nomi',
    adminExport_format_xlsx: 'Excel (XLSX)',
    adminExport_format_csv: 'CSV',
    adminExport_format_pdf: 'PDF',
    adminExport_status_completed: 'Tugallangan',
    adminExport_status_failed: 'Xato',
    adminExport_settings_title: 'Sozlamalar',
    adminExport_default_format: 'Standart format',
    adminExport_max_rows_limit: 'Maks. qatorlar limiti',
    adminExport_date_range_default: 'Standart davr',
    adminExport_date_range_current_month: 'Joriy oy',
    adminExport_footer: 'Eksport ma\'lumotlari statik namuna. Haqiqiy eksport backend ulanganda ishlaydi.',
    adminHelp_subtitle: 'Aloqa ma\'lumotlari va qo\'llab-quvvatlash.',
    adminHelp_subtitle_kassir: 'Aloqa ma\'lumotlari va qo\'llab-quvvatlash.',
    adminHelp_subtitle_mijoz_chat: 'Qo\'llab-quvvatlash chati va aloqa.',
    adminHelp_subtitle_mijoz_chat_only: 'Savolingizni qo‘llab-quvvatlash chatida yuboring — menejer yoki platforma javob beradi.',
    adminHelp_mijoz_chat_title: 'Qo\'llab-quvvatlash chat',
    adminHelp_mijoz_chat_lead: 'Matn, rasm yoki video yuborishingiz mumkin. Viloyat menejeringiz yoki platforma javob beradi.',
    adminHelp_subtitle_tenant_owner_chat: 'Qo‘llab-quvvatlash chat orqali murojaat qiling.',
    adminHelp_tenant_owner_chat_title: 'Qo‘llab-quvvatlash chat',
    adminHelp_tenant_owner_chat_lead:
      'Savolingizni yozing yoki rasm, video, audio yuboring. Viloyat menejeringiz yoki platforma qo‘llab-quvvatlashi javob beradi.',
    adminHelp_quick_start_title: 'Tez yo\'riqnoma',
    adminHelp_step_1: 'Sidebar orqali kerakli bo\'limni tanlang (Statistika, Moliya, Sozlamalar va boshqalar).',
    adminHelp_step_2: 'Hisobotlar va jadvalarda filtrlardan foydalaning — ma\'lumotlarni tez topish uchun.',
    adminHelp_step_3: 'Eksport bo\'limida hisobotlarni Excel, CSV yoki PDF da yuklab oling.',
    adminHelp_step_4: 'Savol yoki muammo bo\'lsa — quyidagi aloqa ma\'lumotlari orqali qo\'llab-quvvatlashga murojaat qiling.',
    adminHelp_kassir_step_1: 'Kassada faqat tanlangan tovarlar bilan ishlang, keraklisini tez qo\'shing.',
    adminHelp_kassir_step_2: 'To\'lov turini to\'g\'ri tanlang va summani mijoz bilan tekshirib tasdiqlang.',
    adminHelp_kassir_step_3: 'Printer ulanishini tekshiring, muammo bo\'lsa Printerlarni ulash bo\'limidan test qiling.',
    adminHelp_kassir_step_4: 'Smena oxirida tranzaksiya va qoldiqni taqqoslab keyin yoping.',
    adminHelp_faq_title: 'Tez-tez beriladigan savollar',
    adminHelp_faq_1_q: 'Parolni qanday o\'zgartirish mumkin?',
    adminHelp_faq_1_a: 'Profil yoki Sozlamalar bo\'limida «Parolni o\'zgartirish» tugmasini bosing. Yangi parol kamida 8 belgidan iborat bo\'lishi, raqam va bosh harfni o\'z ichiga olishi kerak.',
    adminHelp_faq_2_q: 'Rolimga qanday bo\'limlar ochiq?',
    adminHelp_faq_2_a: 'Har bir rol uchun sidebar da faqat ruxsat etilgan bo\'limlar ko\'rinadi. Ega (loyiha egasi) platforma boshqaruvi, tariflar, mijozlar va operatsiya bo\'limlarini ko\'radi; bildirishnomalar yuqori paneldagi qo\'ng\'iroqcha orqali; hisob-fakturalar va maxsus nazorat bo\'limlari asosan buxgalter uchun; mijoz va kassir — o\'zlariga tegishli bo\'limlar.',
    adminHelp_faq_3_q: 'Ma\'lumotlar haqiqiy yoki namuna?',
    adminHelp_faq_3_a: 'Hozircha barcha hisobotlar, tranzaksiyalar, soliqlar va boshqa ma\'lumotlar statik namuna. Backend va 1C ulanganidan keyin haqiqiy ma\'lumotlar ko\'rsatiladi.',
    adminHelp_faq_4_q: 'Eksport qilish qachon ishlaydi?',
    adminHelp_faq_4_a: 'Eksport bo\'limida hisobot turlari va formatlar (Excel, CSV, PDF) ko\'rsatiladi. Faylni yuklab olish backend ulanganda aktiv bo\'ladi.',
    adminHelp_kassir_faq_1_q: 'Printer ishlamay qolsa nima qilaman?',
    adminHelp_kassir_faq_1_a: 'Printerlarni ulash bo\'limiga kiring, ilovani qayta ishga tushiring va test chop etishni sinang.',
    adminHelp_kassir_faq_2_q: 'Nega kassada barcha tovarlar chiqmayapti?',
    adminHelp_kassir_faq_2_a: 'Kassada faqat omborda yulduzcha bilan tanlangan tovarlar ko\'rsatiladi.',
    adminHelp_kassir_faq_3_q: 'Aralash to\'lov summasi mos kelmasa nima bo\'ladi?',
    adminHelp_kassir_faq_3_a: 'Tizim tasdiqlashga ruxsat bermaydi. Summalarni jami qiymatga tenglashtiring.',
    adminHelp_kassir_faq_4_q: 'Muddati tugayotgan tovarlarni qayerdan ko\'raman?',
    adminHelp_kassir_faq_4_a: 'Ombor jadvalida amal qilish muddati rangli ko\'rinadi: yashil, sariq, qizil.',
    adminHelp_faq_5_q: '2FA (ikki bosqichli autentifikatsiya) bormi?',
    adminHelp_faq_5_a: 'Ha. Sozlamalar → Xavfsizlik bo\'limida 2FA yoqish tavsiya etiladi, ayniqsa administratorlar uchun.',
    adminHelp_faq_6_q: 'Qanday qilib qo\'llab-quvvatlash bilan bog\'lanaman?',
    adminHelp_faq_6_a: 'Quyidagi Aloqa bo\'limida telefon ko\'rsatilgan. Odatda 24 soat ichida javob beriladi. Ish vaqti: dushanba–juma, 09:00–18:00.',
    adminHelp_contact_title: 'Aloqa',
    adminHelp_email: 'Email',
    adminHelp_phone: 'Telefon',
    adminHelp_hours: 'Ish vaqti',
    adminHelp_response_time: 'Javob muddati',
    adminHelp_contact_hours_val: '09:00 — 18:00 (dushanba — juma)',
    adminHelp_contact_response: '24 soat ichida',
    adminHelp_links_title: 'Foydali havolalar',
    adminHelp_link_dashboard: 'Statistika',
    adminHelp_link_dashboard_desc: 'Asosiy ko\'rsatkichlar va hisobotlar',
    adminHelp_link_finance: 'Moliya',
    adminHelp_link_finance_desc: 'Daromad, xarajat va tranzaksiyalar',
    adminHelp_link_settings: 'Sozlamalar',
    adminHelp_link_settings_desc: 'Tizim va bildirishnomalar',
    adminHelp_link_export: 'Eksport',
    adminHelp_link_export_desc: 'Hisobotlarni yuklab olish',
    adminHelp_footer: 'Yordam sahifasi statik ma\'lumotlar. Keyingi yangilanishlarda qo\'llanma va video qo\'shiladi.',
    adminPrinterConnect_subtitle: 'Chek chiqarish uchun printer ulash va mahalliy ilovani sozlash.',
    receiptSettings_title: 'Chek (kvitansiya) sozlamalari',
    receiptSettings_desc: 'Chop etiladigan chekda qaysi qatorlar ko‘rinishi va tartibini tanlang. O‘ng panelda bloklarni tortib tartiblang.',
    receiptSettings_preview: 'Oldindan ko‘rish',
    receiptSettings_blocks: 'Chek bloklari',
    receiptSettings_drag_hint: 'Bloklarni o‘ngdagi uch nuqta tutqichidan ushlab yuqoriga-pastga torting.',
    receiptSettings_drag_handle: 'Tortib tartiblash',
    receiptSettings_logo_title: 'Chek logotipi',
    receiptSettings_logo_upload: 'Logo yuklash',
    receiptSettings_logo_default: 'Default logo',
    receiptSettings_logo_invalid: 'Faqat rasm fayllarini yuklash mumkin.',
    receiptSettings_logo_too_large: 'Logo hajmi 2MB dan oshmasligi kerak.',
    receiptSettings_logo_failed: 'Logo yuklab bo‘lmadi. Qayta urinib ko‘ring.',
    receiptBlock_header_sale_number: 'Sotuv raqami',
    receiptBlock_header_store: 'Do‘kon / kompaniya nomi',
    receiptBlock_header_datetime: 'Sana va vaqt',
    receiptBlock_header_work_hours: 'Ish vaqti',
    receiptBlock_cashier: 'Kassir',
    receiptBlock_client: 'Mijoz',
    receiptBlock_contacts: 'Kontaktlar',
    receiptBlock_tin: 'STIR (INN)',
    receiptBlock_legal_name: 'Yuridik shaxs nomi',
    receiptBlock_address: 'Manzil',
    receiptBlock_client_phone: 'Mijoz telefon raqami',
    receiptBlock_sale_note: 'Sotuv eslatmasi / izoh',
    receiptBlock_line_items: 'Tovarlar ro‘yxati',
    receiptBlock_line_discounts: 'Tovar qatorlarida chegirma',
    receiptBlock_line_totals: 'Tovar qatorlarida summalar',
    receiptBlock_receipt_discounts: 'Kvitansiya bo‘yicha chegirma',
    receiptBlock_receipt_totals: 'Kvitansiya jami summalari',
    receiptBlock_product_count: 'Chekdagi mahsulotlar soni',
    receiptPreview_sale: 'Sotuv',
    receiptPreview_store_sample: 'Do‘kon: dilshod-market',
    receiptPreview_date: 'Sana',
    receiptPreview_work_hours: 'Ish vaqti',
    receiptPreview_cashier: 'Kassir',
    receiptPreview_client: 'Mijoz',
    receiptPreview_contacts: 'Kontaktlar',
    receiptPreview_tin: 'STIR',
    receiptPreview_legal: 'Yuridik nom',
    receiptPreview_address: 'Manzil',
    receiptPreview_client_phone: 'Mijoz raqami',
    receiptPreview_note: 'Eslatma',
    receiptPreview_item_name: 'Mahsulot / brend',
    receiptPreview_discount_line: 'Chegirma',
    receiptPreview_product_count: 'Mahsulotlar soni',
    receiptPreview_subtotal: 'Oraliq jami',
    receiptPreview_discount: 'Chegirma',
    receiptPreview_discount_pct: 'Chegirma %',
    receiptPreview_total: 'JAMI',
    receiptPreview_balance: 'Mijoz balansi',
    supportChat_placeholder: 'Xabar yozing…',
    supportChat_send: 'Yuborish',
    supportChat_attach_image: 'Rasm',
    supportChat_attach_video: 'Video',
    supportChat_remove_attach: 'Bekor qilish',
    supportChat_attach_too_large: 'Fayl juda katta (maks. ~12 MB).',
    supportChat_attach_error: 'Faylni o‘qib bo‘lmadi.',
    supportChat_empty_thread: 'Hozircha xabar yo‘q. Pastdan yozing yoki fayl yuboring.',
    supportChat_no_tenant: 'Kompaniya (tenant) aniqlanmadi — profilni tekshiring.',
    supportChat_label_mijoz: 'Mijoz',
    supportChat_label_vm: 'Viloyat menejer',
    supportChat_label_bm: 'Bosh menejer',
    supportChat_label_platform_owner: 'Platforma egasi',
    supportChat_label_staff: 'Qo‘llab-quvvatlash',
    supportChat_backend_note: 'Hozircha xabarlar brauzerda saqlanadi. Backend ulanganda real vaqt va bildirishnomalar qo‘shiladi.',
    supportChat_persist_failed: 'Xabarni saqlab bo‘lmadi (brauzer xotirasi yoki maxfiylik rejimi). Sahifani yangilab qayta urinib ko‘ring.',
    supportChat_thread_status: 'Chat ochiq — javob kutilmoqda',
    supportChat_sync_live: 'Jonli yangilanish yoqilgan',
    supportChat_sync_poll: 'Avto-yangilanish (taxminan har 5 soniya)',
    supportChat_err_realtime: 'Jonli ulanish vaqtincha ishlamayapti — xabarlar baribir saqlanadi va ro‘yxat yangilanadi.',
    supportChat_err_network: 'Serverga ulanishda muammo. Internetni tekshirib, qayta urinib ko‘ring.',
    supportChat_err_forbidden: 'Bu amal uchun ruxsat yo‘q yoki sessiya tugagan. Qayta kiring.',
    supportChat_err_unknown: 'Noma’lum xatolik. Qayta urinib ko‘ring.',
    supportChat_banner_close: 'Yopish',
    staffChat_subtitle: 'Bitta umumiy chat: ega va barcha menejerlar bir xil oqimda. Xabarlar serverda saqlanadi va barcha adminlar ko‘radi. Mijozlar chati alohida.',
    staffChat_thread_status: 'Umumiy ichki chat',
    staffChat_role_platform_owner: 'Platforma egasi',
    staffChat_role_general_manager: 'Bosh menejer',
    staffChat_role_regional_manager: 'Viloyat menejer',
    staffChat_role_dispatcher: 'Dispecher',
    staffChat_label_unknown: 'Ism aniqlanmagan',
    staffChat_empty_thread: 'Hozircha xabar yo‘q. Pastdan yozing yoki fayl biriktiring.',
    staffChat_loading: 'Xabarlar yuklanmoqda…',
    staffChat_sending: 'Yuborilmoqda…',
    staffChat_send_failed: 'Yuborib bo‘lmadi. Qayta urinib ko‘ring.',
    staffChat_edit: 'Tahrirlash',
    staffChat_delete: 'O‘chirish',
    staffChat_save_edit: 'Saqlash',
    staffChat_cancel_edit: 'Bekor qilish',
    staffChat_edited_label: 'tahrirlandi',
    staffChat_confirm_delete: 'Bu xabar o‘chirilsinmi? Boshqa foydalanuvchilar uni ko‘rmay qoladi.',
    staffChat_read_full: 'To‘liq matn',
    staffChat_expand_text: 'Ko‘proq',
    staffChat_collapse_text: 'Yig‘ish',
    staffChat_open_preview: 'Chatda kattalashtirish',
    staffChat_backend_note: 'Barcha foydalanuvchilar uchun xabarlar API orqali sinxronlanadi (polling). Real vaqt uchun WebSocket qo‘shish mumkin.',
    chat_reply: 'Javob',
    chat_replying_to: 'Javob berilmoqda',
    chat_reply_cancel: 'Bekor',
    supportChat_backend_note_api: 'Mijoz chatlari serverda saqlanadi; rasm/video avval fayl sifatida yuklanadi. Boshqa qurilmalarda ham xuddi shu thread ko‘rinadi.',
    supportChat_label_tenant_owner: 'Joy egasi',
    supportChat_attach_audio: 'Audio',
    supportChat_attach_file: 'Fayl',
    supportChat_file_open: 'Faylni ochish',
    supportChat_file_ready: 'Fayl yuborishga tayyor',
    supportChat_recipient_all: 'Barcha kassirlarga',
    supportChat_recipient_label: 'Qabul qiluvchi',
    cashierChat_subtitle_owner: 'Kassirlar bilan alohida yoki umumiy chat qiling.',
    cashierChat_subtitle_cashier: 'Joy egasi bilan shu bo‘limda yozishing.',
    cashierChat_missing_tenant: 'Tenant aniqlanmadi. Administratorga murojaat qiling.',
    tenantMessages_subtitle: 'Har bir mijoz bilan alohida chat. Oxirgi mijoz xabari sariq nuqta bilan belgilanadi.',
    tenantMessages_search: 'Kompaniya yoki telefon bo‘yicha qidirish',
    tenantMessages_no_messages: 'Xabar yo‘q',
    tenantMessages_preview_image: 'Rasm',
    tenantMessages_preview_video: 'Video',
    tenantMessages_needs_reply: 'Javob kutilmoqda',
    tenantMessages_pick_tenant: 'Chatni ochish uchun chapdan mijoz tanlang.',
    adminSettings_subtitle: 'Tizim parametrlari, bildirishnomalar, xavfsizlik va ma\'lumotlar boshqaruvi. Joriy qiymatlar statik ko\'rsatkich.',
    adminSettings_mijoz_subtitle: 'Chek ko‘rinishi (brauzerda), til va operatsion parametrlar — kassa, narx, filial bo‘yicha to‘lov turlari.',
    adminSettings_tenant_owner_subtitle: 'Joy egasi uchun: chek va til, operatsion parametrlar, filial bo‘yicha to‘lov usullari va marketing vitrina sozlamalari — barchasi bitta joyda.',
    adminSettings_tenant_owner_header_hint: 'Chek sozlamalari ushbu qurilmada saqlanadi. Operatsion sozlamalar va filial to‘lovlari «Saqlash» bilan serverga yoziladi.',
    adminSettings_mijoz_header_hint: 'Chek sozlamalari ushbu qurilmada saqlanadi. Operatsion sozlamalar va filial to‘lovlari «Saqlash» bilan serverga yoziladi.',
    adminSettings_reset_confirm: 'Barcha operatsion sozlamalar standart qiymatlarga qaytarilsinmi? Saqlanmagan o‘zgarishlar yo‘qoladi.',
    adminSettings_branches_load_failed: 'Filiallar ro‘yxatini yuklashda xatolik.',
    adminSettings_last_updated: 'Oxirgi yangilanish',
    adminSettings_environment: 'Muhit',
    adminSettings_env_production: 'Ishlab chiqarish',
    adminSettings_env_development: 'Ishlab chiqish',
    adminSettings_section_general: 'Umumiy sozlamalar',
    adminSettings_section_notifications: 'Bildirishnomalar',
    adminSettings_section_security: 'Xavfsizlik',
    adminSettings_section_appearance: 'Ko\'rinish',
    adminSettings_section_system: 'Tizim',
    adminSettings_section_data: 'Ma\'lumotlar va backup',
    adminSettings_section_notes: 'Eslatma',
    adminSettings_section_operational: 'Operatsion sozlamalar',
    adminSettings_section_operational_desc: 'Kassa, narx, o\'lchov va kunlik xulosa boshqaruvi.',
    adminSettings_section_general_desc: 'Til, vaqt mintaqasi, sana formati va asosiy valyuta — barcha foydalanuvchilar uchun.',
    adminSettings_section_notifications_desc: 'Email, push, SMS va kunlik xulosa — qanday va qachon bildirishnoma yuborilishi.',
    adminSettings_section_security_desc: 'Sessiya muddati, 2FA, parol talablari va IP cheklovi.',
    adminSettings_section_appearance_desc: 'Mavzu (qorong\'u/yorug\'), interfeys zichligi va matn o\'lchami.',
    adminSettings_section_system_desc: 'Versiya, API manzili, sessiyalar va log darajasi — tizim parametrlari.',
    adminSettings_section_data_desc: 'Backup vaqti, saqlash muddati, eksport formatlari va backup papkasi.',
    adminSettings_lang: 'Interfeys tili',
    adminSettings_pricing_mode: 'Narx shakllantirish rejimi',
    adminSettings_pricing_mode_manual: 'Qo\'lda (har mahsulotga alohida)',
    adminSettings_pricing_mode_markup: 'Tannarxga ustama (%)',
    adminSettings_default_markup: 'Standart ustama foizi',
    adminSettings_daily_summary_time: 'Kunlik xulosa vaqti',
    adminSettings_sale_units_manage: 'O\'lchov birliklari boshqaruvi',
    adminSettings_quick_discount_enabled: 'Tezkor chegirmalarni yoqish',
    adminSettings_quick_discount_optional: 'Savatda chegirmani ixtiyoriy tanlash',
    adminSettings_quick_discounts: 'Tezkor chegirma qiymatlari',
    adminSettings_retail_cashback_percent: 'Chakana mijoz cashback foizi',
    adminSettings_retail_cashback_hint:
      'Foiz savdoning sof foydasidan hisoblanadi. Bonus chakana mijoz balansiga qo‘shiladi; kassada balansdan to‘lov ham mumkin.',
    adminSettings_reset_defaults: 'Standart holatga qaytarish',
    adminSettings_reset: 'Qaytarish',
    adminSettings_save: 'Saqlash',
    adminSettings_branch_payments: "Filial bo'yicha to'lov turlari",
    adminSettings_branch_payments_section_title: "Filial bo'yicha to'lov turlari",
    adminSettings_branch_payments_section_desc: 'Har bir filial uchun kassada ko‘rinadigan naqd, karta va o‘tkazma nomlarini belgilang. O‘zgarishlar operatsion sozlamalar bilan serverga yoziladi.',
    adminSettings_branch_payments_desc: "Filial kesimida Naqd, Karta va O'tkazma usullarini boshqaring.",
    adminSettings_branch_payments_cash: "Naqd usullari",
    adminSettings_branch_payments_card: "Karta usullari",
    adminSettings_branch_payments_transfer: "O'tkazma usullari",
    adminSettings_branch_payments_apply: "Saqlash (serverga)",
    adminSettings_branch_payments_hint: "Vergul, nuqta-vergul yoki yangi qator bilan ajrating. «Saqlash» operatsion sozlamalarni serverga yozadi.",
    adminSettings_branch_payments_footer: "To'lov turlarini Sozlamalar bo'limida tahrirlash mumkin.",
    adminNav_expenses: 'Operatsion xarajatlar',
    adminExpenses_subtitle: "Xarajatlar: qo'shish, to'lash, arxiv.",
    adminExpenses_active: 'Faol xarajatlar',
    adminExpenses_archive: "Arxiv (to'liq qoplangan)",
    adminExpenses_add_title: "Yangi xarajat qo'shish",
    adminExpenses_name: 'Xarajat nomi',
    adminExpenses_total: 'Umumiy summa',
    adminExpenses_person_name: 'Kimdan olindi (ixtiyoriy)',
    adminExpenses_note_optional: 'Izoh (ixtiyoriy)',
    adminExpenses_recurring_on: 'Doimiy: Yoqilgan (har oy)',
    adminExpenses_recurring_off: "Doimiy: O‘chiq",
    adminExpenses_recurring_hint: 'Har oy avtomatik xarajat yaratish',
    adminExpenses_save: 'Saqlash',
    adminExpenses_required: 'Xarajat nomi va summa kiriting.',
    adminExpenses_delete_confirm: "Xarajatni o'chirasizmi?",
    adminExpenses_pay_invalid: "To'lov summasi noto'g'ri.",
    adminExpenses_pay: "To'lash",
    adminExpenses_pay_amount: "To'lov summasi",
    adminExpenses_pay_save: "To'lovni saqlash",
    adminExpenses_from_cashbox: 'Kassadan',
    adminExpenses_not_from_cashbox: 'Kassadan emas',
    adminExpenses_badge_product: 'Mahsulot xarajati',
    adminExpenses_created_at: 'Sana',
    adminExpenses_qty: 'Miqdor',
    adminExpenses_unit_cost: 'Tannarx/1',
    adminExpenses_remaining: 'Qolgan',
    adminExpenses_status: 'Holat',
    adminExpenses_actions: 'Amallar',
    adminExpenses_note: 'Izoh',
    adminExpenses_product_id_label: 'Mahsulot ID',
    adminExpenses_supplier_label: 'Ta’minotchi',
    adminExpenses_supplier_debts: "Ta'minotchilar bo'yicha qarzdorlik",
    adminExpenses_supplier_day_products: '{n} ta mahsulot',
    adminExpenses_supplier_products_title: 'Olingan mahsulotlar',
    adminExpenses_view_details: 'Batafsil',
    adminExpenses_pay_supplier_total: "Umumiy to'lov",
    adminExpenses_supplier_pay_hint: 'Maksimal: {n}',
    adminExpenses_paid: "To'langan",
    adminExpenses_paid_by: 'Kiritdi',
    adminExpenses_payment_history: 'To‘lovlar tarixi',
    adminExpenses_no_payments: "To'lovlar yo'q",
    adminExpenses_pay_mode_cash: "Naqd / Karta",
    adminExpenses_pay_mode_product: "Tovar orqali",
    adminExpenses_select_product: "Tovar tanlang",
    adminExpenses_pick_branch_for_product: 'Tovar uchun filialni tanlang',
    adminExpenses_pick_branch_placeholder: 'Filialni tanlang',
    adminExpenses_pick_branch_before_products: 'Mahsulotlarni ko‘rish uchun filialni tanlang.',
    adminExpenses_no_products_in_branch: 'Bu filialda qoldiqdagi mahsulot yo‘q.',
    adminExpenses_cashier_no_branch: 'Filial biriktirilmagan.',
    adminExpenses_cashier_products_hint: 'Faqat shu filial omboridagi mahsulotlar.',
    adminExpenses_cashier_wait_branch: 'Filial ma’lumotini kuting.',
    adminExpenses_kassir_products_hint: 'Kassir faqat o‘z filialidagi mahsulotlar bilan to‘lay oladi.',
    adminExpenses_kassir_wait_branch: 'Filial ma’lumotini kuting.',
    adminExpenses_pay_source: "To'lov manbai",
    adminExpenses_without_cashbox: 'Kassasiz',
    adminExpenses_without_cashbox_hint: 'Bu to‘lov kassadan yechilmaydi.',
    adminExpenses_today_cash_sales: 'Bugungi naqd savdo',
    adminExpenses_cashbox_available: 'Kassadan to‘lash uchun mavjud',
    adminExpenses_cashbox_need_branch: 'Kassadan to‘lash uchun filial kerak.',
    adminExpenses_cashbox_load_error: 'Kassa limiti yuklanmadi.',
    adminExpenses_cashbox_cash_only: 'Kassadan faqat naqd usul bilan to‘lash mumkin.',
    adminExpenses_cashbox_wait: 'Kassa limiti yuklanmoqda yoki xato. Kuting yoki qayta urining.',
    adminExpenses_cashbox_exceeds: 'Bugungi kassadagi mavjud naqd yetarli emas. Mavjud: {n}',
    adminExpenses_product_inventory_error: 'Mahsulotlar ro‘yxati yuklanmadi.',
    adminExpenses_select_branch_first: 'Avval filialni tanlang.',
    adminExpenses_product_qty_required: 'Mahsulot va miqdorni kiriting.',
    adminExpenses_product_not_in_list: 'Mahsulot ro‘yxatda yo‘q. Filialni tekshiring.',
    adminExpenses_insufficient_stock: "Yetarli qoldiq yo'q. Mavjud: {n}",
    adminExpenses_pay_error: "To'lov saqlanmadi.",
    adminExpenses_pay_with_product: "Tovar bilan to'lash",
    adminExpenses_product_qty: "Miqdor",
    adminExpenses_product_total: "Jami",
    adminExpenses_product_remaining: "Qoldiq",
    adminExpenses_stock_short: 'Qoldiq',
    adminExpenses_product_search: 'Mahsulot qidirish…',
    adminExpenses_product_max_qty: 'Maksimal miqdor: {n}',
    adminExpenses_product_pick_hint: 'Ro‘yxatdan mahsulotni bosing',
    adminExpenses_restock_batches: 'Partiyalar',
    adminStatistics_payments_block_title: "To'lov turlari",
    adminSettings_last_saved: 'Oxirgi saqlangan vaqt',
    adminSettings_operational_load_failed: 'Operatsion sozlamalarni backenddan olishda xatolik. Lokal qiymatlar ishlatildi.',
    adminSettings_purchase_currency: 'Kirim valyutasi',
    adminSettings_sale_currency: 'Sotuv valyutasi',
    adminSettings_currency_rate: 'NBU kursi',
    adminSettings_currency_rate_failed: 'NBU kurslarini olishda xatolik',
    adminSettings_lang_val: 'O\'zbekcha',
    adminSettings_timezone: 'Vaqt mintaqasi',
    adminSettings_timezone_val: 'Asia/Toshkent (UTC+5)',
    adminSettings_date_format: 'Sana formati',
    adminSettings_date_format_val: 'DD.MM.YYYY',
    adminSettings_currency: 'Asosiy valyuta',
    adminSettings_currency_val: 'UZS (so\'m)',
    adminSettings_week_start: 'Hafta boshi',
    adminSettings_week_start_val: 'Dushanba',
    adminSettings_notif_email: 'Email bildirishnomalar',
    adminSettings_notif_email_val: 'Yoqilgan',
    adminSettings_notif_push: 'Push-bildirishnomalar',
    adminSettings_notif_push_val: 'Yoqilgan',
    adminSettings_notif_sms: 'SMS bildirishnomalar',
    adminSettings_notif_sms_val: 'O\'chirilgan',
    adminSettings_notif_digest: 'Kunlik xulosa (digest)',
    adminSettings_notif_digest_val: 'Yoqilgan — har kuni 09:00',
    adminSettings_session_min: 'Sessiya muddati (tinchlik)',
    adminSettings_2fa: 'Ikki bosqichli autentifikatsiya (2FA)',
    adminSettings_2fa_val: 'Tavsiya etiladi (administratorlar uchun)',
    adminSettings_password_policy: 'Parol talablari',
    adminSettings_password_policy_val: 'Kamida 8 belgi, raqam va bosh harf majburiy',
    adminSettings_ip_whitelist: 'IP cheklovi (whitelist)',
    adminSettings_ip_whitelist_val: 'O\'chirilgan',
    adminSettings_theme: 'Mavzu',
    adminSettings_theme_val: 'Tizim bo\'yicha (avto)',
    adminSettings_density: 'Interfeys zichligi',
    adminSettings_density_val: 'Qulay',
    adminSettings_font_size: 'Matn o\'lchami',
    adminSettings_font_size_val: 'Standart (14px)',
    adminSettings_version: 'Tizim versiyasi',
    adminSettings_api_base: 'API bazaviy URL',
    adminSettings_max_sessions: 'Bitta foydalanuvchi uchun max sessiyalar',
    adminSettings_log_level: 'Log darajasi',
    adminSettings_log_level_val: 'Info',
    adminSettings_backup: 'Avtomatik backup vaqti',
    adminSettings_retention: 'Audit va log saqlash muddati',
    adminSettings_export_format: 'Eksport formati',
    adminSettings_export_format_val: 'CSV, Excel (XLSX), JSON',
    adminSettings_build_id: 'Build ID',
    adminSettings_backup_path: 'Backup papkasi',
    adminSettings_note_text: 'Sozlamalarni o\'zgartirish keyingi yangilanishlarda amalga oshiriladi. Hozircha barcha qiymatlar faqat ko\'rsatish uchun. Muhim o\'zgarishlar uchun qo\'llab-quvvatlash bilan bog\'laning.',
    adminTariff_title: 'Tarif',
    adminTariff_subtitle: 'Sayt tariflarini boshqaring: narxlar, imtiyozlar va tavsiya etilgan tarif. O\'zgartirishlar sahifani yangilaguncha saqlanadi.',
    adminTariff_create_naming: 'Tarif turi',
    adminTariff_create_preset: 'Standart shablon',
    adminTariff_create_custom: 'Maxsus nom',
    adminTariff_template: 'Shablon',
    adminTariff_no_templates_left: 'Uchta standart tur ham allaqachon qo‘shilgan. «Maxsus nom» bilan yangi tarif yarating.',
    adminTariff_validation_template: 'Standart shablondan birini tanlang.',
    adminTariff_validation_custom_name: 'Tarif nomini kiriting.',
    adminTariff_validation_price: 'Narx manfiy bo‘lmasligi kerak.',
    adminTariff_save_new: 'Tarifni yaratish',
    adminTariff_add: 'Yangi tarif qo\'shish',
    adminTariff_edit: 'Tahrirlash',
    adminTariff_delete: 'O\'chirish',
    adminTariff_save: 'Saqlash',
    adminTariff_cancel: 'Bekor qilish',
    adminTariff_name: 'Tarif nomi',
    adminTariff_name_placeholder: 'Masalan: Starter, Business',
    adminTariff_unnamed: 'Nomsiz tarif',
    adminTariff_monthly_price: 'Oylik narx (UZS)',
    adminTariff_recommended: 'Tavsiya etilgan',
    adminTariff_recommended_yes: 'Bu tarifni «Eng mashhur» sifatida ko\'rsatish',
    adminTariff_benefits: 'Imtiyozlar',
    adminTariff_modal_add_title: 'Yangi tarif',
    adminTariff_modal_edit_title: 'Tarifni tahrirlash',
    adminTariff_confirm_delete_title: 'Tarifni o\'chirish',
    adminTariff_confirm_delete_text: 'Quyidagi tarifni o\'chirishni xohlaysizmi',
    adminTariff_empty: 'Hozircha tariflar yo\'q. Yangi tarif qo\'shing.',
    adminInt_subtitle: 'Tashqi xizmatlar, to\'lov tizimlari va API ulanishlari. Har bir integratsiya batafsil tavsifi va holati.',
    adminInt_add: 'Yangi integratsiya qo\'shish',
    adminInt_edit: 'Tahrirlash',
    adminInt_delete: 'O\'chirish',
    adminInt_save: 'Saqlash',
    adminInt_cancel: 'Bekor qilish',
    adminInt_name: 'Nomi',
    adminInt_name_placeholder: 'Masalan: Stripe, SMS.uz',
    adminInt_description: 'Tavsif',
    adminInt_description_placeholder: 'Qisqacha nima uchun va qanday ishlatiladi.',
    adminInt_category: 'Kategoriya',
    adminInt_logo: 'Logo',
    adminInt_logo_choose: 'Logo tanlash',
    adminInt_logo_invalid: 'Faqat rasm fayllari yuklash mumkin',
    adminInt_logo_too_large: 'Rasm hajmi 2MB dan katta bo\'lmasligi kerak',
    adminInt_status_label: 'Holat',
    adminInt_status_active: 'Yoqilgan',
    adminInt_status_inactive: 'O\'chirilgan',
    adminInt_modal_add_title: 'Yangi integratsiya',
    adminInt_modal_edit_title: 'Integratsiyani tahrirlash',
    adminInt_confirm_delete_title: 'Integratsiyani o\'chirish',
    adminInt_confirm_delete_text: 'Quyidagi integratsiyani o\'chirishni xohlaysizmi',
    adminInt_empty: 'Hozircha integratsiyalar yo\'q. Yangi qo\'shing.',
    adminInt_unnamed: 'Nomsiz',
    adminInt_cat_payment: 'To\'lov',
    adminInt_cat_accounting: 'Buxgalteriya',
    adminInt_cat_export: 'Eksport',
    adminInt_cat_api: 'API',
    adminInt_cat_messaging: 'Xabarlar',
    adminInt_telegram_name: 'Telegram',
    adminInt_telegram_desc: 'Bildirishnomalar, xabarlar va bot orqali mijozlar bilan aloqa. Buyurtma holati, eslatmalar va qisqa xabarlar avtomatik yuboriladi.',
    adminInt_1c_name: '1C',
    adminInt_1c_desc: '1C: Buxgalteriya va 1C: Korxona bilan ma\'lumotlar almashinuvi. Tranzaksiyalar, hisob-fakturalar va tovar harakati sinxronlash.',
    adminInt_payme_name: 'Payme',
    adminInt_payme_desc: 'Payme to\'lov tizimi orqali online to\'lov qabul qilish. Kartadan-to\'lov, click va mobil ilova orqali xavfsiz to\'lovlar.',
    adminInt_click_name: 'Click',
    adminInt_click_desc: 'Click to\'lov tizimi integratsiyasi. Mijozlar Click orqali buyurtma va xizmatlar uchun to\'lov amalga oshirishi mumkin.',
    adminInt_uzum_name: 'Uzum',
    adminInt_uzum_desc: 'Uzum Bank va Uzum to\'lov tizimi bilan ulashuv. Kartadan-to\'lov va telefon raqam orqali to\'lovlarni qabul qilish.',
    adminInt_excel_name: 'Excel',
    adminInt_excel_desc: 'Hisobotlar va jadvalarni Excel (XLSX) formatida eksport qilish. Ma\'lumotlarni tahlil va arxivlash uchun foydalanish.',
    adminInt_google_sheets_name: 'Google Sheets',
    adminInt_google_sheets_desc: 'Google Sheets bilan sinxronlash va eksport. Jadval va hisobotlarni bulutda saqlash va jamoada baham ko\'rish.',
    adminInt_api_name: 'API',
    adminInt_api_desc: 'REST API orqali tashqi tizimlar bilan ulashuv. Mahsulotlar, buyurtmalar, mijozlar va hisobotlar uchun ochiq endpointlar.',
    adminTenant_subtitle: 'Platformada ro\'yxatdan o\'tgan tashkilotlar. Har bir mijoz uchun tashkilot, aloqa, tarif va holat.',
    adminTenant_add_via_orders_hint: 'Yangi mijoz faqat «Buyurtmalar» bo‘limida asosiy sayt buyurtmasidan «Mijozga aylantirish» tugmasi orqali qo‘shiladi.',
    adminTenant_add: 'Yangi mijoz qo\'shish',
    adminTenant_view: 'Ko\'rish',
    adminTenant_edit: 'Tahrirlash',
    adminTenant_delete: 'O\'chirish',
    adminTenant_vm_stats_title: 'Viloyat menejer KPI',
    adminTenant_vm_active: 'Faol mijozlar',
    adminTenant_vm_trial: 'Sinovdagi mijozlar',
    adminTenant_vm_suspended: 'To‘xtatilganlar',
    adminTenant_vm_cashiers: 'Jami kassirlar',
    adminTenant_vm_orders_month: 'Oylik buyurtmalar',
    adminTenant_vm_revenue_month: 'Oylik tushum',
    adminTenant_vm_trend_share: 'ulush',
    adminTenant_vm_trend_per_client: 'har mijozga',
    adminTenant_vm_trend_vs_prev: 'o\'tgan davrga',
    adminTenant_save: 'Saqlash',
    adminTenant_cancel: 'Bekor qilish',
    adminTenant_total: 'mijoz',
    adminTenant_company: 'Tashkilot',
    adminTenant_company_placeholder: 'MChJ, LLC nomi',
    adminTenant_contact: 'Mas\'ul shaxs',
    adminTenant_contact_placeholder: 'Ism familiya',
    adminTenant_phone: 'Telefon',
    adminTenant_owner_password: 'Parol',
    adminTenant_owner_password_placeholder: 'Kamida 6 belgi',
    adminTenant_owner_password_placeholder_edit: 'Yangi parol (ixtiyoriy)',
    adminTenant_owner_password_hint: 'Mas\'ul shaxs telefoni bilan kirish uchun parol. Foydalanuvchi roli — Ega (mijoz emas).',
    adminTenant_owner_password_edit_hint: 'Bo\'sh qoldiring — parol o\'zgarmaydi. Yangi parol kamida 6 belgi.',
    adminTenant_owner_password_required: 'Parolni kiriting (kamida 6 belgi).',
    adminTenant_login_sms_2fa: 'Kirishda SMS tasdiqlash',
    adminTenant_login_sms_2fa_hint: 'Ega (platform owner) va bosh menejer boshqaradi. Yoqilganda mijoz (joy egasi) va uning kassirlari telefon + paroldan keyin SMS kod bilan kiradi. O\'chirilganda faqat parol yetarli.',
    adminTenant_login_sms_on: 'Yoqilgan',
    adminTenant_login_sms_off: 'O\'chirilgan',
    adminLogin_password_label: 'Kirish paroli',
    adminLogin_password_placeholder: 'Kamida 6 belgi',
    adminLogin_password_placeholder_edit: 'Yangi parol (ixtiyoriy)',
    adminLogin_password_hint: 'Telefon raqami bilan tizimga kirish uchun parol.',
    adminLogin_password_hint_edit: 'Bo\'sh qoldiring — parol o\'zgarmaydi. Yangi parol kamida 6 belgi.',
    adminLogin_password_required: 'Kirish parolini kiriting (kamida 6 belgi).',
    adminTenant_plan: 'Tarif',
    adminTenant_status: 'Holat',
    adminTenant_status_active: 'Faol',
    adminTenant_status_trial: 'Sinov',
    adminTenant_status_suspended: 'To\'xtatilgan',
    adminTenant_status_payment_pending: 'To\'lov kutilmoqda',
    adminTenant_region: 'Viloyat',
    adminTenant_district: 'Tuman / Shahar',
    adminTenant_address: 'Manzil',
    adminTenant_address_placeholder: 'To‘liq manzil (ko‘cha, uy, orientir)',
    adminTenant_address_required: 'Manzilni kiriting.',
    adminTenant_businessType: 'Biznes turi',
    adminTenant_cashiers: 'Kassirlar',
    adminTenant_select_placeholder: 'Tanlang',
    adminTenant_note: 'Eslatma',
    adminTenant_note_placeholder: 'Qo\'shimcha ma\'lumot',
    adminTenant_actions: 'Amallar',
    adminTenant_modal_add_title: 'Yangi mijoz',
    adminTenant_modal_edit_title: 'Mijozni tahrirlash',
    adminTenant_confirm_delete_title: 'Mijozni o\'chirish',
    adminTenant_confirm_delete_text: 'Quyidagi mijozni ro\'yxatdan o\'chirishni xohlaysizmi',
    adminTenant_empty: 'Hozircha mijozlar yo\'q. Yangi qo\'shing.',
    adminTenant_search_placeholder: 'Tashkilot, ism yoki raqam bo\'yicha qidirish...',
    adminTenant_filter_all_business: 'Barcha biznes turlari',
    adminTenant_filter_all_region: 'Barcha viloyatlar',
    adminTenant_filter_all_district: 'Barcha tumanlar',
    adminTenant_filter_all_plan: 'Barcha tariflar',
    adminTenant_filter_loading: 'Yuklanmoqda...',
    common_loading: 'Yuklanmoqda...',
    appNotice_title_default: 'Bildirishnoma',
    appNotice_title_error: 'Xato',
    appNotice_title_warning: 'Diqqat',
    appNotice_confirm: 'Tushundim',
    common_ok: 'OK',
    common_error: 'Xatolik',
    common_retry: 'Qayta urinish',
    common_no_data: 'Ma\'lumot yo\'q',
    common_yes: 'Ha',
    common_no: 'Yo\'q',
    common_add: 'Qo\'shish',
    common_today: 'Bugun',
    common_week: 'Hafta',
    common_month: 'Oy',
    common_custom_period: 'Maxsus davr',
    adminTenant_no_results: 'Qidiruv bo\'yicha natija topilmadi.',
    adminTenant_clear_filters: 'Filtrlarni tozalash',
    adminTenant_page_prev: 'Oldingi',
    adminTenant_page_next: 'Keyingi',
    adminTenant_page_num: 'Sahifa',
    adminTenant_view_title: 'Mijoz to\'liq ma\'lumotlari',
    adminTenant_detail_info: 'Asosiy ma\'lumotlar',
    adminTenant_detail_tariff: 'Tarif va obuna',
    adminTenant_detail_stats: 'Statistika',
    adminTenant_stat_orders: 'Jami buyurtmalar',
    adminTenant_stat_orders_month: 'Oylik buyurtmalar',
    adminTenant_stat_revenue_month: 'Oylik daromad (UZS)',
    adminTenant_stat_revenue_total: 'Umumiy daromad (UZS)',
    adminTenant_stat_branches: 'Filiallar',
    adminTenant_stat_last_order: 'Oxirgi buyurtma',
    adminTenant_created: 'Ro\'yxatdan o\'tgan sana',
    adminTenant_plan_since: 'Tarifdan foydalanish boshlangan sana',
    adminTenant_last_payment_date: 'Oxirgi to\'lov sanasi',
    adminTenant_tariff_end_date: 'Tarif tugash sanasi',
    adminTenant_no_payment_yet: 'To\'lov hali amalga oshirilmagan',
    adminTenant_close: 'Yopish',
    adminTenant_detail_products: 'Mahsulotlar',
    adminTenant_products_count: 'Xil mahsulotlar',
    adminTenant_products_total_sold: 'Jami sotilgan',
    adminTenant_products_total_stock: 'Jami qoldiq',
    adminTenant_products_list_title: 'Mahsulot nomlari va qoldiqlari',
    adminTenant_product_name: 'Mahsulot nomi',
    adminTenant_product_status: 'Holat',
    adminTenant_product_sold: 'Sotilgan',
    adminTenant_product_stock: 'Qoldiq',
    adminTenant_product_purchase_price: 'Sotib olingan narx',
    adminTenant_product_sale_price: 'Sotilgan narx',
    adminTenant_products_empty: 'Mahsulotlar ma\'lumoti mavjud emas',
    adminFF_subtitle: 'Platformada mavjud va rejalashtirilgan funksiyalar. Har biri uchun holat (yoqilgan / rejalashtirilgan) va qisqacha tavsif.',
    adminFF_filter_all: 'Barchasi',
    adminFF_cat_admin: 'Boshqaruv',
    adminFF_cat_platform: 'Platforma',
    adminFF_cat_analytics: 'Tahlil',
    adminFF_cat_security: 'Xavfsizlik',
    adminFF_status_enabled: 'Yoqilgan',
    adminFF_status_planned: 'Rejalashtirilgan',
    adminFF_status_disabled: 'O\'chirilgan',
    adminFF_footer: 'Funksiyalarni yoqish/o\'chirish keyingi yangilanishlarda backend orqali amalga oshiriladi. Hozircha ko\'rsatish rejimi.',
    adminFF_statistics_name: 'Statistika',
    adminFF_statistics_desc: 'Ega roli uchun KPI va haftalik buyurtmalar grafigi. Statik ma\'lumotlar asosida professional dashboard.',
    adminFF_maslahat_name: 'Maslahat',
    adminFF_maslahat_desc: 'Biznes boshqaruvi bo\'yicha statik qo\'llanma: sotuv, ombor, moliya, xodimlar, CRM va umumiy tavsiyalar.',
    adminFF_dashboard_name: 'Boshqaruv paneli',
    adminFF_dashboard_desc: 'Tizim holati, tezkor kirish, so\'nggi faoliyat, foydalanish va xavfsizlik bo\'limlari.',
    adminFF_settings_name: 'Sozlamalar',
    adminFF_settings_desc: 'Umumiy sozlamalar, bildirishnomalar, xavfsizlik, ko\'rinish, tizim va ma\'lumotlar parametrlari.',
    adminFF_tariffs_name: 'Tariflar',
    adminFF_tariffs_desc: 'Sayt tariflarini boshqarish: narxlar, imtiyozlar, tavsiya etilgan tarif. Qo\'shish, tahrirlash, o\'chirish.',
    adminFF_integrations_name: 'Integratsiyalar',
    adminFF_integrations_desc: 'Telegram, 1C, Payme, Click, Uzum, Excel, Google Sheets, API. Har biri uchun tavsif va yangi qo\'shish.',
    adminFF_tenants_name: 'Mijozlar',
    adminFF_tenants_desc: 'Platformada ro\'yxatdan o\'tgan tashkilotlar: tashkilot, aloqa, tarif, holat. CRUD imkoniyati.',
    adminFF_dark_theme_name: 'Qorong\'u mavzu',
    adminFF_dark_theme_desc: 'Interfeys qorong\'u rejimda. Tugma orqali yorug\'/qorong\'u mavzuni almashtirish.',
    adminFF_i18n_name: 'Ko\'p tillilik',
    adminFF_i18n_desc: 'O\'zbek, rus va ingliz tillarida interfeys. Barcha admin bo\'limlari va sahifalar tarjima qilingan.',
    adminFF_audit_name: 'Audit jurnali',
    adminFF_audit_desc: 'Foydalanuvchi harakatlari va tizim hodisalari tarixi. Keyingi yangilanishlarda qo\'shiladi.',
    adminFF_health_name: 'Tizim holati',
    adminFF_health_desc: 'Server, ma\'lumotlar bazasi va xizmatlar monitoringi. Keyingi yangilanishlarda.',
    adminFF_usage_name: 'Foydalanish hisobotlari',
    adminFF_usage_desc: 'API so\'rovlari, sessiyalar va resurslar bo\'yicha hisobotlar. Keyingi yangilanishlarda.',
    adminFF_errors_name: 'Xatoliklar monitoringi',
    adminFF_errors_desc: 'Ilova xatoliklari va loglar. Keyingi yangilanishlarda.',
    adminFF_apikeys_name: 'API kalitlari',
    adminFF_apikeys_desc: 'API kalitlari yaratish va boshqarish. Tashqi tizimlar uchun kirish. Keyingi yangilanishlarda.',
    adminAudit_subtitle: 'Foydalanuvchi harakatlari va tizim hodisalari jurnali. Har bir yozuv: vaqt, kim, nima qilgani, natija va IP.',
    adminAudit_filter_all: 'Barchasi',
    adminAudit_result_success: 'Muvaffaqiyat',
    adminAudit_result_failure: 'Muvaffaqiyatsiz',
    adminAudit_total: 'yozuv',
    adminAudit_time: 'Sana va vaqt',
    adminAudit_user: 'Foydalanuvchi',
    adminAudit_action: 'Harakat',
    adminAudit_resource: 'Resurs',
    adminAudit_details: 'Tafsilot',
    adminAudit_result: 'Natija',
    adminAudit_ip: 'IP manzil',
    adminAudit_footer: 'Audit yozuvlari statik namuna. Haqiqiy jurnal backend va log tizimi ulanganda to\'ldiriladi. Eksport keyingi yangilanishlarda.',
    adminAudit_login: 'Tizimga kirish',
    adminAudit_settings_update: 'Sozlamalar yangilandi',
    adminAudit_tenant_create: 'Mijoz qo\'shildi',
    adminAudit_tenant_edit: 'Mijoz tahrirlandi',
    adminAudit_integration_enable: 'Integratsiya yoqildi',
    adminAudit_tariff_edit: 'Tarif tahrirlandi',
    adminAudit_api_key_create: 'API kalit yaratildi',
    adminAudit_export: 'Eksport',
    adminAudit_resource_settings: 'Sozlamalar',
    adminAudit_resource_tenants: 'Mijozlar',
    adminAudit_resource_integrations: 'Integratsiyalar',
    adminAudit_resource_tariffs: 'Tariflar',
    adminAudit_resource_apikeys: 'API kalitlari',
    adminAudit_resource_audit: 'Audit jurnali',
    adminAudit_detail_tariff_limits: 'Tarif limitlari o\'zgartirildi',
    adminAudit_detail_export_csv: 'CSV formatida yuklab olindi',
    adminAudit_detail_wrong_password: 'Noto\'g\'ri parol',
    roleTitle_business_admin: 'Biznes Admin',
    roleTitle_manager: 'Menejer / Sotuvchi',
    roleTitle_warehouse: 'Omborchi',
    roleTitle_accountant: 'Buxgalter',
    roleTitle_analytics: 'Analitik / Marketing',
    roleTitle_courier: 'Kuryer / Field agent',
    roleTitle_customer: 'Mijoz',

    // Admin sidebar (nav) – professional nomlar
    adminNav_system_dashboard: 'Boshqaruv paneli',
    adminNav_role_access: 'Rollarga kirish',
    adminNav_ai_chat: 'AI chat',
    adminNav_ai_advisor: 'AI Maslahatchi',
    adminNav_managers: 'Menejerlar',
    adminNav_rating: 'Reyting',
    adminNav_rating_dispatchers: 'Reyting (dispecherlar)',
    adminNav_rating_tenants: 'Reyting (mijozlar)',
    adminNav_dispatchers: 'Dispecherlar',
    adminNav_statistics: 'Statistika',
    adminNav_leads: 'Leadlar',
    adminNav_leads_dispatcher: 'Murojaatlar',
    adminNav_leads_vm: 'Murojaatlar',
    adminNav_to_managers: 'Menejerlarga yuborish',
    adminNav_cashiers: 'Kassirlar',
    adminNav_pos_access: 'POS kabina ruxsati',
    adminPosAccess_subtitle: 'Faqat kassa kabinasi — tanlangan filial mahsulotlari ko‘rinadi.',
    adminPosAccess_quota: 'POS ruxsati',
    adminPosAccess_quota_unavailable: 'Joriy tarifda mavjud emas (299 000 so‘mdan)',
    adminPosAccess_quota_full: 'POS ruxsati limiti to‘ldi',
    adminPosAccess_add_disabled: 'Tarif bo‘yicha yangi POS foydalanuvchi qo‘shib bo‘lmaydi',
    adminPosAccess_total: 'POS foydalanuvchi',
    adminPosAccess_col_name: 'Ism',
    adminPosAccess_col_phone: 'Telefon',
    adminPosAccess_col_branch: 'Filial',
    adminPosAccess_col_status: 'Holat',
    adminPosAccess_status_active: 'Faol',
    adminPosAccess_status_inactive: 'Nofaol',
    adminPosAccess_scope_hint: 'Foydalanuvchi faqat biriktirilgan filial mahsulotlarini ko‘radi va kassada ishlaydi.',
    adminPosAccess_branch_scope: 'POS kabina faqat shu filial bo‘yicha ishlaydi.',
    adminPosAccess_phone_hint: 'Telefon raqami tizimga kirish uchun login sifatida ishlatiladi.',
    adminPosAccess_password_hint: 'Kamida 6 belgi. Telefon raqami bilan kirish uchun.',
    adminPosAccess_name_placeholder: 'To‘liq ism',
    adminPosAccess_error_plan: 'Joriy tarifda POS kabina ruxsati yo‘q. Tarifni 299 000 so‘m yoki yuqoriga yangilang.',
    adminPosAccess_error_limit: 'Tarif bo‘yicha POS ruxsati limiti to‘ldi.',
    cashierKassa_out_of_stock: '«{name}» — omborda qolmagan.',
    cashierKassa_branch_mix_forbidden: 'Bitta savatchada turli filial tovarlarini aralashtirib bo‘lmaydi.',
    cashierKassa_test_receipt_success: 'Test chek muvaffaqiyatli yuborildi.',
    adminPosAccess_add: 'POS foydalanuvchi qo‘shish',
    adminPosAccess_empty: 'POS foydalanuvchilar yo‘q. «POS foydalanuvchi qo‘shish» orqali birinchi foydalanuvchini yarating.',
    adminPosAccess_modal_add: 'POS foydalanuvchi qo‘shish',
    adminPosAccess_modal_edit: 'POS foydalanuvchini tahrirlash',
    adminPosAccess_delete_title: 'POS foydalanuvchini o‘chirish',
    adminPosAccess_delete_text: 'Ushbu foydalanuvchini o‘chirasizmi?',
    adminNav_staff_workers: 'Ishchilar',
    adminNav_credits: 'Nasiya',
    adminNav_global_settings: 'Sozlamalar',
    adminNav_tariff_plans: 'Tariflar',
    adminNav_landing_team: 'Sayt jamoasi',
    adminNav_tariff_plan: 'Tarif rejasi',
    adminLandingTeam_subtitle: 'Landing sahifasidagi «Bizning jamoa» bo\'limi — rasm, lavozim va qisqa tavsif.',
    adminLandingTeam_add: 'A\'zo qo\'shish',
    adminLandingTeam_edit: 'Tahrirlash',
    adminLandingTeam_delete: 'O\'chirish',
    adminLandingTeam_save: 'Saqlash',
    adminLandingTeam_cancel: 'Bekor qilish',
    adminLandingTeam_empty: 'Hozircha a\'zolar yo\'q. Birinchi a\'zoni qo\'shing.',
    adminLandingTeam_col_photo: 'Rasm',
    adminLandingTeam_col_name: 'Ism',
    adminLandingTeam_col_role: 'Lavozim',
    adminLandingTeam_col_order: 'Tartib',
    adminLandingTeam_col_status: 'Holat',
    adminLandingTeam_col_actions: 'Amallar',
    adminLandingTeam_active: 'Faol',
    adminLandingTeam_inactive: 'Yashirin',
    adminLandingTeam_field_name: 'Ism familiya',
    adminLandingTeam_field_role: 'Lavozim',
    adminLandingTeam_field_description: 'Qisqa tavfsif',
    adminLandingTeam_field_sort: 'Ko\'rsatish tartibi',
    adminLandingTeam_field_active: 'Landingda ko\'rsatish',
    adminLandingTeam_field_photo: 'Rasm',
    adminLandingTeam_remove_photo: 'Rasmni olib tashlash',
    adminLandingTeam_validation_required: 'Ism, lavozim va tavsif to\'ldirilishi shart.',
    adminLandingTeam_photo_invalid: 'Faqat rasm fayllari (JPEG, PNG, WebP).',
    adminLandingTeam_photo_too_large: 'Rasm 4 MB dan kichik bo\'lishi kerak.',
    adminLandingTeam_delete_confirm: '«{name}» ni o\'chirishni tasdiqlaysizmi?',
    tenant_tariff_no_tenant: 'Tenant aniqlanmadi.',
    tenant_tariff_load_error: 'Ma’lumot yuklanmadi.',
    tenant_tariff_cancel_error: 'So‘rov yuborilmadi. Qayta urinib ko‘ring.',
    tenant_tariff_status: 'Obuna holati',
    tenant_tariff_plan_key: 'Tarif',
    tenant_tariff_status_field: 'Holat',
    tenant_tariff_trial_ends: 'Sinov tugash sanasi',
    tenant_tariff_subscription_ends: 'Obuna tugash sanasi',
    tenant_tariff_cancel_title: 'Obunani bekor qilish',
    tenant_tariff_cancel_lead:
      'Agar ayrilmoqchi bo‘lsangiz, so‘rov menejerga boradi. Obuna muddati tugaguncha tizimdan foydalanish davom etadi. Sabab (ixtiyoriy) yozishingiz mumkin.',
    tenant_tariff_cancel_requested: 'Bekor qilish so‘rovi',
    tenant_tariff_cancel_note: 'Izoh (ixtiyoriy)',
    tenant_tariff_cancel_placeholder: 'Nima uchun bekor qilmoqchisiz?',
    tenant_tariff_cancel_submit: 'Obunani bekor qilish so‘rovi yuborish',
    tenant_tariff_transactions: 'Obuna tranzaksiyalari',

    subscription_extend: 'Obunani uzaytirish (oldindan to‘lov)',
    subscription_status_label: 'Holat',
    subscription_expired: 'Obuna tugagan',
    subscription_data_preserved_hint: 'Ma\'lumotlaringiz (mahsulotlar, buyurtmalar, nasiya) saqlanadi. Yangi amallar uchun obunani yangilang.',
    subscription_trial: 'Sinov davri',
    subscription_active: 'Obuna faol',
    subscription_days_remaining: 'Qolgan kunlar',
    subscription_days_unit: 'kun',
    subscription_ends_at: 'Tugash sanasi',
    subscription_monthly_price: 'Oylik tarif narxi',
    subscription_prepay_matches_tariff:
      'Ushbu summa sizdagi joriy tarif bo‘yicha: platforma «Tariflar»dagi oylik narx bilan bir xil. Uzaytirishdagi (oldindan to‘lov) yig‘indisi shu oylik narx va tanlangan oylar bo‘yicha hisoblanadi.',
    subscription_months_unit: 'oy',
    subscription_prepay_base: 'Oldindan to‘lov (chegirmasiz)',
    subscription_prepay_discount_label: 'Chegirma',
    subscription_total: 'To‘lash kerak bo‘lgan summa',
    subscription_provider: 'To‘lov provayderi',
    subscription_provider_new_tab: 'to‘lov sahifasiga yo‘naltiriladi',
    subscription_pay_btn: 'To‘lash',
    subscription_cashback_balance: 'Cashback balansi',
    subscription_cashback_apply: 'Cashbackdan foydalanish (yilda bir marta)',
    subscription_cashback_hint: 'O‘rta / yirik tariflarda har to‘lovdan 5% balansga; yilda bir marta chegirma sifatida ishlatiladi.',
    subscription_cashback_next: 'Keyingi cashback ishlatish',
    subscription_click_sms_error_hint:
      'Agar Click da «СМС услуга не включена (-33006)» chiqsa: bu xato odatda Click kabinetida yoki to‘lov qilayotgan kartada SMS-bildirishnoma xizmati yoqilmaganda beriladi. Savdogar sifatida Click supportga xizmat (SERVICE_ID) bo‘yicha SMS-xizmatni yoqishni so‘rang; mijozlar kartasida esa bankomat/ilova orqali SMS-informatsiya ulang.',
    subscription_click_continue_checkout: 'Click to‘lov sahifasiga o‘tish',
    subscription_click_provider_error_hint:
      '«Поставщик недоступен (-21)» (Click checkout): odatda Prepare bosqichida — Click sizning serveringizga POST qila olmayapti yoki javobda `error: 0` va to‘g‘ri JSON yo‘q (timeout, SSL, 404/500, noto‘g‘ri imzo `SIGN CHECK FAILED`, bo‘sh `CLICK_SECRET_KEY`). Kabinetda Prepare/Complete URL `https://…/api/webhooks/click` yoki `…/webhooks/click`; `API_PUBLIC_URL` shu host bilan bir xil. Log: `click.webhook.post_hit`, `click.webhook.received`, `click.webhook.sign_check_failed` (docs.click.uz/en/click-api-request/).',
    subscription_pay_tech_click:
      'Texnik: POST /api/subscription/initiate → Click shop https://my.click.uz/services/pay — parametrlar docs.click.uz/en/click-button/ bo‘yicha.',
    subscription_pay_tech_payme:
      'Texnik: POST /api/subscription/initiate → Payme/Paycom checkout (sozlamadagi domen, odatda checkout.paycom.uz).',
    subscription_pay_err_no_url: "To'lov havolasi yaratilmadi. Qaytadan urining.",
    subscription_pay_err_generic: "To'lov boshlanmadi. Qaytadan urining.",
    subscription_pay_err_payme_test_merchant:
      'Payme test rejimi: serverda PAYME_TEST_MERCHANT_ID (sandbox kassa) sozlanmagan. Production kassa ID test checkoutda «поставщик не найден» beradi.',
    subscription_pay_err_payme_not_configured: 'Payme merchant ID serverda sozlanmagan (PAYME_MERCHANT_ID).',
    subscription_pay_err_payme_invalid_merchant:
      'Payme kassa ID noto‘g‘ri (24 ta hex). Payme Business kabinetidagi qiymatni tekshiring.',
    subscription_pay_err_payme_key_not_configured:
      'Payme production kaliti (PAYME_KEY) serverda sozlanmagan.',
    subscription_pay_err_payme_production_checkout:
      'Payme checkout production domeni kerak (checkout.paycom.uz). Serverda PAYME_USE_TEST=false va PAYME_CHECKOUT_BASE tekshiring.',

    tenant_tariff_plan_change_title: 'Tarifni o‘zgartirish so‘rovi',
    tenant_tariff_plan_change_lead:
      'Boshqa tarif rejasi yoki hajmni xohlasangiz, quyida tanlang va izoh yozing. Platforma menejeri siz bilan bog‘lanadi.',
    tenant_tariff_plan_change_desired: 'Qaysi tarifga o‘tmoqchisiz',
    tenant_tariff_plan_change_desired_placeholder: 'Tanlang…',
    tenant_tariff_plan_change_note: 'Izoh',
    tenant_tariff_plan_change_note_ph: 'Masalan: katta filial ochmoqchiman, foydalanuvchilar soni oshishi kerak…',
    tenant_tariff_plan_change_submit: 'So‘rovni yuborish',
    tenant_tariff_plan_change_ok: 'So‘rov qabul qilindi. Tez orada bog‘lanamiz.',
    tenant_tariff_plan_change_error: 'So‘rov yuborilmadi. Qayta urinib ko‘ring.',

    tariff_type_start: 'Start',
    tariff_type_businessSmall: 'Kichik biznes',
    tariff_type_businessMedium: 'O‘rta biznes',
    tariff_type_businessEnterprise: 'Yirik korporatsiya',
    adminNav_integrations: 'Integratsiyalar',
    adminNav_tenant_management: 'Mijozlar',
    adminNav_tenant_messages: 'Mijozlar chati',
    adminNav_cashier_chat: 'Kassirlar bilan chat',
    adminNav_chat: 'Chat',
    adminNav_cashier_rating: 'Kassirlar reytingi',
    adminNav_ai_helper: 'AI yordamchi',
    adminNav_staff_chat: 'Ichki chat',
    adminNav_branches: 'Filiallar',
    adminNav_ombor: 'Ombor',
    adminOmbor_subtitle: 'Barcha mijozlarning tovarlari — qoldiq va sotilgan miqdori.',
    adminOmbor_add_product: 'Mahsulot qo\'shish',
    adminOmbor_mijozlar: 'Mijozlar',
    adminOmbor_mahsulotlar: 'Mahsulot turlari',
    adminOmbor_jami_qoldiq: 'Jami qoldiq',
    adminOmbor_jami_sotilgan: 'Jami sotilgan',
    adminOmbor_jami_qoldiq_summasi: 'Qoldiq summasi',
    adminOmbor_search_placeholder: 'Mijoz, mahsulot yoki viloyat bo\'yicha qidirish...',
    adminOmbor_refresh: 'Yangilash',
    adminOmbor_mijoz: 'Mijoz',
    adminOmbor_viloyat: 'Viloyat',
    adminOmbor_mahsulot: 'Mahsulot',
    adminOmbor_col_image: 'Rasm',
    adminOmbor_col_measure_variant: 'Variant / o\'lchov',
    adminOmbor_tenant_fav: 'Tanlangan',
    adminOmbor_tenant_fav_hint: 'Kassada tez topish uchun belgilang',
    adminOmbor_tenant_fav_toggle: 'Tanlangan mahsulot (yulduz)',
    adminOmbor_tenant_fav_add: "Tanlanganlarga qo'shish",
    adminOmbor_tenant_fav_remove: "Tanlanganlardan olib tashlash",
    adminOmbor_product_image: 'Mahsulot rasmi (ixtiyoriy)',
    adminOmbor_product_id: 'ID',
    adminOmbor_barcode: 'Shtrix-kod',
    adminOmbor_barcode_print: 'Shtrix-kodni chop etish',
    adminOmbor_barcode_copies: 'Soni',
    adminOmbor_barcode_size_mm: "O'lcham (mm)",
    adminOmbor_barcode_print_success: 'Shtrix-kod printerga yuborildi',
    adminOmbor_qoldiq: 'Qoldiq',
    adminOmbor_qoldiq_value: 'Qoldiq summasi',
    adminOmbor_batch_toggle_show: 'Boshqa partiyalarni ko‘rish',
    adminOmbor_batch_toggle_hide: 'Partiyalarni yashirish',
    adminOmbor_batch_arrived: 'Kelgan',
    adminOmbor_batch_paid: 'To‘langan',
    adminOmbor_batch_unpaid: 'To‘lanmagan',
    adminOmbor_batch_expense_link: 'Xarajat',
    adminOmbor_sotilgan: 'Sotilgan',
    adminOmbor_empty: 'Ma\'lumot topilmadi.',
    adminOmbor_modal_add: 'Yangi mahsulot',
    adminOmbor_modal_edit: 'Mahsulotni tahrirlash',
    adminOmbor_name_placeholder: 'Mahsulot nomi',
    adminOmbor_supplier_name: "Ta'minotchi",
    adminOmbor_supplier_placeholder: "Ta'minotchi nomini kiriting",
    adminOmbor_supplier_phone: "Ta'minotchi raqami",
    adminOmbor_supplier_phone_placeholder: "Ta'minotchi telefon raqamini kiriting",
    admininOmbor_supplier_name: "Ta'minotchi",
    admininOmbor_supplier_placeholder: "Ta'minotchi nomini kiriting",
    adminOmbor_quantity: 'Miqdor',
    adminOmbor_bulk_intake_title: "Ta'minotchi kirimi",
    adminOmbor_bulk_intake_hint:
      "Bir ta'minotchidan bir nechta mahsulotni bir vaqtda kiriting — ta'minotchi ma'lumotlari barcha qatorlar uchun umumiy.",
    adminOmbor_bulk_intake_add_row: 'Yana qator',
    adminOmbor_bulk_intake_remove_row: 'Qatorni olib tashlash',
    adminOmbor_bulk_intake_submit: 'Kirimni saqlash',
    adminOmbor_bulk_intake_product_select: 'Mahsulot tanlang',
    adminOmbor_bulk_intake_product_search: 'Mahsulot nomi, shtrix-kod yoki ID',
    adminOmbor_bulk_intake_product_no_results: 'Qidiruv bo‘yicha mahsulot topilmadi',
    adminOmbor_bulk_intake_error_no_items: 'Kamida bitta mahsulot va miqdor kiriting.',
    adminOmbor_bulk_intake_error_qty: 'Miqdor noto‘g‘ri.',
    adminOmbor_bulk_intake_error_qty_small: 'Miqdor juda kichik.',
    adminOmbor_bulk_intake_error_product: 'Barcha qatorlarda mahsulot tanlang.',
    adminOmbor_barcode_auto: 'bo\'sh qoldirilsa avtomatik yaratiladi',
    adminOmbor_measures_section: 'O\'lchovlar',
    adminOmbor_measure_card_title: 'O\'lchov',
    adminOmbor_primary_unit_title: 'ASOSIY O\'LCHOV',
    adminOmbor_extra_sale_header: 'QO\'SHIMCHA SOTILISH',
    adminOmbor_add_short: 'Qo\'shish',
    adminOmbor_variant_delete_disabled: 'Kamida bitta variant bo\'lishi kerak',
    adminOmbor_confirm_delete: 'Mahsulotni o\'chirish',
    adminOmbor_confirm_delete_text: 'Quyidagi mahsulotni o\'chirishni xohlaysizmi',
    adminOmbor_view_title: 'Mahsulot ma\'lumotlari',
    adminOmbor_detail_info: 'Asosiy ma\'lumotlar',
    adminOmbor_detail_stats: 'Sotuv statistikasi',
    adminOmbor_detail_variants_hint: 'Variantlar va o\'lchovlar',
    adminOmbor_detail_col_variant: 'Variant',
    adminOmbor_detail_col_stock_value: 'Qoldiq summasi',
    adminOmbor_sold_daily_avg: 'O\'rtacha kunlik sotuv',
    adminOmbor_sold_weekly_avg: 'O\'rtacha haftalik sotuv',
    adminOmbor_sold_monthly_avg: 'O\'rtacha oylik sotuv',
    adminOmbor_total_revenue: 'Umumiy savdo narxi',
    adminOmbor_total_cost: 'Tan narxi',
    adminOmbor_net_profit: 'Sof foyda',
    adminOmbor_filter_all_branches: 'Barcha filiallar',
    adminOmbor_sales_by_day: "Oylik sotuv (kunlar bo'yicha)",
    adminOmbor_chart_no_data: "Bu oy uchun ma'lumot yo'q",
    adminOmbor_chart_legend: "Kunlar 1–31, ustun — sotilgan miqdor",
    adminOmbor_search_inv_placeholder: "Mahsulot nomi, narx, shtrix-kod bo'yicha qidirish",
    adminOmbor_kpi_product_types: 'Mahsulot umumiy turi',
    adminOmbor_kpi_expiry_critical: 'Muddati 3 kundan kam',
    adminOmbor_kpi_expiry_hint: 'Bosib filtrlash / yana bosib bekor',
    adminOmbor_expiry_date: 'Amal qilish muddati',
    adminOmbor_expiry_days_left: 'kun qoldi',
    adminOmbor_expiry_passed: 'Muddati o\'tgan',
    adminOmbor_select_branch_for_table: 'Jadvalni ko\'rish uchun filial tanlang',
    product_sale_unit_type: 'O‘lchov',
    product_sale_unit_piece: 'Dona',
    product_sale_unit_kg: 'Kilogramm (kg)',
    product_sale_unit_meter: 'Metr (m)',
    product_sale_unit_liter: 'Litr (l)',
    product_sale_unit_box: 'Quti',
    product_sale_unit_pack: 'Pachka',
    product_sale_unit_roll: 'Rulon',
    product_sale_unit_set: "To'plam",
    product_sale_unit_pallet: 'Pallet',
    product_sale_unit_ton: 'Tonna (t)',
    product_sale_unit_sqm: 'Kv.m (m²)',
    product_sale_unit_cubic_meter: 'Kub.m (m³)',
    product_sale_unit_cm: 'Santimetr (cm)',
    product_sale_unit_mm: 'Millimetr (mm)',
    product_sale_unit_pair: 'Juft',
    product_sale_unit_size: "O'lcham (razmer)",
    product_sale_unit_wholesale: 'Optom',
    product_sale_unit_kg_short: 'kg',
    product_sale_unit_meter_short: 'm',
    product_sale_unit_liter_short: 'l',
    product_sale_unit_ton_short: 't',
    product_sale_unit_sqm_short: 'm²',
    product_sale_unit_cubic_meter_short: 'm³',
    product_sale_unit_cm_short: 'cm',
    product_sale_unit_mm_short: 'mm',
    product_sale_unit_pair_short: 'juft',
    product_sale_unit_size_short: 'razmer',
    product_sale_unit_wholesale_short: 'optom',
    product_wholesale_price: 'Optom narx',
    cashierKassa_optom_toggle: 'Optom',
    cashierKassa_optom_hint: 'Narqlar optom narx bo‘yicha sotiladi',
    product_sale_price_per_unit_hint: '1 kg yoki 1 m uchun narx',
    adminAIAdvisor_subtitle: 'AI tavsiyalar, prognozlar va strategik maslahatlar.',
    adminAIAdvisor_coming: 'Sales forecast, KPI reytinglar va AI Marketing tavsiyalari tez kunda.',
    adminNav_feature_flags: 'Funksiya bayroqlari',
    adminNav_audit_logs: 'Audit jurnali',
    adminNav_system_health: 'Tizim monitoringi',
    adminNav_usage_metrics: 'Foydalanish statistikasi',
    adminNav_error_monitoring: 'Nosozliklar va xatolar',
    adminNav_api_keys: 'API kalitlari',
    adminNav_company_dashboard: 'Boshqaruv yig‘masi',
    adminNav_branches: 'Filiallar tarmog‘i',
    adminNav_warehouses: 'Omborlar',
    adminNav_employees_roles: 'Xodimlar va rollar',
    adminNav_products: 'Mahsulotlar',
    adminNav_categories: 'Kategoriyalar',
    adminNav_price_management: 'Narxlar boshqaruvi',
    adminNav_customers: 'Mijozlar bazasi',
    adminNav_orders: 'Buyurtmalar boshqaruvi',
    adminNav_deliveries: 'Yetkazib berishlar',
    adminNav_reports: 'Tahliliy hisobotlar',
    adminNav_marketing: 'Marketing asboblari',
    adminNav_marketing_orders: 'Online buyurtmalar',
    adminNav_desktop_apps: 'Ilovalar',
    marketingAddon_modal_title: 'Marketing va onlayn buyurtmalar paketi',
    marketingAddon_modal_intro:
      '«Kichik biznes» tarifida bu modullarni birgalikda yoqish uchun bir martalik to‘lov — ikkala bo‘lim ham shu summada ochiladi.',
    marketingAddon_modal_amount_label: 'To‘lov summasi (bir marta)',
    marketingAddon_modal_unlocks: 'Marketing asboblari va Online buyurtmalar bir vaqtda yoqiladi.',
    marketingAddon_pay_click: 'Click orqali to‘lash',
    marketingAddon_pay_payme: 'Payme orqali to‘lash',
    marketingAddon_err_generic: 'To‘lovni boshlab bo‘lmadi. Qayta urinib ko‘ring.',
    marketingAddon_refresh_hint: 'To‘lovdan keyin «Yangilash» bosing yoki sahifani qayta yuklang.',
    marketingAddon_refresh_btn: 'Profilni yangilash',
    marketingAddon_close_btn: 'Boshqa bo‘limga o‘tish',
    desktopApps_page_subtitle:
      'Windows uchun Add-e desktop ilovasi serverda saqlanadi — bu yerda serverdagi joy va yuklab olish manzilini ko‘rasiz.',
    desktopApps_live_web_note:
      'Interfeys yangilanishlari veb-saytdan avtomatik yuklanadi — har safar .exe qayta yuklash shart emas. Ctrl+R yoki menyudan «Yangilash» bilan keshni yangilashingiz mumkin. Faqat bir marta yangi .exe o‘rnating (eski versiyada bu ishlamaydi).',
    desktopApps_card_title: 'Add-e Desktop App',
    desktopApps_card_platform: 'Windows',
    desktopApps_download_title: 'Add-e Desktop (Windows)',
    desktopApps_download_desc: 'O‘rnatuvchi (Setup) — yuklab oling, o‘rnating, papka va ishchi stol yorlig‘ini tanlang, keyin tizimga kiring.',
    desktopApps_download_btn: 'Yuklab olishni boshlash',
    desktopApps_download_note: 'Yuklab olish boshlanganini brauzer pastki qismidagi progressdan kuzating.',
    desktopApps_step_1: 'Faylni yuklab oling',
    desktopApps_step_2: 'Setup faylini ishga tushiring, o‘rnatish joyini va yorliqlarni tanlang',
    desktopApps_step_3: 'Desktop ilovada «Kirish» orqali akkauntingiz bilan kiring',
    desktopApps_no_url: 'Yuklab olish havolasi hozircha sozlanmagan. Qo‘llab-quvvatlashga murojaat qiling.',
    desktopApps_info_loading: 'Server ma’lumotlari yuklanmoqda…',
    desktopApps_info_load_error: 'Desktop ilova haqida ma’lumot olinmadi.',
    desktopApps_server_file_label: 'Serverdagi fayl',
    desktopApps_public_url_label: 'Yuklab olish havolasi (HTTPS)',
    desktopApps_file_size_label: 'Fayl hajmi',
    desktopApps_download_public_note: 'Tugma bosilganda brauzer public papkadagi .exe faylni yuklab oladi (masalan https://api.addegroup.uz/Adde-1.0.0-x64.exe).',
    desktopApps_download_error: 'Yuklab olishda xato. Qayta urinib ko‘ring yoki administratorga murojaat qiling.',
    desktopApps_not_on_server:
      'Serverda public papkada .exe topilmadi. Faylni masalan public/Adde-1.0.0-x64.exe ga yuklang (nomi .env da ADDE_DESKTOP_PUBLIC_FILENAME bilan mos bo‘lsin).',
    desktopApps_deploy_hint:
      'Administrator: tayyor Adde-1.0.0-x64.exe faylni API saytining public/ papkasiga yuklang. Boshqa nom yoki versiya bo‘lsa .env da ADDE_DESKTOP_PUBLIC_FILENAME ni yangilang.',
    subscription_force_renew_hint:
      'Obuna muddati tugagan. Ishlashni davom ettirish uchun tarifni yangilang va to‘lovni amalga oshiring. To‘lov tasdiqlanmaguncha bu oyna yopilmaydi.',
    cashierSubscriptionReminder_title: 'Obuna to‘lovi eslatmasi',
    cashierSubscriptionReminder_body:
      'Mijoz (do‘kon egasi) uchun oylik obuna muddati o‘tgan va to‘lov hali amalga oshirilmagan. Iltimos, mijozga xabar bering — to‘lov qilinmaguncha bu oyna yopilmaydi.',
    adminNav_notifications: 'Bildirishnomalar markazi',
    adminNav_company_settings: 'Kompaniya sozlamalari',
    adminNav_settings: 'Profil va tizim sozlamalari',
    adminNav_printer_connect: 'Chek printerlari',
    adminNav_help: 'Qo‘llanma va qo‘llab-quvvatlash',
    adminNav_sessions: 'Sessiyalar va qurilmalar',
    adminSessions_subtitle: 'Hisobingizga kirgan qurilmalarni kuzating va kerak bo‘lsa sessiyalarni bekor qiling.',
    adminSessions_refresh: 'Yangilash',
    adminSessions_revoke_others: 'Joriydan boshqasini bekor qilish',
    adminSessions_revoke_selected: 'Tanlanganlarni bekor qilish',
    adminSessions_total: 'Jami sessiyalar',
    adminSessions_selected: 'Tanlangan',
    adminSessions_current: 'Joriy qurilma',
    adminSessions_loading: 'Sessiyalar yuklanmoqda...',
    adminSessions_empty: 'Faol sessiyalar topilmadi.',
    adminSessions_device: 'Qurilma',
    adminSessions_type: 'Turi',
    adminSessions_last_active: 'Oxirgi faollik',
    adminSessions_created: 'Yaratilgan',
    adminSessions_device_unknown: 'Noma’lum qurilma',
    adminSessions_current_badge: 'Joriy',
    adminSessions_current_session: 'Joriy sessiya',
    adminSessions_select_session: 'Sessiyani tanlash',
    adminSessions_confirm_selected: 'Tanlangan sessiyalar bekor qilinsinmi?',
    adminSessions_confirm_others: 'Joriy qurilmadan tashqari barcha sessiyalar bekor qilinsinmi?',
    adminSessions_load_error: 'Sessiyalarni yuklab bo‘lmadi.',
    adminSessions_action_error: 'Sessiyani bekor qilishda xatolik yuz berdi.',
    adminNav_kassa: 'Savdo kabinasi (POS)',
    adminNav_retail_clients: 'Chakana mijozlar bazasi',
    adminNav_pos_orders: 'Kassa buyurtmalari',
    adminNav_manager_customers: 'Mijozlar bazasi',
    adminNav_manager_payments: 'To‘lovlar va tranzaksiyalar',
    adminNav_cashier_z_report: 'Z-Report',
    adminNav_order_history: 'Buyurtmalar tarixi',
    adminNav_ombor_products: 'Tovar qoldiqlari',
    adminNav_maslahat: 'Maslahat va tavsiyalar',
    adminNav_delivery_status: 'Yetkazib berish holati',
    adminNav_product_catalog: 'Mahsulot katalogi',
    adminNav_inventory_dashboard: 'Ombor boshqaruvi',
    adminNav_stock_in: 'Tovar kirimi',
    adminNav_stock_out: 'Tovar chiqimi',
    adminNav_transfers: 'Omborlararo ko‘chirish',
    adminNav_barcode_scanner: 'Shtrix-kod skaneri',
    adminNav_inventory_audit: 'Inventarizatsiya',
    adminNav_expiry_tracking: 'Yaroqlilik muddati',
    adminInventory_product_id: 'Mahsulot ID',
    adminInventory_stock_add: "Qoldiq qo'shish",
    adminInventory_stock_add_expense_hint:
      "To'langan belgilanmasa, xarid summasi xarajatlar bo'limiga qo'shiladi. Ta'minotchi tanlanmasa — har kirim uchun alohida mahsulot xarajati va alohida partiya yaratiladi.",
    adminOmbor_purchase_price: "Sotib olingan narx",
    adminOmbor_sale_price: 'Sotish narxi',
    adminOmbor_additional_sale_price: "Qo'shimcha sotilish narxi (ixtiyoriy)",
    adminInventory_quantity: 'Miqdor',
    adminInventory_expiry: 'Amal qilish muddati',
    adminInvDash_expiry_empty: 'Kiritilmagan',
    adminTopbar_expiry_alerts: 'Muddati tugashga yaqin mahsulotlar',
    adminTopbar_expiry_days: 'kun',
    adminTopbar_expiry_left: 'qoldi',
    adminTopbar_expiry_ago: 'oldin',
    adminTopbar_expiry_today: 'Bugun',
    adminInventory_from_warehouse: 'Qayerdan ombor',
    adminInventory_to_warehouse: 'Qayerga ombor',
    adminInventory_action_save: 'Saqlash',
    adminInventory_action_loading: 'Saqlanmoqda...',
    adminInventory_action_success: 'Saqlandi',
    adminBarcodeScan_title: 'Shtrix-kod',
    adminBarcodeScan_placeholder: 'Shtrix-kodni kiriting',
    adminBarcodeScan_action: 'Tekshirish',
    adminBarcodeScan_found: 'Topildi',
    adminPagination_prev: 'Oldingi',
    adminPagination_next: 'Keyingi',
    adminPagination_page: 'Sahifa',
    adminNav_finance_dashboard: 'Moliyaviy ko‘rsatkichlar',
    adminNav_transactions: 'Pul oqimi (tranzaksiyalar)',
    adminNav_invoices: 'Hisob-fakturalar (invoys)',
    adminNav_taxes: 'Soliq hisobi',
    adminNav_1c_integration: '1C integratsiyasi',
    adminNav_profit_loss: 'Foyda va zarar hisobi',
    adminNav_balance_sheet: 'Balans jadvali',
    adminNav_export_reports: 'Ma’lumotlarni eksport',
    adminNav_analytics_dashboard: 'Marketing va sotuv tahlili',
    adminNav_sales_funnel: 'Sotuv voronkasi',
    adminNav_customer_segments: 'Mijoz segmentlari',
    adminNav_campaigns: 'Marketing kampaniyalari',
    adminNav_ai_recommendations: 'AI tavsiyalar',
    adminNav_retention: 'Mijozlarni ushlab qolish',
    adminNav_cohort_analysis: 'Kohort tahlili',
    analytics_dash_subtitle: 'Asosiy KPI: tashriflar, sessiyalar, konversiya va daromad.',
    analytics_dash_subtitle_pro: 'Maqsad va fakt, kanal tahlili, trend va qarorlar uchun tavsiyalar.',
    analytics_dash_exec_summary: 'O\'tgan oyga nisbatan daromad +12,4% oshdi. Eng kuchli trafik manbai — Organic Search (45%). Konversiya 4,2% — reja ustida. Keyingi oy prognoz ijobiy.',
    analytics_dash_goals_title: 'Maqsad vs Fakt (joriy oy)',
    analytics_dash_goals_metric: 'Ko\'rsatkich',
    analytics_dash_goals_target: 'Maqsad',
    analytics_dash_goals_actual: 'Fakt',
    analytics_dash_goals_achievement: 'Bajarilishi',
    analytics_goal_revenue: 'Daromad (UZS)',
    analytics_goal_conversion: 'Konversiya (%)',
    analytics_goal_new_customers: 'Yangi mijozlar',
    analytics_goal_visitors: 'Unikal tashriflar',
    analytics_goal_sessions: 'Sessiyalar',
    analytics_goal_avg_session: 'O\'rtacha sessiya (daq.)',
    analytics_dash_channels_title: 'Trafik manbalari bo\'yicha taqsimot',
    channel_organic: 'Organik qidiruv',
    channel_direct: 'To\'g\'ridan-to\'g\'ri',
    channel_paid: 'Pulli reklama',
    analytics_dash_visitors_short: 'tashrif',
    analytics_dash_sessions_short: 'sessiya',
    analytics_dash_conversion_short: 'konv.',
    analytics_week: 'Hafta',
    analytics_dash_trend_weekly: 'Haftalik trafik (oxirgi 12 hafta)',
    analytics_dash_min: 'Min',
    analytics_dash_max: 'Maks',
    analytics_dash_avg: 'O\'rtacha',
    analytics_dash_trend_growth: 'O\'sish',
    analytics_dash_forecast_title: 'Prognoz va faollik',
    analytics_dash_forecast_label: 'Keyingi oy daromad prognozi',
    analytics_dash_peak_hours: 'Eng faol soatlar (trafik)',
    analytics_dash_insights_title: 'Asosiy xulosalar',
    analytics_insight_1: 'Organik kanal o\'sishi davom etmoqda — SEO va kontent strategiyasini saqlab qoling.',
    analytics_insight_2: 'Ijtimoiy tarmoq trafigi o\'tgan oyga nisbatan +15% — reklama byudjetini qayta ko\'rib chiqing.',
    analytics_insight_3: 'Pulli kanalda tushish — A/B testlar va landing sahifalar optimallashtirish tavsiya etiladi.',
    analytics_insight_4: 'Haftalik trafik oxirgi 4 haftada barqaror o\'sishda — reklama va kontent rejasi samarali.',
    analytics_insight_5: 'To\'g\'ridan-to\'g\'ri tashriflar yuqori konversiya beradi — brend va eslatmalarni kuchaytiring.',
    analytics_insight_6: 'Eng faol soatlar 10:00–14:00 — shu vaqtda reklama va push-xabarnomalarni rejalashtiring.',
    analytics_dash_recommendations_title: 'Tavsiya qilinadigan qadamlar',
    analytics_rec_1: 'Landing sahifalarda konversiyani oshirish uchun CTA va formani soddalashtiring.',
    analytics_rec_2: 'Email kampaniyasini at-risk segmentga yo\'naltiring — churnni kamaytirish.',
    analytics_rec_3: 'Keyingi chorak uchun pulli kanal maqsadlarini qayta belgilang va ROI kuzating.',
    analytics_rec_4: '10:00–14:00 oralig\'ida reklama byudjetini oshiring — eng yuqori konversiya davri.',
    analytics_rec_5: 'Haftalik hisobotlarni avtomatlashtiring va menejerlar uchun qisqa xulosa yuboring.',
    analytics_priority_high: 'Yuqori',
    analytics_priority_medium: 'O\'rta',
    analytics_dash_kpi: 'Asosiy ko\'rsatkichlar',
    analytics_dash_unique_visitors: 'Unikal tashriflar (30 kun)',
    analytics_dash_sessions: 'Sessiyalar',
    analytics_dash_conversion_rate: 'Konversiya (%)',
    analytics_dash_avg_session: 'O\'rtacha sessiya (min)',
    analytics_dash_bounce_rate: 'Bounce rate (%)',
    analytics_dash_revenue_month: 'Oylik daromad',
    analytics_dash_top_channel: 'Eng samarali kanal',
    analytics_dash_new_customers: 'Yangi mijozlar (oy)',
    analytics_dash_repeat_orders: 'Takroriy buyurtmalar (%)',
    analytics_dash_visitors_weekly: 'Haftalik tashriflar',
    analytics_dash_revenue_6m: 'Oylik daromad (6 oy)',
    analytics_funnel_subtitle: 'Sotuv funneli bosqichlari va keyingi bosqichga o\'tish foizi.',
    analytics_funnel_stage: 'Bosqich',
    analytics_funnel_count: 'Son',
    analytics_funnel_conversion_next: 'Keyingi bosqichga (%)',
    analytics_funnel_dropoff: 'Tushish (%)',
    funnel_awareness: 'Xabardorlik',
    funnel_interest: 'Qiziqish',
    funnel_consideration: 'Ko\'rib chiqish',
    funnel_intent: 'Niyat',
    funnel_purchase: 'Xarid',
    funnel_loyalty: 'Sadoqat',
    analytics_segments_subtitle: 'Mijoz segmentlari bo\'yicha daromad ulushi va o\'sish.',
    analytics_segments_name: 'Segment',
    analytics_segments_count: 'Mijozlar',
    analytics_segments_revenue_share: 'Daromad ulushi (%)',
    analytics_segments_avg_order: 'O\'rtacha check (UZS)',
    analytics_segments_growth: 'O\'sish (%)',
    analytics_segments_desc: 'Tavsif',
    segment_vip: 'VIP',
    segment_active: 'Faol',
    segment_regular: 'Oddiy',
    segment_new: 'Yangi',
    segment_at_risk: 'Xavf ostida',
    segment_churned: 'Ketgan',
    segment_vip_desc: 'Eng yuqori daromad va tez-tez xarid qiluvchilar.',
    segment_active_desc: 'So\'nggi 3 oyda faol xarid qilgan.',
    segment_regular_desc: 'O\'rtacha chastotada xarid qiluvchilar.',
    segment_new_desc: 'Ro\'yxatdan o\'tganidan 30 kun otmagan.',
    segment_at_risk_desc: 'Faolligi pasaygan, churn xavfi yuqori.',
    segment_churned_desc: 'Uzun muddat faol emas.',
    analytics_campaigns_subtitle: 'Marketing kampaniyalari: byudjet, qamrov va ROI.',
    analytics_campaigns_name: 'Kampaniya',
    analytics_campaigns_status: 'Status',
    analytics_campaigns_channel: 'Kanal',
    analytics_campaigns_budget: 'Byudjet',
    analytics_campaigns_spent: 'Sarflangan',
    analytics_campaigns_reach: 'Qamrov',
    analytics_campaigns_conversions: 'Konversiyalar',
    analytics_campaigns_roi: 'ROI (%)',
    analytics_campaigns_dates: 'Davr',
    analytics_campaign_status_active: 'Faol',
    analytics_campaign_status_paused: 'To\'xtatilgan',
    analytics_campaign_status_completed: 'Tugallangan',
    analytics_campaign_status_draft: 'Qoralama',
    campaign_spring_sale: 'Bahor chegirmasi 2025',
    campaign_email_retention: 'Email — saqlab qolish',
    campaign_google_ads: 'Google Ads — yanvar',
    campaign_telegram: 'Telegram kanal — yanvar',
    campaign_new_segment: 'Yangi segment loyihasi',
    channel_social: 'Ijtimoiy tarmoq',
    channel_email: 'Email',
    channel_google: 'Google Ads',
    channel_telegram: 'Telegram',
    analytics_ai_rec_subtitle: 'AI asosida mahsulot, narx va marketing tavsiyalari.',
    analytics_rec_priority_high: 'Yuqori',
    analytics_rec_priority_medium: 'O\'rta',
    analytics_rec_priority_low: 'Past',
    analytics_rec_estimated_lift: 'Taxminiy o\'sish',
    rec_product_bundle: 'Komplekt taklifi',
    rec_product_bundle_desc: 'A, B, C mahsulotlarini bitta komplekt sifatida taklif qilish — xaridorlarning o\'rtacha checkini oshiradi.',
    rec_product_bundle_impact: 'Kutilayotgan ta\'sir: savdo hajmi +18%.',
    rec_retention_email: 'Email orqali eslatma',
    rec_retention_email_desc: 'So\'nggi 14 kun ichida xarid qilmagan faol segmentga shaxsiylashtirilgan taklif yuborish.',
    rec_retention_email_impact: 'Qayta faollashtirish va churnni kamaytirish.',
    rec_pricing_dynamic: 'Dinamik narxlash',
    rec_pricing_dynamic_desc: 'Talab va zaxiraga qarab tanlangan kategoriyalarda narxlarni avtomatik sozlash.',
    rec_pricing_dynamic_impact: 'Marja va aylanma optimallashtirish.',
    rec_marketing_segment: 'Segment bo\'yicha reklama',
    rec_marketing_segment_desc: 'VIP va At risk segmentlariga alohida kampaniyalar ishlab chiqish.',
    rec_marketing_segment_impact: 'ROI va konversiya oshishi.',
    rec_inventory_stock: 'Zaxira optimallashtirish',
    rec_inventory_stock_desc: 'AI prognoziga ko\'ra kam qolgan tovarlar uchun buyurtma tavsiyasi.',
    rec_inventory_stock_impact: 'Yetishmaslikni kamaytirish.',
    analytics_retention_subtitle: 'Mijozlarni saqlab qolish: 1-, 7-, 30-, 90-kun ko\'rsatkichlari.',
    analytics_retention_kpi: 'Saqlab qolish foizi',
    analytics_retention_day1: '1-kun',
    analytics_retention_day7: '7-kun',
    analytics_retention_day30: '30-kun',
    analytics_retention_day90: '90-kun',
    analytics_retention_chart_title: 'Haftalik saqlab qolish (kohort)',
    retention_week1: '1-hafta',
    retention_week2: '2-hafta',
    retention_week3: '3-hafta',
    retention_week4: '4-hafta',
    retention_week8: '8-hafta',
    retention_week12: '12-hafta',
    analytics_cohort_subtitle: 'Ro\'yxatdan o\'tgan kohortlar bo\'yicha saqlab qolish matritsasi.',
    analytics_cohort_cohort: 'Kohort',
    analytics_cohort_size: 'Hajm',
    analytics_cohort_period0: '0-period (%)',
    analytics_cohort_period1: '1-period (%)',
    analytics_cohort_period2: '2-period (%)',
    analytics_cohort_period3: '3-period (%)',
    analytics_cohort_note: 'Foizlar — ro\'yxatdan o\'tganlar soniga nisbatan har bir davrda faol qolgan mijozlar.',
    adminNav_my_deliveries: 'Yetkazib berishlar',
    adminNav_route_map: 'Marshrutlar',
    adminNav_courier_order_status: 'Buyurtma holati',
    adminNav_offline_sync: 'Offline',
    adminNav_earnings: 'Daromad',
    adminNav_my_orders: 'Buyurtmalarim',
    adminNav_customer_payments: 'To\'lovlar',
    adminNav_profile: 'Profil',
    adminNav_locations: 'Manzillar',

    // Super Admin sections (promptga mos)
    adminSuper1Title: 'Tizimning umumiy sozlamalarini boshqarish',
    adminSuper1Desc: 'Tizimning umumiy sozlamalarini boshqarish. Bu rol asosan tizimni rivojlantiruvchilar yoki yuqori darajadagi administratorlar uchun mo\'ljallangan.',
    adminSuper2Title: 'Tarif paketlarini belgilash',
    adminSuper2Desc: 'Tarif paketlarini belgilash va narxlarni boshqarish.',
    adminSuper3Title: 'Tashqi integratsiyalarni o\'rnatish',
    adminSuper3Desc: 'Tashqi integratsiyalarni o\'rnatish: API, to\'lov tizimlari va uchinchi tomon xizmatlari.',
    adminSuper4Title: 'Barcha ma\'lumotlarga to\'liq kirish huquqiga ega bo\'lish',
    adminSuper4Desc: 'Barcha ma\'lumotlarga to\'liq kirish huquqiga ega bo\'lish: foydalanuvchilar, hisobotlar, audit va eksport.',
    adminSuper5Title: 'Boshqa rollarni ham nazorat qilish',
    adminSuper5Desc: 'Bu rol boshqa rollarni ham nazorat qiladi: rollarni yaratish, huquqlarni belgilash va boshqarish.',

    // Biznes Admin sections (promptga mos)
    adminBiznes1Title: 'Filiallar va omborlarni yaratish va boshqarish',
    adminBiznes1Desc: 'Filiallar va omborlarni yaratish va boshqarish. Bu rol biznes egasi yoki yuqori rahbarlar uchun.',
    adminBiznes2Title: 'Xodimlarni ro\'yxatdan o\'tkazish va huquqlarini belgilash',
    adminBiznes2Desc: 'Xodimlarni ro\'yxatdan o\'tkazish va huquqlarini belgilash.',
    adminBiznes3Title: 'Mahsulotlar katalogini yuritish',
    adminBiznes3Desc: 'Mahsulotlar katalogini yuritish: mahsulotlar, kategoriyalar va narxlar.',
    adminBiznes4Title: 'Savdo jarayonlarini nazorat qilish',
    adminBiznes4Desc: 'Savdo jarayonlarini nazorat qilish.',
    adminBiznes5Title: 'Hisobotlarni chiqarish',
    adminBiznes5Desc: 'Hisobotlarni chiqarish. Bu rol kompaniya ichki faoliyatini to\'liq boshqarishga imkon beradi.',

    // Menejer/Sotuvchi sections (promptga mos)
    adminMenejer1Title: 'Buyurtmalarni yaratish va boshqarish',
    adminMenejer1Desc: 'Buyurtmalarni yaratish va boshqarish. Bu rol savdo guruhlari uchun mo\'ljallangan.',
    adminMenejer2Title: 'Mijozlar ma\'lumotlarini yuritish',
    adminMenejer2Desc: 'Mijozlar ma\'lumotlarini yuritish: baza, qidiruv va xarid tarixi.',
    adminMenejer3Title: 'To\'lovlarni qabul qilish',
    adminMenejer3Desc: 'To\'lovlarni qabul qilish.',
    adminMenejer4Title: 'Yetkazib berish jarayonini nazorat qilish',
    adminMenejer4Desc: 'Yetkazib berish jarayonini nazorat qilish. Kunlik savdo operatsiyalarini tez va samarali amalga oshirishga yordam beradi.',

    // Admin settings (sidebar sections)
    adminSettingsHeading: 'Sozlamalar',
    adminAdd: 'Qo\'shish',
    adminFormSave: 'Saqlash',
    adminFormClose: 'Yopish',
    adminSetPlaceholder: 'Kiriting',
    adminSetLang: 'Til',
    adminSetTimezone: 'Vaqt zonasi',
    adminSetPanelName: 'Panel nomi',
    adminSetTariffName: 'Tarif nomi',
    adminSetPrice: 'Narx (UZS)',
    adminSetPeriod: 'Amal qilish muddati',
    adminSetApiKey: 'API kalit',
    adminSetWebhook: 'Webhook URL',
    adminSetExportFormat: 'Eksport formati',
    adminSetMaxRows: 'Maksimal qatorlar',
    adminSetRoleName: 'Rol nomi',
    adminSetPermissionType: 'Huquq turi',
    adminSetBranchName: 'Filial nomi',
    adminSetWarehouse: 'Ombor',
    adminSetAddress: 'Manzil',
    adminSetStaffName: 'Xodim F.I.O.',
    adminSetPosition: 'Lavozim',
    adminSetAccess: 'Kirish huquqi',
    adminSetProductName: 'Mahsulot nomi',
    adminSetCategory: 'Kategoriya',
    adminSetPaymentMethod: 'To\'lov usuli',
    adminSetReceiptType: 'Chek turi',
    adminSetReportType: 'Hisobot turi',
    adminSetDateRange: 'Sana oralig\'i',
    adminSetOrderNumber: 'Buyurtma raqami',
    adminSetOrderStatus: 'Buyurtma holati',
    adminSetCustomer: 'Mijoz',
    adminSetCustomerName: 'Mijoz F.I.O.',
    adminSetPhone: 'Telefon',
    adminSetAmount: 'Summa',
    adminSetDeliveryAddress: 'Yetkazib berish manzili',
    adminSetDeliveryStatus: 'Yetkazib berish holati',
    adminSetQuantity: 'Miqdor',
    adminSetOperationType: 'Operatsiya turi',
    adminSetInventoryDate: 'Inventarizatsiya sanasi',
    adminSetBarcode: 'Shtrix-kod',
    adminSetTaxSystem: 'Soliq tizimi',
    adminSetTaxRate: 'Soliq stavkasi',
    adminSetCampaignName: 'Kampaniya nomi',
    adminSetSegmentName: 'Segment nomi',
    adminSetAiRecommendation: 'AI tavsiyasi',
    adminSetOfflineMode: 'Offline rejim',
    adminSetSyncInterval: 'Sinxronlash oralig\'i',
    adminSetRouteName: 'Marshrut nomi',
    adminSetLocation: 'Lokatsiya',

    // New roles
    roleTitle_warehouse_clerk: 'Omborchi',
    roleDesc_warehouse_clerk: 'Mahsulotlarning kirim-chiqim operatsiyalarini yuritish, inventarizatsiyani o\'tkazish va shtrix-kod orqali mahsulotlarni identifikatsiya qilish. Bu rol ombor xodimlari uchun bo\'lib, qoldiqlar va harakatlarni real vaqt rejimida kuzatish imkonini beradi.',
    roleTitle_accountant: 'Buxgalter',
    roleDesc_accountant: 'Soliq tizimlari va 1C dasturlari bilan integratsiya, to\'lovlar va moliyaviy hujjatlarni boshqarish. Bu rol moliyaviy bo\'lim xodimlari uchun mo\'ljallangan bo\'lib, hisobotlar va soliq deklaratsiyalarini avtomatlashtirishga yordam beradi.',
    roleTitle_analitik_marketing: 'Analitik',
    roleDesc_analitik_marketing: 'Kampaniya va sotuv tahlili, mijoz segmentlari, hisobotlar va tavsiyalar.',
    roleTitle_kuryer_field: 'Kuryer / Field agent',
    roleDesc_kuryer_field: 'Offline rejimda ishlash imkoniyati, yetkazib berish statuslarini yangilash va marshrutlarni kuzatish. Bu rol yetkazib beruvchilar uchun mo\'ljallangan bo\'lib, mobil qurilmalar orqali real vaqt rejimida ma\'lumotlarni yangilashga yordam beradi.',
    roleTitle_tenant_owner: 'Joy egasi (dastur sotib olgan)',
    roleDesc_tenant_owner: 'O\'z joyining boshqaruvi: kassirlar, filiallar, savdo, nasiya, moliya va hisobotlar. Chakana mijozlar va Telegram orqali xabarlar.',

    // Omborchi sections (promptga mos)
    adminOmborchi1Title: 'Mahsulotlarning kirim-chiqim operatsiyalarini yuritish',
    adminOmborchi1Desc: 'Mahsulotlarning kirim-chiqim operatsiyalarini yuritish.',
    adminOmborchi2Title: 'Inventarizatsiyani o\'tkazish',
    adminOmborchi2Desc: 'Inventarizatsiyani o\'tkazish.',
    adminOmborchi3Title: 'Shtrix-kod orqali mahsulotlarni identifikatsiya qilish',
    adminOmborchi3Desc: 'Shtrix-kod orqali mahsulotlarni identifikatsiya qilish.',
    adminOmborchi4Title: 'Qoldiqlar va harakatlarni real vaqt rejimida kuzatish',
    adminOmborchi4Desc: 'Qoldiqlar va harakatlarni real vaqt rejimida kuzatish. Bu rol ombor xodimlari uchun bo\'lib, bu imkoniyatni beradi.',
    adminOmborchi5Title: 'Ombor xodimlari uchun sozlamalar',
    adminOmborchi5Desc: 'Bu rol ombor xodimlari uchun bo\'lib, qoldiqlar va harakatlarni real vaqt rejimida kuzatish imkonini beradi.',

    // Buxgalter sections (promptga mos)
    adminBuxgalter1Title: 'Soliq tizimlari va 1C dasturlari bilan integratsiya',
    adminBuxgalter1Desc: 'Soliq tizimlari va 1C dasturlari bilan integratsiya. Bu rol moliyaviy bo\'lim xodimlari uchun mo\'ljallangan.',
    adminBuxgalter2Title: '1C dasturlari bilan integratsiya',
    adminBuxgalter2Desc: '1C dasturlari bilan ma\'lumotlar almashinuvi va sinxronlash.',
    adminBuxgalter3Title: 'To\'lovlar va moliyaviy hujjatlarni boshqarish',
    adminBuxgalter3Desc: 'To\'lovlar va moliyaviy hujjatlarni boshqarish.',
    adminBuxgalter4Title: 'Hisobotlar va soliq deklaratsiyalarini avtomatlashtirish',
    adminBuxgalter4Desc: 'Hisobotlar va soliq deklaratsiyalarini avtomatlashtirishga yordam beradi.',
    adminBuxgalter5Title: 'Moliyaviy bo\'lim sozlamalari',
    adminBuxgalter5Desc: 'Bu rol moliyaviy bo\'lim xodimlari uchun mo\'ljallangan bo\'lib, hisobotlar va soliq deklaratsiyalarini avtomatlashtirishga yordam beradi.',

    // Analitik bo'limlari
    adminAnalitik1Title: 'Kampaniya hisoboti',
    adminAnalitik1Desc: 'Reklama kampaniyalari samaradorligi va xarajatlar bo\'yicha hisobot.',
    adminAnalitik2Title: 'Mijoz segmentlari',
    adminAnalitik2Desc: 'Mijozlarni guruhlash, filtrlar va segmentlar bo\'yicha ishlash.',
    adminAnalitik3Title: 'Mahsulot tavsiyalari',
    adminAnalitik3Desc: 'Savdo va xaridlar asosida tavsiyalar sozlash.',
    adminAnalitik4Title: 'Mijoz tahlili',
    adminAnalitik4Desc: 'Xulq-atvor va saqlash (retention) ko\'rsatkichlari.',
    adminAnalitik5Title: 'Analitika sozlamalari',
    adminAnalitik5Desc: 'Hisobotlar, eksport va integratsiya parametrlari.',

    // Kuryer/Field sections (promptga mos)
    adminKuryer1Title: 'Offline rejimda ishlash imkoniyati',
    adminKuryer1Desc: 'Offline rejimda ishlash imkoniyati. Bu rol yetkazib beruvchilar uchun mo\'ljallangan.',
    adminKuryer2Title: 'Yetkazib berish statuslarini yangilash',
    adminKuryer2Desc: 'Yetkazib berish statuslarini yangilash.',
    adminKuryer3Title: 'Marshrutlarni kuzatish',
    adminKuryer3Desc: 'Marshrutlarni kuzatish.',
    adminKuryer4Title: 'Mobil qurilmalar orqali real vaqt rejimida ma\'lumotlarni yangilash',
    adminKuryer4Desc: 'Mobil qurilmalar orqali real vaqt rejimida ma\'lumotlarni yangilashga yordam beradi.',
    adminKuryer5Title: 'Yetkazib beruvchilar uchun sozlamalar',
    adminKuryer5Desc: 'Bu rol yetkazib beruvchilar uchun mo\'ljallangan bo\'lib, mobil qurilmalar orqali real vaqt rejimida ma\'lumotlarni yangilashga yordam beradi.',

    // Mijoz sections (promptga mos, ixtiyoriy portal)
    adminMijoz1Title: 'Buyurtma tarixini ko\'rish',
    adminMijoz1Desc: 'Buyurtma tarixini ko\'rish. Bu rol mijozlar uchun.',
    adminMijoz2Title: 'To\'lovlarni amalga oshirish',
    adminMijoz2Desc: 'To\'lovlarni amalga oshirish.',
    adminMijoz3Title: 'Lokatsiya ma\'lumotlarini ulashish',
    adminMijoz3Desc: 'Lokatsiya ma\'lumotlarini ulashish.',
    adminMijoz4Title: 'O\'z-o\'ziga xizmat ko\'rsatish portali',
    adminMijoz4Desc: 'O\'z-o\'ziga xizmat ko\'rsatish portalini taqdim etadi va biznes bilan aloqani osonlashtiradi.',
    adminMijoz5Title: 'Mijoz portali (ixtiyoriy)',
    adminMijoz5Desc: 'Bu rol mijozlar uchun bo\'lib, o\'z-o\'ziga xizmat ko\'rsatish portalini taqdim etadi va biznes bilan aloqani osonlashtiradi.',

    // Nasiya / Credits (sidebar: adminNav_credits yuqoridagi nav blokida)
    adminCredits_cashier_subtitle: 'Joriy kassir uchun nasiya savdolari va qoplash ro\'yxati.',
    adminCredits_client_subtitle: 'Filiallar va kassirlar bo\'yicha barcha nasiya savdolari.',
    adminCredits_list_title: 'Nasiya ro\'yxati',
    adminCredits_archive_title: 'Nasiya arxivi',
    adminCredits_archive_btn: 'Arxiv',
    adminCredits_back_to_active: 'Faol ro\'yxat',
    adminCredits_archive_empty: 'Arxivda yozuvlar yo\'q.',
    adminCredits_empty: 'Hozircha nasiya savdolar yo\'q.',
    adminCredits_products: 'Mahsulotlar',
    adminCredits_prices: 'Narxlar',
    adminCredits_client: 'Mijoz',
    adminCredits_branch: 'Filial',
    adminCredits_cashier: 'Kassir',
    adminCredits_total: 'Nasiya summasi',
    adminCredits_remaining: 'Qolgan summa',
    adminCredits_createdAt: 'Yaratilgan sana',
    adminCredits_actions: 'Amallar',
    adminCredits_repay: 'Qoplash',
    adminCredits_closed: 'Yopilgan',
    adminCredits_repay_title: 'Nasiyani qoplash',
    adminCredits_repay_remaining: 'Qolgan summa',
    adminCredits_repay_amount: 'Qoplanadigan summa',
    adminCredits_repay_method: 'To\'lov usuli',
    adminCredits_repay_saving: 'Saqlanmoqda…',
    adminCredits_repay_submit: 'Qoplash',
    adminCredits_repay_discount_optional: 'Chegirma (ixtiyoriy), UZS',
    adminCredits_repay_discount_hint:
      'Chegirma faqat nasiya qoldigʻidan yechiladi; kassaga tushadigan summa yuqoridagi «Qoplanadigan summa». Naqd + chegirma jami qoldiqdan oshmasin.',
    adminCredits_repay_total_applied: 'Nasiyadan yechiladi (jami)',
    adminCredits_telegram_reminder: 'Telegram eslatma',
    adminCredits_telegram_reminder_sending: 'Yuborilmoqda…',
    adminCredits_telegram_reminder_hint: 'Mijozga nasiya qoldig‘i haqida Telegram orqali xabar yuborish',
    adminCredits_telegram_not_linked: 'Mijoz hali chakana botiga telefon orqali ulanmagan',
    adminCredits_card_total: 'Umumiy nasiyalar',
    adminCredits_card_repaid: 'Qoplangan nasiyalar',
    adminCredits_card_remaining: 'Qolgan nasiyalar',
    adminCredits_card_outstanding: 'Umumiy qoldiq (nasiya)',
    adminCredits_card_issued_lifetime: 'Berilgan jami',
    adminCredits_card_active_count: 'faol',
    adminCredits_card_contracts: 'Nasiya shartnomalari',
    adminCredits_card_all_time: 'Jami yozuvlar',
    adminCredits_credit_number: 'Tartib raqami',
    adminCredits_top_creation: 'Ko\'p nasiya qiluvchilar (filial, kassir)',
    adminCredits_top_repaid: 'Ko\'proq nasiyalarni qoplayotganlar (filial, kassir)',
    adminCredits_search_placeholder: 'Qidirish…',
    adminCredits_filter_all_branches: 'Barcha filiallar',
    adminCredits_filter_all_cashiers: 'Barcha kassirlar',
    adminCredits_no_results: 'Qidiruv bo\'yicha natija topilmadi.',
    retailClients_subtitle: 'Kassadan kiritilgan mijozlar: ism, telefon, savdolar soni va nasiya qoldig‘i.',
    retailClients_credit_banner: '{count} ta mijozda nasiya qoldig‘i bor. Boshqarish:',
    retailClients_go_kassa: 'Kassaga o‘tish',
    retailClients_go_credits: 'Nasiya bo‘limi',
    retailClients_go_list: 'Chakana mijozlar ro‘yxati',
    retailClients_empty: 'Hozircha yozuv yo‘q. Kassada savatga mijoz telefonini kiriting.',
    retailClients_col_name: 'Ism',
    retailClients_col_phone: 'Telefon',
    retailClients_col_sales: 'Savdolar',
    retailClients_col_sales_total: 'Savdolar summasi',
    retailClients_col_balance: 'Cashback balans',
    retailClients_col_credit: 'Nasiya qoldig‘i',
    retailClients_filter_month: 'Oy',
    retailClients_filter_current_month: 'Joriy oy',
    retailClients_filter_all_time: 'Barcha vaqt',
    retailClients_filter_month_hint: 'Savdolar {month} davri bo‘yicha. Balans joriy.',
    retailClients_filter_all_time_hint: 'Savdolar barcha vaqt bo‘yicha. Balans joriy.',
    retailClients_repay: 'Qoldiqni kamaytirish',
    retailClients_repay_amount: 'Summa (UZS)',
    retailClients_repay_confirm: 'Qo‘llash',
    retailClients_edit_balance: 'Balansni tahrirlash',
    retailClients_edit_balance_save: 'Saqlash'
  },
  ru: {
    // Navigation
    navFeatures: 'Возможности',
    navSolutions: 'Решения',
    navPricing: 'Тарифы',
    navAIAnalytics: 'AI Аналитика',
    navContact: 'Контакты',

    appNotice_title_default: 'Уведомление',
    appNotice_title_error: 'Ошибка',
    appNotice_title_warning: 'Внимание',
    appNotice_confirm: 'Понятно',
    common_ok: 'OK',

    // Product sale units
    product_sale_unit_type: 'Ед. измерения',
    product_sale_unit_piece: 'Штука',
    product_sale_unit_kg: 'Килограмм (кг)',
    product_sale_unit_meter: 'Метр (м)',
    product_sale_unit_liter: 'Литр (л)',
    product_sale_unit_box: 'Коробка',
    product_sale_unit_pack: 'Пачка',
    product_sale_unit_roll: 'Рулон',
    product_sale_unit_set: 'Набор',
    product_sale_unit_pallet: 'Паллет',
    product_sale_unit_ton: 'Тонна (т)',
    product_sale_unit_sqm: 'Кв.м (м²)',
    product_sale_unit_cubic_meter: 'Куб.м (м³)',
    product_sale_unit_cm: 'Сантиметр (см)',
    product_sale_unit_mm: 'Миллиметр (мм)',
    product_sale_unit_pair: 'Пара',
    product_sale_unit_size: 'Размер',
    product_sale_unit_wholesale: 'Опт',
    product_sale_unit_kg_short: 'кг',
    product_sale_unit_meter_short: 'м',
    product_sale_unit_liter_short: 'л',
    product_sale_unit_ton_short: 'т',
    product_sale_unit_sqm_short: 'м²',
    product_sale_unit_cubic_meter_short: 'м³',
    product_sale_unit_cm_short: 'см',
    product_sale_unit_mm_short: 'мм',
    product_sale_unit_pair_short: 'пара',
    product_sale_unit_size_short: 'размер',
    product_sale_unit_wholesale_short: 'опт',
    product_wholesale_price: 'Оптовая цена',
    cashierKassa_optom_toggle: 'Опт',
    cashierKassa_optom_hint: 'Цены продажи по оптовой цене',
    
    // Header buttons
    btnLogin: 'Войти',
    btnStartFreeTrial: 'Начать бесплатно',
    
    // Hero section
    heroTitle: 'Платформа управления бизнесом с AI Аналитикой',
    heroSubtitle: 'Управляйте продажами, складом, персоналом, финансами и аналитикой в одной системе. Автоматизируйте процессы и повышайте эффективность.',
    heroDemoBadge: 'Бесплатный демо',
    demoDays: '14',
    demoFree: 'дней бесплатно',
    demoDescription: 'Кредитная карта не требуется. Протестируйте все функции в полном объеме.',
    btnRequestDemo: 'Запросить демо',
    btnViewFeatures: 'Посмотреть возможности',
    
    // Trust Stats
    statRealTime: 'Аналитика в реальном времени',
    statAIPowered: 'AI-аналитика',
    statMultiBranch: 'Поддержка нескольких филиалов',
    statOfflineSync: 'Офлайн + Онлайн синхронизация',
    
    // Core Features
    sectionCoreFeatures: 'Основные возможности',
    featureSales: 'Автоматизация продаж и заказов',
    featureWarehouse: 'Управление складом и инвентарем',
    featureStaff: 'Управление KPI и зарплатой сотрудников',
    featureAIForecast: 'AI прогнозирование и аналитика',
    featureCRM: 'CRM и сегментация клиентов',
    featureReports: 'Отчеты и панели управления',
    
    // AI Power
    aiTitle: 'Работает на базе продвинутой AI аналитики',
    aiSubtitle: 'Точные прогнозы и рекомендации на основе данных. Принимайте решения быстрее и увереннее.',
    aiSalesPredictions: 'Прогнозирование продаж',
    aiStockOptimization: 'Оптимизация склада',
    aiStaffScoring: 'Оценка работы сотрудников',
    aiSmartReminders: 'Умные напоминания',
    aiSalesPredictionsDesc: 'Прогноз спроса по истории продаж и сезонности — проще планировать закупки и акции.',
    aiStockOptimizationDesc: 'Анализ остатков и оборачиваемости снижает риск излишков и дефицита.',
    aiStaffScoringDesc: 'Прозрачная оценка KPI продаж и операций для каждого сотрудника.',
    aiSmartRemindersDesc: 'Своевременные напоминания по оплатам, остаткам и важным срокам.',
    statRealTimeDesc: 'Показатели продаж и склада обновляются быстро — картина бизнеса всегда актуальна.',
    statAIPoweredDesc: 'Автоматический разбор данных и подсказки, на что обратить внимание.',
    statMultiBranchDesc: 'Все филиалы и кассы в одной панели управления.',
    statOfflineSyncDesc: 'Касса работает без сети, затем данные безопасно синхронизируются.',
    coreFeaturesSubtitle: 'Продажи, склад, персонал и отчёты — в одной связанной платформе.',
    featureSalesDesc: 'Автоматизация заказов и оплат — меньше ошибок в ежедневной работе.',
    featureWarehouseDesc: 'Остатки, партии и движения — прозрачный контроль инвентаря.',
    featureStaffDesc: 'KPI, смены и расчёты — упорядоченное управление командой.',
    featureAIForecastDesc: 'Вспомогательная аналитика трендов и спроса.',
    featureCRMDesc: 'Сегменты клиентов и история контактов в одном месте.',
    featureReportsDesc: 'Готовые отчёты и графики по филиалам и периодам.',
    businessTypesSubtitle: 'Выберите тариф под масштаб бизнеса — основные модули доступны во всех планах.',
    tariffCardDescription: 'В выбранном плане — ключевые модули, обновления и поддержка.',
    teamMemberDesc1: 'Стратегия и партнёрство: дорожная карта продукта и успех клиентов.',
    teamMemberDesc2: 'Архитектура и безопасность — стабильная масштабируемая система.',
    teamMemberDesc3: 'Проекты и поставка — сроки и качество под контролем.',
    teamMemberDesc4: 'Успех клиентов и обучение — быстрый запуск и меньше вопросов.',
    teamMemberDesc5: 'Рост и маркетинг — ясное позиционирование на рынке.',
    teamMemberDesc6: 'Финансы и прозрачность — порядок в бюджете и отчётах.',
    testimonial_1_text: 'Касса и склад в одном окне — путаница между филиалами почти исчезла.',
    testimonial_1_name: 'Сардор Каримов',
    testimonial_1_role: 'Директор, розничная сеть',
    testimonial_1_initials: 'СК',
    testimonial_2_text: 'Кредиты и возвраты видны в таблице — ежедневный контроль стал проще.',
    testimonial_2_name: 'Мадина Юсупова',
    testimonial_2_role: 'Финансовый менеджер',
    testimonial_2_initials: 'МЮ',
    testimonial_3_text: 'Остатки обновляются почти в реальном времени, медленно продающийся товар виден сразу.',
    testimonial_3_name: 'Джахонгир Тошматов',
    testimonial_3_role: 'Начальник склада',
    testimonial_3_initials: 'ДТ',
    testimonial_4_text: 'Отчёты по шаблону — для руководства каждую неделю понятные цифры.',
    testimonial_4_name: 'Нилуфар Рахимова',
    testimonial_4_role: 'Операционный менеджер',
    testimonial_4_initials: 'НР',
    testimonial_5_text: 'Несколько магазинов из одной панели — заметная экономия времени.',
    testimonial_5_name: 'Бобур Эргашев',
    testimonial_5_role: 'Владелец сети',
    testimonial_5_initials: 'БЭ',
    testimonial_6_text: 'Поддержка отвечает быстро, внедрение прошло спокойно.',
    testimonial_6_name: 'Ширин Азимова',
    testimonial_6_role: 'IT и процессы',
    testimonial_6_initials: 'ША',
    
    // Business Types
    sectionBusinessTypes: 'Для бизнеса любого размера',
    businessSmall: 'Малый бизнес',
    businessMedium: 'Средний бизнес',
    biz_retail: 'Торговля',
    biz_food: 'Питание',
    biz_logistics: 'Логистика',
    biz_services: 'Услуги',
    biz_manufacturing: 'Производство',
    biz_construction: 'Строительство',
    businessEnterprise: 'Корпорация',
    badgeMostPopular: 'Самый продаваемый',
    btnGetStarted: 'Начать',
    benefitUpTo10Users: 'До 10 пользователей',
    benefitBasicCRM: 'Базовый CRM и инвентарь',
    benefitEssentialReports: 'Основные отчеты',
    benefitEmailSupport: 'Поддержка по email',
    benefitAILocation: 'AI локация',
    benefitOnlineSalesExtra: 'Онлайн продажи с доп. оплатой',
    benefitUpTo50Users: 'До 50 пользователей',
    benefitFullCRM: 'Полный набор CRM и ERP',
    benefitAdvancedAnalytics: 'Расширенная аналитика',
    benefitPrioritySupport: 'Приоритетная поддержка',
    benefitUnlimitedUsers: 'Неограниченное количество пользователей',
    benefitCustomIntegrations: 'Индивидуальные интеграции',
    benefitAISuite: 'Набор AI аналитики',
    benefitDedicatedManager: 'Персональный менеджер',
    benefitAILocation: 'AI локация',
    benefitOnlineSalesFree: 'Онлайн продажи бесплатно',
    benefit24x7Support: 'Поддержка 24/7',
    benefitMonthlyDiscount: '10% скидка на ежемесячную оплату',
    benefitOneBranch: 'До 1 филиала',
    benefitOneCashier: 'До 1 кассира',
    benefitProducts1000: 'До 1000 товаров',
    benefitRetailClients1000: 'До 1000 розничных клиентов',
    benefitBranches3: 'До 3 филиалов',
    benefitCashiers10: 'До 10 кассиров',
    benefitUnlimitedProducts: 'Неограниченное число товаров',
    benefitRetailClients5000: 'До 5000 розничных клиентов',
    benefitAIAdvisor: 'AI помощник',
    benefitMarketingOnlinePaidAddon: 'Маркетинг + онлайн‑продажи (доп. оплата к тарифу)',
    benefitBranches5: 'До 5 филиалов',
    benefitCashiers20: 'До 20 кассиров',
    benefitRetailClients20000: 'До 20000 розничных клиентов',
    benefitMarketingTools: 'Маркетинговые инструменты',
    benefitOnlineOrdersFree: 'Онлайн‑заказы (в тарифе)',
    benefitUnlimitedBranches: 'Неограниченное число филиалов',
    benefitUnlimitedCashiers: 'Неограниченное число кассиров',
    benefitUnlimitedRetailClients: 'Неограниченное число розничных клиентов',

    // Pricing
    pricingMonthly: 'Месяц',
    pricingAnnual: 'Год',
    pricingDiscount: '20% дешевле',
    pricingSave: 'Экономия',
    pricingCurrency: 'UZS',
    pricingPerMonth: 'в месяц',
    pricingPerYear: 'в год',
    pricingMonth: 'мес',
    pricingTryFree: 'Попробовать',
    pricingAnnualDiscountHint: 'до 10–25%',
    pricingRevealStartCta: 'Посмотреть от 99 000 сум?',
    pricingRevealStartClose: 'Скрыть тариф Start',
    
    // Contact
    sectionContact: 'Контакты',
    contactSubtitle: 'Есть вопросы? Свяжитесь с нами и получите помощь в развитии вашего бизнеса.',
    contactEmail: 'Email',
    contactPhone: 'Телефон',
    contactOffice: 'Офис',
    contactOfficeAddress: 'г. Ташкент, Юнусабадский район, ул. Амира Темура, д. 123',
    formName: 'Имя',
    formNamePlaceholder: 'Введите ваше имя',
    formEmail: 'Email',
    formEmailPlaceholder: 'email@example.com',
    formPhone: 'Телефон',
    formPhonePlaceholder: '+998 90 123 45 67',
    formCompany: 'Компания',
    formCompanyPlaceholder: 'Название компании (необязательно)',
    formBusinessType: 'Тип бизнеса',
    formBusinessTypePlaceholder: 'Выберите (необязательно)',
    formTariff: 'Тариф',
    formTariffPlaceholder: 'Выберите тариф (необязательно)',
    formMessage: 'Сообщение',
    formMessagePlaceholder: 'Напишите ваше сообщение (необязательно)...',
    formOptional: 'необязательно',
    btnSendMessage: 'Отправить сообщение',
    contactSubmitSuccess: 'Ваше сообщение принято. Мы свяжемся с вами скоро.',
    contactSubmitError: 'Не удалось отправить. Попробуйте позже.',
    contactSending: 'Отправка…',

    // CTA
    ctaTitle: 'Начните управлять бизнесом умнее уже сегодня',
    ctaSubtitle: 'Тысячи компаний уже оптимизируют процессы с нашей платформой. Попробуйте бесплатный период.',
    ctaDemoBadge: 'Бесплатный демо',
    btnGetStartedFree: 'Начать бесплатно',
    
    // Footer
    footerDescription: 'Комплексная платформа управления бизнесом на основе AI. Управляйте продажами, складом, персоналом, финансами и аналитикой в одной системе.',
    footerEmail: 'Email',
    footerPhone: 'Телефон',
    footerAddress: 'Адрес',
    footerAddressValue: 'г. Ташкент, Юнусабадский район, ул. Амира Темура, д. 123',
    footerFollowUs: 'Следите за нами',
    footerProduct: 'Продукт',
    footerCompany: 'Компания',
    footerLegal: 'Правовая информация',
    footerPrivacy: 'Политика конфиденциальности',
    footerTerms: 'Условия использования',
    footerRights: 'Все права защищены.',
    
    // Statistics
    statUsers: 'Пользователи',
    statOrders: 'Заказы',
    statBranches: 'Филиалы',
    statSatisfaction: 'Удовлетворенность',
    
    // Testimonials
    sectionTestimonials: 'Что говорят наши клиенты',
    testimonialsSubtitle: 'Компании, которые уже ведут бизнес на платформе, делятся опытом.',
    
    // Integrations
    sectionIntegrations: 'Интеграции',
    integrationsSubtitle: 'Подключайте нужные сервисы и ведите процессы в одном окне.',
    btnViewAllIntegrations: 'Посмотреть все интеграции',
    
    // Comparison
    sectionComparison: 'Сравнение с конкурентами',
    comparisonSubtitle: 'Чем наша платформа отличается от других решений и какие преимущества даёт бизнесу.',
    comparisonFeature: 'Функция',
    comparisonUs: 'Наша платформа',
    comparisonCompetitor: 'Конкуренты',
    compFeature1: 'AI аналитика',
    compFeature2: 'Синхронизация в реальном времени',
    compFeature3: 'Поддержка нескольких филиалов',
    compFeature4: 'Офлайн режим',
    compFeature5: 'CRM модуль',
    compFeature6: 'Автоматические отчеты',
    compFeature7: 'Мобильное приложение',
    compFeature8: 'Поддержка 24/7',
    
    // Dashboard
    dashboardTitle: 'Панель управления',
    dashboardRevenue: 'Месячная прибыль',
    dashboardOrders: 'Месячный доход',
    dashboardSalesOverview: 'Обзор продаж',
    dashboardNewOrder: 'Новый заказ',
    dashboardPaymentReceived: 'Платеж получен',
    dashboardStockUpdated: 'Склад обновлен',
    dashboardMinAgo: 'мин назад',
    
    // Team
    sectionTeam: 'Наша команда',
    teamSubtitle: 'Наша профессиональная команда поможет развитию вашего бизнеса.',
    teamPosition1: 'Генеральный директор',
    teamPosition2: 'Технический директор',
    teamPosition3: 'Менеджер проектов',
    teamPosition4: 'Менеджер по работе с клиентами',
    teamPosition5: 'Маркетинг менеджер',
    teamPosition6: 'Финансовый менеджер',

    // Login modal
    loginModalTitle: 'Вход',
    loginModalPhoneSubtitle: 'Введите номер телефона для входа в систему.',
    loginModalPhoneLabel: 'Номер телефона',
    loginModalPhonePlaceholder: '90 123 45 67',
    loginModalPhoneError: 'Введите полный номер (9 цифр).',
    loginModalPhoneNotAllowed: 'Этот номер не зарегистрирован в системе. Вход только для разрешённых номеров.',
    loginModalPasswordSubtitle: 'Войдите по номеру телефона и паролю.',
    loginModalPasswordLabel: 'Пароль',
    loginModalPasswordPlaceholder: 'Введите пароль',
    loginModalPasswordError: 'Пароль должен быть не короче 4 символов.',
    loginModalPasswordInvalid: 'Неверный пароль или ответ сервера. Попробуйте снова.',
    loginModalSignIn: 'Войти',
    loginModalSigningIn: 'Вход…',
    loginModalAuth_invalid_credentials: 'Неверный телефон или пароль, либо пароль для аккаунта не задан.',
    loginModalAuth_phone_invalid: 'Неверный формат номера телефона.',
    loginModalAuth_missing_or_invalid_fields: 'Заполните телефон и пароль.',
    loginModalSendSms: 'Отправить SMS',
    loginModalSending: 'Отправка...',
    loginModalChecking: 'Проверка...',
    loginModalSmsTitle: 'Подтверждение SMS',
    loginModalSmsSubtitle: 'Введите 4-значный код, отправленный на ваш номер.',
    loginModalSmsLabel: 'Код из SMS',
    loginModalSmsPlaceholder: '0000',
    loginModalSmsPlaceholderHint: 'Введите код',
    loginModalSmsError: 'Введите 4-значный код.',
    loginModalBack: 'Назад',
    loginModalConfirm: 'Подтвердить',
    loginModalSuccessTitle: 'Вход выполнен',
    loginModalSuccessGuest: 'Вы вошли в систему.',
    loginModalClose: 'Закрыть',
    loginModalForgotPassword: 'Забыли пароль?',
    loginModal2FATitle: 'SMS подтверждение',
    loginModal2FASubtitle: 'Пароль верный! На ваш телефон отправлен 4-значный код.',
    loginModalOtpLabel: 'SMS код',
    loginModalOtpPlaceholder: '0000',
    loginModalOtpError: 'Введите 4-значный код.',
    loginModalOtpInvalid: 'Неверный или истёкший код.',
    loginModalResend: 'Отправить ещё раз',
    loginModalResendIn: 'Повторно через {{n}} с',
    loginModalResetTitle: 'Сброс пароля',
    loginModalResetSubtitle: 'Вам будет отправлен SMS с кодом подтверждения.',
    loginModalResetSendCode: 'Отправить код',
    loginModalResetOtpSubtitle: 'Введите 4-значный код из SMS.',
    loginModalNewPasswordTitle: 'Установите новый пароль',
    loginModalNewPasswordLabel: 'Новый пароль',
    loginModalNewPasswordPlaceholder: 'Минимум 6 символов',
    loginModalNewPasswordConfirmLabel: 'Повторите пароль',
    loginModalNewPasswordConfirmPlaceholder: 'Повторите пароль',
    loginModalSavePassword: 'Сохранить пароль',
    loginModalSaving: 'Сохранение...',
    loginModalResetSuccess: 'Пароль успешно обновлён! Войдите с новым паролем.',
    loginModalPasswordMinError: 'Пароль должен содержать минимум 6 символов.',
    loginModalPasswordMismatch: 'Пароли не совпадают.',

    // Roles (static) – новая структура
    roleTitle_platform_owner: 'Владелец (Владелец проекта)',
    roleDesc_platform_owner: 'Общие настройки системы, тарифы, полный доступ к данным. Статистика и добавление менеджеров. Для разработчиков и администраторов.',
    roleTitle_general_manager: 'Главный менеджер',
    roleDesc_general_manager: 'Статистика по всем регионам, управление региональными менеджерами, филиалы и отчёты.',
    roleTitle_regional_manager: 'Региональный менеджер',
    roleDesc_regional_manager: 'Свой регион: филиалы и склады, сотрудники и роли, каталог товаров, заказы и отчёты.',
    roleTitle_dispatcher: 'Диспетчер',
    roleDesc_dispatcher: 'Входящие продажи (сделки) и заказы, статусы доставки и уведомления.',
    roleTitle_warehouse_clerk: 'Кладовщик',
    roleDesc_warehouse_clerk: 'Приходно-расходные операции, инвентаризация, штрих-коды. Остатки и движения в реальном времени.',
    roleTitle_accountant: 'Бухгалтер',
    roleDesc_accountant: 'Интеграция с налоговыми системами и 1С, платежи и финансовые документы, отчёты.',
    roleTitle_analyst: 'Аналитик',
    roleDesc_analyst: 'Анализ кампаний и продаж, сегменты клиентов, отчёты и рекомендации.',
    roleTitle_kuryer: 'Курьер / Агент',
    roleDesc_kuryer: 'Офлайн-режим, обновление статусов доставки, маршруты. Мобильные устройства.',
    roleTitle_tenant_owner: 'Клиент (Владелец точки)',
    roleDesc_tenant_owner: 'Управление точкой: кассиры, филиалы, продажи, рассрочка, финансы и отчёты. Розничные клиенты и уведомления в Telegram.',
    roleTitle_cashier: 'Кассир',
    roleDesc_cashier: 'POS и заказы, приём платежей. Управляется владельцем точки.',

    // Admin panel
    adminTitle: 'Панель управления',
    adminWelcome: 'Следующие разделы доступны для вашей роли.',
    adminLogout: 'Выйти',
    adminSidebarHeading: 'Меню',
    adminSidebar_collapse: 'Сузить меню (только иконки)',
    adminSidebar_expand: 'Развернуть меню',
    adminCurrentRole: 'Текущая роль',
    adminLanguageLabel: 'Выбор языка',
    adminMore: 'Ещё',
    adminActivityLog: 'Журнал активности',
    adminNotifications: 'Уведомления',
    adminProfileSettings: 'Настройки профиля',
    adminProfile: 'Профиль',
    adminSettings_login_password: 'Пароль для входа',
    adminProfile_password_current: 'Текущий пароль',
    adminProfile_password_new: 'Новый пароль',
    adminProfile_password_confirm: 'Подтвердите новый пароль',
    adminProfile_password_current_required: 'Введите текущий пароль',
    adminProfile_password_min: 'Новый пароль — не менее 6 символов',
    adminProfile_password_mismatch: 'Новый пароль и подтверждение не совпадают',
    adminProfile_password_invalid: 'Неверный текущий пароль',
    adminProfile_password_set_first: 'Установите пароль для входа',
    adminProfile_phone_already_exists: 'Этот номер телефона уже зарегистрирован у другого пользователя',
    save: 'Сохранить',
    saving: 'Сохранение...',
    saved: 'Сохранено',
    edit: 'Редактировать',
    cancel: 'Отмена',
    roleSwitch_title: 'Смена роли',
    roleSwitch_desc: 'Текущая роль',
    roleSwitch_target: 'Новая роль',
    roleSwitch_current: 'Текущая роль',
    roleSwitch_pin_label: 'Введите PIN',
    roleSwitch_pin_required: 'Введите PIN',
    roleSwitch_pin_invalid: 'Неверный PIN',
    roleSwitch_pin_min: 'PIN не менее 4 символов',
    roleSwitch_pin_mismatch: 'PIN не совпадает',
    roleSwitch_pin_new: 'Новый PIN',
    roleSwitch_pin_confirm: 'Повторите PIN',
    roleSwitch_pin_current: 'Текущий PIN',
    roleSwitch_set_pin: 'Сохранить',
    roleSwitch_set_pin_first: 'Установите PIN',
    roleSwitch_enter_pin_tenant_owner: 'Введите PIN для перехода в роль клиента',
    roleSwitch_enter_pin_kassir: 'Введите PIN для перехода в роль кассира',
    roleSwitch_choose_kassir: 'Перейти в роль кассира (без PIN)',
    roleSwitch_choose_cashier: 'Перейти в роль кассира (нужен PIN кассира)',
    roleSwitch_choose_target: 'В какую роль перейти?',
    roleSwitch_no_cashiers: 'Кассиры не найдены',
    roleSwitch_no_pin: 'PIN не установлен',
    roleSwitch_enter_tenant_owner_pin: 'Введите PIN клиента (владельца)',
    roleSwitch_enter_kassir_pin: 'Введите PIN кассира',
    roleSwitch_pin_profile_label: 'PIN смены роли',
    roleSwitch_pin_change: 'Изменить',
    roleSwitch_confirm: 'Сменить роль',
    adminImpersonate_title: 'Войти как другой пользователь',
    adminImpersonate_desc: 'Выберите пользователя с более низкой ролью, затем введите пароль от своей учётной записи.',
    adminImpersonate_search: 'Поиск (имя, телефон)',
    adminImpersonate_search_ph: 'Имя или телефон...',
    adminImpersonate_empty: 'Пользователи не найдены',
    adminImpersonate_your_password: 'Ваш пароль для подтверждения',
    adminImpersonate_submit: 'Войти',
    adminImpersonate_failed: 'Не удалось выполнить',
    adminImpersonate_select_user: 'Выберите пользователя',
    adminImpersonate_password_required: 'Введите пароль',
    adminImpersonate_banner: 'Вы вошли от имени другого пользователя. Можно вернуться в свою учётную запись.',
    adminImpersonate_exit: 'Вернуться в свой аккаунт',
    adminImpersonate_exit_error: 'Не удалось вернуться. Попробуйте снова.',
    adminImpersonate_nested_blocked: 'Сначала выйдите из текущего сеанса «войти как».',
    sidebar_impersonation_section: 'Вход в роли',
    sidebar_impersonation_load_error: 'Не удалось загрузить список. Проверьте сеть.',
    sidebar_impersonation_empty: 'Пока нет учётных записей для нижестоящих ролей. После добавления пользователей нажмите «Обновить».',
    sidebar_impersonation_role_empty: 'Нет учётных записей для этой роли',
    sidebar_impersonation_refresh: 'Обновить',
    role_access_page_subtitle: 'Выберите учётную запись ниже по иерархии и подтвердите своим паролем.',
    role_access_accounts_total: 'Всего учётных записей:',
    role_access_denied: 'У вас нет доступа к этой странице.',
    role_access_row_action: 'Войти',
    role_access_filters_label: 'Фильтры',
    role_access_search_placeholder: 'Поиск по имени или номеру...',
    role_access_region_filter: 'Фильтр по региону',
    role_access_region_all: 'Все регионы',
    adminSettings: 'Настройки',
    adminNoActivity: 'Нет недавней активности',
    adminNoNotifications: 'Нет уведомлений',
    adminTopbar_chat_notifications: 'Сообщения чата',
    adminTopbar_currency_title: 'Курс',
    adminTopbar_currency_updated: 'Обновлено',
    adminTopbar_currency_select: 'Выберите валюту',
    notif_chat_from_tenant_owner: 'Новое сообщение от клиента',
    notif_chat_from_support: 'Ответ поддержки',
    support_new_message_title: 'Новое сообщение от клиента',
    support_new_message_body: 'В чате новое сообщение — откройте и ответьте.',
    support_reply_title: 'Ответ менеджера',
    support_reply_body: 'Новый ответ в чате поддержки.',
    notif_chat_meta_tenant: 'Клиент',
    adminTheme: 'Тема',
    adminThemeLight: 'Светлый режим',
    adminThemeDark: 'Тёмный режим',
    adminMenuOpen: 'Открыть меню',
    adminMenuClose: 'Закрыть меню',
    adminGoToPanel: 'Перейти в панель',
    adminComingSoon: 'Скоро',
    adminPlaceholderFeature1: 'Полная панель управления и отчёты',
    adminPlaceholderFeature2: 'Настройки и интеграции',
    adminPlaceholderFeature3: 'Экспорт и детальный анализ',
    adminStat_period: 'Текущий месяц (статические данные)',
    adminStat_tenants: 'Клиенты',
    adminStat_tenants_active_short: 'активные',
    adminStat_tenants_suspended_short: 'остановленные',
    adminStat_tenants_trial_short: 'в пробном',
    adminStat_tariffCustomers: 'Клиенты по тарифам',
    adminStat_tariffDistribution: 'Распределение тарифов',
    adminStat_tariff_other: 'Другие тарифы',
    adminStat_activeUsers: 'Активные пользователи',
    adminStat_ordersMonth: 'Заказы (за месяц)',
    adminStat_dispatcherOrdersCard: 'Заказы, поступившие диспетчеру',
    adminStat_dispatcherOrdersConvertedShort: 'конвертированы в клиента',
    adminStat_dispatcherOrdersRejectedShort: 'отклонены',
    adminStat_revenueMonth: 'Доход (за месяц, UZS)',
    adminStat_growth: 'Рост (к прошлому месяцу)',
    adminStat_summaryTitle: 'Кратко',
    adminStat_topRegion: 'Наиболее активный регион',
    adminStat_fastestGrowingRegion: 'Самый быстрорастущий регион',
    adminStat_newTenantsWeek: 'Новые клиенты (за неделю)',
    adminStat_empty: 'Нет данных',
    adminStat_note: 'Примечание',
    adminStat_noteText: 'Данные — примерные показатели. Полные отчёты будут в следующих обновлениях.',
    adminStat_bm_overview: 'Панель управления',
    adminStat_bm_page_sub: 'Сводные показатели по всем регионам, менеджерам и клиентам.',
    adminStat_bm_hero_eyebrow: 'Главный менеджер',
    adminStat_bm_hero_title: 'Операционные показатели',
    adminStat_bm_regions_short: 'регионов',
    adminStat_chartTitle_bm: 'Заказы — все регионы (8 недель)',
    adminStat_bm_managers: 'Менеджеры',
    adminStat_bm_dispatchers: 'Диспетчеры',
    adminStat_bm_regions: 'Регионы',
    adminStat_bm_totalBranches: 'Филиалы (всего)',
    adminStat_bm_topManager: 'Лучший менеджер',
    adminStat_bm_topDispatcher: 'Лучший диспетчер',
    adminStat_bm_bestRatingRegion: 'Лучший рейтинг (регион)',
    adminStat_bm_newLeadsMonth: 'Новые лиды (мес.)',
    adminStat_vm_overview: 'Показатели по региону',
    adminStat_vm_region: 'Регион',
    adminStat_vm_topBranch: 'Лучший филиал',
    adminStat_vm_topClientCategory: 'Топ категория по заказам',
    adminStat_vm_tenants: 'Клиенты',
    adminStat_vm_operational_title: 'Операционные показатели региона',
    adminStat_vm_monthlyRevenue: 'Выручка региона за 6 месяцев',
    adminStat_chartTitle_vm: 'Заказы за последние 8 недель (регион)',
    adminStat_chart_axis_week: 'Неделя',
    adminStat_disp_overview: 'Личные показатели (продажи и заказы)',
    adminStat_disp_leadsToday: 'Новые продажи сегодня',
    adminStat_disp_leadsWeek: 'Продажи за неделю',
    adminStat_disp_ordersInProgress: 'Заказы в работе',
    adminStat_disp_ordersCompletedToday: 'Выполнено сегодня',
    adminStat_disp_ordersCompletedWeek: 'Выполнено за неделю',
    adminStat_disp_leadsMonth: 'Продажи за месяц',
    adminStat_disp_topManager: 'Партнёр-менеджер',
    adminStat_disp_topLeadSource: 'Основной источник продаж',
    adminStat_hours_short: 'ч',
    adminStat_analitik_overview: 'Аналитические показатели (визиты, конверсия, выручка)',
    adminStat_analitik_visitors: 'Уникальные визиты (30 дн.)',
    adminStat_analitik_sessions: 'Сессии',
    adminStat_analitik_top_channel: 'Лучший канал',
    adminStat_analitik_new_customers: 'Новые клиенты (мес.)',
    adminStat_analitik_avg_session: 'Средняя сессия (мин)',
    adminStat_analitik_bounce: 'Отказ (%)',
    adminStat_chartTitle_analitik: 'Визиты по неделям',
    adminStat_overview: 'Ключевые показатели',
    adminStat_tenant_owner_overview: 'Показатели компании',
    adminStat_selected_period_prefix: 'Выбранный период',
    adminStat_davr_today: 'Сегодня',
    adminStat_davr_week: 'Неделя',
    adminStat_davr_month: 'Месяц',
    adminStat_davr_year: 'Год',
    adminStat_davr_custom: 'Произвольный период',
    adminStat_custom_from: 'С',
    adminStat_custom_to: 'По',
    adminStat_tenant_owner_section_kpi: 'Продажи и рентабельность',
    adminStat_tenant_owner_scope_period: 'Период',
    adminStat_tenant_owner_revenue_today: 'Продажи сегодня (поступления)',
    adminStat_tenant_owner_revenue_week: 'Продажи за неделю (поступления)',
    adminStat_tenant_owner_revenue_month: 'Продажи за месяц (поступления)',
    adminStat_tenant_owner_revenue_year: 'Продажи за год (поступления)',
    adminStat_tenant_owner_net_today: 'Чистая прибыль сегодня (оценка)',
    adminStat_tenant_owner_net_week: 'Чистая прибыль за неделю (оценка)',
    adminStat_tenant_owner_net_month: 'Чистая прибыль за месяц',
    adminStat_tenant_owner_net_year: 'Чистая прибыль за год (оценка)',
    adminStat_tenant_owner_orders_today: 'Операции сегодня',
    adminStat_tenant_owner_orders_week: 'Операции за неделю',
    adminStat_tenant_owner_orders_month: 'Операции за месяц',
    adminStat_tenant_owner_orders_year: 'Операции за год',
    adminStat_tenant_owner_orders_period: 'Операции (выбранный период)',
    adminStat_tenant_owner_revenue_period: 'Продажи / поступления (выбранный период)',
    adminStat_tenant_owner_net_period: 'Чистая прибыль (выбранный период)',
    adminStat_tenant_owner_chart_custom_daily: 'Выбранный период — продажи по дням',
    adminStat_tenant_owner_trend_custom: 'рост (по отчёту)',
    adminStat_tenant_owner_trend_mom: 'к прошлому месяцу (месячная динамика)',
    adminStat_tenant_owner_trend_recent: 'динамика последних месяцев',
    adminStat_tenant_owner_trend_yoy: 'к прошлому году (годовая динамика)',
    adminStat_tenant_owner_last7_title: 'Последние 7 дней — продажи по дням',
    adminStat_tenant_owner_weekday_title: 'Распределение по дням недели',
    adminStat_tenant_owner_payments_hint: 'По поступлениям за выбранный период и филиал.',
    adminStat_expense_paid_title: 'Расходы (погашено)',
    adminStat_expense_paid_badge: 'расход',
    adminStat_expense_paid_split: 'Типы погашения расходов',
    adminStat_expense_paid_cash: 'Наличные (из кассы)',
    adminStat_expense_paid_product: 'Товаром',
    adminStat_expense_paid_other: 'Прочее',
    adminStat_expenses_title: 'Детализация расходов',
    expenseMeta_productId: 'ID товара',
    expenseMeta_qty: 'Количество',
    expenseMeta_supplier: 'Поставщик',
    expenseMeta_supplierId: 'ID поставщика',
    expenseMeta_purchasePrice: 'Закупочная цена',
    adminStat_expenses_all: 'Все',
    adminStat_expenses_active: 'Активные',
    adminStat_expenses_archived: 'Полностью погашено',
    adminStat_expenses_total: 'Всего расходов',
    adminStat_expenses_paid: 'Оплачено',
    adminStat_expenses_remaining: 'Остаток',
    adminStat_expenses_count: 'Кол-во',
    adminStat_expenses_product: 'Товар',
    adminStat_expenses_active_badge: 'Активно',
    adminStat_expenses_archived_badge: 'Закрыто',
    adminStat_mijoz_branch_leaders: 'Лидеры продаж по филиалам',
    adminStat_nasiya_portfolio: 'Состояние рассрочки',
    adminStat_nasiya_repaid_label: 'Погашено',
    adminStat_nasiya_remaining_label: 'Остаток',
    adminStat_tenant_owner_monthly_revenue: 'Последние 6 месяцев — продажи',
    adminStat_top_products: 'Товары — рейтинг продаж',
    adminStat_top_products_unit: 'ед.',
    adminStat_top_sellers: 'Продавцы — рейтинг продаж',
    adminStat_chartTitle: 'Заказы по неделям',
    adminStat_insights: 'Краткий обзор',
    adminStat_unifiedRatingTitle: 'Единая рейтинговая статистика',
    adminStat_regionRatingTitle: 'Рейтинг регионов',
    adminStat_dispatcherRatingTitle: 'Рейтинг диспетчеров',
    adminStat_managerRatingTitle: 'Рейтинг менеджеров',
    adminStat_byRegion_title: 'Статистика по регионам',
    adminStat_byRegion_region: 'Регион',
    adminStat_byRegion_tenants: 'Клиенты',
    adminStat_byRegion_orders: 'Заказы (мес.)',
    adminStat_byRegion_revenue: 'Выручка (мес.)',
    adminStat_byRegion_growth: 'Рост %',
    adminStat_byRegion_branches: 'Филиалы',
    adminStat_byRegion_users: 'Активные пользователи',
    adminStat_byRegion_avgCheck: 'Средний чек',
    adminStat_byManager_title: 'Статистика по менеджерам',
    adminStat_byManager_name: 'Менеджер',
    adminStat_byManager_region: 'Регион',
    adminStat_byManager_role: 'Роль',
    adminStat_byManager_orders: 'Заказы (мес.)',
    adminStat_byManager_revenue: 'Выручка (мес.)',
    adminStat_byManager_rating: 'Рейтинг',
    adminStat_byManager_satisfaction: 'Удовлетворённость %',
    adminStat_byManager_trend: 'Тренд',
    adminStat_byManager_branches: 'Филиалы',
    adminStat_byManager_dispatchers: 'Диспетчеры',
    adminStat_prevMonth: 'к прошлому месяцу',
    adminStat_avgOrderValue: 'Средний чек (UZS)',
    adminStat_conversionPercent: 'Конверсия (лид → заказ)',
    adminStat_ordersToday: 'Заказы за сегодня',
    adminStat_cancelledMonth: 'Отменённые (за месяц)',
    adminStat_supportTicketsOpen: 'Открытые тикеты поддержки',
    adminStat_newRegistrationsMonth: 'Новые регистрации (за месяц)',
    adminStat_monthlyRevenue: 'Доход по месяцам (6 мес.)',
    adminStat_weeklySalesByDay: 'Объем продаж за неделю',
    adminStat_weeklysalesbyday: 'Объем продаж за неделю',
    adminStat_topProductCategory: 'Топ категория товаров',
    adminStat_avgResponseHours: 'Среднее время ответа (ч)',
    adminStat_repeatOrdersPercent: 'Повторные заказы (%)',
    month_jan: 'Январь',
    month_feb: 'Февраль',
    month_mar: 'Март',
    month_apr: 'Апрель',
    month_may: 'Май',
    month_jun: 'Июнь',
    adminAdvice_subtitle: 'Краткое руководство и рекомендации по управлению бизнесом, CRM и ERP. Ниже — практические советы по основным направлениям.',
    adminAdvice_subtitle_mijoz: 'Практические советы для роли клиента: контроль продаж, прибыли, остатков и задолженности.',
    adminAdvice_subtitle_kassir: 'Практические советы для роли кассира: чеки, оплата, принтер и дисциплина смены.',
    adminAdvice_subtitle_cashier: 'Практические советы для роли кассира: чеки, оплата, принтер и дисциплина смены.',
    adminAdvice_subtitle_viloyat: 'Оперативное управление по региону: заказы, диспетчеры, клиенты, отчёты и эффективность команды.',
    maslahat_viloyat_title: 'Практические советы региональному менеджеру',
    maslahat_viloyat_1: 'Ежедневно проверяйте лиды и заказы: новые, в работе и с задержкой — своевременно обновляйте статусы.',
    maslahat_viloyat_2: 'Короткий дневной план с диспетчерами: открытые лиды, просроченные ответы и приоритетные заказы.',
    maslahat_viloyat_3: 'Ежемесячный обзор по клиентам (tenant): новые подключения, активность и сопровождение по необходимости.',
    maslahat_viloyat_4: 'Используйте внутренний чат для оперативных вопросов — решения и ответственность в одном канале.',
    maslahat_viloyat_5: 'Экспорт в Excel из отчётов — храните файлы с датой и названием региона.',
    maslahat_viloyat_6: 'Региональные KPI: время приёма заказа, рейтинг диспетчеров, обращения клиентов — сравнение по неделям.',
    maslahat_viloyat_7: 'Крупные суммы и особые договоры подтверждайте в два этапа — это снижает риски.',
    maslahat_viloyat_8: 'Роли и доступы: для новых сотрудников или точек открывайте только нужные разделы.',
    adminAdvice_sales_title: 'Продажи и заказы',
    adminAdvice_sales_1: 'Регулярно проверяйте лиды и заказы по статусам: новый, повторный контакт, договор готов, закрыт. Обновляйте статус не реже раза в день.',
    adminAdvice_sales_2: 'Сокращайте время обработки заказа: диспетчер назначает лид менеджеру в течение 15 минут, менеджер связывается с клиентом в течение 24 часов.',
    adminAdvice_sales_3: 'На каждую сделку назначайте ответственного и срок. Ежедневно получайте отчёт по просроченным заказам.',
    adminAdvice_sales_4: 'Выделяйте повторные заказы — планируйте особые условия или скидки для самых лояльных клиентов.',
    adminAdvice_sales_5: 'Анализируйте воронку продаж: на каком этапе теряются клиенты — там и улучшайте процесс.',
    adminAdvice_warehouse_title: 'Склад и запасы',
    adminAdvice_warehouse_1: 'Задайте минимальный (страховой) и максимальный остаток по каждой позиции. Включите автоматические уведомления в системе.',
    adminAdvice_warehouse_2: 'Планируйте инвентаризацию: для медленно оборачиваемых — ежемесячно, для быстрых — еженедельно или ежедневно.',
    adminAdvice_warehouse_3: 'Стандартизируйте штрихкоды и артикулы — это ускоряет приход/расход и снижает ошибки.',
    adminAdvice_warehouse_4: 'Отслеживайте срок годности: соблюдайте принцип FEFO (первым выходит с ближайшим сроком).',
    adminAdvice_warehouse_5: 'Фиксируйте перемещения и списания с номером и датой документа — необходимо для аудита и отчётности.',
    adminAdvice_finance_title: 'Финансы и отчётность',
    adminAdvice_finance_1: 'Группируйте транзакции по типу оплаты и контрагенту. Еженедельно сверяйте кассу и банк с отчётом.',
    adminAdvice_finance_2: 'Связывайте счета и платежи: каждый платёж привязан к документу, ведите список просроченной задолженности.',
    adminAdvice_finance_3: 'Настройте интеграцию с налоговой и 1С — автоматическая выгрузка отчётов снижает ошибки.',
    adminAdvice_finance_4: 'Ежемесячно анализируйте отчёт о прибылях и убытках и баланс. При аномалиях выясняйте причину.',
    adminAdvice_finance_5: 'Регулярно делайте экспорт и архив — для проверок и внутреннего аудита все документы должны быть под рукой.',
    adminAdvice_staff_title: 'Персонал и эффективность',
    adminAdvice_staff_1: 'Определите чёткие KPI по ролям: менеджер по продажам — объём и новые клиенты, диспетчер — сроки заказов и количество жалоб.',
    adminAdvice_staff_2: 'Рейтинги делайте открытыми и справедливыми: мотивируйте команду по еженедельным или ежемесячным результатам.',
    adminAdvice_staff_3: 'Планируйте обучение и инструктажи — стандартные процедуры помогут новым сотрудникам быстрее выйти на результат.',
    adminAdvice_staff_4: 'Распределяйте задачи по ролям: не перегружайте одного человека — не создавайте «узкие места».',
    adminAdvice_staff_5: 'Принимайте обратную связь и жалобы в письменном виде и отвечайте быстро — это повышает доверие и эффективность.',
    adminAdvice_crm_title: 'Клиенты (CRM) и маркетинг',
    adminAdvice_crm_1: 'Сегментируйте клиентов: VIP, постоянные, новые, «спящие». Для каждого сегмента — свой канал и предложения.',
    adminAdvice_crm_2: 'Измеряйте результаты кампаний (SMS, push, email): открытия, клики, конверсия. Оптимизируйте неэффективные каналы.',
    adminAdvice_crm_3: 'Ежемесячно анализируйте удержание и отток — почему уходят и как вернуть.',
    adminAdvice_crm_4: 'Используйте AI-рекомендации: тестируйте предложенные сегменты и акции.',
    adminAdvice_crm_5: 'Собирайте жалобы в одном канале (например, поддержка) и задайте стандарт ответа в течение 24 часов.',
    adminAdvice_general_title: 'Общие рекомендации',
    adminAdvice_general_1: 'Регулярно делайте резервное копирование и своевременно обновляйте систему — для безопасности и стабильности.',
    adminAdvice_general_2: 'Документируйте настройки и интеграции: кто и какие API-ключи и лимиты использует.',
    adminAdvice_general_3: 'Ежемесячно просматривайте аудит и отчёты об использовании — выявляйте нарушения на ранней стадии.',
    adminAdvice_general_4: 'Внедряйте новые функции поэтапно: сначала пилотная группа, затем все пользователи.',
    adminAdvice_general_5: 'Собирайте обратную связь и развивайте раздел помощи — инструкции и поддержка важны для полного использования платформы.',
    adminAdvice_footer: 'Рекомендации выше приведены как статическое руководство. Для каждого бизнеса настройки и приоритеты могут отличаться. В следующих обновлениях будут добавлены персональные советы на основе AI.',
    adminAdvice_developing: 'В разработке',
    maslahat_top10_title: 'Топ 10 рекомендаций',
    maslahat_mijoz_title: 'Рекомендации для роли клиента',
    maslahat_mijoz_1: 'Ежедневно проверяйте продажи, прибыль и остаток по насии в одном месте.',
    maslahat_mijoz_2: 'Товары с остатком срока менее 3 дней выносите в приоритет продаж.',
    maslahat_mijoz_3: 'Сравнивайте остатки и продажи по филиалам, чтобы находить медленно оборачиваемые позиции.',
    maslahat_mijoz_4: 'Перед применением быстрой скидки на крупный чек проверяйте маржу.',
    maslahat_mijoz_5: 'Во время ежедневной сводки закрывайте кассу, насию и склад.',
    maslahat_kassir_title: 'Рекомендации для роли кассира',
    maslahat_kassir_1: 'Перед продажей ещё раз проверьте в корзине товар, цену и количество.',
    maslahat_kassir_2: 'Перед печатью чека подтвердите с клиентом способ оплаты.',
    maslahat_kassir_3: 'Работайте быстрее через избранные товары, при нулевом остатке сразу сообщайте на склад.',
    maslahat_kassir_4: 'Если принтер дает ошибку, проверьте подключение и сделайте тестовый чек.',
    maslahat_kassir_5: 'В конце смены сверяйте транзакции и сдачу перед закрытием.',
    maslahat_level_zarur: 'Срочно',
    maslahat_level_muhim: 'Важно',
    maslahat_level_keyinroq: 'Можно позже',
    maslahat_top_1: 'Проверяйте лиды и заказы по статусам не реже раза в день. Своевременно обновляйте статусы.',
    maslahat_top_2: 'Диспетчер назначает лид менеджеру в течение 15 минут, менеджер связывается с клиентом в течение 24 часов.',
    maslahat_top_3: 'Задайте минимальный и максимальный остаток по каждой позиции. Включите автоматические уведомления.',
    maslahat_top_4: 'Связывайте счета и платежи. Еженедельно ведите список просроченной задолженности.',
    maslahat_top_5: 'Определите чёткие KPI по ролям. Рейтинги делайте открытыми и справедливыми.',
    maslahat_top_6: 'Сегментируйте клиентов: VIP, постоянные, новые. Для каждого сегмента — свои предложения.',
    maslahat_top_7: 'Регулярно делайте резервное копирование и своевременно обновляйте систему.',
    maslahat_top_8: 'Анализируйте воронку продаж — на каком этапе теряются клиенты, там и улучшайте.',
    maslahat_top_9: 'Внедряйте новые функции сначала в пилотной группе, затем для всех.',
    maslahat_top_10: 'Собирайте обратную связь и развивайте раздел помощи.',
    maslahat_chat_title: 'Спросить у AI',
    maslahat_ai_quota_monthly: 'Запросов в месяц: {used} / {max}',
    maslahat_ai_quota_exceeded: 'Лимит AI-запросов на этот месяц исчерпан. Продолжите в следующем месяце или на более высоком тарифе.',
    maslahat_chat_placeholder: 'Напишите вопрос… Совет, отчёт или другая тема.',
    maslahat_chat_send: 'Отправить',
    maslahat_chat_you: 'Вы',
    maslahat_chat_demo_reply: 'Ваш вопрос принят. Ответ AI будет показан после подключения в следующем обновлении.',
    maslahat_chat_history_loading: 'Загрузка истории…',
    maslahat_chat_thinking: 'Анализ данных…',
    maslahat_chat_sending: 'Отправка…',
    maslahat_chat_footer_hint: 'Ответы опираются на ваши данные ERP (продажи, заказы, остатки).',
    maslahat_chat_footer_hint_owner:
      'Ответы по данным платформы (клиенты, сотрудники, рассрочка, заказы) через SQL-агент и JSON-контекст. Не вводите секреты в чат.',
    maslahat_quick_platform_tenants: 'Активные клиенты + тариф',
    maslahat_quick_platform_tenants_prompt:
      'Покажи список активных клиентов (tenants, status=active): ID, название, тариф и статус — таблица SQL.',
    maslahat_quick_platform_by_tariff: 'По тарифам (число)',
    maslahat_quick_platform_by_tariff_prompt:
      'Сгруппируй активных клиентов по тарифам: таблица тариф и количество клиентов (только числа).',
    maslahat_quick_platform_overview: 'Сводка платформы',
    maslahat_quick_platform_overview_prompt:
      'Общие показатели платформы: активные клиенты, пробный период, менеджеры регионов, открытая рассрочка — SQL таблица.',
    maslahat_top10_loading: 'Загрузка рекомендаций…',
    maslahat_top10_error: 'Не удалось загрузить рекомендации. Ниже запасной список.',
    maslahat_top10_fallback_hint: 'Офлайн / резерв.',
    maslahat_chat_reply_empty: 'Пустой ответ. Отправьте запрос ещё раз.',
    maslahat_chat_new: 'Новый чат',
    maslahat_chat_reload_history: 'Обновить историю',
    maslahat_chat_load_more: 'Загрузить ещё',
    maslahat_chat_offline: 'Нет сети. Отправка недоступна.',
    maslahat_quick_sales: 'Продажи за 7 дней и рост',
    maslahat_quick_stock: 'Нулевые и низкие остатки',
    maslahat_quick_inventory_cost: 'Закупочная цена + остаток',
    maslahat_quick_inventory_cost_prompt:
      'Покажи по товарам закупочную цену, текущий остаток и 10 позиций с самой низкой маржой.',
    maslahat_quick_debt: 'Дебиторка и открытые заказы',
    maslahat_quick_orders: 'Заказы за 30 дней',
    maslahat_quick_summary: 'Краткий итог за сегодня',
    maslahat_quick_data_scope: 'Какие данные у вас есть в этом чате?',
    maslahat_quick_stock_disabled_hint: 'Сейчас нет позиций с нулевым или отрицательным остатком в снимке.',
    maslahat_quick_summary_disabled_hint: 'Недостаточно данных для краткого итога.',
    maslahat_discuss_ai: 'Обсудить с AI',
    maslahat_discuss_prefill: 'Раскрой рекомендацию №{rank}: «{text}». Отвечай только на основе моего JSON-снимка ERP.',
    maslahat_snapshot_title: 'Данные для ответа',
    maslahat_snapshot_sales: 'Продажи за 7 дней (UZS)',
    maslahat_snapshot_growth: 'Рост неделя к неделе',
    maslahat_snapshot_orders: 'Заказов за 30 дней',
    maslahat_snapshot_top: 'Топ товары',
    maslahat_snapshot_oos: 'Нулевые остатки',
    maslahat_snapshot_at: 'Обновлено',
    maslahat_snapshot_none: '—',
    maslahat_chat_typing: 'AI печатает…',
    maslahat_chat_loading_overlay: 'Готовим данные и ответ…',
    maslahat_structured_reasons: 'Сигналы',
    maslahat_structured_actions: 'Действия',
    maslahat_sql_query_btn: 'SQL-запрос',
    maslahat_sql_query_placeholder: 'Задайте точный вопрос: «Какой товар продавался больше всего за 7 дней?»',
    maslahat_sql_badge: 'Данные из БД (live)',
    maslahat_sql_rows: 'строк возвращено',
    maslahat_sql_sending: 'Запрос к базе данных…',
    maslahat_sql_error_scope: 'SQL-агент не применяется для этого вопроса. Используйте обычный чат.',
    adminAdvice_subtitle_dispatcher: 'Продажи, заказы и быстрые ответы AI.',
    adminAdvice_subtitle_warehouse: 'Остатки, оборот и советы AI.',
    adminAdvice_subtitle_accountant: 'Вопросы по финансам и отчётам.',
    adminAdvice_subtitle_analyst: 'Аналитика, сегменты и воронка с AI.',
    adminAdvice_subtitle_gm: 'KPI и стратегические советы для руководства.',
    adminAdvice_subtitle_platform: 'Советы по платформе и проекту.',
    adminAdvice_subtitle_owner_ai:
      'AI-чат: клиенты (tenant), тариф и подписка, менеджеры, диспетчеры, рассрочка и платежи — ответы на основе безопасного SELECT и JSON-контекста.',
    adminAdvice_subtitle_tenant_owner: 'Практические советы для владельца точки: филиалы, кассиры, продажи, склад, маркетинг и финансовые процессы.',
    adminDashboard_subtitle: 'Быстрый переход в основные разделы. Показатели системы обновляются с сервера, когда они доступны.',
    adminDashboard_status_title: 'Состояние системы',
    adminDashboard_label_version: 'Версия',
    adminDashboard_label_uptime: 'Аптайм',
    adminDashboard_label_backup: 'Последний бэкап',
    adminDashboard_label_db: 'База данных',
    adminDashboard_quick_statistics_desc: 'Сводка по продажам, филиалам и KPI.',
    adminDashboard_quick_messages_desc: 'Переписка и сообщения с клиентами.',
    adminDashboard_quick_managers_desc: 'Управление региональными и другими менеджерами.',
    adminDashboard_metrics_empty: 'Пока нет данных с сервера для карточек состояния системы. Остальные разделы работают как обычно.',
    adminDashboard_help_hint: 'Команды и ответы на частые вопросы — в разделе «Помощь».',
    adminDashboard_quick_title: 'Быстрый доступ',
    adminDashboard_quick_settings_title: 'Настройки',
    adminDashboard_quick_settings_desc: 'Общие настройки, язык, часовой пояс и параметры системы.',
    adminDashboard_quick_tariffs_title: 'Тарифы',
    adminDashboard_quick_tariffs_desc: 'Управление тарифными планами, ценами и лимитами.',
    adminDashboard_quick_tenants_title: 'Клиенты',
    adminDashboard_quick_tenants_desc: 'Список клиентов платформы, добавление и настройка.',
    adminDashboard_quick_integrations_title: 'Интеграции',
    adminDashboard_quick_integrations_desc: 'Подключение внешних сервисов, API и платёжных систем.',
    adminDashboard_quick_audit_title: 'Журнал аудита',
    adminDashboard_quick_audit_desc: 'История действий пользователей и событий системы.',
    adminDashboard_quick_apikeys_title: 'API ключи',
    adminDashboard_quick_apikeys_desc: 'Создание, обновление и ограничения API ключей.',
    adminDashboard_activity_title: 'Последняя активность',
    adminDashboard_activity_1: 'Вход в систему — 2025-02-05 09:15',
    adminDashboard_activity_2: 'Настройки обновлены — лимиты тарифов (2025-02-04 16:22)',
    adminDashboard_activity_3: 'Добавлен новый клиент — «ABC MChJ» (2025-02-04 14:00)',
    adminDashboard_activity_4: 'Интеграция включена — 1С (2025-02-03 11:30)',
    adminDashboard_activity_5: 'Создан API ключ — production (2025-02-02 10:15)',
    adminDashboard_activity_6: 'Экспорт аудита загружен — 2025-02-01 17:45',
    adminDashboard_activity_7: 'Резервное копирование завершено — 2025-02-05 03:00',
    adminDashboard_usage_title: 'Использование',
    adminDashboard_usage_requests: 'API запросы (сегодня)',
    adminDashboard_usage_sessions: 'Активные сессии',
    adminDashboard_usage_storage: 'Объём хранилища',
    adminDashboard_security_title: 'Безопасность',
    adminDashboard_security_last_login: 'Последний вход',
    adminDashboard_security_failed: 'Неудачные попытки',
    adminDashboard_security_2fa: 'Двухфакторная аутентификация (2FA) поддерживается. Рекомендуется включить для всех администраторов.',
    adminDashboard_docs_title: 'Документация и поддержка',
    adminDashboard_docs_text: 'Полное руководство администратора и документация API будут добавлены в следующих обновлениях. По вопросам обращайтесь в службу поддержки.',
    adminHealth_subtitle: 'Подробная информация о сервисах, ресурсах и последних событиях. Все показатели — статический пример.',
    adminHealth_status_operational: 'Работает',
    adminHealth_status_degraded: 'Ограничено',
    adminHealth_status_outage: 'Недоступен',
    adminHealth_overview_title: 'Общие показатели',
    adminHealth_version: 'Версия',
    adminHealth_uptime: 'Аптайм',
    adminHealth_uptime_days: 'дней',
    adminHealth_last_backup: 'Последний бэкап',
    adminHealth_last_deploy: 'Последний деплой',
    adminHealth_services_title: 'Состояние сервисов',
    adminHealth_service_api: 'API-сервер',
    adminHealth_service_database: 'База данных',
    adminHealth_service_cache: 'Кэш (Redis)',
    adminHealth_service_queue: 'Очередь (Queue)',
    adminHealth_service_storage: 'Хранилище файлов',
    adminHealth_service_cdn: 'CDN',
    adminHealth_resources_title: 'Ресурсы',
    adminHealth_resource_cpu: 'Процессор (CPU)',
    adminHealth_resource_memory: 'Память (RAM)',
    adminHealth_resource_disk: 'Диск',
    adminHealth_incidents_title: 'Последние инциденты',
    adminHealth_incidents_none: 'За последние 30 дней инциденты не зафиксированы. Все системы работают стабильно.',
    adminHealth_resolved: 'Исправлено',
    adminHealth_recommendations_title: 'Рекомендации',
    adminHealth_recommend_1: 'Проверяйте резервные копии ежедневно и периодически тестируйте восстановление.',
    adminHealth_recommend_2: 'Своевременно устанавливайте обновления безопасности и отслеживайте логи.',
    adminHealth_recommend_3: 'Следите за использованием диска и памяти по плану; настройте уведомления до достижения лимитов.',
    adminHealth_recommend_4: 'При инцидентах проверяйте журнал аудита и раздел мониторинга ошибок.',
    adminHealth_footer: 'Данные — статический пример. Обновление при подключении бэкенда мониторинга.',
    adminUsage_subtitle: 'Подробная статистика по API-запросам, активным пользователям, хранилищу и лимитам тарифа. Все данные — статический пример.',
    adminUsage_period: 'Последние 30 дней',
    adminUsage_kpi_title: 'Основные показатели',
    adminUsage_kpi_requests_total: 'API-запросы (всего)',
    adminUsage_kpi_requests_today: 'Сегодня',
    adminUsage_kpi_active_users: 'Активные пользователи',
    adminUsage_kpi_storage: 'Хранилище',
    adminUsage_kpi_tenants: 'Клиенты',
    adminUsage_kpi_avg_response: 'Среднее время ответа',
    adminUsage_limits_title: 'Лимиты тарифа',
    adminUsage_limit_api: 'API-запросы (в месяц)',
    adminUsage_limit_storage: 'Хранилище',
    adminUsage_limit_users: 'Пользователи',
    adminUsage_trend_title: 'Дневной тренд',
    adminUsage_trend_caption: 'Относительное использование за последние 15 дней (%).',
    adminUsage_endpoints_title: 'Самые вызываемые endpoint\'ы',
    adminUsage_endpoint_path: 'Endpoint',
    adminUsage_endpoint_method: 'Метод',
    adminUsage_endpoint_count: 'Запросы',
    adminUsage_footer: 'Показатели — статический пример. Реальные отчёты и экспорт будут добавлены при подключении бэкенда.',
    adminError_subtitle: 'Ошибки системы, их уровень и источник. Все записи — статический пример.',
    adminError_filter_all: 'Все',
    adminError_severity_critical: 'Критично',
    adminError_severity_warning: 'Предупреждение',
    adminError_severity_info: 'Инфо',
    adminError_summary_title: 'Кратко (последние 24 ч)',
    adminError_summary_24h: 'Ошибки (24 ч)',
    adminError_total: 'записей',
    adminError_time: 'Время',
    adminError_severity: 'Уровень',
    adminError_message: 'Сообщение',
    adminError_source: 'Источник',
    adminError_endpoint: 'Endpoint',
    adminError_request_id: 'Request ID',
    adminError_status: 'Статус',
    adminError_resolved: 'Исправлено',
    adminError_new: 'Новая',
    adminError_source_api: 'API',
    adminError_source_auth: 'Auth',
    adminError_source_database: 'БД',
    adminError_source_worker: 'Worker',
    adminError_source_integration: 'Интеграция',
    adminError_msg_rate_limit: 'Превышен лимит запросов (rate limit). Клиент временно ограничен.',
    adminError_msg_validation: 'Ошибка валидации: переданы некорректные значения полей.',
    adminError_msg_db_connection: 'Таймаут подключения к БД. Переподключение выполнено успешно.',
    adminError_msg_token_expired: 'Истёк срок действия access token. Пользователь повторно аутентифицирован.',
    adminError_msg_integration_timeout: 'Внешний сервис (1С) не ответил. Timeout 30 сек.',
    adminError_msg_queue_delay: 'Задержка в очереди: перегрузка worker. Обработано позже.',
    adminError_msg_file_size: 'Размер загруженного файла превысил лимит (макс. 10 МБ).',
    adminError_msg_payment_gateway: 'Платёжный шлюз (Payme) временно не ответил. Платёж подтверждён позже.',
    adminError_msg_memory_high: 'Высокое использование памяти сервера (85%+). Кэш очищен.',
    adminError_msg_deprecated_api: 'Вызван устаревший API (v0). Рекомендуется переход на v1.',
    adminError_footer: 'Ошибки — статический пример. Реальный мониторинг и уведомления при подключении бэкенда.',
    adminApiKey_subtitle: 'Создание, редактирование и ограничения API-ключей. Доступ для внешних систем и интеграций.',
    adminApiKey_add: 'Добавить',
    adminApiKey_name: 'Название',
    adminApiKey_key: 'Ключ',
    adminApiKey_environment: 'Среда',
    adminApiKey_scopes: 'Права',
    adminApiKey_created: 'Создан',
    adminApiKey_expires: 'Истекает',
    adminApiKey_status: 'Статус',
    adminApiKey_actions: 'Действия',
    adminApiKey_edit: 'Изменить',
    adminApiKey_delete: 'Удалить',
    adminApiKey_empty: 'API-ключей пока нет. Создайте первый через «Добавить».',
    adminApiKey_modal_add_title: 'Новый API-ключ',
    adminApiKey_modal_edit_title: 'Редактировать API-ключ',
    adminApiKey_name_placeholder: 'Например: Production — основной',
    adminApiKey_expires_placeholder: 'ГГГГ-ММ-ДД или пусто (без срока)',
    adminApiKey_cancel: 'Отмена',
    adminApiKey_save: 'Сохранить',
    adminApiKey_confirm_delete_title: 'Удалить API-ключ',
    adminApiKey_confirm_delete_text: 'Удалить ключ',
    adminApiKey_env_production: 'Production',
    adminApiKey_env_staging: 'Staging',
    adminApiKey_status_active: 'Активен',
    adminApiKey_status_revoked: 'Отозван',
    adminApiKey_scope_read: 'Чтение',
    adminApiKey_scope_write: 'Запись',
    adminApiKey_scope_admin: 'Админ',
    adminManager_subtitle: 'Список главных и региональных менеджеров. Ответственные за филиалы, заказы и отчёты.',
    adminManager_add: 'Добавить',
    adminManager_total: 'менеджеров',
    adminManager_name: 'Ф.И.О.',
    adminManager_role: 'Роль',
    adminManager_region: 'Регион',
    adminManager_contact: 'Контакт',
    adminManager_territory: 'Территория / филиалы',
    adminManager_status: 'Статус',
    adminManager_joined: 'Дата присоединения',
    adminManager_actions: 'Действия',
    adminManager_edit: 'Изменить',
    adminManager_delete: 'Удалить',
    adminManager_empty: 'Список менеджеров пуст. Добавьте через «Добавить».',
    adminManager_modal_add_title: 'Новый менеджер',
    adminManager_modal_edit_title: 'Редактировать менеджера',
    adminManager_name_placeholder: 'Полное имя',
    adminManager_region_placeholder: 'Например: Ташкент, Самарканд',
    adminManager_territory_placeholder: 'Например: г. Ташкент — 12 филиалов',
    adminManager_note_placeholder: 'Доп. примечание',
    adminManager_cancel: 'Отмена',
    adminManager_save: 'Сохранить',
    adminManager_confirm_delete_title: 'Удалить менеджера',
    adminManager_confirm_delete_text: 'Удалить из списка',
    adminManager_role_bosh_menejer: 'Главный менеджер',
    adminManager_role_viloyat_menejer: 'Региональный менеджер',
    adminManager_role_general_manager: 'Главный менеджер',
    adminManager_role_regional_manager: 'Региональный менеджер',
    adminManager_status_active: 'Активен',
    adminManager_status_inactive: 'Неактивен',
    adminManager_phone: 'Телефон',
    adminManager_note: 'Примечание',
    adminBranch_subtitle: 'Список филиалов. Добавление, редактирование и удаление.',
    adminBranch_add: 'Добавить филиал',
    adminBranch_total: 'филиалов',
    adminBranch_name: 'Название филиала',
    adminBranch_tenant: 'Клиент (компания) и номер',
    adminBranch_region: 'Регион',
    adminBranch_address: 'Адрес',
    adminBranch_responsible_name: 'Ответственный сотрудник',
    adminBranch_responsible_phone: 'Телефон ответственного',
    adminBranch_actions: 'Действия',
    adminBranch_edit: 'Изменить',
    adminBranch_delete: 'Удалить',
    adminBranch_empty: 'Список филиалов пуст. Добавьте через «Добавить филиал».',
    adminBranch_modal_add_title: 'Новый филиал',
    adminBranch_modal_edit_title: 'Редактировать филиал',
    adminBranch_name_placeholder: 'Напр.: Ташкентский филиал',
    adminBranch_address_placeholder: 'Введите адрес',
    adminBranch_responsible_name_placeholder: 'Ф.И.О. ответственного',
    adminBranch_responsible_phone_placeholder: '+998 90 123 45 67',
    adminBranch_cancel: 'Отмена',
    adminBranch_save: 'Сохранить',
    adminBranch_confirm_delete_title: 'Удалить филиал',
    adminBranch_confirm_delete_text: 'Вы действительно хотите удалить филиал',
    adminBranch_error_tenant_required: 'Клиент (tenant) не определён. Обновите профиль или войдите заново.',
    adminBranch_yes: 'Да',
    adminBranch_no: 'Нет',
    adminBranch_region_placeholder: 'Выберите регион',
    adminBranch_tenant_placeholder: 'Выберите клиента (компанию)',
    adminBranch_view: 'Просмотр филиала',
    adminBranch_view_title: 'Информация по филиалу',
    adminBranch_detail_info: 'Основная информация',
    adminBranch_detail_stats: 'Статистика продаж',
    adminBranch_detail_cashiers: 'Кассиры филиала',
    adminBranch_detail_warehouse: 'Состояние склада',
    adminBranch_stat_orders_month: 'Кол-во заказов за месяц',
    adminBranch_stat_revenue_month: 'Выручка за месяц',
    adminBranch_stat_revenue_total: 'Общая выручка',
    adminBranch_stat_last_order: 'Время последнего заказа',
    adminBranch_cashier_name: 'Кассир',
    adminBranch_cashier_phone: 'Телефон',
    adminBranch_cashier_status: 'Статус',
    adminBranch_cashier_orders_month: 'Заказы за месяц',
    adminBranch_cashier_revenue_month: 'Выручка за месяц',
    adminBranch_cashier_last_shift: 'Последняя смена',
    adminBranch_warehouse_products: 'Количество товаров',
    adminBranch_warehouse_stock: 'Общий остаток',
    adminBranch_warehouse_stock_value: 'Сумма остатка',
    adminBranch_close: 'Закрыть',
    adminCashier_subtitle: 'Список кассиров. Добавление, редактирование и удаление. Телефон кассира — для входа в систему.',
    adminCashier_add: 'Добавить кассира',
    adminCashier_total: 'кассиров',
    adminCashier_name: 'Имя и фамилия кассира',
    adminCashier_fullName: 'Кассир',
    adminCashier_surname: 'Фамилия',
    adminCashier_phone: 'Телефон кассира',
    adminCashier_name_placeholder: 'Полное имя и фамилия',
    adminCashier_phone_placeholder: '+998 90 123 45 67',
    adminCashier_modal_add_title: 'Новый кассир',
    adminCashier_modal_edit_title: 'Редактировать кассира',
    adminCashier_confirm_delete_title: 'Удалить кассира',
    adminCashier_confirm_delete_text: 'Вы действительно хотите удалить кассира',
    adminCashier_empty: 'Список кассиров пуст. Добавьте через «Добавить кассира».',
    adminCashier_branch_placeholder: 'Выберите филиал (обязательно)',
    adminCashier_branches_empty_hint: 'Филиалы не найдены. Сначала добавьте филиал в разделе «Филиалы» или войдите снова под клиентом.',
    adminCashier_my_branch: 'Мой филиал',
    adminCashier_branch_products_scope: 'Добавление и правки действуют только для этого филиала.',
    adminMarketing_cashier_lead:
      'Ваш филиал: ссылка на онлайн-магазин и онлайн-заказы, поступившие в этот филиал.',
    adminMarketing_cashier_no_branch:
      'К учётной записи не привязан филиал. Обратитесь к администратору — заказы маркетинга отображаются по филиалу.',
    adminMarketing_cashier_settings_note: 'Настройки маркетинга (название магазина, Telegram) — через владельца точки.',
    adminMarketing_your_branch: 'Ваш филиал',
    adminMarketing_no_branches: 'Филиалы не найдены.',
    adminMarketing_orders_branch_title: 'Онлайн-заказы (ваш филиал)',
    adminMarketing_orders_hint_cashier: 'Только онлайн-заказы (маркетинг), поступившие в этот филиал. Фильтр по дате.',
    adminStaffWorkers_subtitle:
      'Сотрудники: фиксированная зарплата, филиал и должность. Ежемесячно KPI анализируются (ИИ на backend), процент премии рассчитывается автоматически.',
    adminStaffWorkers_add: 'Добавить сотрудника',
    adminStaffWorkers_total: 'сотрудников',
    adminStaffWorkers_name: 'Ф.И.О.',
    adminStaffWorkers_position: 'Должность',
    adminStaffWorkers_position_placeholder: 'Напр.: продавец, ст. продавец',
    adminStaffWorkers_monthly_salary: 'Оклад (UZS)',
    adminStaffWorkers_phone: 'Телефон',
    adminStaffWorkers_phone_placeholder: '+998 …',
    adminStaffWorkers_modal_add: 'Новый сотрудник',
    adminStaffWorkers_modal_edit: 'Редактировать',
    adminStaffWorkers_confirm_delete_title: 'Удалить сотрудника',
    adminStaffWorkers_confirm_delete_text: 'Удалить из списка сотрудника',
    adminStaffWorkers_empty: 'Список пуст. Добавьте через «Добавить сотрудника».',
    adminStaffWorkers_empty_cashiers:
      'Кассиры не найдены. Добавьте кассиров в разделе кассиров — список сотрудников строится из них.',
    adminStaffWorkers_branch_placeholder: 'Выберите филиал (обязательно)',
    adminStaffWorkers_bonus_section: 'Месячная премия (ИИ)',
    adminStaffWorkers_bonus_hint:
      'За выбранный месяц backend собирает KPI (продажи, выручка, посещаемость и т.д.), LLM или rule-engine предлагает % премии по каждому сотруднику. Кнопка запускает пересчёт на сервере.',
    adminStaffWorkers_year: 'Год',
    adminStaffWorkers_month: 'Месяц',
    adminStaffWorkers_run_ai: 'Рассчитать (ИИ)',
    adminStaffWorkers_run_ai_loading: 'Расчёт…',
    adminStaffWorkers_col_bonus_pct: 'Премия %',
    adminStaffWorkers_col_bonus_amount: 'Сумма премии',
    adminStaffWorkers_col_monthly_sales: 'Продажи за месяц',
    adminStaffWorkers_ai_rationale: 'Краткое обоснование',
    adminStaffWorkers_status: 'Статус',
    adminStaffWorkers_status_pending: 'Ожидает',
    adminStaffWorkers_status_ready: 'Готово',
    adminStaffWorkers_no_eval_yet: 'За этот месяц оценки ещё нет. Нажмите «Рассчитать (ИИ)».',
    adminBranch_save: 'Сохранить',
    adminBranch_confirm_delete_title: 'Удалить филиал',
    adminBranch_confirm_delete_text: 'Удалить из списка филиал',
    adminDispatcher_subtitle: 'Список диспетчеров, принимающих лиды и заказы. Привязка к менеджеру, рейтинг и смены.',
    adminDispatcher_subtitle_vm: 'Диспетчеры вашего региона. Телефон используется как логин.',
    adminDispatcher_phone_login: ' (логин)',
    adminDispatcher_login_required: 'Укажите телефон диспетчера — он будет логином.',
    adminDispatcher_add: 'Добавить',
    adminDispatcher_total: 'диспетчеров',
    adminDispatcher_name: 'Ф.И.О.',
    adminDispatcher_zone: 'Зона / территория',
    adminDispatcher_contact: 'Контакт',
    adminDispatcher_manager: 'Менеджер',
    adminDispatcher_orders: 'Заказы (мес.)',
    adminDispatcher_status: 'Статус',
    adminDispatcher_joined: 'Дата присоединения',
    adminDispatcher_actions: 'Действия',
    adminDispatcher_edit: 'Изменить',
    adminDispatcher_delete: 'Удалить',
    adminDispatcher_empty: 'Список диспетчеров пуст. Добавьте через «Добавить».',
    adminDispatcher_modal_add_title: 'Новый диспетчер',
    adminDispatcher_modal_edit_title: 'Редактировать диспетчера',
    adminDispatcher_name_placeholder: 'Полное имя',
    adminDispatcher_zone_placeholder: 'Например: Ташкент — центр',
    adminDispatcher_manager_placeholder: 'Ф.И.О. ответственного менеджера',
    adminDispatcher_note_placeholder: 'Смена, задача и др. примечание',
    adminDispatcher_cancel: 'Отмена',
    adminDispatcher_save: 'Сохранить',
    adminDispatcher_confirm_delete_title: 'Удалить диспетчера',
    adminDispatcher_confirm_delete_text: 'Удалить из списка',
    adminDispatcher_status_active: 'Активен',
    adminDispatcher_status_inactive: 'Неактивен',
    adminDispatcher_phone: 'Телефон',
    adminDispatcher_firstName: 'Имя',
    adminDispatcher_lastName: 'Фамилия',
    adminDispatcher_firstName_ph: 'Например: Санжар',
    adminDispatcher_lastName_ph: 'Например: Рахимов',
    adminDispatcher_select_manager: 'Региональный менеджер',
    adminDispatcher_select_manager_ph: 'Выберите менеджера',
    adminDispatcher_select_region: 'Регион',
    adminDispatcher_select_region_ph: 'Выберите регион',
    adminDispatcher_manager_required: 'Сначала выберите регионального менеджера.',
    adminDispatcher_region_required: 'Выберите регион для привязки диспетчера.',
    adminDispatcher_region_col: 'Регион',
    adminDispatcher_note: 'Примечание',
    adminOrder_subtitle: 'Список заказов по всем регионам. Контроль по клиенту, менеджеру, диспетчеру и статусу.',
    adminOrder_subtitle_vm: 'Заказы по вашему региону. Контроль по клиенту, диспетчеру и статусу.',
    adminOrder_subtitle_disp: 'Статусы: Новый, Отклонён или Отправлен менеджеру. «В клиента» помечает как отправлено менеджеру; иначе доступен только отказ.',
    adminOrder_number: 'Номер',
    adminOrder_client: 'Клиент',
    adminOrder_region: 'Регион',
    adminOrder_manager: 'Менеджер',
    adminOrder_dispatcher: 'Диспетчер',
    adminOrder_business_type: 'Тип бизнеса',
    adminOrder_tariff: 'Тариф',
    adminOrder_amount: 'Сумма',
    adminOrder_status: 'Статус',
    adminOrder_created: 'Дата',
    adminOrder_note: 'Примечание',
    adminOrder_summary_total: 'Итого',
    adminOrder_summary_count: 'заказов',
    adminOrder_period: 'Последние 30 дней',
    adminOrder_empty: 'Заказов нет.',
    adminOrder_actions: 'Действия',
    adminOrder_convert_to_tenant: 'В клиента',
    adminOrder_convert_title: 'Преобразовать заказ в клиента',
    adminOrder_convert_subtitle: 'На основе заявки с основного сайта будет создан клиент платформы.',
    adminOrder_convert_submit: 'Создать клиента',
    adminOrder_convert_validation: 'Укажите email, адрес и пароль не короче 6 символов.',
    adminOrder_disp_status_new: 'Новый',
    adminOrder_disp_status_rejected: 'Отклонён',
    adminOrder_disp_status_sent: 'Отправлен менеджеру',
    adminOrder_reject_btn: 'Отклонить',
    adminOrder_reject_confirm: 'Отклонить этот заказ?',
    adminOrder_company_short: 'Компания',
    cashierKassa_subtitle: 'Добавьте товары, выберите способ оплаты, распечатайте.',
    cashierKassa_search_placeholder: 'Штрих-код, маркировка или название товара',
    cashierKassa_pos_qty_active: 'Режим количества',
    cashierKassa_pos_amount_active: 'Режим свободной цены',
    cashierKassa_pos_press_enter: 'нажмите Enter',
    cashierKassa_pos_search_then_enter: 'сначала найдите товар, затем Enter',
    cashierKassa_pos_prefix_hint: 'Сначала найдите товар (например чай), затем 15+ или 19.000* и Enter',
    cashierKassa_pos_prefix_apply_failed: 'Не удалось обновить последнюю строку. Проверьте количество или цену.',
    cashierKassa_pos_not_found: 'Товар не найден. Проверьте название или выберите из списка.',
    cashierKassa_scan_barcode: 'Сканировать штрих-код',
    cashierKassa_scan_title: 'Сканирование штрих-кода',
    cashierKassa_scan_close: 'Закрыть',
    cashierKassa_choose_variant: 'Выберите единицу или вариант',
    cashierKassa_scan_added: 'Добавлено в корзину',
    cashierKassa_cart: 'Корзина',
    cashierKassa_cart_empty: 'Корзина пуста.',
    cashierKassa_cart_default: 'Корзина 1',
    cashierKassa_cart_tab: 'Корзина',
    cashierKassa_cart_current: 'Текущая корзина',
    cashierKassa_col_variant_measure: 'Вариант / ед. изм.',
    cashierKassa_new_cart: 'Новая корзина',
    cashierKassa_other_carts: 'Другие корзины',
    cashierKassa_cart_select: 'Выбрать',
    cashierKassa_more: 'ещё',
    cashierKassa_stock_empty: 'На складе нет остатков.',
    cashierKassa_stock_limit: 'Недостаточно на складе. В наличии: ',
    cashierKassa_stock_available: 'В наличии',
    cashierKassa_stock_total: 'Общий остаток',
    cashierKassa_stock_total_short: 'Остаток',
    cashierKassa_stock_pcs: 'шт.',
    cashierKassa_total: 'Итого',
    cashierKassa_no_discount: 'Без скидки',
    cashierKassa_discount_applied: 'Скидка',
    cashierKassa_favorites_title: 'Избранные товары',
    cashierKassa_favorites_empty: 'Нет избранных товаров. Отметьте товары звездочкой в складе.',
    cashierKassa_search_results_title: 'Результаты поиска',
    cashierKassa_search_empty: 'По запросу товары не найдены.',
    cashierKassa_amount_qty_no_price: 'Для количества по сумме нужна цена товара.',
    cashierKassa_amount_free_price_only: 'Сумма (*) только для товаров со свободной ценой.',
    cashierKassa_remove: 'Удалить',
    cashierKassa_to_payment: 'К оплате',
    cashierKassa_print_before_payment: 'Печать чека',
    cashierKassa_draft_receipt: 'Предварительный чек',
    cashierKassa_select_payment: 'Выберите способ оплаты',
    cashierKassa_cash: 'Наличные',
    cashierKassa_card: 'Карта',
    cashierKassa_click: 'Click',
    cashierKassa_discount_profit_blocked: 'Такую скидку применить нельзя (превышает прибыль и уводит ниже себестоимости).',
    cashierKassa_nasiya: 'Рассрочка',
    cashierKassa_aralash: 'Смешанная оплата',
    cashierKassa_nasiya_client: 'Рассрочка: имя и телефон (подставляются из корзины)',
    cashierKassa_client_name: 'Имя клиента',
    cashierKassa_client_phone: 'Телефон',
    cashierKassa_buyer_block_title: 'Клиент в корзине',
    cashierKassa_buyer_hint: 'Поиск по имени или телефону; выбор из списка привязывает клиента.',
    cashierKassa_buyer_new: 'Новый клиент (сохраняется по телефону)',
    cashierKassa_supplier: 'Поставщик',
    cashierKassa_supplier_suggest: 'Поставщики',
    cashierKassa_supplier_phone_missing: 'Телефон не указан',
    cashierKassa_supplier_found: 'Поставщик найден',
    cashierKassa_supplier_balance: 'Остаток долга',
    cashierKassa_supplier_cover_expense: 'Погасить расход',
    cashierKassa_expense_cover_btn: 'Погашение расхода',
    cashierKassa_supplier_as_retail: 'Как розничный клиент',
    cashierKassa_supplier_no_account: 'Карта поставщика не найдена: для погашения расхода отредактируйте товар и привяжите поставщика.',
    cashierKassa_free_trade: 'Свободная цена',
    cashierKassa_free_trade_hint: 'Если включено, при выборе товара вводится цена (количество без изменений).',
    cashierKassa_price_modal_title: 'Цена продажи',
    cashierKassa_price_modal_label: 'Цена (UZS)',
    cashierKassa_price_modal_add: 'В корзину',
    cashierKassa_line_discount_label: 'Скидка по строке (%)',
    cashierKassa_cart_edit_title_piece: 'Строка: количество, цена, скидка',
    cashierKassa_cart_edit_piece_hint: 'Штучный товар: количество, при необходимости своя цена, скидка по строке (UZS).',
    cashierKassa_variable_price_total: 'Переменная цена',
    cashierKassa_cart_line_discount_badge: 'скидка',
    cashierKassa_line_discount_too_high: 'Скидка не может быть больше суммы строки.',
    cashierKassa_back: 'Назад',
    cashierKassa_confirm: 'Подтвердить',
    cashierKassa_confirm_print: 'Подтвердить и печать',
    cashierKassa_payment_method: 'Способ оплаты',
    cashierKassa_confirm_and_print: 'Подтвердить и печать',
    cashierKassa_printing: 'Печать…',
    cashierKassa_order_saved: 'Заказ сохранён (офлайн).',
    cashierKassa_order_saved_synced: 'Заказ сохранён.',
    cashierKassa_sync_failed_title: 'Синхронизация завершилась с ошибкой',
    cashierKassa_sync_failed_body: 'Заказ сохранён офлайн. Проверьте интернет и попробуйте синхронизировать позже.',
    cashierKassa_sync_error_403:
      'Сервер отклонил запрос для вашей роли (403). Попросите администратора разрешить POST /api/sync/orders для кассира.',
    cashierKassa_sync_error_detail: 'Подробнее',
    cashierOrderHistory_subtitle: 'Последние транзакции. Статус синхронизации.',
    cashierOrderHistory_refresh: 'Обновить',
    cashierOrderHistory_empty: 'Пока нет заказов.',
    cashierOrderHistory_synced: 'Синхронизировано',
    cashierOrderHistory_pending: 'Ожидает',
    cashierPayments_subtitle: 'Смена за день, X/Z отчёты, наличные и карта.',
    cashierPayments_today: 'Смена сегодня',
    cashierPayments_reports: 'Отчёты',
    cashierPayments_x_report_hint: 'X-Report — промежуточный отчёт без закрытия смены.',
    cashierPayments_z_report_hint: 'Z-Report — итоговый отчёт при закрытии смены.',
    cashierPayments_backend_note: 'Реальные данные появятся после подключения бэкенда.',
    cashierZReport_subtitle: 'Итоговый отчёт смены за день — только ваши продажи',
    cashierZReport_sales_total: 'Итого продаж',
    cashierZReport_sales_count: 'продаж',
    cashierZReport_average_check: 'Средний чек',
    cashierZReport_payment_types: 'Типы оплат',
    cashierZReport_operations: 'операций',
    cashierZReport_nasiya_issued: 'Выдано сегодня',
    cashierZReport_nasiya_repaid: 'Погашено сегодня',
    cashierZReport_active_credits: 'активных рассрочек',
    cashierZReport_footnote: 'Z-Report — итоговый отчёт смены. Данные только по продажам текущего кассира.',
    cashierZReport_send_to_owner: 'Отправить руководителю',
    cashierZReport_sent_success: 'Z-Report отправлен клиенту',
    ownerZReport_subtitle: 'Ежедневные Z-Report от кассиров — фильтр по дате',
    ownerZReport_reports_count: 'Отправленные отчёты',
    ownerZReport_empty: 'За выбранную дату Z-Report не найден.',
    adminNav_owner_z_reports: 'Z-Report',
    adminRefresh: 'Обновить',
    adminCashier_permissions: 'Права кассира',
    adminCashier_perm_products: 'Добавление / редактирование / удаление товаров',
    adminCashier_perm_barcode: 'Добавление штрих-кода к существующему товару',
    adminCashier_perm_add_only: 'Только добавление (новый + остаток)',
    adminCashier_add_to_existing_product: 'Добавить к существующему товару',
    adminNav_product_audit: 'Аудит товаров',
    adminProductAudit_subtitle: 'История добавления, изменения и удаления товаров кассирами',
    adminProductAudit_action_created: 'Добавлен',
    adminProductAudit_action_updated: 'Изменён',
    adminProductAudit_action_deleted: 'Удалён',
    adminProductAudit_filter_action: 'Тип действия',
    adminProductAudit_all_actions: 'Все действия',
    adminProductAudit_summary_added: 'Добавлено',
    adminProductAudit_summary_updated: 'Изменено',
    adminProductAudit_summary_deleted: 'Удалено',
    adminProductAudit_col_product: 'Товар',
    adminProductAudit_col_action: 'Действие',
    adminProductAudit_col_cashier: 'Кассир',
    adminProductAudit_col_branch: 'Филиал',
    adminProductAudit_col_date: 'Дата',
    adminProductAudit_empty: 'Записей по выбранному фильтру нет',
    adminProductAudit_date_from: 'Дата с',
    adminProductAudit_date_to: 'Дата по',
    adminProductAudit_total: 'Всего записей',
    adminProductAudit_filter_branch: 'Название филиала',
    adminProductAudit_filter_cashier: 'Имя и фамилия кассира',
    adminProductAudit_col_details: 'Подробности',
    adminProductAudit_qty: 'Количество',
    adminProductAudit_purchase: 'Закупочная цена',
    adminProductAudit_sale: 'Цена продажи',
    adminTrans_all_branches: 'Все филиалы',
    adminTrans_all_cashiers: 'Все кассиры',
    cashierKassa_mixed_remaining: 'Остаток суммы',
    cashierKassa_cashback_use: 'Списать cashback',
    cashierKassa_cashback_balance: 'Баланс',
    cashierKassa_cashback_amount_ph: 'Сумма',
    cashierKassa_cashback_use_all: 'Всё',
    cashierKassa_cashback_applied: 'Cashback',
    cashierKassa_cashback_pay_remaining: 'К оплате',
    cashierKassa_mixed_after_cashback: 'Осталось к оплате',
    adminCashier_branch_products_view_only: 'Только просмотр — остатки по вашему филиалу',
    adminOmbor_tenant_fav_select_all: 'Выбрать все',
    adminOmbor_tenant_fav_clear_all: 'Снять выбор со всех',
    adminOmbor_col_free_price: 'Свободная цена',
    adminOmbor_free_price_enable_all: 'Включить свободную цену для всех',
    adminOmbor_free_price_disable_all: 'Отключить свободную цену для всех',
    adminOmbor_free_price_enable_row: 'Включить свободную цену',
    adminOmbor_free_price_disable_row: 'Отключить свободную цену',
    adminOmbor_free_price_toggle_error: 'Не удалось обновить свободную цену',
    adminOmbor_free_price_bulk_partial: 'Частично обновлено',
    adminOmbor_free_price_bulk_skipped_hint: 'Обновлено: {updated}. Пропущено: {skipped} — нет цены продажи.',
    cashierProducts_subtitle: 'Товары: добавление, редактирование, удаление. Штрих-код генерируется автоматически, если не указан.',
    cashierProducts_search_placeholder: 'Поиск по названию, штрих-коду, маркировке, ID',
    cashierProducts_add: 'Добавить товар',
    cashierProducts_edit: 'Редактировать',
    cashierProducts_name: 'Название',
    cashierProducts_name_placeholder: 'Название товара',
    cashierProducts_quantity: 'Количество',
    cashierProducts_purchase_price: 'Закупочная цена',
    cashierProducts_sale_price: 'Цена продажи',
    cashierProducts_barcode: 'Штрих-код',
    cashierProducts_marking_code: 'Маркировка',
    cashierProducts_marking_hint: 'необязательно; сканирование Data Matrix / GS1 на кассе',
    cashierProducts_barcode_auto: 'авто при пустом',
    cashierProducts_empty: 'Товаров нет.',
    cashierProducts_free_trade_suffix: 'свободная цена',
    cashierProducts_free_price: 'Свободная цена',
    cashierProducts_sale_modes: 'Доп. единицы и варианты',
    cashierProducts_additional_sale_options: 'Доп. единицы/варианты',
    cashierProducts_add_sale_option: 'Добавить доп. единицу',
    cashierProducts_size_label: 'Размер (например: 41)',
    cashierProducts_option_label_optional: 'Метка (необязательно)',
    cashierProducts_add_variant: 'Добавить вариант',
    cashierProducts_color_label: 'Цвет (например: чёрный)',
    cashierProducts_variant_barcode: 'Штрих-код варианта (необязательно)',
    cashierProducts_expense_paid: 'Оплачено',
    cashierProducts_unit_factor: 'Сколько списывать за 1 продажу (в базовой ед.)',
    adminSettings_pwa_cashier: 'PWA / Настройки кассы',
    adminSettings_pwa_cashier_desc: 'Принтер и язык — локальные настройки.',
    adminSettings_printer: 'Принтер',
    adminSettings_printer_browser: 'Браузер (Печать)',
    adminSettings_printer_default: 'Системный по умолчанию',
    adminHelp_telegram: 'Telegram',
    adminHelp_telegram_link: 'Бот поддержки',
    adminLead_subtitle: 'Лиды, назначенные вам. Источник, статус и направление менеджеру.',
    adminLead_subtitle_dispatcher: 'Ищите клиентов (телефон и др.), отправляйте обращение (жалоба, предложение) — попадёт региональному менеджеру в раздел «Обращения».',
    adminLead_subtitle_regional: 'Продажи по вашему региону. Сообщения диспетчера и статусы обращений — здесь.',
    adminLead_summary_total: 'Всего лидов',
    adminLead_summary_total_dispatcher: 'Всего записей',
    adminLead_summary_count: 'лидов',
    adminLead_code: 'Код',
    adminLead_client: 'Клиент',
    adminLead_region: 'Регион',
    adminLead_source: 'Источник',
    adminLead_status: 'Статус',
    adminLead_priority: 'Приоритет',
    adminLead_manager: 'Менеджер',
    adminLead_estimated: 'Ориентир. сумма',
    adminLead_created: 'Дата',
    adminLead_note: 'Примечание',
    adminLead_create_title: 'Создать лид',
    adminLead_create_subtitle: 'При создании также отправляется в заказы.',
    adminLead_create_submit: 'Создать лид',
    adminLead_create_submitting: 'Создание...',
    adminLead_create_error: 'Ошибка при создании лида.',
    adminLead_empty: 'Лидов нет.',
    adminLead_empty_dispatcher: 'Список обращений пуст.',
    adminLead_filter_empty: 'По фильтру лиды не найдены.',
    adminLead_filter_empty_dispatcher: 'По поиску или фильтру записи не найдены.',
    adminLead_empty_regional: 'В регионе нет записей по продажам.',
    adminLead_actions: 'Действия',
    adminLead_escalate_btn: 'Обращение',
    adminLead_escalate_modal_title: 'Сообщение региональному менеджеру',
    adminLead_escalate_message_label: 'Текст проблемы или сообщения',
    adminLead_escalate_message_ph: 'Ситуация клиента, результат поиска или вопрос, требующий решения...',
    adminLead_search_placeholder: 'Поиск: телефон, код, имя, примечание, регион',
    adminLead_escalate_kind_label: 'Тип обращения',
    adminLead_escalate_kind_general: 'Другое / сообщение',
    adminLead_escalate_kind_complaint: 'Жалоба',
    adminLead_escalate_kind_suggestion: 'Предложение',
    adminLead_escalate_kind_tariff_plan_change: 'Запрос на смену тарифа',
    adminLead_tariff_change_intro: 'Клиент отправил запрос на смену тарифного плана.',
    adminLead_tariff_change_current: 'Текущий тариф',
    adminLead_tariff_change_desired: 'Запрошенный тариф',
    adminLead_tariff_change_note: 'Комментарий',
    adminLead_tariff_change_company: 'Организация',
    adminLead_tariff_change_phone: 'Телефон',
    adminLead_tariff_change_dispatcher_note: 'Комментарий диспетчера',
    adminLead_forward_tariff_hint: 'Запрос клиента на смену тарифа. Проверьте и отправьте региональному менеджеру.',
    adminLead_forward_to_manager: 'Отправить менеджеру',
    adminLead_forward_note_label: 'Комментарий менеджеру (необязательно)',
    adminLead_forward_note_ph: 'Например: связался с клиентом, нужно подтверждение…',
    notif_tenant_tariff_change_dispatcher_title: 'Запрос клиента на смену тарифа',
    notif_tenant_tariff_change_dispatcher_body: 'Откройте раздел «Лиды» и отправьте менеджеру.',
    adminLead_escalate_cancel: 'Отмена',
    adminLead_escalate_submit: 'Отправить менеджеру',
    adminLead_escalate_sending: 'Отправка...',
    adminLead_escalations_review: 'Обращения',
    adminLead_escalations_modal_title: 'Обращения',
    adminLead_escalations_loading: 'Загрузка...',
    adminLead_escalations_none: 'По этой продаже обращений нет.',
    adminLead_escalation_status_select: 'Статус обращения',
    adminLead_escalation_resolution_ph: 'Решение или комментарий',
    adminLead_escalation_save: 'Сохранить',
    adminLead_escalation_status_open: 'Новое',
    adminLead_escalation_status_in_progress: 'В работе',
    adminLead_escalation_status_resolved: 'Решено',
    adminLead_escalation_status_declined: 'Отклонено',
    adminLead_escalation_status_closed: 'Закрыто',
    adminLead_escalation_col_latest: 'Последнее обращение',
    adminLead_escalation_view: 'Просмотр',
    adminLead_escalation_view_title: 'Обращения и ответы менеджера',
    adminLead_escalation_view_close: 'Закрыть',
    adminLead_escalation_dp_msg: 'Диспетчер',
    adminLead_escalation_manager_reply: 'Ответ менеджера',
    adminLead_escalation_resolved_at: 'Закрыто',
    adminLead_escalation_no_manager_reply_yet: 'Ответа менеджера пока нет.',
    adminLead_escalation_open_hint: 'Количество открытых обращений',
    adminLead_escalation_pending_banner:
      'Внимание: есть открытое или в работе обращение. Перед новым сообщением проверьте историю и ответ менеджера ниже.',
    adminLead_escalation_prior_title: 'Предыдущие обращения',
    adminLead_status_new: 'Новый',
    adminLead_status_contacted: 'Связались',
    adminLead_status_qualified: 'Квалифицирован',
    adminLead_status_assigned: 'Назначен',
    adminLead_status_converted: 'В заказ',
    adminLead_status_cancelled: 'Отменён',
    adminLead_source_site: 'Сайт',
    adminLead_source_phone: 'Телефон',
    adminLead_source_telegram: 'Telegram',
    adminLead_source_referral: 'Реферал',
    adminLead_source_other: 'Другое',
    adminLead_priority_low: 'Низкий',
    adminLead_priority_normal: 'Средний',
    adminLead_priority_high: 'Высокий',
    adminOrder_status_new: 'Новый',
    adminOrder_status_contacted: 'Связались',
    adminOrder_status_negotiation: 'Переговоры',
    adminOrder_status_confirmed: 'Подтверждён',
    adminOrder_status_in_delivery: 'Доставляется',
    adminOrder_status_completed: 'Выполнен',
    adminOrder_status_cancelled: 'Отменён',
    adminNotif_subtitle: 'Системные и бизнес-уведомления. Заказы, отчёты и сообщения системы.',
    adminNotif_subtitle_vm: 'Уведомления по вашему региону. Заказы и отчёты.',
    adminNotif_subtitle_disp: 'Уведомления по назначенным вам продажам и заказам.',
    adminNotif_subtitle_mijoz: 'Чат и системные уведомления. Ответы поддержки также отображаются здесь.',
    adminNotif_unread: 'непрочитанных',
    adminNotif_total: 'всего',
    adminNotif_empty: 'Уведомлений нет.',
    notif_order_new_title: 'Новый заказ',
    notif_order_new_body: 'Поступил новый заказ. Требуется проверка и назначение менеджеру.',
    notif_order_status_title: 'Статус заказа изменился',
    notif_order_status_body: 'Заказ перешёл в доставку. Продолжайте связь с клиентом.',
    notif_lead_escalation_title: 'Обращение от диспетчера',
    notif_lead_escalation_body: 'Новое обращение. Обновите статус в разделе «Обращения».',
    notif_lead_assigned_title: 'Лид назначен менеджеру',
    notif_lead_assigned_body: 'Новый лид назначен ответственному менеджеру. Свяжитесь в течение 24 часов.',
    notif_report_title: 'Отчёт готов',
    notif_report_body: 'Ежемесячный отчёт готов к скачиванию. Перейдите в раздел Отчёты.',
    notif_system_title: 'Системное сообщение',
    notif_system_body: 'Ежедневная резервная копия успешно завершена. Данные сохранены.',
    notif_reminder_title: 'Напоминание: рейтинг',
    notif_reminder_body: 'Еженедельный рейтинг менеджеров и диспетчеров готов. См. раздел Рейтинг.',
    notif_alert_title: 'Заказ отменён',
    notif_alert_body: 'Клиент отменил заказ. Рекомендуется выяснить причину и зафиксировать в отчёте.',
    notif_order_completed_title: 'Заказ доставлен',
    notif_order_completed_body: 'Заказ успешно доставлен и принят клиентом.',
    adminReports_subtitle: 'Шаблоны отчётов по продажам, заказам, менеджерам и диспетчерам. История скачиваний.',
    adminReports_subtitle_vm: 'Шаблоны отчётов по региону: продажи, заказы, диспетчеры и KPI.',
    adminReports_subtitle_bm: 'Сводные отчёты по всем регионам: продажи, заказы, менеджеры и диспетчеры.',
    adminReports_subtitle_mijoz: 'Аналитика: продажи, маржа, филиалы и товары за выбранный период.',
    adminReports_templates_title: 'Шаблоны отчётов',
    adminReports_templates_count: 'Шаблонов',
    adminReports_last: 'Последнее скачивание',
    adminReports_period: 'Период',
    adminReports_last_generated: 'Последнее создание',
    adminReports_status_ready: 'Готов',
    adminReports_status_generating: 'Формируется',
    adminReports_status_failed: 'Ошибка',
    adminReports_history_title: 'Последние отчёты',
    adminReports_history_report: 'Отчёт',
    adminReports_history_period: 'Период',
    adminReports_history_format: 'Формат',
    adminReports_history_generated: 'Создан',
    adminReports_history_by: 'Кем',
    adminReports_history_size: 'Размер',
    adminReports_em_dash: '—',
    adminReports_region_unknown: 'Регион (не указан в профиле)',
    adminReports_vm_region_label: 'Ваш регион:',
    adminReports_summary_vm_scope: 'Все шаблоны и история фильтруются по вашему региону. Данные обновляются с бэкендом.',
    report_vm_period_last_month: 'прошлый месяц',
    report_vm_period_last_week: 'прошлая неделя',
    report_vm_period_current_month: 'текущий месяц',
    report_vm_period_active_tenants: 'активные клиенты',
    report_vm_period_last_30_days: 'последние 30 дней',
    adminReports_period_today: 'Сегодня',
    adminReports_period_week: 'Неделя',
    adminReports_period_month: 'Месяц',
    adminRating_period_label: 'Период',
    adminReports_period_custom: 'Свой период',
    adminReports_mijoz_snapshot_hint: 'Продажи, маржа и товары за выбранный период и филиал — данные синхронизированы с сервером.',
    adminReports_branch_unassigned: 'Филиал не определён',
    adminReports_payment_terminal: 'Терминал / перевод',
    adminReports_filter_all_branches: 'Все филиалы',
    adminReports_download_excel: 'Excel (XLSX)',
    adminReports_download_pdf: 'PDF',
    adminReports_download_csv: 'CSV',
    adminReports_download_unavailable: 'Экспорт в этом формате недоступен',
    adminReports_download_pdf_only: 'Этот шаблон пока только PDF — Excel скоро',
    adminReports_mijoz_download_csv: 'Скачать отчёт CSV (открыть в Excel)',
    adminReports_mijoz_download_xlsx: 'Скачать отчёт Excel (XLSX)',
    adminReports_mijoz_xlsx_title: 'Аналитический отчёт',
    adminReports_filter_period_aria: 'Период отчёта',
    adminReports_filter_branch_aria: 'Фильтр по филиалу',
    adminReports_filter_date_from: 'Дата начала',
    adminReports_filter_date_to: 'Дата окончания',
    adminReports_product_subtitle: 'Ед. изм. / вариант',
    adminReports_total_sales: 'Общая выручка',
    adminReports_net_profit: 'Чистая прибыль',
    adminReports_net_profit_hint: 'Без учёта рассрочки',
    adminReports_net_profit_hint_nasiya: 'Маржа продаж в рассрочку',
    adminReports_net_profit_hint_all: 'Маржа по всем способам оплаты',
    adminReports_nasiya_total: 'Продажа в рассрочку',
    adminReports_nasiya_covered: 'Погашено',
    adminReports_items_sold: 'Продано товаров',
    adminReports_branch_cashiers: 'Кассиры',
    adminReports_sales_amount: 'Сумма продаж',
    adminReports_by_payment: 'По способам оплаты',
    report_sales_monthly_name: 'Ежемесячный отчёт по продажам',
    report_sales_monthly_desc: 'Продажи, выручка и рост по регионам и категориям.',
    report_sales_monthly_region_desc: 'Месячные продажи и выручка по вашему региону.',
    report_orders_region_name: 'Заказы по регионам',
    report_orders_region_desc: 'Количество заказов, сумма и распределение по статусам по регионам.',
    report_orders_region_vm_desc: 'Заказы, сумма и статусы по вашему региону.',
    report_managers_name: 'Эффективность менеджеров',
    report_managers_desc: 'Рейтинг менеджеров, заказы и показатели удовлетворённости клиентов.',
    report_dispatchers_name: 'Эффективность диспетчеров',
    report_dispatchers_desc: 'Рейтинг диспетчеров, время ответа и выполненные заказы.',
    report_dispatchers_region_desc: 'Рейтинг диспетчеров региона, время ответа и заказы.',
    report_revenue_name: 'Сводка по выручке',
    report_revenue_desc: 'Краткий отчёт по выручке, расходам и прибыли за месяц.',
    report_revenue_region_desc: 'Выручка и краткий отчёт по региону за месяц.',
    report_kpi_name: 'KPI панель',
    report_kpi_desc: 'Ключевые KPI: заказы, выручка, конверсия и др.',
    report_kpi_region_desc: 'KPI по региону: заказы, выручка, конверсия.',
    report_leads_region_name: 'Лиды (регион)',
    report_leads_region_desc: 'Лиды региона: источник, статус, диспетчер.',
    report_tenants_dir_name: 'Реестр клиентов',
    report_tenants_dir_desc: 'Тенанты региона: компания, контакт, статус.',
    report_orders_detail_vm_name: 'Заказы детально',
    report_orders_detail_vm_desc: 'Заказы региона: клиент, диспетчер, сумма, статус.',
    adminRating_subtitle: 'Рейтинг менеджеров по результатам работы и удовлетворённости клиентов. Баллы, заказы и динамика.',
    adminRating_summary_title: 'Сводные показатели',
    adminRating_best_score: 'Лучший балл',
    adminRating_average_score: 'Средний балл',
    adminRating_total_evaluated: 'Оценено',
    adminRating_managers: 'менеджеров',
    adminRating_top_region: 'Лидер по региону',
    adminRating_out_of: 'из 100',
    adminRating_table_title: 'Рейтинг менеджеров',
    adminRating_rank: 'Место',
    adminRating_name: 'Менеджер',
    adminRating_region: 'Регион',
    adminRating_score: 'Балл',
    adminRating_orders: 'Заказы',
    adminRating_satisfaction: 'Удовлетворённость',
    adminRating_change: 'Изменение',
    adminRating_trend_up: 'Рост',
    adminRating_trend_down: 'Снижение',
    adminRating_trend_neutral: 'Без изменений',
    adminRating_footer: 'Рейтинг — статический пример. Фактические баллы и отчёты при подключении бэкенда.',
    adminRatingTenants_subtitle: 'Рейтинг клиентов по объёму продаж',
    adminRatingTenants_summary_title: 'Общая статистика',
    adminRatingTenants_total_sales: 'Общий объём продаж',
    adminRatingTenants_average_sales: 'Средний объём продаж',
    adminRatingTenants_total_tenants: 'Всего клиентов',
    adminRatingTenants_companies: 'компаний',
    adminRatingTenants_top_region: 'Лучший регион',
    adminRatingTenants_top_tenant: 'Лучший клиент',
    adminRatingTenants_table_title: 'Рейтинг клиентов',
    adminRatingTenants_rank: 'Место',
    adminRatingTenants_company: 'Компания',
    adminRatingTenants_region: 'Регион',
    adminRatingTenants_district: 'Район',
    adminRatingTenants_sales_volume: 'Объём продаж',
    adminRatingTenants_orders_count: 'Количество заказов',
    adminRatingTenants_avg_order: 'Средний заказ',
    adminRatingTenants_growth: 'Рост',
    adminRatingTenants_footer: 'Рейтинг рассчитывается по объёму продаж',
    adminRatingDisp_subtitle: 'Рейтинг диспетчеров: обработка лидов и заказов, время ответа и удовлетворённость клиентов.',
    adminRatingDisp_summary_title: 'Сводные показатели',
    adminRatingDisp_best_score: 'Лучший балл',
    adminRatingDisp_average_score: 'Средний балл',
    adminRatingDisp_total_evaluated: 'Оценено',
    adminRatingDisp_dispatchers: 'диспетчеров',
    adminRatingDisp_top_zone: 'Лучшая зона',
    adminRatingDisp_out_of: 'из 100',
    adminRatingDisp_table_title: 'Рейтинг диспетчеров',
    adminRatingDisp_rank: 'Место',
    adminRatingDisp_name: 'Диспетчер',
    adminRatingDisp_zone: 'Зона',
    adminRatingDisp_manager: 'Менеджер',
    adminRatingDisp_score: 'Балл',
    adminRatingDisp_orders: 'Заказы (мес.)',
    adminRatingDisp_response: 'Время ответа',
    adminRatingDisp_satisfaction: 'Удовлетворённость',
    adminRatingDisp_change: 'Изменение',
    adminRatingDisp_min: 'мин',
    adminRatingDisp_trend_up: 'Рост',
    adminRatingDisp_trend_down: 'Снижение',
    adminRatingDisp_trend_neutral: 'Без изменений',
    adminRatingDisp_footer: 'Рейтинг диспетчеров — статический пример. Обновление при подключении бэкенда.',
    adminFinance_subtitle: 'Доходы, расходы, касса и банк, типы оплаты и последние транзакции. Все данные — статический пример.',
    adminFinance_overview_title: 'Сводка',
    adminFinance_revenue: 'Доход за месяц',
    adminFinance_expenses: 'Расход за месяц',
    adminFinance_profit: 'Чистая прибыль',
    adminFinance_cash: 'Касса',
    adminFinance_bank: 'Банк',
    adminFinance_vs_prev: 'к пред. месяцу',
    adminFinance_payment_title: 'По типам оплаты',
    adminFinance_payment_cash: 'Наличные',
    adminFinance_payment_card: 'Карта',
    adminFinance_payment_transfer: 'Перевод',
    adminFinance_transactions_title: 'Последние транзакции',
    adminFinance_date: 'Дата',
    adminFinance_type: 'Тип',
    adminFinance_counterparty: 'Контрагент',
    adminFinance_amount: 'Сумма',
    adminFinance_payment_type: 'Тип оплаты',
    adminFinance_description: 'Описание',
    adminFinance_income: 'Приход',
    adminFinance_expense: 'Расход',
    adminFinance_footer: 'Данные финансов — статический пример. Интеграция 1С и экспорт при подключении бэкенда.',
    adminTrans_subtitle: 'Все приходные и расходные транзакции, фильтрация и краткий отчёт. Данные — статический пример.',
    adminTrans_subtitle_live: 'Все приходные и расходные транзакции, фильтрация и краткий отчёт. Данные с сервера.',
    adminTrans_filter_all: 'Все',
    adminTrans_income: 'Приход',
    adminTrans_expense: 'Расход',
    adminTrans_status_all: 'Все статусы',
    adminTrans_status_completed: 'Выполнено',
    adminTrans_status_pending: 'В ожидании',
    adminTrans_status_failed: 'Ошибка',
    adminTrans_summary_title: 'Сводка',
    adminTrans_total_income: 'Всего приход',
    adminTrans_total_expense: 'Всего расход',
    adminTrans_count: 'Количество транзакций',
    adminTrans_transactions: 'транзакций',
    adminTrans_shown: 'показано',
    adminTrans_group_legacy: 'Предыдущие продажи',
    adminTrans_group_today: 'Сегодня',
    adminTrans_number: '№',
    adminTrans_date: 'Дата',
    adminTrans_date_from: 'Дата с',
    adminTrans_date_to: 'Дата по',
    adminTrans_total: 'Всего',
    adminTrans_type: 'Тип',
    adminTrans_counterparty: 'Контрагент',
    adminTrans_amount: 'Сумма',
    adminTrans_payment: 'Тип оплаты',
    adminTrans_invoice: 'Счёт',
    adminTrans_description: 'Описание',
    adminTrans_status: 'Статус',
    adminTrans_payment_card: 'Карта',
    adminTrans_payment_cash: 'Наличные',
    adminTrans_payment_transfer: 'Перевод',
    adminTrans_empty: 'По выбранным фильтрам транзакций не найдено.',
    adminTrans_footer: 'Транзакции — статический пример. При подключении бэкенда и 1С будут отображаться реальные данные.',
    adminTrans_footer_live:
      'Данные приходят с backend. Названия способов оплаты по филиалу соответствуют операционным настройкам клиента.',
    adminInv_subtitle: 'Все счета, статус оплаты, срок и НДС. Данные наглядные и подробные, статический пример.',
    adminInv_filter_all: 'Все',
    adminInv_status_paid: 'Оплачено',
    adminInv_status_partial: 'Частично оплачено',
    adminInv_status_overdue: 'Просрочено',
    adminInv_status_draft: 'Черновик',
    adminInv_summary_title: 'Сводка',
    adminInv_total_invoiced: 'Всего выставлено',
    adminInv_total_paid: 'Всего оплачено',
    adminInv_total_outstanding: 'Остаток (не оплачено)',
    adminInv_count: 'Количество счетов',
    adminInv_invoices: 'сч.',
    adminInv_shown: 'показано',
    adminInv_number: '№',
    adminInv_date: 'Дата',
    adminInv_due_date: 'Срок',
    adminInv_client: 'Клиент',
    adminInv_amount: 'Сумма (без НДС)',
    adminInv_vat: 'НДС',
    adminInv_total: 'Итого',
    adminInv_paid: 'Оплачено',
    adminInv_status: 'Статус',
    adminInv_description: 'Описание',
    adminInv_empty: 'По выбранному фильтру счетов не найдено.',
    adminInv_footer: 'Счета — статический пример. При подключении 1С и бэкенда отобразятся реальные документы.',
    adminTax_subtitle: 'Налоговые обязательства, сроки, статус оплаты и декларации. Данные наглядные и подробные, статический пример.',
    adminTax_filter_all: 'Все',
    adminTax_type_vat: 'НДС',
    adminTax_type_income: 'Налог на доход',
    adminTax_type_simplified: 'Упрощённый',
    adminTax_type_property: 'Налог на имущество',
    adminTax_type_land: 'Земельный',
    adminTax_type_transport: 'Транспортный',
    adminTax_type_other: 'Прочее',
    adminTax_status_all: 'Все статусы',
    adminTax_status_paid: 'Оплачено',
    adminTax_status_pending: 'Ожидает',
    adminTax_status_overdue: 'Просрочено',
    adminTax_summary_title: 'Сводка',
    adminTax_total_due: 'Всего обязательств',
    adminTax_total_paid: 'Всего оплачено',
    adminTax_total_outstanding: 'Остаток',
    adminTax_next_due: 'Ближайший срок',
    adminTax_shown: 'показано',
    adminTax_code: 'Код',
    adminTax_type: 'Вид налога',
    adminTax_period: 'Период',
    adminTax_due_date: 'Срок уплаты',
    adminTax_amount: 'Сумма',
    adminTax_paid: 'Оплачено',
    adminTax_status: 'Статус',
    adminTax_description: 'Описание',
    adminTax_period_monthly: 'мес.',
    adminTax_period_quarterly: 'кварт.',
    adminTax_period_annual: 'год',
    adminTax_empty: 'По выбранному фильтру записей не найдено.',
    adminTax_footer: 'Данные по налогам — статический пример. При подключении 1С и налоговой системы отобразятся реальные декларации.',
    admin1c_subtitle: 'Подключение к 1С: Бухгалтерия и Предприятие, синхронизация и настройки. Данные наглядные и подробные, статический пример.',
    admin1c_connection_connected: 'Подключено',
    admin1c_connection_disconnected: 'Не подключено',
    admin1c_connection_title: 'Подключение',
    admin1c_base_url: 'Адрес базы',
    admin1c_version: 'Версия 1С',
    admin1c_database: 'Имя базы',
    admin1c_last_checked: 'Последняя проверка',
    admin1c_entities_title: 'Объекты синхронизации',
    admin1c_entity_products: 'Номенклатура',
    admin1c_entity_invoices: 'Счета',
    admin1c_entity_transactions: 'Транзакции',
    admin1c_entity_contacts: 'Контакты',
    admin1c_entity_stock: 'Остатки на складе',
    admin1c_entity_prices: 'Цены',
    admin1c_records: 'записей',
    admin1c_entity_status_synced: 'Синхронизировано',
    admin1c_entity_status_pending: 'Ожидает',
    admin1c_entity_status_error: 'Ошибка',
    admin1c_sync_log_title: 'История синхронизации',
    admin1c_date: 'Дата',
    admin1c_direction: 'Направление',
    admin1c_entity: 'Объект',
    admin1c_status: 'Статус',
    admin1c_message: 'Сообщение',
    admin1c_direction_import: 'Импорт',
    admin1c_direction_export: 'Экспорт',
    admin1c_direction_both: 'Двусторонняя',
    admin1c_sync_status_success: 'Успешно',
    admin1c_sync_status_partial: 'Частично',
    admin1c_sync_status_failed: 'Ошибка',
    admin1c_settings_title: 'Настройки',
    admin1c_sync_interval: 'Интервал синхронизации',
    admin1c_auth_type: 'Авторизация',
    admin1c_export_format: 'Формат экспорта',
    admin1c_auto_sync: 'Автосинхронизация',
    admin1c_yes: 'Да',
    admin1c_no: 'Нет',
    admin1c_footer: 'Данные интеграции 1С — статический пример. Реальное подключение при настройке бэкенда и 1С.',
    adminPL_subtitle: 'Доходы, расходы, валовая и чистая прибыль — детальный отчёт P&L. Данные статический пример.',
    adminPL_summary_title: 'Сводка',
    adminPL_total_revenue: 'Всего доход',
    adminPL_gross_profit: 'Валовая прибыль',
    adminPL_margin: 'маржа',
    adminPL_operating_profit: 'Операционная прибыль',
    adminPL_net_profit: 'Чистая прибыль',
    adminPL_net_margin: 'маржа чистой прибыли',
    adminPL_detail_title: 'Состав прибылей и убытков',
    adminPL_block_revenue: 'Доходы',
    adminPL_block_cogs: 'Себестоимость продаж',
    adminPL_block_operating: 'Операционные расходы',
    adminPL_block_other: 'Прочие доходы и расходы',
    adminPL_revenue_sales: 'Выручка от продаж',
    adminPL_revenue_services: 'Услуги',
    adminPL_revenue_orders: 'Доход от заказов',
    adminPL_revenue_invoices: 'Доход от счетов',
    adminPL_revenue_other: 'Прочий доход',
    adminPL_revenue_total: 'Всего доход',
    adminPL_cogs_goods: 'Себестоимость товаров',
    adminPL_cogs_delivery: 'Доставка',
    adminPL_cogs_total: 'Всего себестоимость',
    adminPL_op_salary: 'Зарплата',
    adminPL_op_rent: 'Аренда',
    adminPL_op_utilities: 'Коммунальные',
    adminPL_op_marketing: 'Маркетинг',
    adminPL_op_depreciation: 'Амортизация',
    adminPL_op_operating: 'Операционные расходы',
    adminPL_op_other: 'Прочие расходы',
    adminPL_op_total: 'Всего операционные',
    adminPL_other_interest_income: 'Процентный доход',
    adminPL_other_interest_expense: 'Процентный расход',
    adminPL_other_currency: 'Курсовая разница',
    adminPL_other_taxes: 'Налоги',
    adminPL_other_invoices_expenses: 'Расходы по счетам',
    adminPL_other_net: 'Прочее (нетто)',
    adminPL_footer: 'Данные прибылей и убытков — статический пример. Реальный отчёт при подключении 1С и бухгалтерии.',
    adminBS_subtitle: 'Активы, обязательства и капитал — балансовый отчёт. Данные наглядные и подробные, статический пример.',
    adminBS_summary_title: 'Сводка',
    adminBS_total_assets: 'Всего активы',
    adminBS_total_liabilities: 'Всего обязательства',
    adminBS_total_equity: 'Всего капитал',
    adminBS_balance_check: 'Проверка баланса (Обязательства + Капитал = Активы)',
    adminBS_detail_title: 'Состав баланса',
    adminBS_assets: 'Активы',
    adminBS_liabilities_equity: 'Обязательства и капитал',
    adminBS_assets_current: 'Оборотные активы',
    adminBS_assets_noncurrent: 'Внеоборотные активы',
    adminBS_liab_current: 'Краткосрочные обязательства',
    adminBS_liab_longterm: 'Долгосрочные обязательства',
    adminBS_equity: 'Капитал',
    adminBS_total_liab_equity: 'Всего обязательства и капитал',
    adminBS_cash: 'Касса',
    adminBS_bank: 'Банк',
    adminBS_receivables: 'Дебиторская задолженность',
    adminBS_inventory: 'Товарно-материальные запасы',
    adminBS_prepaid: 'Предоплата',
    adminBS_current_total: 'Итого оборотные',
    adminBS_fixed_assets: 'Основные средства',
    adminBS_intangible: 'Нематериальные активы',
    adminBS_investments: 'Инвестиции',
    adminBS_noncurrent_total: 'Итого внеоборотные',
    adminBS_payables: 'Кредиторская задолженность',
    adminBS_short_term_debt: 'Краткосрочный долг',
    adminBS_tax_payable: 'Налоговые обязательства',
    adminBS_other_current: 'Прочие краткосрочные',
    adminBS_current_liab_total: 'Итого краткосрочные',
    adminBS_long_term_loans: 'Долгосрочные кредиты',
    adminBS_long_term_total: 'Итого долгосрочные',
    adminBS_share_capital: 'Уставный капитал',
    adminBS_retained_earnings: 'Нераспределённая прибыль',
    adminBS_current_year_profit: 'Прибыль текущего года',
    adminBS_equity_total: 'Итого капитал',
    adminBS_footer: 'Данные баланса — статический пример. Реальный баланс при подключении 1С и бухгалтерии.',
    adminExport_subtitle: 'Экспорт отчётов в Excel, CSV и PDF. Типы, форматы и последние экспорты — статический пример.',
    adminExport_report_types_title: 'Типы отчётов',
    adminExport_type_transactions: 'Транзакции',
    adminExport_type_invoices: 'Счета',
    adminExport_type_taxes: 'Налоги',
    adminExport_type_profit_loss: 'Прибыль и убыток',
    adminExport_type_balance_sheet: 'Баланс',
    adminExport_formats: 'форматов',
    adminExport_transactions_desc: 'Все приходные и расходные транзакции, экспорт по фильтрам.',
    adminExport_invoices_desc: 'Список счетов, статус оплаты и сроки.',
    adminExport_taxes_desc: 'Список налоговых обязательств и платежей.',
    adminExport_profit_loss_desc: 'Отчёт P&L — доходы, расходы и прибыль.',
    adminExport_balance_sheet_desc: 'Балансовый отчёт — активы, обязательства и капитал.',
    adminExport_max_rows: 'Макс. строк',
    adminExport_history_title: 'Последние экспорты',
    adminExport_date: 'Дата',
    adminExport_report_type: 'Отчёт',
    adminExport_format: 'Формат',
    adminExport_rows: 'Строк',
    adminExport_status: 'Статус',
    adminExport_file: 'Имя файла',
    adminExport_format_xlsx: 'Excel (XLSX)',
    adminExport_format_csv: 'CSV',
    adminExport_format_pdf: 'PDF',
    adminExport_status_completed: 'Выполнено',
    adminExport_status_failed: 'Ошибка',
    adminExport_settings_title: 'Настройки',
    adminExport_default_format: 'Формат по умолчанию',
    adminExport_max_rows_limit: 'Лимит строк',
    adminExport_date_range_default: 'Период по умолчанию',
    adminExport_date_range_current_month: 'Текущий месяц',
    adminExport_footer: 'Данные экспорта — статический пример. Реальный экспорт при подключении бэкенда.',
    adminHelp_subtitle: 'Контакты и поддержка.',
    adminHelp_subtitle_kassir: 'Контакты и поддержка.',
    adminHelp_subtitle_mijoz_chat: 'Чат поддержки и контакты.',
    adminHelp_subtitle_mijoz_chat_only: 'Задайте вопрос в чате поддержки — ответит региональный менеджер или платформа.',
    adminHelp_mijoz_chat_title: 'Чат поддержки',
    adminHelp_mijoz_chat_lead: 'Можно отправить текст, фото или видео. Ответит региональный менеджер или платформа.',
    adminHelp_subtitle_tenant_owner_chat: 'Обратитесь через чат поддержки.',
    adminHelp_tenant_owner_chat_title: 'Чат поддержки',
    adminHelp_tenant_owner_chat_lead:
      'Напишите сообщение или отправьте фото, видео или аудио. Ответит региональный менеджер или служба поддержки платформы.',
    adminHelp_quick_start_title: 'Быстрый старт',
    adminHelp_step_1: 'Выберите нужный раздел в боковом меню (Статистика, Финансы, Настройки и др.).',
    adminHelp_step_2: 'Используйте фильтры в отчётах и таблицах — для быстрого поиска данных.',
    adminHelp_step_3: 'В разделе Экспорт загружайте отчёты в Excel, CSV или PDF.',
    adminHelp_step_4: 'При вопросах или проблемах — обратитесь в поддержку по контактам ниже.',
    adminHelp_kassir_step_1: 'Работайте в кассе только с избранными товарами для быстрого обслуживания.',
    adminHelp_kassir_step_2: 'Выберите правильный способ оплаты и подтвердите сумму с клиентом.',
    adminHelp_kassir_step_3: 'Проверьте подключение принтера; при проблемах используйте раздел подключения принтера.',
    adminHelp_kassir_step_4: 'В конце смены сверяйте транзакции и остатки перед закрытием.',
    adminHelp_faq_title: 'Частые вопросы',
    adminHelp_faq_1_q: 'Как сменить пароль?',
    adminHelp_faq_1_a: 'В разделе Профиль или Настройки нажмите «Сменить пароль». Новый пароль — не менее 8 символов, обязательны цифра и заглавная буква.',
    adminHelp_faq_2_q: 'Какие разделы доступны моей роли?',
    adminHelp_faq_2_a: 'В боковом меню отображаются только разрешённые для вашей роли разделы. Владелец — управление платформой, тарифы, клиенты и операции; уведомления — в колокольчике на верхней панели; счета и отдельные разделы контроля в основном у бухгалтера; клиент и кассир — свои разделы.',
    adminHelp_faq_3_q: 'Данные реальные или демо?',
    adminHelp_faq_3_a: 'Пока все отчёты, транзакции, налоги и прочее — статический пример. После подключения бэкенда и 1С будут отображаться реальные данные.',
    adminHelp_faq_4_q: 'Когда заработает экспорт?',
    adminHelp_faq_4_a: 'В разделе Экспорт указаны типы отчётов и форматы (Excel, CSV, PDF). Скачивание файлов станет доступно после подключения бэкенда.',
    adminHelp_kassir_faq_1_q: 'Что делать, если принтер не печатает?',
    adminHelp_kassir_faq_1_a: 'Откройте раздел подключения принтера, перезапустите приложение и выполните тестовую печать.',
    adminHelp_kassir_faq_2_q: 'Почему в кассе видны не все товары?',
    adminHelp_kassir_faq_2_a: 'В кассе отображаются только товары, отмеченные звездочкой в складе.',
    adminHelp_kassir_faq_3_q: 'Что делать, если сумма смешанной оплаты не сходится?',
    adminHelp_kassir_faq_3_a: 'Система не даст подтвердить. Приведите суммы к общему итогу.',
    adminHelp_kassir_faq_4_q: 'Где посмотреть товары с истекающим сроком?',
    adminHelp_kassir_faq_4_a: 'В таблице склада срок отображается цветом: зелёный, жёлтый, красный.',
    adminHelp_faq_5_q: 'Есть ли 2FA (двухфакторная аутентификация)?',
    adminHelp_faq_5_a: 'Да. В Настройках → Безопасность включение 2FA рекомендуется, особенно для администраторов.',
    adminHelp_faq_6_q: 'Как связаться с поддержкой?',
    adminHelp_faq_6_a: 'В блоке Контакты ниже указан телефон. Обычно ответ в течение 24 часов. Часы работы: пн–пт, 09:00–18:00.',
    adminHelp_contact_title: 'Контакты',
    adminHelp_email: 'Email',
    adminHelp_phone: 'Телефон',
    adminHelp_hours: 'Часы работы',
    adminHelp_response_time: 'Срок ответа',
    adminHelp_contact_hours_val: '09:00 — 18:00 (пн — пт)',
    adminHelp_contact_response: 'В течение 24 часов',
    adminHelp_links_title: 'Полезные ссылки',
    adminHelp_link_dashboard: 'Статистика',
    adminHelp_link_dashboard_desc: 'Основные показатели и отчёты',
    adminHelp_link_finance: 'Финансы',
    adminHelp_link_finance_desc: 'Доходы, расходы и транзакции',
    adminHelp_link_settings: 'Настройки',
    adminHelp_link_settings_desc: 'Система и уведомления',
    adminHelp_link_export: 'Экспорт',
    adminHelp_link_export_desc: 'Скачивание отчётов',
    adminHelp_footer: 'Страница помощи — статическая информация. В следующих обновлениях добавят руководство и видео.',
    adminPrinterConnect_subtitle: 'Подключите принтер и настройте локальное приложение для печати чеков.',
    receiptSettings_title: 'Настройки чека',
    receiptSettings_desc: 'Выберите, что показывать на печатном чеке, и порядок блоков. Перетаскивайте строки за ручку справа.',
    receiptSettings_preview: 'Предпросмотр',
    receiptSettings_blocks: 'Блоки чека',
    receiptSettings_drag_hint: 'Удерживайте ручку справа и перетащите блок вверх или вниз.',
    receiptSettings_drag_handle: 'Перетаскивание',
    receiptSettings_logo_title: 'Логотип чека',
    receiptSettings_logo_upload: 'Загрузить логотип',
    receiptSettings_logo_default: 'Логотип по умолчанию',
    receiptSettings_logo_invalid: 'Можно загрузить только файлы изображений.',
    receiptSettings_logo_too_large: 'Размер логотипа не должен превышать 2 МБ.',
    receiptSettings_logo_failed: 'Не удалось загрузить логотип. Попробуйте ещё раз.',
    receiptBlock_header_sale_number: 'Номер продажи',
    receiptBlock_header_store: 'Название магазина / компании',
    receiptBlock_header_datetime: 'Дата и время',
    receiptBlock_header_work_hours: 'Часы работы',
    receiptBlock_cashier: 'Кассир',
    receiptBlock_client: 'Клиент',
    receiptBlock_contacts: 'Контакты',
    receiptBlock_tin: 'ИНН',
    receiptBlock_legal_name: 'Юр. название',
    receiptBlock_address: 'Адрес',
    receiptBlock_client_phone: 'Телефон клиента',
    receiptBlock_sale_note: 'Комментарий к продаже',
    receiptBlock_line_items: 'Список товаров',
    receiptBlock_line_discounts: 'Скидки по строкам',
    receiptBlock_line_totals: 'Суммы по строкам',
    receiptBlock_receipt_discounts: 'Скидки по чеку',
    receiptBlock_receipt_totals: 'Итоги по чеку',
    receiptBlock_product_count: 'Количество позиций в чеке',
    receiptPreview_sale: 'Продажа',
    receiptPreview_store_sample: 'Магазин: dilshod-market',
    receiptPreview_date: 'Дата',
    receiptPreview_work_hours: 'Часы работы',
    receiptPreview_cashier: 'Кассир',
    receiptPreview_client: 'Клиент',
    receiptPreview_contacts: 'Контакты',
    receiptPreview_tin: 'ИНН',
    receiptPreview_legal: 'Юр. лицо',
    receiptPreview_address: 'Адрес',
    receiptPreview_client_phone: 'Телефон клиента',
    receiptPreview_note: 'Примечание',
    receiptPreview_item_name: 'Товар / бренд',
    receiptPreview_discount_line: 'Скидка',
    receiptPreview_product_count: 'Кол-во товаров',
    receiptPreview_subtotal: 'Промежуточный итог',
    receiptPreview_discount: 'Скидка',
    receiptPreview_discount_pct: 'Скидка %',
    receiptPreview_total: 'ИТОГО',
    receiptPreview_balance: 'Баланс клиента',
    supportChat_placeholder: 'Введите сообщение…',
    supportChat_send: 'Отправить',
    supportChat_attach_image: 'Фото',
    supportChat_attach_video: 'Видео',
    supportChat_remove_attach: 'Убрать',
    supportChat_attach_too_large: 'Файл слишком большой (макс. ~12 МБ).',
    supportChat_attach_error: 'Не удалось прочитать файл.',
    supportChat_empty_thread: 'Пока нет сообщений. Напишите ниже или прикрепите файл.',
    supportChat_no_tenant: 'Не определена компания (tenant) — проверьте профиль.',
    supportChat_label_mijoz: 'Клиент',
    supportChat_label_vm: 'Региональный менеджер',
    supportChat_label_bm: 'Главный менеджер',
    supportChat_label_platform_owner: 'Владелец платформы',
    supportChat_label_staff: 'Поддержка',
    supportChat_backend_note: 'Сейчас сообщения хранятся в браузере. После подключения backend — онлайн и уведомления.',
    supportChat_persist_failed: 'Не удалось сохранить сообщение (память браузера или режим инкогнито). Обновите страницу и попробуйте снова.',
    supportChat_thread_status: 'Чат открыт — ожидается ответ',
    supportChat_sync_live: 'Включено живое обновление',
    supportChat_sync_poll: 'Автообновление (примерно каждые 5 сек.)',
    supportChat_err_realtime: 'Живое соединение временно недоступно — сообщения всё равно сохраняются, список обновится.',
    supportChat_err_network: 'Проблема с подключением к серверу. Проверьте интернет и попробуйте снова.',
    supportChat_err_forbidden: 'Нет прав или сессия истекла. Войдите снова.',
    supportChat_err_unknown: 'Неизвестная ошибка. Попробуйте ещё раз.',
    supportChat_banner_close: 'Скрыть',
    staffChat_subtitle: 'Один общий чат для владельца и всех менеджеров. Сообщения на сервере — видны всем в админке. Чат с клиентами отдельно.',
    staffChat_thread_status: 'Общий внутренний чат',
    staffChat_role_platform_owner: 'Владелец платформы',
    staffChat_role_general_manager: 'Главный менеджер',
    staffChat_role_regional_manager: 'Региональный менеджер',
    staffChat_role_dispatcher: 'Диспетчер',
    staffChat_label_unknown: 'Имя не указано',
    staffChat_empty_thread: 'Пока нет сообщений. Напишите ниже или прикрепите файл.',
    staffChat_loading: 'Загрузка сообщений…',
    staffChat_sending: 'Отправка…',
    staffChat_send_failed: 'Не удалось отправить. Попробуйте снова.',
    staffChat_edit: 'Редактировать',
    staffChat_delete: 'Удалить',
    staffChat_save_edit: 'Сохранить',
    staffChat_cancel_edit: 'Отмена',
    staffChat_edited_label: 'изменено',
    staffChat_confirm_delete: 'Удалить это сообщение? Другие пользователи больше не увидят его.',
    staffChat_read_full: 'Полный текст',
    staffChat_expand_text: 'Ещё',
    staffChat_collapse_text: 'Свернуть',
    staffChat_open_preview: 'Открыть в чате',
    staffChat_backend_note: 'Сообщения синхронизируются через API (опрос). Для онлайна можно добавить WebSocket.',
    chat_reply: 'Ответить',
    chat_replying_to: 'Ответ на сообщение',
    chat_reply_cancel: 'Отмена',
    supportChat_backend_note_api: 'Чаты с клиентами на сервере; фото/видео сначала загружаются как файл. Тред виден на всех устройствах.',
    supportChat_label_tenant_owner: 'Клиент',
    supportChat_attach_audio: 'Аудио',
    supportChat_attach_file: 'Файл',
    supportChat_file_open: 'Открыть файл',
    supportChat_file_ready: 'Файл готов к отправке',
    supportChat_recipient_all: 'Всем кассирам',
    supportChat_recipient_label: 'Получатель',
    cashierChat_subtitle_owner: 'Пишите кассирам лично или сразу всем.',
    cashierChat_subtitle_cashier: 'Общайтесь с клиентом (владельцем tenant) в этом разделе.',
    cashierChat_missing_tenant: 'Tenant не определён. Обратитесь к администратору.',
    tenantMessages_subtitle: 'Отдельный чат с каждым клиентом. Жёлтая точка — последнее сообщение от клиента.',
    tenantMessages_search: 'Поиск по компании или телефону',
    tenantMessages_no_messages: 'Нет сообщений',
    tenantMessages_preview_image: 'Фото',
    tenantMessages_preview_video: 'Видео',
    tenantMessages_needs_reply: 'Ожидает ответа',
    tenantMessages_pick_tenant: 'Выберите клиента слева, чтобы открыть чат.',
    adminSettings_subtitle: 'Параметры системы, уведомления, безопасность и управление данными. Текущие значения — статический пример.',
    adminSettings_mijoz_subtitle: 'Вид чека (в браузере), язык и операционные параметры — касса, цены, способы оплаты по филиалам.',
    adminSettings_tenant_owner_subtitle: 'Для владельца точки: чек и язык, операционные параметры, способы оплаты по филиалам и настройки маркетинг-витрины.',
    adminSettings_tenant_owner_header_hint: 'Настройки чека хранятся на этом устройстве. Операционные настройки и оплаты по филиалам сохраняются на сервере кнопкой «Сохранить».',
    adminSettings_mijoz_header_hint: 'Настройки чека хранятся на этом устройстве. Операционные настройки и оплаты по филиалам сохраняются на сервере кнопкой «Сохранить».',
    adminSettings_reset_confirm: 'Сбросить все операционные настройки к значениям по умолчанию? Несохранённые изменения будут потеряны.',
    adminSettings_branches_load_failed: 'Не удалось загрузить список филиалов.',
    adminSettings_last_updated: 'Последнее обновление',
    adminSettings_environment: 'Среда',
    adminSettings_env_production: 'Продакшен',
    adminSettings_env_development: 'Разработка',
    adminSettings_section_general: 'Общие настройки',
    adminSettings_section_notifications: 'Уведомления',
    adminSettings_section_security: 'Безопасность',
    adminSettings_section_appearance: 'Внешний вид',
    adminSettings_section_system: 'Система',
    adminSettings_section_data: 'Данные и резервное копирование',
    adminSettings_section_notes: 'Примечание',
    adminSettings_section_operational: 'Операционные настройки',
    adminSettings_section_operational_desc: 'Управление кассой, ценой, единицами измерения и временем ежедневной сводки.',
    adminSettings_section_general_desc: 'Язык, часовой пояс, формат даты и валюта — для всех пользователей.',
    adminSettings_section_notifications_desc: 'Email, push, SMS и ежедневная сводка — когда и какие уведомления отправлять.',
    adminSettings_section_security_desc: 'Время жизни сессии, 2FA, требования к паролю и ограничение по IP.',
    adminSettings_section_appearance_desc: 'Тема (тёмная/светлая), плотность интерфейса и размер шрифта.',
    adminSettings_section_system_desc: 'Версия, URL API, сессии и уровень логирования — параметры системы.',
    adminSettings_section_data_desc: 'Время backup, срок хранения, форматы экспорта и папка backup.',
    adminSettings_lang: 'Язык интерфейса',
    adminSettings_pricing_mode: 'Режим формирования цены',
    adminSettings_pricing_mode_manual: 'Вручную (по каждому товару)',
    adminSettings_pricing_mode_markup: 'Наценка к себестоимости (%)',
    adminSettings_default_markup: 'Стандартная наценка',
    adminSettings_daily_summary_time: 'Время ежедневной сводки',
    adminSettings_sale_units_manage: 'Управление единицами измерения',
    adminSettings_quick_discount_enabled: 'Включить быстрые скидки',
    adminSettings_quick_discount_optional: 'Скидка в корзине по выбору (необязательно)',
    adminSettings_quick_discounts: 'Значения быстрых скидок',
    adminSettings_retail_cashback_percent: 'Cashback для розничных клиентов (%)',
    adminSettings_retail_cashback_hint:
      'Процент считается от чистой прибыли продажи. Бонус зачисляется на баланс клиента; на кассе можно оплатить с баланса.',
    adminSettings_reset_defaults: 'Сбросить к значениям по умолчанию',
    adminSettings_reset: 'Сброс',
    adminSettings_save: 'Сохранить',
    adminSettings_branch_payments: 'Типы оплаты по филиалам',
    adminSettings_branch_payments_section_title: 'Типы оплаты по филиалам',
    adminSettings_branch_payments_section_desc: 'Задайте подписи для наличных, карты и перевода в кассе по каждому филиалу. Сохранение отправляет операционные настройки на сервер.',
    adminSettings_branch_payments_desc: 'Управляйте способами Наличные, Карта и Перевод по филиалам.',
    adminSettings_branch_payments_cash: 'Способы наличных',
    adminSettings_branch_payments_card: 'Способы картой',
    adminSettings_branch_payments_transfer: 'Способы перевода',
    adminSettings_branch_payments_apply: 'Сохранить (на сервер)',
    adminSettings_branch_payments_hint: 'Разделяйте запятой, точкой с запятой или новой строкой. «Сохранить» записывает настройки на сервер.',
    adminSettings_branch_payments_footer: 'Типы оплаты можно изменить в разделе Настройки.',
    adminNav_expenses: 'Расходы',
    adminExpenses_subtitle: 'Расходы: добавление, оплата, архив.',
    adminExpenses_active: 'Активные расходы',
    adminExpenses_archive: 'Архив (полностью закрытые)',
    adminExpenses_add_title: 'Добавить новый расход',
    adminExpenses_name: 'Название расхода',
    adminExpenses_total: 'Общая сумма',
    adminExpenses_person_name: 'Кто передал (необязательно)',
    adminExpenses_note_optional: 'Комментарий (необязательно)',
    adminExpenses_recurring_on: 'Постоянный: Включено (ежемесячно)',
    adminExpenses_recurring_off: 'Постоянный: Выключено',
    adminExpenses_recurring_hint: 'Автоматически создавать расход каждый месяц',
    adminExpenses_save: 'Сохранить',
    adminExpenses_required: 'Введите название расхода и сумму.',
    adminExpenses_delete_confirm: 'Удалить расход?',
    adminExpenses_pay_invalid: 'Некорректная сумма оплаты.',
    adminExpenses_pay: 'Оплатить',
    adminExpenses_pay_amount: 'Сумма оплаты',
    adminExpenses_pay_save: 'Сохранить оплату',
    adminExpenses_from_cashbox: 'Из кассы',
    adminExpenses_not_from_cashbox: 'Не из кассы',
    adminExpenses_badge_product: 'Расход по товару',
    adminExpenses_created_at: 'Дата',
    adminExpenses_qty: 'Кол-во',
    adminExpenses_unit_cost: 'Себест./1',
    adminExpenses_remaining: 'Остаток',
    adminExpenses_status: 'Статус',
    adminExpenses_actions: 'Действия',
    adminExpenses_note: 'Комментарий',
    adminExpenses_product_id_label: 'ID товара',
    adminExpenses_supplier_label: 'Поставщик',
    adminExpenses_supplier_debts: 'Задолженность по поставщикам',
    adminExpenses_supplier_day_products: '{n} товаров',
    adminExpenses_supplier_products_title: 'Полученные товары',
    adminExpenses_view_details: 'Подробнее',
    adminExpenses_pay_supplier_total: 'Общая оплата',
    adminExpenses_supplier_pay_hint: 'Максимум: {n}',
    adminExpenses_paid: 'Оплачено',
    adminExpenses_no_payments: 'Нет оплат',
    adminExpenses_pay_mode_cash: 'Наличные / Карта',
    adminExpenses_pay_mode_product: 'Оплата товаром',
    adminExpenses_select_product: 'Выберите товар',
    adminExpenses_pick_branch_for_product: 'Выберите филиал для оплаты товаром',
    adminExpenses_pick_branch_placeholder: 'Выберите филиал',
    adminExpenses_pick_branch_before_products: 'Выберите филиал, чтобы увидеть товары.',
    adminExpenses_no_products_in_branch: 'В этом филиале нет товара в остатке.',
    adminExpenses_cashier_no_branch: 'Филиал не привязан.',
    adminExpenses_cashier_products_hint: 'Только товары со склада этого филиала.',
    adminExpenses_cashier_wait_branch: 'Ожидание данных по филиалу.',
    adminExpenses_kassir_products_hint: 'Кассир может оплачивать только товарами своего филиала.',
    adminExpenses_kassir_wait_branch: 'Ожидание данных по филиалу.',
    adminExpenses_pay_source: 'Источник оплаты',
    adminExpenses_without_cashbox: 'Без кассы',
    adminExpenses_without_cashbox_hint: 'Этот платеж не списывается из кассы.',
    adminExpenses_today_cash_sales: 'Сегодняшние продажи за наличные',
    adminExpenses_cashbox_available: 'Доступно для оплаты из кассы',
    adminExpenses_cashbox_need_branch: 'Для оплаты из кассы нужно выбрать филиал.',
    adminExpenses_cashbox_load_error: 'Не удалось загрузить лимит кассы.',
    adminExpenses_cashbox_cash_only: 'Оплата из кассы возможна только наличными.',
    adminExpenses_cashbox_wait: 'Лимит кассы загружается или недоступен. Повторите позже.',
    adminExpenses_cashbox_exceeds: 'Недостаточно наличных в кассе на сегодня. Доступно: {n}',
    adminExpenses_product_inventory_error: 'Не удалось загрузить список товаров.',
    adminExpenses_select_branch_first: 'Сначала выберите филиал.',
    adminExpenses_product_qty_required: 'Укажите товар и количество.',
    adminExpenses_product_not_in_list: 'Товар отсутствует в списке. Проверьте филиал.',
    adminExpenses_insufficient_stock: 'Недостаточно остатка. Доступно: {n}',
    adminExpenses_pay_error: 'Не удалось сохранить платеж.',
    adminExpenses_pay_with_product: 'Оплатить товаром',
    adminExpenses_product_qty: 'Количество',
    adminExpenses_product_total: 'Итого',
    adminExpenses_product_remaining: 'Остаток',
    adminExpenses_stock_short: 'Остаток',
    adminExpenses_product_search: 'Поиск товара…',
    adminExpenses_product_max_qty: 'Максимальное количество: {n}',
    adminExpenses_product_pick_hint: 'Нажмите товар в списке',
    adminExpenses_restock_batches: 'Партии',
    adminStatistics_payments_block_title: 'Типы оплат',
    adminSettings_last_saved: 'Время последнего сохранения',
    adminSettings_operational_load_failed: 'Не удалось загрузить операционные настройки с backend. Использованы локальные значения.',
    adminSettings_purchase_currency: 'Валюта закупки',
    adminSettings_sale_currency: 'Валюта продажи',
    adminSettings_currency_rate: 'Курс НБУ',
    adminSettings_currency_rate_failed: 'Не удалось получить курсы НБУ',
    adminSettings_lang_val: 'Узбекский',
    adminSettings_timezone: 'Часовой пояс',
    adminSettings_timezone_val: 'Asia/Tashkent (UTC+5)',
    adminSettings_date_format: 'Формат даты',
    adminSettings_date_format_val: 'ДД.ММ.ГГГГ',
    adminSettings_currency: 'Основная валюта',
    adminSettings_currency_val: 'UZS (сум)',
    adminSettings_week_start: 'Начало недели',
    adminSettings_week_start_val: 'Понедельник',
    adminSettings_notif_email: 'Email-уведомления',
    adminSettings_notif_email_val: 'Включены',
    adminSettings_notif_push: 'Push-уведомления',
    adminSettings_notif_push_val: 'Включены',
    adminSettings_notif_sms: 'SMS-уведомления',
    adminSettings_notif_sms_val: 'Выключены',
    adminSettings_notif_digest: 'Ежедневная сводка (digest)',
    adminSettings_notif_digest_val: 'Включена — каждый день в 09:00',
    adminSettings_session_min: 'Время жизни сессии (бездействие)',
    adminSettings_2fa: 'Двухфакторная аутентификация (2FA)',
    adminSettings_2fa_val: 'Рекомендуется (для администраторов)',
    adminSettings_password_policy: 'Требования к паролю',
    adminSettings_password_policy_val: 'Минимум 8 символов, цифра и заглавная буква обязательны',
    adminSettings_ip_whitelist: 'Ограничение по IP (whitelist)',
    adminSettings_ip_whitelist_val: 'Выключено',
    adminSettings_theme: 'Тема',
    adminSettings_theme_val: 'По системе (авто)',
    adminSettings_density: 'Плотность интерфейса',
    adminSettings_density_val: 'Комфортная',
    adminSettings_font_size: 'Размер шрифта',
    adminSettings_font_size_val: 'Стандарт (14px)',
    adminSettings_version: 'Версия системы',
    adminSettings_api_base: 'Базовый URL API',
    adminSettings_max_sessions: 'Макс. сессий на пользователя',
    adminSettings_log_level: 'Уровень логирования',
    adminSettings_log_level_val: 'Info',
    adminSettings_backup: 'Время автоматического backup',
    adminSettings_retention: 'Срок хранения аудита и логов',
    adminSettings_export_format: 'Формат экспорта',
    adminSettings_export_format_val: 'CSV, Excel (XLSX), JSON',
    adminSettings_build_id: 'Build ID',
    adminSettings_backup_path: 'Папка backup',
    adminSettings_note_text: 'Изменение настроек будет доступно в следующих обновлениях. Сейчас все значения только для отображения. Для важных изменений обратитесь в поддержку.',
    adminTariff_title: 'Тариф',
    adminTariff_subtitle: 'Управление тарифами сайта: цены, преимущества и рекомендуемый тариф. Изменения сохраняются до обновления страницы.',
    adminTariff_create_naming: 'Тип тарифа',
    adminTariff_create_preset: 'Стандартный шаблон',
    adminTariff_create_custom: 'Своё название',
    adminTariff_template: 'Шаблон',
    adminTariff_no_templates_left: 'Все три стандартных типа уже добавлены. Создайте тариф со своим названием.',
    adminTariff_validation_template: 'Выберите шаблон из списка.',
    adminTariff_validation_custom_name: 'Введите название тарифа.',
    adminTariff_validation_price: 'Цена не может быть отрицательной.',
    adminTariff_save_new: 'Создать тариф',
    adminTariff_add: 'Добавить тариф',
    adminTariff_edit: 'Изменить',
    adminTariff_delete: 'Удалить',
    adminTariff_save: 'Сохранить',
    adminTariff_cancel: 'Отмена',
    adminTariff_name: 'Название тарифа',
    adminTariff_name_placeholder: 'Например: Старт, Бизнес',
    adminTariff_unnamed: 'Без названия',
    adminTariff_monthly_price: 'Цена за месяц (UZS)',
    adminTariff_recommended: 'Рекомендуемый',
    adminTariff_recommended_yes: 'Показывать как «Самый популярный»',
    adminTariff_benefits: 'Преимущества',
    adminTariff_modal_add_title: 'Новый тариф',
    adminTariff_modal_edit_title: 'Редактировать тариф',
    adminTariff_confirm_delete_title: 'Удалить тариф',
    adminTariff_confirm_delete_text: 'Вы уверены, что хотите удалить тариф',
    adminTariff_empty: 'Пока нет тарифов. Добавьте новый.',
    adminInt_subtitle: 'Внешние сервисы, платёжные системы и API. Подробное описание и статус каждой интеграции.',
    adminInt_add: 'Добавить интеграцию',
    adminInt_edit: 'Изменить',
    adminInt_delete: 'Удалить',
    adminInt_save: 'Сохранить',
    adminInt_cancel: 'Отмена',
    adminInt_name: 'Название',
    adminInt_name_placeholder: 'Например: Stripe, SMS.uz',
    adminInt_description: 'Описание',
    adminInt_description_placeholder: 'Кратко: для чего и как используется.',
    adminInt_category: 'Категория',
    adminInt_logo: 'Логотип',
    adminInt_logo_choose: 'Выбрать логотип',
    adminInt_logo_invalid: 'Можно загружать только файлы изображений',
    adminInt_logo_too_large: 'Размер изображения не должен превышать 2MB',
    adminInt_status_label: 'Статус',
    adminInt_status_active: 'Включена',
    adminInt_status_inactive: 'Выключена',
    adminInt_modal_add_title: 'Новая интеграция',
    adminInt_modal_edit_title: 'Редактировать интеграцию',
    adminInt_confirm_delete_title: 'Удалить интеграцию',
    adminInt_confirm_delete_text: 'Вы уверены, что хотите удалить интеграцию',
    adminInt_empty: 'Пока нет интеграций. Добавьте новую.',
    adminInt_unnamed: 'Без названия',
    adminInt_cat_payment: 'Платежи',
    adminInt_cat_accounting: 'Бухгалтерия',
    adminInt_cat_export: 'Экспорт',
    adminInt_cat_api: 'API',
    adminInt_cat_messaging: 'Сообщения',
    adminInt_telegram_name: 'Telegram',
    adminInt_telegram_desc: 'Уведомления, сообщения и связь с клиентами через бота. Автоматическая отправка статусов заказов и напоминаний.',
    adminInt_1c_name: '1С',
    adminInt_1c_desc: 'Обмен данными с 1С:Бухгалтерия и 1С:Предприятие. Синхронизация транзакций, счетов и движения товаров.',
    adminInt_payme_name: 'Payme',
    adminInt_payme_desc: 'Приём онлайн-платежей через Payme. Оплата картой, click и мобильное приложение.',
    adminInt_click_name: 'Click',
    adminInt_click_desc: 'Интеграция с платёжной системой Click. Оплата заказов и услуг через Click.',
    adminInt_uzum_name: 'Uzum',
    adminInt_uzum_desc: 'Подключение Uzum Bank и платёжной системы Uzum. Приём платежей картой и по номеру телефона.',
    adminInt_excel_name: 'Excel',
    adminInt_excel_desc: 'Экспорт отчётов и таблиц в Excel (XLSX). Анализ и архивирование данных.',
    adminInt_google_sheets_name: 'Google Sheets',
    adminInt_google_sheets_desc: 'Синхронизация и экспорт в Google Таблицы. Хранение и совместный доступ к отчётам в облаке.',
    adminInt_api_name: 'API',
    adminInt_api_desc: 'Подключение внешних систем через REST API. Открытые эндпоинты для товаров, заказов, клиентов и отчётов.',
    adminTenant_subtitle: 'Организации, зарегистрированные на платформе. По каждому клиенту: компания, контакт, тариф и статус.',
    adminTenant_add_via_orders_hint: 'Нового клиента можно добавить только через раздел «Заказы» — кнопка «Преобразовать в клиента» по заявке с основного сайта.',
    adminTenant_add: 'Добавить клиента',
    adminTenant_view: 'Просмотр',
    adminTenant_edit: 'Изменить',
    adminTenant_delete: 'Удалить',
    adminTenant_vm_stats_title: 'KPI регионального менеджера',
    adminTenant_vm_active: 'Активные клиенты',
    adminTenant_vm_trial: 'Клиенты на испытании',
    adminTenant_vm_suspended: 'Приостановленные',
    adminTenant_vm_cashiers: 'Кассиров всего',
    adminTenant_vm_orders_month: 'Заказы за месяц',
    adminTenant_vm_revenue_month: 'Выручка за месяц',
    adminTenant_vm_trend_share: 'доля',
    adminTenant_vm_trend_per_client: 'на клиента',
    adminTenant_vm_trend_vs_prev: 'к прошлому периоду',
    adminTenant_save: 'Сохранить',
    adminTenant_cancel: 'Отмена',
    adminTenant_total: 'клиентов',
    adminTenant_company: 'Организация',
    adminTenant_company_placeholder: 'Название компании',
    adminTenant_contact: 'Ответственный',
    adminTenant_contact_placeholder: 'Имя и фамилия',
    adminTenant_phone: 'Телефон',
    adminTenant_owner_password: 'Пароль',
    adminTenant_owner_password_placeholder: 'Не менее 6 символов',
    adminTenant_owner_password_placeholder_edit: 'Новый пароль (необязательно)',
    adminTenant_owner_password_hint: 'Пароль для входа по телефону ответственного. Роль пользователя — владелец (Ega), не розничный клиент.',
    adminTenant_owner_password_edit_hint: 'Оставьте пустым — пароль не меняется. Новый пароль: не менее 6 символов.',
    adminTenant_owner_password_required: 'Введите пароль (не менее 6 символов).',
    adminTenant_login_sms_2fa: 'SMS-подтверждение при входе',
    adminTenant_login_sms_2fa_hint: 'Управляют владелец платформы (Ega) и главный менеджер. Если включено, клиент и его кассиры после телефона и пароля вводят SMS-код. Если выключено — достаточно пароля.',
    adminTenant_login_sms_on: 'Включено',
    adminTenant_login_sms_off: 'Выключено',
    adminLogin_password_label: 'Пароль для входа',
    adminLogin_password_placeholder: 'Не менее 6 символов',
    adminLogin_password_placeholder_edit: 'Новый пароль (необязательно)',
    adminLogin_password_hint: 'Пароль для входа по номеру телефона.',
    adminLogin_password_hint_edit: 'Оставьте пустым — пароль не меняется. Новый: не менее 6 символов.',
    adminLogin_password_required: 'Укажите пароль для входа (не менее 6 символов).',
    adminTenant_plan: 'Тариф',
    adminTenant_status: 'Статус',
    adminTenant_status_active: 'Активен',
    adminTenant_status_trial: 'Пробный',
    adminTenant_status_suspended: 'Приостановлен',
    adminTenant_status_payment_pending: 'Ожидается оплата',
    adminTenant_region: 'Регион',
    adminTenant_district: 'Район / Город',
    adminTenant_address: 'Адрес',
    adminTenant_address_placeholder: 'Полный адрес (улица, дом, ориентир)',
    adminTenant_address_required: 'Укажите адрес.',
    adminTenant_businessType: 'Тип бизнеса',
    adminTenant_cashiers: 'Кассиры',
    adminTenant_select_placeholder: 'Выберите',
    adminTenant_note: 'Примечание',
    adminTenant_note_placeholder: 'Доп. информация',
    adminTenant_actions: 'Действия',
    adminTenant_modal_add_title: 'Новый клиент',
    adminTenant_modal_edit_title: 'Редактировать клиента',
    adminTenant_confirm_delete_title: 'Удалить клиента',
    adminTenant_confirm_delete_text: 'Вы уверены, что хотите удалить клиента',
    adminTenant_empty: 'Пока нет клиентов. Добавьте нового.',
    adminTenant_search_placeholder: 'Поиск по организации, имени или номеру...',
    adminTenant_filter_all_business: 'Все типы бизнеса',
    adminTenant_filter_all_region: 'Все регионы',
    adminTenant_filter_all_district: 'Все районы',
    adminTenant_filter_all_plan: 'Все тарифы',
    adminTenant_filter_loading: 'Загрузка...',
    adminTenant_no_results: 'По вашему запросу ничего не найдено.',
    adminTenant_clear_filters: 'Сбросить фильтры',
    adminTenant_page_prev: 'Назад',
    adminTenant_page_next: 'Вперёд',
    adminTenant_page_num: 'Страница',
    adminTenant_view_title: 'Полные данные клиента',
    adminTenant_detail_info: 'Основные данные',
    adminTenant_detail_tariff: 'Тариф и подписка',
    adminTenant_detail_stats: 'Статистика',
    adminTenant_stat_orders: 'Всего заказов',
    adminTenant_stat_orders_month: 'Заказов за месяц',
    adminTenant_stat_revenue_month: 'Доход за месяц (UZS)',
    adminTenant_stat_revenue_total: 'Общий доход (UZS)',
    adminTenant_stat_branches: 'Филиалы',
    adminTenant_stat_last_order: 'Последний заказ',
    adminTenant_created: 'Дата регистрации',
    adminTenant_plan_since: 'Дата начала тарифа',
    adminTenant_last_payment_date: 'Дата последнего платежа',
    adminTenant_tariff_end_date: 'Дата окончания тарифа',
    adminTenant_no_payment_yet: 'Оплата пока не проведена',
    adminTenant_close: 'Закрыть',
    adminTenant_detail_products: 'Товары',
    adminTenant_products_count: 'Видов товаров',
    adminTenant_products_total_sold: 'Всего продано',
    adminTenant_products_total_stock: 'Всего остаток',
    adminTenant_products_list_title: 'Названия товаров и остатки',
    adminTenant_product_name: 'Название товара',
    adminTenant_product_status: 'Статус',
    adminTenant_product_sold: 'Продано',
    adminTenant_product_stock: 'Остаток',
    adminTenant_product_purchase_price: 'Закупочная цена',
    adminTenant_product_sale_price: 'Цена продажи',
    adminTenant_products_empty: 'Данные о товарах отсутствуют',
    adminFF_subtitle: 'Текущие и запланированные функции платформы. Для каждой — статус (вкл. / запланировано) и краткое описание.',
    adminFF_filter_all: 'Все',
    adminFF_cat_admin: 'Управление',
    adminFF_cat_platform: 'Платформа',
    adminFF_cat_analytics: 'Аналитика',
    adminFF_cat_security: 'Безопасность',
    adminFF_status_enabled: 'Включено',
    adminFF_status_planned: 'Запланировано',
    adminFF_status_disabled: 'Выключено',
    adminFF_footer: 'Включение и отключение функций будет реализовано через backend в следующих обновлениях. Сейчас — режим просмотра.',
    adminFF_statistics_name: 'Статистика',
    adminFF_statistics_desc: 'KPI и график заказов по неделям для роли владельца. Профессиональная панель на статических данных.',
    adminFF_maslahat_name: 'Консультация',
    adminFF_maslahat_desc: 'Статическое руководство по управлению бизнесом: продажи, склад, финансы, персонал, CRM и общие советы.',
    adminFF_dashboard_name: 'Панель управления',
    adminFF_dashboard_desc: 'Статус системы, быстрый доступ, последняя активность, использование и безопасность.',
    adminFF_settings_name: 'Настройки',
    adminFF_settings_desc: 'Общие настройки, уведомления, безопасность, внешний вид, система и данные.',
    adminFF_tariffs_name: 'Тарифы',
    adminFF_tariffs_desc: 'Управление тарифами сайта: цены, преимущества, рекомендуемый план. Добавление, редактирование, удаление.',
    adminFF_integrations_name: 'Интеграции',
    adminFF_integrations_desc: 'Telegram, 1С, Payme, Click, Uzum, Excel, Google Sheets, API. Описание каждой и добавление новых.',
    adminFF_tenants_name: 'Клиенты',
    adminFF_tenants_desc: 'Организации на платформе: компания, контакт, тариф, статус. CRUD.',
    adminFF_dark_theme_name: 'Тёмная тема',
    adminFF_dark_theme_desc: 'Интерфейс в тёмном режиме. Переключение кнопкой.',
    adminFF_i18n_name: 'Многоязычность',
    adminFF_i18n_desc: 'Интерфейс на узбекском, русском и английском. Все разделы админки переведены.',
    adminFF_audit_name: 'Журнал аудита',
    adminFF_audit_desc: 'История действий пользователей и событий системы. В следующих обновлениях.',
    adminFF_health_name: 'Состояние системы',
    adminFF_health_desc: 'Мониторинг сервера, БД и сервисов. В следующих обновлениях.',
    adminFF_usage_name: 'Отчёты об использовании',
    adminFF_usage_desc: 'Отчёты по API-запросам, сессиям и ресурсам. В следующих обновлениях.',
    adminFF_errors_name: 'Мониторинг ошибок',
    adminFF_errors_desc: 'Ошибки приложения и логи. В следующих обновлениях.',
    adminFF_apikeys_name: 'API ключи',
    adminFF_apikeys_desc: 'Создание и управление API ключами. Доступ для внешних систем. В следующих обновлениях.',
    adminAudit_subtitle: 'Журнал действий пользователей и событий системы. Каждая запись: время, кто, действие, результат и IP.',
    adminAudit_filter_all: 'Все',
    adminAudit_result_success: 'Успешно',
    adminAudit_result_failure: 'Ошибка',
    adminAudit_total: 'записей',
    adminAudit_time: 'Дата и время',
    adminAudit_user: 'Пользователь',
    adminAudit_action: 'Действие',
    adminAudit_resource: 'Ресурс',
    adminAudit_details: 'Детали',
    adminAudit_result: 'Результат',
    adminAudit_ip: 'IP-адрес',
    adminAudit_footer: 'Записи аудита — статический пример. Реальный журнал заполняется при подключении backend и системы логирования. Экспорт — в следующих обновлениях.',
    adminAudit_login: 'Вход в систему',
    adminAudit_settings_update: 'Настройки обновлены',
    adminAudit_tenant_create: 'Клиент добавлен',
    adminAudit_tenant_edit: 'Клиент изменён',
    adminAudit_integration_enable: 'Интеграция включена',
    adminAudit_tariff_edit: 'Тариф изменён',
    adminAudit_api_key_create: 'API ключ создан',
    adminAudit_export: 'Экспорт',
    adminAudit_resource_settings: 'Настройки',
    adminAudit_resource_tenants: 'Клиенты',
    adminAudit_resource_integrations: 'Интеграции',
    adminAudit_resource_tariffs: 'Тарифы',
    adminAudit_resource_apikeys: 'API ключи',
    adminAudit_resource_audit: 'Журнал аудита',
    adminAudit_detail_tariff_limits: 'Изменены лимиты тарифа',
    adminAudit_detail_export_csv: 'Скачан в формате CSV',
    adminAudit_detail_wrong_password: 'Неверный пароль',
    roleTitle_business_admin: 'Бизнес Админ',
    roleTitle_manager: 'Менеджер / Продавец',
    roleTitle_warehouse: 'Кладовщик',
    roleTitle_accountant: 'Бухгалтер',
    roleTitle_analytics: 'Аналитик / Маркетинг',
    roleTitle_courier: 'Курьер / Агент',
    roleTitle_customer: 'Клиент',

    // Admin sidebar (nav) – professional
    adminNav_system_dashboard: 'Панель управления',
    adminNav_role_access: 'Вход в роль',
    adminNav_ai_chat: 'AI‑чат',
    adminNav_ai_advisor: 'AI Советник',
    adminNav_managers: 'Менеджеры',
    adminNav_rating: 'Рейтинг',
    adminNav_rating_dispatchers: 'Рейтинг (диспетчеры)',
    adminNav_rating_tenants: 'Рейтинг (клиенты)',
    adminNav_dispatchers: 'Диспетчеры',
    adminNav_statistics: 'Статистика',
    adminNav_leads: 'Лиды',
    adminNav_leads_dispatcher: 'Обращения',
    adminNav_leads_vm: 'Обращения',
    adminNav_to_managers: 'Назначить менеджерам',
    adminNav_cashiers: 'Кассиры',
    adminNav_pos_access: 'Доступ POS-кассы',
    adminPosAccess_subtitle: 'Только POS-касса — товары выбранного филиала.',
    adminPosAccess_quota: 'POS-доступы',
    adminPosAccess_quota_unavailable: 'недоступно на текущем тарифе (от 299 000 сум)',
    adminPosAccess_quota_full: 'Лимит POS-доступов исчерпан',
    adminPosAccess_add_disabled: 'Нельзя добавить POS-пользователя — лимит тарифа исчерпан',
    adminPosAccess_total: 'POS-пользователей',
    adminPosAccess_col_name: 'Имя',
    adminPosAccess_col_phone: 'Телефон',
    adminPosAccess_col_branch: 'Филиал',
    adminPosAccess_col_status: 'Статус',
    adminPosAccess_status_active: 'Активен',
    adminPosAccess_status_inactive: 'Неактивен',
    adminPosAccess_scope_hint: 'Пользователь видит только товары назначенного филиала и работает на кассе.',
    adminPosAccess_branch_scope: 'POS-касса работает только в рамках выбранного филиала.',
    adminPosAccess_phone_hint: 'Номер телефона используется как логин для входа.',
    adminPosAccess_password_hint: 'Не менее 6 символов. Для входа по номеру телефона.',
    adminPosAccess_name_placeholder: 'Полное имя',
    adminPosAccess_error_plan: 'На вашем тарифе нет POS-доступов. Обновите тариф от 299 000 сум.',
    adminPosAccess_error_limit: 'Достигнут лимит POS-доступов по тарифу.',
    adminPosAccess_add: 'Добавить POS-пользователя',
    adminPosAccess_empty: 'POS-пользователей пока нет. Нажмите «Добавить POS-пользователя», чтобы создать первого.',
    adminPosAccess_modal_add: 'Добавить POS-пользователя',
    adminPosAccess_modal_edit: 'Редактировать POS-пользователя',
    adminPosAccess_delete_title: 'Удалить POS-пользователя',
    adminPosAccess_delete_text: 'Удалить этого пользователя?',
    adminPosAccess_error_plan: 'На текущем тарифе POS-доступ недоступен. Обновите тариф от 299 000 сум.',
    adminPosAccess_error_limit: 'Достигнут лимит POS-доступов по тарифу.',
    cashierKassa_out_of_stock: '«{name}» — на складе нет остатка.',
    cashierKassa_branch_mix_forbidden: 'Нельзя смешивать товары разных филиалов в одной корзине.',
    cashierKassa_test_receipt_success: 'Тестовый чек успешно отправлен.',
    adminNav_staff_workers: 'Сотрудники',
    adminNav_credits: 'Насия',
    adminNav_global_settings: 'Настройки',
    adminNav_tariff_plans: 'Тарифы',
    adminNav_landing_team: 'Команда на сайте',
    adminNav_tariff_plan: 'Тарифный план',
    adminLandingTeam_subtitle: 'Раздел «Наша команда» на лендинге — фото, должность и краткое описание.',
    adminLandingTeam_add: 'Добавить участника',
    adminLandingTeam_edit: 'Редактировать',
    adminLandingTeam_delete: 'Удалить',
    adminLandingTeam_save: 'Сохранить',
    adminLandingTeam_cancel: 'Отмена',
    adminLandingTeam_empty: 'Участников пока нет. Добавьте первого.',
    adminLandingTeam_col_photo: 'Фото',
    adminLandingTeam_col_name: 'Имя',
    adminLandingTeam_col_role: 'Должность',
    adminLandingTeam_col_order: 'Порядок',
    adminLandingTeam_col_status: 'Статус',
    adminLandingTeam_col_actions: 'Действия',
    adminLandingTeam_active: 'Активен',
    adminLandingTeam_inactive: 'Скрыт',
    adminLandingTeam_field_name: 'ФИО',
    adminLandingTeam_field_role: 'Должность',
    adminLandingTeam_field_description: 'Краткое описание',
    adminLandingTeam_field_sort: 'Порядок отображения',
    adminLandingTeam_field_active: 'Показывать на лендинге',
    adminLandingTeam_field_photo: 'Фото',
    adminLandingTeam_remove_photo: 'Удалить фото',
    adminLandingTeam_validation_required: 'Заполните имя, должность и описание.',
    adminLandingTeam_photo_invalid: 'Только изображения (JPEG, PNG, WebP).',
    adminLandingTeam_photo_too_large: 'Размер файла не более 4 МБ.',
    adminLandingTeam_delete_confirm: 'Удалить «{name}»?',
    tenant_tariff_no_tenant: 'Tenant не определён.',
    tenant_tariff_load_error: 'Не удалось загрузить данные.',
    tenant_tariff_cancel_error: 'Запрос не отправлен. Попробуйте снова.',
    tenant_tariff_status: 'Статус подписки',
    tenant_tariff_plan_key: 'Тариф',
    tenant_tariff_status_field: 'Статус',
    tenant_tariff_trial_ends: 'Окончание пробного периода',
    tenant_tariff_subscription_ends: 'Окончание подписки',
    tenant_tariff_cancel_title: 'Отмена подписки',
    tenant_tariff_cancel_lead:
      'Запрос уйдёт менеджеру. До окончания оплаченного периода вы продолжите пользоваться сервисом. Можно указать причину (по желанию).',
    tenant_tariff_cancel_requested: 'Запрос на отмену',
    tenant_tariff_cancel_note: 'Комментарий (необязательно)',
    tenant_tariff_cancel_placeholder: 'Почему хотите отменить?',
    tenant_tariff_cancel_submit: 'Отправить запрос на отмену подписки',
    tenant_tariff_transactions: 'Транзакции подписки',

    subscription_extend: 'Продление подписки (предоплата)',
    subscription_status_label: 'Статус',
    subscription_expired: 'Подписка истекла',
    subscription_data_preserved_hint: 'Ваши данные (товары, заказы, рассрочка) сохранены. Для новых операций продлите подписку.',
    subscription_trial: 'Пробный период',
    subscription_active: 'Подписка активна',
    subscription_days_remaining: 'Осталось дней',
    subscription_days_unit: 'дн.',
    subscription_ends_at: 'Дата окончания',
    subscription_monthly_price: 'Ежемесячная стоимость тарифа',
    subscription_prepay_matches_tariff:
      'Сумма соответствует вашему текущему тарифу (как в разделе «Тарифы»). Предоплата за выбранные месяцы считается от этой ежемесячной цены.',
    subscription_months_unit: 'мес.',
    subscription_prepay_base: 'Предоплата (без скидки)',
    subscription_prepay_discount_label: 'Скидка',
    subscription_total: 'К оплате',
    subscription_provider: 'Платёжный провайдер',
    subscription_provider_new_tab: 'переход на страницу оплаты',
    subscription_pay_btn: 'Оплатить',
    subscription_cashback_balance: 'Баланс cashback',
    subscription_cashback_apply: 'Использовать cashback (раз в год)',
    subscription_cashback_hint: 'Тарифы «средний / крупный»: 5% с каждого платежа на баланс; раз в год как скидка.',
    subscription_cashback_next: 'Следующее использование cashback',
    subscription_click_sms_error_hint:
      'Если Click показывает «СМС услуга не включена (-33006)»: ошибка обычно связана с отключённой SMS-услугой у мерчанта в Click или у карты плательщика. Как мерчант — подключите SMS в кабинете Click по вашему SERVICE_ID или обратитесь в поддержку Click; для карты — включите SMS-информирование в банке.',
    subscription_click_continue_checkout: 'Перейти к оплате в Click',
    subscription_click_provider_error_hint:
      '«Поставщик недоступен (-21)» на странице Click обычно связано с этапом Prepare: Click не смог получить от вашего API корректный ответ (`error: 0`, JSON) — таймаут, SSL, 404/500, неверная подпись, пустой `CLICK_SECRET_KEY`. В кабинете URL Prepare/Complete = `https://…/api/webhooks/click` или `…/webhooks/click`; `API_PUBLIC_URL` должен совпадать с этим хостом. Логи: `click.webhook.post_hit`, `click.webhook.received`, `click.webhook.sign_check_failed` (docs.click.uz/en/click-api-request/).',
    subscription_pay_tech_click:
      'Технически: POST /api/subscription/initiate → витрина Click https://my.click.uz/services/pay — параметры по docs.click.uz/en/click-button/.',
    subscription_pay_tech_payme:
      'Технически: POST /api/subscription/initiate → checkout Payme/Paycom (домен из настроек, обычно checkout.paycom.uz).',
    subscription_pay_err_no_url: 'Ссылка оплаты не создана. Попробуйте снова.',
    subscription_pay_err_generic: 'Оплата не началась. Попробуйте снова.',
    subscription_pay_err_payme_test_merchant:
      'Режим Payme test: на сервере не задан PAYME_TEST_MERCHANT_ID (sandbox). Production ID на test checkout даёт «поставщик не найден».',
    subscription_pay_err_payme_not_configured: 'Payme merchant ID не настроен на сервере (PAYME_MERCHANT_ID).',
    subscription_pay_err_payme_invalid_merchant:
      'Неверный ID кассы Payme (24 hex). Проверьте значение в кабинете Payme Business.',
    subscription_pay_err_payme_key_not_configured:
      'Не настроен production-ключ Payme (PAYME_KEY) на сервере.',
    subscription_pay_err_payme_production_checkout:
      'Нужен production checkout (checkout.paycom.uz). На сервере: PAYME_USE_TEST=false.',

    tenant_tariff_plan_change_title: 'Запрос на смену тарифа',
    tenant_tariff_plan_change_lead:
      'Если нужен другой тариф или объём, выберите ниже и оставьте комментарий. Менеджер свяжется с вами.',
    tenant_tariff_plan_change_desired: 'Какой тариф нужен',
    tenant_tariff_plan_change_desired_placeholder: 'Выберите…',
    tenant_tariff_plan_change_note: 'Комментарий',
    tenant_tariff_plan_change_note_ph: 'Например: открываю филиал, нужно больше пользователей…',
    tenant_tariff_plan_change_submit: 'Отправить запрос',
    tenant_tariff_plan_change_ok: 'Запрос принят. Мы свяжемся с вами в ближайшее время.',
    tenant_tariff_plan_change_error: 'Не удалось отправить. Попробуйте снова.',

    tariff_type_start: 'Старт',
    tariff_type_businessSmall: 'Малый бизнес',
    tariff_type_businessMedium: 'Средний бизнес',
    tariff_type_businessEnterprise: 'Крупная компания',
    adminNav_integrations: 'Интеграции',
    adminNav_tenant_management: 'Клиенты',
    adminNav_tenant_messages: 'Чат с клиентами',
    adminNav_cashier_chat: 'Чат с кассирами',
    adminNav_chat: 'Чат',
    adminNav_cashier_rating: 'Рейтинг кассиров',
    adminNav_ai_helper: 'AI помощник',
    adminNav_staff_chat: 'Внутренний чат',
    adminNav_branches: 'Филиалы',
    adminNav_ombor: 'Склад',
    adminAIAdvisor_subtitle: 'AI рекомендации, прогнозы и стратегические советы.',
    adminAIAdvisor_coming: 'Прогноз продаж, KPI рейтинги и AI маркетинговые рекомендации — скоро.',
    adminNav_feature_flags: 'Флаги функций',
    adminNav_audit_logs: 'Журнал аудита',
    adminNav_system_health: 'Мониторинг системы',
    adminNav_usage_metrics: 'Статистика использования',
    adminNav_error_monitoring: 'Сбои и ошибки',
    adminNav_api_keys: 'API-ключи',
    adminNav_company_dashboard: 'Сводка для руководства',
    adminNav_branches: 'Сеть филиалов',
    adminNav_warehouses: 'Склады',
    adminNav_employees_roles: 'Сотрудники и роли',
    adminNav_products: 'Товары',
    adminNav_categories: 'Категории',
    adminNav_price_management: 'Управление ценами',
    adminNav_customers: 'База клиентов',
    adminNav_orders: 'Управление заказами',
    adminNav_deliveries: 'Доставки',
    adminNav_reports: 'Аналитические отчёты',
    adminNav_marketing: 'Маркетинговые инструменты',
    adminNav_marketing_orders: 'Онлайн-заказы',
    adminNav_desktop_apps: 'Приложения',
    marketingAddon_modal_title: 'Пакет маркетинга и онлайн-заказов',
    marketingAddon_modal_intro:
      'На тарифе «Малый бизнес» эти модули подключаются единоразовым платежом — оба раздела открываются по одной сумме.',
    marketingAddon_modal_amount_label: 'Сумма платежа (один раз)',
    marketingAddon_modal_unlocks: 'Откроются маркетинговые инструменты и онлайн-заказы одновременно.',
    marketingAddon_pay_click: 'Оплатить через Click',
    marketingAddon_pay_payme: 'Оплатить через Payme',
    marketingAddon_err_generic: 'Не удалось начать оплату. Попробуйте снова.',
    marketingAddon_refresh_hint: 'После оплаты нажмите «Обновить» или перезагрузите страницу.',
    marketingAddon_refresh_btn: 'Обновить профиль',
    marketingAddon_close_btn: 'Перейти в другой раздел',
    desktopApps_page_subtitle:
      'Десктоп Add-e для Windows хранится на сервере — здесь путь к файлу и адрес загрузки.',
    desktopApps_live_web_note:
      'Обновления интерфейса подгружаются с сайта автоматически — не нужно каждый раз скачивать .exe. Ctrl+R или «Обновить» в меню. Один раз установите новый .exe (в старой версии это не работает).',
    desktopApps_card_title: 'Add-e Desktop App',
    desktopApps_card_platform: 'Windows',
    desktopApps_download_title: 'Add-e Desktop (Windows)',
    desktopApps_download_desc: 'ZIP или установщик — скачайте, распакуйте или запустите установку.',
    desktopApps_download_btn: 'Начать загрузку',
    desktopApps_download_note: 'Прогресс загрузки смотрите внизу браузера.',
    desktopApps_step_1: 'Скачайте файл',
    desktopApps_step_2: 'Распакуйте архив или запустите установщик',
    desktopApps_step_3: 'Войдите в десктоп-приложении через «Вход»',
    desktopApps_no_url: 'Ссылка на загрузку пока не настроена. Обратитесь в поддержку.',
    desktopApps_info_loading: 'Загрузка данных с сервера…',
    desktopApps_info_load_error: 'Не удалось получить информацию о приложении.',
    desktopApps_server_file_label: 'Файл на сервере',
    desktopApps_public_url_label: 'Ссылка для загрузки (HTTPS)',
    desktopApps_file_size_label: 'Размер файла',
    desktopApps_download_public_note: 'Браузер скачает .exe из public (например https://api.addegroup.uz/Adde-1.0.0-x64.exe).',
    desktopApps_download_error: 'Ошибка загрузки. Повторите попытку или обратитесь к администратору.',
    desktopApps_not_on_server:
      'В public нет .exe. Загрузите файл, например public/Adde-1.0.0-x64.exe (имя должно совпадать с ADDE_DESKTOP_PUBLIC_FILENAME в .env).',
    desktopApps_deploy_hint:
      'Администратор: загрузите Adde-1.0.0-x64.exe в папку public API-сайта. Другая версия — обновите ADDE_DESKTOP_PUBLIC_FILENAME в .env.',
    subscription_force_renew_hint:
      'Подписка истекла. Продлите тариф и оплатите. Окно закроется после подтверждения оплаты.',
    cashierSubscriptionReminder_title: 'Напоминание об оплате подписки',
    cashierSubscriptionReminder_body:
      'Срок месячной подписки для владельца точки истёк, оплата ещё не поступила. Сообщите клиенту — это окно закроется после оплаты.',
    adminNav_notifications: 'Центр уведомлений',
    adminNav_company_settings: 'Настройки компании',
    adminNav_settings: 'Профиль и системные настройки',
    adminNav_printer_connect: 'Чековые принтеры',
    adminNav_help: 'Справка и поддержка',
    adminNav_sessions: 'Сессии и устройства',
    adminSessions_subtitle: 'Контролируйте активные устройства и при необходимости завершайте сессии.',
    adminSessions_refresh: 'Обновить',
    adminSessions_revoke_others: 'Завершить все, кроме текущей',
    adminSessions_revoke_selected: 'Завершить выбранные',
    adminSessions_total: 'Всего сессий',
    adminSessions_selected: 'Выбрано',
    adminSessions_current: 'Текущее устройство',
    adminSessions_loading: 'Загрузка сессий...',
    adminSessions_empty: 'Активные сессии не найдены.',
    adminSessions_device: 'Устройство',
    adminSessions_type: 'Тип',
    adminSessions_last_active: 'Последняя активность',
    adminSessions_created: 'Создана',
    adminSessions_device_unknown: 'Неизвестное устройство',
    adminSessions_current_badge: 'Текущая',
    adminSessions_current_session: 'Текущая сессия',
    adminSessions_select_session: 'Выбрать сессию',
    adminSessions_confirm_selected: 'Завершить выбранные сессии?',
    adminSessions_confirm_others: 'Завершить все сессии, кроме текущей?',
    adminSessions_load_error: 'Не удалось загрузить список сессий.',
    adminSessions_action_error: 'Не удалось завершить сессию.',
    adminNav_kassa: 'Торговая касса (POS)',
    adminNav_retail_clients: 'База розничных клиентов',
    adminNav_pos_orders: 'Кассовые заказы',
    adminNav_manager_customers: 'База клиентов',
    adminNav_manager_payments: 'Платежи и транзакции',
    adminNav_cashier_z_report: 'Z-отчёт',
    adminNav_order_history: 'История заказов',
    adminNav_ombor_products: 'Остатки товаров',
    adminOmbor_col_measure_variant: 'Вариант / ед. изм.',
    adminOmbor_tenant_fav: 'Избранное',
    adminOmbor_tenant_fav_hint: 'Отмечайте для быстрого поиска на кассе',
    adminOmbor_tenant_fav_toggle: 'Избранный товар (звезда)',
    adminOmbor_tenant_fav_add: 'Добавить в избранное',
    adminOmbor_tenant_fav_remove: 'Убрать из избранного',
    adminOmbor_detail_variants_hint: 'Варианты и единицы',
    adminOmbor_detail_col_variant: 'Вариант',
    adminOmbor_detail_col_stock_value: 'Сумма остатка',
    adminOmbor_supplier_name: 'Поставщик',
    adminOmbor_supplier_placeholder: 'Введите название поставщика',
    adminOmbor_supplier_phone: 'Телефон поставщика',
    adminOmbor_supplier_phone_placeholder: 'Введите телефон поставщика',
    admininOmbor_supplier_name: 'Поставщик',
    admininOmbor_supplier_placeholder: 'Введите название поставщика',
    adminOmbor_bulk_intake_title: 'Приём от поставщика',
    adminOmbor_bulk_intake_hint:
      'Оформите несколько товаров от одного поставщика за раз — данные поставщика общие для всех строк.',
    adminOmbor_bulk_intake_add_row: 'Ещё строка',
    adminOmbor_bulk_intake_remove_row: 'Удалить строку',
    adminOmbor_bulk_intake_submit: 'Сохранить приём',
    adminOmbor_bulk_intake_product_select: 'Выберите товар',
    adminOmbor_bulk_intake_product_search: 'Название, штрих-код или ID',
    adminOmbor_bulk_intake_product_no_results: 'По запросу товары не найдены',
    adminOmbor_bulk_intake_error_no_items: 'Укажите хотя бы один товар и количество.',
    adminOmbor_bulk_intake_error_qty: 'Неверное количество.',
    adminOmbor_bulk_intake_error_qty_small: 'Слишком маленькое количество.',
    adminOmbor_bulk_intake_error_product: 'Выберите товар во всех заполненных строках.',
    adminNav_maslahat: 'Советы и рекомендации',
    adminNav_delivery_status: 'Статус доставки',
    adminNav_product_catalog: 'Каталог товаров',
    adminNav_inventory_dashboard: 'Управление складом',
    adminNav_stock_in: 'Оприходование',
    adminNav_stock_out: 'Отпуск со склада',
    adminNav_transfers: 'Межскладские перемещения',
    adminNav_barcode_scanner: 'Сканер штрих-кода',
    adminNav_inventory_audit: 'Инвентаризация',
    adminNav_expiry_tracking: 'Контроль сроков годности',
    adminInventory_product_id: 'ID товара',
    adminInventory_stock_add: 'Добавить остаток',
    adminInventory_stock_add_expense_hint:
      'Если «Оплачено» не отмечено, сумма закупки (цена × количество) добавится в расходы или к существующему расходу по этому товару.',
    adminOmbor_barcode: 'Штрих-код',
    adminOmbor_barcode_print: 'Печать штрих-кода',
    adminOmbor_barcode_copies: 'Количество',
    adminOmbor_barcode_size_mm: 'Размер (мм)',
    adminOmbor_barcode_print_success: 'Штрих-код отправлен на принтер',
    adminOmbor_purchase_price: 'Закупочная цена',
    adminOmbor_sale_price: 'Цена продажи',
    adminOmbor_additional_sale_price: 'Доп. цена продажи (необяз.)',
    adminInventory_quantity: 'Количество',
    adminInventory_expiry: 'Срок годности',
    adminInvDash_expiry_empty: 'Не указано',
    adminTopbar_expiry_alerts: 'Товары с близким сроком годности',
    adminTopbar_expiry_days: 'дн.',
    adminTopbar_expiry_left: 'осталось',
    adminTopbar_expiry_ago: 'назад',
    adminTopbar_expiry_today: 'Сегодня',
    adminInventory_from_warehouse: 'Со склада',
    adminInventory_to_warehouse: 'На склад',
    adminInventory_action_save: 'Сохранить',
    adminInventory_action_loading: 'Сохранение...',
    adminInventory_action_success: 'Сохранено',
    adminBarcodeScan_title: 'Штрих-код',
    adminBarcodeScan_placeholder: 'Введите штрих-код',
    adminBarcodeScan_action: 'Проверить',
    adminBarcodeScan_found: 'Найдено',
    adminPagination_prev: 'Назад',
    adminPagination_next: 'Вперёд',
    adminPagination_page: 'Страница',
    adminNav_finance_dashboard: 'Финансовые показатели',
    adminNav_transactions: 'Денежные потоки',
    adminNav_invoices: 'Счета и акты',
    adminNav_taxes: 'Налоговый учёт',
    adminNav_1c_integration: 'Интеграция с 1С',
    adminNav_profit_loss: 'Отчёт о прибылях и убытках',
    adminNav_balance_sheet: 'Балансовый отчёт',
    adminNav_export_reports: 'Экспорт данных',
    adminNav_analytics_dashboard: 'Маркетинг и продажи',
    adminNav_sales_funnel: 'Воронка продаж',
    adminNav_customer_segments: 'Сегменты клиентов',
    adminNav_campaigns: 'Маркетинговые кампании',
    adminNav_ai_recommendations: 'Рекомендации AI',
    adminNav_retention: 'Удержание клиентов',
    adminNav_cohort_analysis: 'Когортный анализ',
    analytics_dash_subtitle: 'Ключевые KPI: визиты, сессии, конверсия и выручка.',
    analytics_dash_subtitle_pro: 'Цель vs факт, анализ каналов, тренды и рекомендации для решений.',
    analytics_dash_exec_summary: 'Выручка выросла на +12,4% к прошлому месяцу. Главный источник трафика — Organic Search (45%). Конверсия 4,2% — выше плана. Прогноз на следующий месяц положительный.',
    analytics_dash_goals_title: 'Цель vs Факт (текущий месяц)',
    analytics_dash_goals_metric: 'Показатель',
    analytics_dash_goals_target: 'Цель',
    analytics_dash_goals_actual: 'Факт',
    analytics_dash_goals_achievement: 'Выполнение',
    analytics_goal_revenue: 'Выручка (UZS)',
    analytics_goal_conversion: 'Конверсия (%)',
    analytics_goal_new_customers: 'Новые клиенты',
    analytics_goal_visitors: 'Уникальные визиты',
    analytics_goal_sessions: 'Сессии',
    analytics_goal_avg_session: 'Средняя сессия (мин)',
    analytics_dash_channels_title: 'Распределение по источникам трафика',
    channel_organic: 'Органический поиск',
    channel_direct: 'Прямые заходы',
    channel_paid: 'Платная реклама',
    analytics_dash_visitors_short: 'визитов',
    analytics_dash_sessions_short: 'сессий',
    analytics_dash_conversion_short: 'конв.',
    analytics_week: 'Неделя',
    analytics_dash_trend_weekly: 'Недельный трафик (последние 12 недель)',
    analytics_dash_min: 'Мин',
    analytics_dash_max: 'Макс',
    analytics_dash_avg: 'Среднее',
    analytics_dash_trend_growth: 'Рост',
    analytics_dash_forecast_title: 'Прогноз и активность',
    analytics_dash_forecast_label: 'Прогноз выручки на следующий месяц',
    analytics_dash_peak_hours: 'Пиковые часы (трафик)',
    analytics_dash_insights_title: 'Ключевые выводы',
    analytics_insight_1: 'Органический канал продолжает расти — сохраняйте SEO и контент-стратегию.',
    analytics_insight_2: 'Трафик из соцсетей +15% к прошлому месяцу — пересмотрите рекламный бюджет.',
    analytics_insight_3: 'Спад по платному каналу — рекомендуется A/B тесты и оптимизация лендингов.',
    analytics_insight_4: 'Недельный трафик стабильно растёт последние 4 недели — реклама и контент работают.',
    analytics_insight_5: 'Прямые заходы дают высокую конверсию — усиливайте бренд и напоминания.',
    analytics_insight_6: 'Пик активности 10:00–14:00 — планируйте рекламу и push на это время.',
    analytics_dash_recommendations_title: 'Рекомендуемые действия',
    analytics_rec_1: 'Упростите CTA и формы на лендингах для роста конверсии.',
    analytics_rec_2: 'Направьте email-кампанию на сегмент «под риском» — снижение оттока.',
    analytics_rec_3: 'Пересмотрите цели платного канала на следующий квартал и отслеживайте ROI.',
    analytics_rec_4: 'Увеличьте бюджет рекламы в интервале 10:00–14:00 — пик конверсии.',
    analytics_rec_5: 'Автоматизируйте еженедельные отчёты и краткую сводку для менеджеров.',
    analytics_priority_high: 'Высокий',
    analytics_priority_medium: 'Средний',
    analytics_dash_kpi: 'Ключевые показатели',
    analytics_dash_unique_visitors: 'Уникальные визиты (30 дн.)',
    analytics_dash_sessions: 'Сессии',
    analytics_dash_conversion_rate: 'Конверсия (%)',
    analytics_dash_avg_session: 'Средняя сессия (мин)',
    analytics_dash_bounce_rate: 'Отказ (%)',
    analytics_dash_revenue_month: 'Выручка за месяц',
    analytics_dash_top_channel: 'Лучший канал',
    analytics_dash_new_customers: 'Новые клиенты (мес.)',
    analytics_dash_repeat_orders: 'Повторные заказы (%)',
    analytics_dash_visitors_weekly: 'Визиты по неделям',
    analytics_dash_revenue_6m: 'Выручка по месяцам (6 мес.)',
    analytics_funnel_subtitle: 'Этапы воронки продаж и конверсия в следующий этап.',
    analytics_funnel_stage: 'Этап',
    analytics_funnel_count: 'Кол-во',
    analytics_funnel_conversion_next: 'В след. этап (%)',
    analytics_funnel_dropoff: 'Отток (%)',
    funnel_awareness: 'Узнаваемость',
    funnel_interest: 'Интерес',
    funnel_consideration: 'Рассмотрение',
    funnel_intent: 'Намерение',
    funnel_purchase: 'Покупка',
    funnel_loyalty: 'Лояльность',
    analytics_segments_subtitle: 'Доля выручки и рост по сегментам клиентов.',
    analytics_segments_name: 'Сегмент',
    analytics_segments_count: 'Клиенты',
    analytics_segments_revenue_share: 'Доля выручки (%)',
    analytics_segments_avg_order: 'Средний чек (UZS)',
    analytics_segments_growth: 'Рост (%)',
    analytics_segments_desc: 'Описание',
    segment_vip: 'VIP',
    segment_active: 'Активные',
    segment_regular: 'Обычные',
    segment_new: 'Новые',
    segment_at_risk: 'Под риском',
    segment_churned: 'Ушедшие',
    segment_vip_desc: 'Максимальная выручка и частота покупок.',
    segment_active_desc: 'Покупали в последние 3 месяца.',
    segment_regular_desc: 'Средняя частота покупок.',
    segment_new_desc: 'Регистрация менее 30 дней назад.',
    segment_at_risk_desc: 'Снижение активности, риск оттока.',
    segment_churned_desc: 'Долго не проявляли активность.',
    analytics_campaigns_subtitle: 'Маркетинговые кампании: бюджет, охват и ROI.',
    analytics_campaigns_name: 'Кампания',
    analytics_campaigns_status: 'Статус',
    analytics_campaigns_channel: 'Канал',
    analytics_campaigns_budget: 'Бюджет',
    analytics_campaigns_spent: 'Потрачено',
    analytics_campaigns_reach: 'Охват',
    analytics_campaigns_conversions: 'Конверсии',
    analytics_campaigns_roi: 'ROI (%)',
    analytics_campaigns_dates: 'Период',
    analytics_campaign_status_active: 'Активна',
    analytics_campaign_status_paused: 'На паузе',
    analytics_campaign_status_completed: 'Завершена',
    analytics_campaign_status_draft: 'Черновик',
    campaign_spring_sale: 'Весенняя распродажа 2025',
    campaign_email_retention: 'Email — удержание',
    campaign_google_ads: 'Google Ads — январь',
    campaign_telegram: 'Telegram — январь',
    campaign_new_segment: 'Проект нового сегмента',
    channel_social: 'Соцсети',
    channel_email: 'Email',
    channel_google: 'Google Ads',
    channel_telegram: 'Telegram',
    analytics_ai_rec_subtitle: 'Рекомендации AI: товар, цена, маркетинг.',
    analytics_rec_priority_high: 'Высокий',
    analytics_rec_priority_medium: 'Средний',
    analytics_rec_priority_low: 'Низкий',
    analytics_rec_estimated_lift: 'Ожидаемый прирост',
    rec_product_bundle: 'Предложение комплекта',
    rec_product_bundle_desc: 'Предлагать товары A, B, C комплектом для увеличения среднего чека.',
    rec_product_bundle_impact: 'Ожидаемый эффект: объём продаж +18%.',
    rec_retention_email: 'Напоминание по email',
    rec_retention_email_desc: 'Персонализированное предложение сегменту, не покупавшему 14 дней.',
    rec_retention_email_impact: 'Реактивация и снижение оттока.',
    rec_pricing_dynamic: 'Динамическое ценообразование',
    rec_pricing_dynamic_desc: 'Автонастройка цен по выбранным категориям от спроса и запасов.',
    rec_pricing_dynamic_impact: 'Оптимизация маржи и оборота.',
    rec_marketing_segment: 'Реклама по сегментам',
    rec_marketing_segment_desc: 'Отдельные кампании для VIP и сегмента под риском.',
    rec_marketing_segment_impact: 'Рост ROI и конверсии.',
    rec_inventory_stock: 'Оптимизация запасов',
    rec_inventory_stock_desc: 'Рекомендации заказа по товарам с низким остатком на основе AI.',
    rec_inventory_stock_impact: 'Снижение дефицита.',
    analytics_retention_subtitle: 'Удержание клиентов: показатели на 1-, 7-, 30-, 90-й день.',
    analytics_retention_kpi: 'Удержание (%)',
    analytics_retention_day1: '1 день',
    analytics_retention_day7: '7 дней',
    analytics_retention_day30: '30 дней',
    analytics_retention_day90: '90 дней',
    analytics_retention_chart_title: 'Удержание по неделям (когорта)',
    retention_week1: 'Неделя 1',
    retention_week2: 'Неделя 2',
    retention_week3: 'Неделя 3',
    retention_week4: 'Неделя 4',
    retention_week8: 'Неделя 8',
    retention_week12: 'Неделя 12',
    analytics_cohort_subtitle: 'Матрица удержания по когортам регистрации.',
    analytics_cohort_cohort: 'Когорта',
    analytics_cohort_size: 'Размер',
    analytics_cohort_period0: '0-период (%)',
    analytics_cohort_period1: '1-период (%)',
    analytics_cohort_period2: '2-период (%)',
    analytics_cohort_period3: '3-период (%)',
    analytics_cohort_note: 'Проценты — активные клиенты в каждом периоде от размера когорты.',
    adminNav_my_deliveries: 'Доставки',
    adminNav_route_map: 'Маршруты',
    adminNav_courier_order_status: 'Статус заказа',
    adminNav_offline_sync: 'Офлайн',
    adminNav_earnings: 'Доход',
    adminNav_my_orders: 'Мои заказы',
    adminNav_customer_payments: 'Платежи',
    adminNav_profile: 'Профиль',
    adminNav_locations: 'Адреса',

    // Super Admin sections (promptga mos)
    adminSuper1Title: 'Управление общими настройками системы',
    adminSuper1Desc: 'Управление общими настройками системы. Роль для разработчиков или администраторов высшего уровня.',
    adminSuper2Title: 'Определение тарифных пакетов',
    adminSuper2Desc: 'Определение тарифных пакетов и управление ценами.',
    adminSuper3Title: 'Установка внешних интеграций',
    adminSuper3Desc: 'Установка внешних интеграций: API, платёжные системы и сторонние сервисы.',
    adminSuper4Title: 'Полный доступ ко всем данным',
    adminSuper4Desc: 'Иметь полный доступ ко всем данным: пользователи, отчёты, аудит и экспорт.',
    adminSuper5Title: 'Контроль остальных ролей',
    adminSuper5Desc: 'Роль контролирует остальные роли: создание ролей, назначение прав и управление.',

    // Biznes Admin sections (promptga mos)
    adminBiznes1Title: 'Создание и управление филиалами и складами',
    adminBiznes1Desc: 'Создание и управление филиалами и складами. Роль для владельцев бизнеса и руководителей.',
    adminBiznes2Title: 'Регистрация сотрудников и назначение прав',
    adminBiznes2Desc: 'Регистрация сотрудников и назначение прав.',
    adminBiznes3Title: 'Ведение каталога товаров',
    adminBiznes3Desc: 'Ведение каталога товаров: товары, категории и цены.',
    adminBiznes4Title: 'Контроль процессов продаж',
    adminBiznes4Desc: 'Контроль процессов продаж.',
    adminBiznes5Title: 'Формирование отчётов',
    adminBiznes5Desc: 'Формирование отчётов. Роль обеспечивает полное управление внутренней деятельностью компании.',

    // Menejer/Sotuvchi sections (promptga mos)
    adminMenejer1Title: 'Создание и управление заказами',
    adminMenejer1Desc: 'Создание и управление заказами. Роль для торговых групп.',
    adminMenejer2Title: 'Ведение данных клиентов',
    adminMenejer2Desc: 'Ведение данных клиентов: база, поиск и история покупок.',
    adminMenejer3Title: 'Приём оплаты',
    adminMenejer3Desc: 'Приём оплаты.',
    adminMenejer4Title: 'Контроль процесса доставки',
    adminMenejer4Desc: 'Контроль процесса доставки. Быстрые и эффективные ежедневные операции.',

    // Admin settings (sidebar sections)
    adminSettingsHeading: 'Настройки',
    adminAdd: 'Добавить',
    adminFormSave: 'Сохранить',
    adminFormClose: 'Закрыть',
    adminSetPlaceholder: 'Введите',
    adminSetLang: 'Язык',
    adminSetTimezone: 'Часовой пояс',
    adminSetPanelName: 'Название панели',
    adminSetTariffName: 'Название тарифа',
    adminSetPrice: 'Цена (UZS)',
    adminSetPeriod: 'Срок действия',
    adminSetApiKey: 'API ключ',
    adminSetWebhook: 'Webhook URL',
    adminSetExportFormat: 'Формат экспорта',
    adminSetMaxRows: 'Макс. строк',
    adminSetRoleName: 'Название роли',
    adminSetPermissionType: 'Тип прав',
    adminSetBranchName: 'Название филиала',
    adminSetWarehouse: 'Склад',
    adminSetAddress: 'Адрес',
    adminSetStaffName: 'ФИО сотрудника',
    adminSetPosition: 'Должность',
    adminSetAccess: 'Права доступа',
    adminSetProductName: 'Название товара',
    adminSetCategory: 'Категория',
    adminSetPaymentMethod: 'Способ оплаты',
    adminSetReceiptType: 'Тип чека',
    adminSetReportType: 'Тип отчёта',
    adminSetDateRange: 'Период',
    adminSetOrderNumber: 'Номер заказа',
    adminSetOrderStatus: 'Статус заказа',
    adminSetCustomer: 'Клиент',
    adminSetCustomerName: 'ФИО клиента',
    adminSetPhone: 'Телефон',
    adminSetAmount: 'Сумма',
    adminSetDeliveryAddress: 'Адрес доставки',
    adminSetDeliveryStatus: 'Статус доставки',
    adminSetQuantity: 'Количество',
    adminSetOperationType: 'Тип операции',
    adminSetInventoryDate: 'Дата инвентаризации',
    adminSetBarcode: 'Штрих-код',
    adminSetTaxSystem: 'Налоговая система',
    adminSetTaxRate: 'Налоговая ставка',
    adminSetCampaignName: 'Название кампании',
    adminSetSegmentName: 'Название сегмента',
    adminSetAiRecommendation: 'Рекомендация AI',
    adminSetOfflineMode: 'Офлайн режим',
    adminSetSyncInterval: 'Интервал синхронизации',
    adminSetRouteName: 'Название маршрута',
    adminSetLocation: 'Локация',

    // New roles
    roleTitle_warehouse_clerk: 'Кладовщик',
    roleDesc_warehouse_clerk: 'Ведение приходно-расходных операций, проведение инвентаризации и идентификация товаров по штрих-коду. Роль для складских сотрудников, контроль остатков и движений в реальном времени.',
    roleTitle_accountant: 'Бухгалтер',
    roleDesc_accountant: 'Интеграция с налоговыми системами и 1С, управление платежами и финансовыми документами. Роль для финансового отдела, автоматизация отчётов и налоговых деклараций.',
    roleTitle_analitik_marketing: 'Аналитик',
    roleDesc_analitik_marketing: 'Анализ кампаний и продаж, сегменты клиентов, отчёты и рекомендации.',
    roleTitle_kuryer_field: 'Курьер / Field agent',
    roleDesc_kuryer_field: 'Возможность работы в офлайн режиме, обновление статусов доставки и отслеживание маршрутов. Роль для курьеров, обновление данных в реальном времени с мобильных устройств.',
    roleTitle_tenant_owner: 'Клиент (владелец точки)',
    roleDesc_tenant_owner: 'Управление точкой: кассиры, филиалы, продажи, рассрочка, финансы и отчёты. Интеграция с розничными клиентами и Telegram.',

    // Omborchi sections (promptga mos)
    adminOmborchi1Title: 'Ведение приходно-расходных операций по товарам',
    adminOmborchi1Desc: 'Ведение приходно-расходных операций по товарам.',
    adminOmborchi2Title: 'Проведение инвентаризации',
    adminOmborchi2Desc: 'Проведение инвентаризации.',
    adminOmborchi3Title: 'Идентификация товаров по штрих-коду',
    adminOmborchi3Desc: 'Идентификация товаров по штрих-коду.',
    adminOmborchi4Title: 'Контроль остатков и движений в реальном времени',
    adminOmborchi4Desc: 'Контроль остатков и движений в реальном времени. Роль для складских сотрудников.',
    adminOmborchi5Title: 'Настройки для складских сотрудников',
    adminOmborchi5Desc: 'Роль для складских сотрудников, контроль остатков и движений в реальном времени.',

    // Buxgalter sections (promptga mos)
    adminBuxgalter1Title: 'Интеграция с налоговыми системами и 1С',
    adminBuxgalter1Desc: 'Интеграция с налоговыми системами и 1С. Роль для финансового отдела.',
    adminBuxgalter2Title: 'Интеграция с 1С',
    adminBuxgalter2Desc: 'Обмен данными и синхронизация с 1С.',
    adminBuxgalter3Title: 'Управление платежами и финансовыми документами',
    adminBuxgalter3Desc: 'Управление платежами и финансовыми документами.',
    adminBuxgalter4Title: 'Автоматизация отчётов и налоговых деклараций',
    adminBuxgalter4Desc: 'Помощь в автоматизации отчётов и налоговых деклараций.',
    adminBuxgalter5Title: 'Настройки финансового отдела',
    adminBuxgalter5Desc: 'Роль для сотрудников финансового отдела, помощь в автоматизации отчётов и деклараций.',

    // Analitik/Marketing sections (promptga mos)
    adminAnalitik1Title: 'Отчёт по кампаниям',
    adminAnalitik1Desc: 'Эффективность и расходы рекламных кампаний.',
    adminAnalitik2Title: 'Сегменты клиентов',
    adminAnalitik2Desc: 'Группировка клиентов, фильтры и работа с сегментами.',
    adminAnalitik3Title: 'Рекомендации по товарам',
    adminAnalitik3Desc: 'Настройка рекомендаций по продажам и покупкам.',
    adminAnalitik4Title: 'Анализ клиентов',
    adminAnalitik4Desc: 'Поведение и показатели удержания (retention).',
    adminAnalitik5Title: 'Настройки аналитики',
    adminAnalitik5Desc: 'Отчёты, экспорт и параметры интеграции.',

    // Kuryer/Field sections (promptga mos)
    adminKuryer1Title: 'Возможность работы в офлайн режиме',
    adminKuryer1Desc: 'Возможность работы в офлайн режиме. Роль для курьеров.',
    adminKuryer2Title: 'Обновление статусов доставки',
    adminKuryer2Desc: 'Обновление статусов доставки.',
    adminKuryer3Title: 'Отслеживание маршрутов',
    adminKuryer3Desc: 'Отслеживание маршрутов.',
    adminKuryer4Title: 'Обновление данных в реальном времени с мобильных устройств',
    adminKuryer4Desc: 'Помощь в обновлении данных в реальном времени с мобильных устройств.',
    adminKuryer5Title: 'Настройки для курьеров',
    adminKuryer5Desc: 'Роль для курьеров, помощь в обновлении данных в реальном времени с мобильных устройств.',

    // Mijoz sections (promptga mos, опционально)
    adminMijoz1Title: 'Просмотр истории заказов',
    adminMijoz1Desc: 'Просмотр истории заказов. Роль для клиентов.',
    adminMijoz2Title: 'Осуществление платежей',
    adminMijoz2Desc: 'Осуществление платежей.',
    adminMijoz3Title: 'Передача данных локации',
    adminMijoz3Desc: 'Передача данных локации.',
    adminMijoz4Title: 'Портал самообслуживания',
    adminMijoz4Desc: 'Предоставляет портал самообслуживания и упрощает связь с бизнесом.',
    adminMijoz5Title: 'Портал клиента (опционально)',
    adminMijoz5Desc: 'Роль для клиентов, предоставляет портал самообслуживания и упрощает связь с бизнесом.',

    // Насия / Credits (пункт меню: adminNav_credits в блоке навигации выше)
    adminCredits_cashier_subtitle: 'Список продаж в рассрочку для текущего кассира и погашений.',
    adminCredits_client_subtitle: 'Все продажи в рассрочку по филиалам и кассирам.',
    adminCredits_list_title: 'Список рассрочек',
    adminCredits_archive_title: 'Архив рассрочек',
    adminCredits_archive_btn: 'Архив',
    adminCredits_back_to_active: 'Активный список',
    adminCredits_archive_empty: 'В архиве записей нет.',
    adminCredits_empty: 'Продаж в рассрочку пока нет.',
    adminCredits_products: 'Товары',
    adminCredits_prices: 'Цены',
    adminCredits_client: 'Клиент',
    adminCredits_branch: 'Филиал',
    adminCredits_cashier: 'Кассир',
    adminCredits_total: 'Сумма рассрочки',
    adminCredits_remaining: 'Остаток',
    adminCredits_createdAt: 'Дата создания',
    adminCredits_actions: 'Действия',
    adminCredits_repay: 'Погасить',
    adminCredits_closed: 'Закрыто',
    adminCredits_repay_title: 'Погашение рассрочки',
    adminCredits_repay_remaining: 'Остаток',
    adminCredits_repay_amount: 'Сумма погашения',
    adminCredits_repay_method: 'Способ оплаты',
    adminCredits_repay_saving: 'Сохранение…',
    adminCredits_repay_submit: 'Погасить',
    adminCredits_repay_discount_optional: 'Скидка (необязательно), UZS',
    adminCredits_repay_discount_hint:
      'Скидка уменьшает только остаток рассрочки; в кассу попадает сумма «Погашения». Наличные + скидка не больше остатка.',
    adminCredits_repay_total_applied: 'Списание с рассрочки (всего)',
    adminCredits_telegram_reminder: 'Напоминание в Telegram',
    adminCredits_telegram_reminder_sending: 'Отправка…',
    adminCredits_telegram_reminder_hint: 'Отправить клиенту напоминание о рассрочке через Telegram-бота',
    adminCredits_telegram_not_linked: 'Клиент ещё не подключил бота (отправьте контакт в боте)',
    adminCredits_card_total: 'Все рассрочки',
    adminCredits_card_repaid: 'Погашенные рассрочки',
    adminCredits_card_remaining: 'Оставшиеся рассрочки',
    adminCredits_card_outstanding: 'Общий остаток (рассрочка)',
    adminCredits_card_issued_lifetime: 'Выдано всего',
    adminCredits_card_active_count: 'активных',
    adminCredits_card_contracts: 'Договоры рассрочки',
    adminCredits_card_all_time: 'Всего записей',
    adminCredits_credit_number: 'Номер рассрочки',
    adminCredits_top_creation: 'Больше всего выдают рассрочку (филиал, кассир)',
    adminCredits_top_repaid: 'Больше всего гасят рассрочки (филиал, кассир)',
    adminCredits_search_placeholder: 'Поиск…',
    adminCredits_filter_all_branches: 'Все филиалы',
    adminCredits_filter_all_cashiers: 'Все кассиры',
    adminCredits_no_results: 'По запросу ничего не найдено.',
    retailClients_subtitle: 'Клиенты из кассы: имя, телефон, число продаж и остаток рассрочки.',
    retailClients_credit_banner: 'У {count} клиентов есть рассрочка. Управление:',
    retailClients_go_kassa: 'К кассе',
    retailClients_go_credits: 'Раздел рассрочки',
    retailClients_go_list: 'Список розничных клиентов',
    retailClients_empty: 'Пока нет записей. Введите телефон клиента в корзине на кассе.',
    retailClients_col_name: 'Имя',
    retailClients_col_phone: 'Телефон',
    retailClients_col_sales: 'Продажи',
    retailClients_col_sales_total: 'Сумма продаж',
    retailClients_col_balance: 'Баланс cashback',
    retailClients_col_credit: 'Остаток рассрочки',
    retailClients_filter_month: 'Месяц',
    retailClients_filter_current_month: 'Текущий месяц',
    retailClients_filter_all_time: 'Всё время',
    retailClients_filter_month_hint: 'Продажи за {month}. Баланс — текущий.',
    retailClients_filter_all_time_hint: 'Продажи за всё время. Баланс — текущий.',
    retailClients_repay: 'Уменьшить остаток',
    retailClients_repay_amount: 'Сумма (UZS)',
    retailClients_repay_confirm: 'Применить',
    retailClients_edit_balance: 'Изменить баланс',
    retailClients_edit_balance_save: 'Сохранить',
    common_retry: 'Повторить',
    common_loading: 'Загрузка...',
    common_error: 'Ошибка',
    common_no_data: 'Нет данных',
    common_yes: 'Да',
    common_no: 'Нет',
    common_add: 'Добавить',
    common_today: 'Сегодня',
    common_week: 'Неделя',
    common_month: 'Месяц',
    common_custom_period: 'Произвольный период'
  },
  en: {
    // Navigation
    navFeatures: 'Features',
    navSolutions: 'Solutions',
    navPricing: 'Pricing',
    navAIAnalytics: 'AI Analytics',
    navContact: 'Contact',

    appNotice_title_default: 'Notice',
    appNotice_title_error: 'Error',
    appNotice_title_warning: 'Warning',
    appNotice_confirm: 'Got it',
    common_ok: 'OK',

    // Product sale units
    product_sale_unit_type: 'Unit',
    product_sale_unit_piece: 'Piece',
    product_sale_unit_kg: 'Kilogram (kg)',
    product_sale_unit_meter: 'Meter (m)',
    product_sale_unit_liter: 'Liter (l)',
    product_sale_unit_box: 'Box',
    product_sale_unit_pack: 'Pack',
    product_sale_unit_roll: 'Roll',
    product_sale_unit_set: 'Set',
    product_sale_unit_pallet: 'Pallet',
    product_sale_unit_ton: 'Ton (t)',
    product_sale_unit_sqm: 'Sq. m (m²)',
    product_sale_unit_cubic_meter: 'Cubic m (m³)',
    product_sale_unit_cm: 'Centimeter (cm)',
    product_sale_unit_mm: 'Millimeter (mm)',
    product_sale_unit_pair: 'Pair',
    product_sale_unit_size: 'Size',
    product_sale_unit_wholesale: 'Wholesale',
    product_sale_unit_kg_short: 'kg',
    product_sale_unit_meter_short: 'm',
    product_sale_unit_liter_short: 'l',
    product_sale_unit_ton_short: 't',
    product_sale_unit_sqm_short: 'm²',
    product_sale_unit_cubic_meter_short: 'm³',
    product_sale_unit_cm_short: 'cm',
    product_sale_unit_mm_short: 'mm',
    product_sale_unit_pair_short: 'pair',
    product_sale_unit_size_short: 'size',
    product_sale_unit_wholesale_short: 'wh',
    product_wholesale_price: 'Wholesale price',
    cashierKassa_optom_toggle: 'Wholesale',
    cashierKassa_optom_hint: 'Prices use wholesale rate',
    
    // Header buttons
    btnLogin: 'Login',
    btnStartFreeTrial: 'Start Free Trial',
    
    // Hero section
    heroTitle: 'AI-Powered Comprehensive Business Management Platform',
    heroSubtitle: 'Manage sales, inventory, staff, finance, and analytics in one system. Automate your business and increase efficiency.',
    heroDemoBadge: 'Free Demo',
    demoDays: '14',
    demoFree: 'days free',
    demoDescription: 'No credit card required. Try all features at full capacity.',
    btnRequestDemo: 'Start Free Trial',
    btnViewFeatures: 'View Features',
    
    // Trust Stats
    statRealTime: 'Real-time Analytics',
    statAIPowered: 'AI-Powered Analytics',
    statMultiBranch: 'Multi-Branch Management',
    statOfflineSync: 'Offline + Online Sync',
    
    // Core Features
    sectionCoreFeatures: 'Core Features',
    featureSales: 'Sales and Order Automation',
    featureWarehouse: 'Warehouse and Inventory Management',
    featureStaff: 'Staff KPI and Payroll Management',
    featureAIForecast: 'AI Forecasting and Analytics',
    featureCRM: 'CRM and Customer Segmentation',
    featureReports: 'Reports and Dashboards',
    
    // AI Power
    aiTitle: 'Powered by Advanced AI Analytics',
    aiSubtitle: 'Get accurate forecasts and recommendations for your business using AI technology. Make data-driven decisions.',
    aiSalesPredictions: 'Sales Predictions',
    aiStockOptimization: 'Inventory Optimization',
    aiStaffScoring: 'Staff Performance Scoring',
    aiSmartReminders: 'Smart Reminders',
    aiSalesPredictionsDesc: 'Demand forecasts from past sales and seasonality — simpler planning for stock and promos.',
    aiStockOptimizationDesc: 'Stock levels and turnover insights reduce overstock and shortage risk.',
    aiStaffScoringDesc: 'Clear KPI scoring for sales and operations, per team member.',
    aiSmartRemindersDesc: 'Timely alerts for payments, stock, and important deadlines.',
    statRealTimeDesc: 'Sales and warehouse metrics refresh quickly — always an up-to-date picture.',
    statAIPoweredDesc: 'Automatic data insights and guidance on what to watch next.',
    statMultiBranchDesc: 'All branches and POS terminals in one admin view.',
    statOfflineSyncDesc: 'POS works offline, then syncs safely when you are back online.',
    coreFeaturesSubtitle: 'Sales, warehouse, people, and reports — one connected platform.',
    featureSalesDesc: 'Automate orders and payments — fewer day-to-day mistakes.',
    featureWarehouseDesc: 'Stock, batches, and movements — transparent inventory control.',
    featureStaffDesc: 'KPIs, shifts, and payroll — structured team management.',
    featureAIForecastDesc: 'Assistive analytics for trends and demand.',
    featureCRMDesc: 'Customer segments and contact history in one place.',
    featureReportsDesc: 'Ready-made reports and charts by branch and period.',
    businessTypesSubtitle: 'Pick a plan that fits your scale — core modules are included in every tier.',
    tariffCardDescription: 'Your plan includes core modules, updates, and support.',
    teamMemberDesc1: 'Strategy and partnerships — product roadmap and customer success.',
    teamMemberDesc2: 'Architecture and security — a stable, scalable system.',
    teamMemberDesc3: 'Projects and delivery — timelines and quality under control.',
    teamMemberDesc4: 'Customer success and training — faster adoption, fewer blockers.',
    teamMemberDesc5: 'Growth and marketing — clear positioning in the market.',
    teamMemberDesc6: 'Finance and transparency — disciplined budgets and reporting.',
    testimonial_1_text: 'POS and warehouse in one place — almost no confusion across branches.',
    testimonial_1_name: 'Sardor Karimov',
    testimonial_1_role: 'Director, retail chain',
    testimonial_1_initials: 'SK',
    testimonial_2_text: 'Credit and repayments are visible in one grid — daily control got easier.',
    testimonial_2_name: 'Madina Yusupova',
    testimonial_2_role: 'Finance manager',
    testimonial_2_initials: 'MY',
    testimonial_3_text: 'Stock updates feel real-time; slow movers stand out immediately.',
    testimonial_3_name: 'Jahongir Toshmatov',
    testimonial_3_role: 'Warehouse lead',
    testimonial_3_initials: 'JT',
    testimonial_4_text: 'Templated reports — leadership gets clear numbers every week.',
    testimonial_4_name: 'Nilufar Rakhimova',
    testimonial_4_role: 'Operations manager',
    testimonial_4_initials: 'NR',
    testimonial_5_text: 'Several stores from one panel — a noticeable time saving.',
    testimonial_5_name: 'Bobur Ergashev',
    testimonial_5_role: 'Chain owner',
    testimonial_5_initials: 'BE',
    testimonial_6_text: 'Support responds quickly; rollout was smooth.',
    testimonial_6_name: 'Shirin Azimova',
    testimonial_6_role: 'IT & processes',
    testimonial_6_initials: 'SA',
    
    // Business Types
    sectionBusinessTypes: 'For Businesses of Any Size',
    businessSmall: 'Small Business',
    businessMedium: 'Medium Business',
    biz_retail: 'Retail',
    biz_food: 'Food',
    biz_logistics: 'Logistics',
    biz_services: 'Services',
    biz_manufacturing: 'Manufacturing',
    biz_construction: 'Construction',
    businessEnterprise: 'Enterprise',
    badgeMostPopular: 'Most Popular',
    btnGetStarted: 'Get Started',
    benefitUpTo10Users: 'Up to 10 users',
    benefitBasicCRM: 'Basic CRM and Inventory',
    benefitEssentialReports: 'Essential Reports',
    benefitEmailSupport: 'Email Support',
    benefitAILocation: 'AI Location',
    benefitOnlineSalesExtra: 'Online sales with extra charge',
    benefitUpTo50Users: 'Up to 50 users',
    benefitFullCRM: 'Full CRM and ERP Suite',
    benefitAdvancedAnalytics: 'Advanced Analytics',
    benefitPrioritySupport: 'Priority Support',
    benefitUnlimitedUsers: 'Unlimited Users',
    benefitCustomIntegrations: 'Custom Integrations',
    benefitAISuite: 'AI Analytics Suite',
    benefitDedicatedManager: 'Dedicated Manager',
    benefitAILocation: 'AI Location',
    benefitOnlineSalesFree: 'Online sales free',
    benefit24x7Support: '24/7 Support',
    benefitMonthlyDiscount: '10% discount on monthly payment',
    benefitOneBranch: 'Up to 1 branch',
    benefitOneCashier: 'Up to 1 cashier',
    benefitProducts1000: 'Up to 1000 products',
    benefitRetailClients1000: 'Up to 1000 retail customers',
    benefitBranches3: 'Up to 3 branches',
    benefitCashiers10: 'Up to 10 cashiers',
    benefitUnlimitedProducts: 'Unlimited products',
    benefitRetailClients5000: 'Up to 5000 retail customers',
    benefitAIAdvisor: 'AI assistant',
    benefitMarketingOnlinePaidAddon: 'Marketing + online sales (paid add-on)',
    benefitBranches5: 'Up to 5 branches',
    benefitCashiers20: 'Up to 20 cashiers',
    benefitRetailClients20000: 'Up to 20000 retail customers',
    benefitMarketingTools: 'Marketing tools',
    benefitOnlineOrdersFree: 'Online orders (included)',
    benefitUnlimitedBranches: 'Unlimited branches',
    benefitUnlimitedCashiers: 'Unlimited cashiers',
    benefitUnlimitedRetailClients: 'Unlimited retail customers',

    // Pricing
    pricingMonthly: 'Monthly',
    pricingAnnual: 'Annual',
    pricingDiscount: '20% off',
    pricingSave: 'Save',
    pricingCurrency: 'UZS',
    pricingPerMonth: 'per month',
    pricingPerYear: 'per year',
    pricingMonth: 'mo',
    pricingTryFree: 'Try it',
    pricingAnnualDiscountHint: 'up to 10–25%',
    pricingRevealStartCta: 'See plans from 99,000 UZS?',
    pricingRevealStartClose: 'Hide Start plan',
    
    // Contact
    sectionContact: 'Contact',
    contactSubtitle: 'Have questions? Contact us and get help growing your business.',
    contactEmail: 'Email',
    contactPhone: 'Phone',
    contactOffice: 'Office',
    contactOfficeAddress: 'Tashkent city, Yunusabad district, Amir Temur street, building 123',
    formName: 'Name',
    formNamePlaceholder: 'Enter your name',
    formEmail: 'Email',
    formEmailPlaceholder: 'email@example.com',
    formPhone: 'Phone',
    formPhonePlaceholder: '+998 90 123 45 67',
    formCompany: 'Company',
    formCompanyPlaceholder: 'Company name (optional)',
    formBusinessType: 'Business type',
    formBusinessTypePlaceholder: 'Select (optional)',
    formTariff: 'Tariff',
    formTariffPlaceholder: 'Select tariff (optional)',
    formMessage: 'Message',
    formMessagePlaceholder: 'Write your message (optional)...',
    formOptional: 'optional',
    btnSendMessage: 'Send Message',
    contactSubmitSuccess: 'Your message has been received. We will contact you soon.',
    contactSubmitError: 'Failed to send. Please try again later.',
    contactSending: 'Sending…',
    
    // CTA
    ctaTitle: 'Start Managing Your Business Smarter Today',
    ctaSubtitle: 'Thousands of companies are using our platform to optimize their operations. Join them today.',
    ctaDemoBadge: 'Free Demo',
    btnGetStartedFree: 'Get Started Free',
    
    // Footer
    footerDescription: 'AI-powered comprehensive business management platform. Manage sales, inventory, staff, finance, and analytics in one system.',
    footerEmail: 'Email',
    footerPhone: 'Phone',
    footerAddress: 'Address',
    footerAddressValue: 'Tashkent city, Yunusabad district, Amir Temur street, building 123',
    footerFollowUs: 'Follow Us',
    footerProduct: 'Product',
    footerCompany: 'Company',
    footerLegal: 'Legal',
    footerPrivacy: 'Privacy Policy',
    footerTerms: 'Terms of Service',
    footerRights: 'All rights reserved.',
    
    // Statistics
    statUsers: 'Users',
    statOrders: 'Orders',
    statBranches: 'Branches',
    statSatisfaction: 'Satisfaction',
    
    // Testimonials
    sectionTestimonials: 'What Our Clients Say',
    testimonialsSubtitle: 'Companies using our platform share their thoughts about our solutions.',
    
    // Integrations
    sectionIntegrations: 'Integrations',
    integrationsSubtitle: 'Integrate with your favorite services and manage all processes in one place.',
    btnViewAllIntegrations: 'View All Integrations',
    
    // Comparison
    sectionComparison: 'Comparison with Competitors',
    comparisonSubtitle: 'How our platform differs from other solutions and what advantages it offers.',
    comparisonFeature: 'Feature',
    comparisonUs: 'Our Platform',
    comparisonCompetitor: 'Competitors',
    compFeature1: 'AI Analytics',
    compFeature2: 'Real-time Sync',
    compFeature3: 'Multi-Branch Support',
    compFeature4: 'Offline Mode',
    compFeature5: 'CRM Module',
    compFeature6: 'Automated Reports',
    compFeature7: 'Mobile App',
    compFeature8: '24/7 Support',
    
    // Dashboard
    dashboardTitle: 'Dashboard',
    dashboardRevenue: 'Monthly Revenue',
    dashboardOrders: 'Monthly Income',
    dashboardSalesOverview: 'Sales Overview',
    dashboardNewOrder: 'New Order',
    dashboardPaymentReceived: 'Payment Received',
    dashboardStockUpdated: 'Stock Updated',
    dashboardMinAgo: 'min ago',
    
    // Team
    sectionTeam: 'Our Team',
    teamSubtitle: 'Our professional team will help you grow your business.',
    teamPosition1: 'Chief Executive Officer',
    teamPosition2: 'Chief Technology Officer',
    teamPosition3: 'Project Manager',
    teamPosition4: 'Customer Success Manager',
    teamPosition5: 'Marketing Manager',
    teamPosition6: 'Finance Manager',

    // Login modal
    loginModalTitle: 'Login',
    loginModalPhoneSubtitle: 'Enter your phone number to sign in.',
    loginModalPhoneLabel: 'Phone number',
    loginModalPhonePlaceholder: '90 123 45 67',
    loginModalPhoneError: 'Enter full number (9 digits).',
    loginModalPhoneNotAllowed: 'This number is not registered. Only allowed numbers can sign in.',
    loginModalPasswordSubtitle: 'Sign in with your phone number and password.',
    loginModalPasswordLabel: 'Password',
    loginModalPasswordPlaceholder: 'Enter your password',
    loginModalPasswordError: 'Password must be at least 4 characters.',
    loginModalPasswordInvalid: 'Wrong password or server response. Please try again.',
    loginModalSignIn: 'Sign in',
    loginModalSigningIn: 'Signing in…',
    loginModalAuth_invalid_credentials: 'Wrong phone or password, or no password is set for this account.',
    loginModalAuth_phone_invalid: 'Invalid phone number format.',
    loginModalAuth_missing_or_invalid_fields: 'Enter both phone and password.',
    loginModalSendSms: 'Send SMS',
    loginModalSending: 'Sending...',
    loginModalChecking: 'Checking...',
    loginModalSmsTitle: 'SMS verification',
    loginModalSmsSubtitle: 'Enter the 4-digit code sent to your number.',
    loginModalSmsLabel: 'SMS code',
    loginModalSmsPlaceholder: '0000',
    loginModalSmsPlaceholderHint: 'Enter code',
    loginModalSmsError: 'Enter 4-digit code.',
    loginModalBack: 'Back',
    loginModalConfirm: 'Confirm',
    loginModalSuccessTitle: 'Signed in successfully',
    loginModalSuccessGuest: 'You are signed in.',
    loginModalClose: 'Close',
    loginModalForgotPassword: 'Forgot password?',
    loginModal2FATitle: 'SMS Verification',
    loginModal2FASubtitle: 'Password correct! A 4-digit code was sent to your phone.',
    loginModalOtpLabel: 'SMS code',
    loginModalOtpPlaceholder: '0000',
    loginModalOtpError: 'Enter the 4-digit code.',
    loginModalOtpInvalid: 'Invalid or expired code.',
    loginModalResend: 'Resend code',
    loginModalResendIn: 'Resend in {{n}}s',
    loginModalResetTitle: 'Reset Password',
    loginModalResetSubtitle: 'An SMS code will be sent to your phone number.',
    loginModalResetSendCode: 'Send Code',
    loginModalResetOtpSubtitle: 'Enter the 4-digit code from your SMS.',
    loginModalNewPasswordTitle: 'Set New Password',
    loginModalNewPasswordLabel: 'New password',
    loginModalNewPasswordPlaceholder: 'At least 6 characters',
    loginModalNewPasswordConfirmLabel: 'Confirm password',
    loginModalNewPasswordConfirmPlaceholder: 'Confirm password',
    loginModalSavePassword: 'Save Password',
    loginModalSaving: 'Saving...',
    loginModalResetSuccess: 'Password updated successfully! Sign in with your new password.',
    loginModalPasswordMinError: 'Password must be at least 6 characters.',
    loginModalPasswordMismatch: 'Passwords do not match.',

    // Roles (static) – new structure
    roleTitle_platform_owner: 'Owner (Project owner)',
    roleDesc_platform_owner: 'System settings, tariff plans, full data access. Statistics and adding managers. For developers and top-level administrators.',
    roleTitle_general_manager: 'Chief Manager',
    roleDesc_general_manager: 'Statistics across all regions, manage regional managers, branches and reports.',
    roleTitle_regional_manager: 'Regional Manager',
    roleDesc_regional_manager: 'Own region: branches and warehouses, staff and roles, product catalog, orders and reports.',
    roleTitle_dispatcher: 'Dispatcher',
    roleDesc_dispatcher: 'Incoming sales and orders, delivery statuses and notifications.',
    roleTitle_warehouse_clerk: 'Warehouse',
    roleDesc_warehouse_clerk: 'Stock in/out, inventory, barcode identification. Real-time stock and movements.',
    roleTitle_accountant: 'Accountant',
    roleDesc_accountant: 'Tax and 1C integration, payments and financial documents, reports.',
    roleTitle_analyst: 'Analyst',
    roleDesc_analyst: 'Campaign and sales analysis, customer segments, reports and recommendations.',
    roleTitle_kuryer: 'Courier / Field agent',
    roleDesc_kuryer: 'Offline mode, delivery status updates, routes. Mobile devices.',
    roleTitle_tenant_owner: 'Client (Point owner)',
    roleDesc_tenant_owner: 'Run your business: cashiers, branches, sales, credit, finance and reports. Retail customers and Telegram notifications.',
    roleTitle_cashier: 'Cashier',
    roleDesc_cashier: 'POS and orders, accept payments. Managed by point owner.',

    // Admin panel
    adminTitle: 'Admin Panel',
    adminWelcome: 'The following sections are available for your role.',
    adminLogout: 'Log out',
    adminSidebarHeading: 'Menu',
    adminSidebar_collapse: 'Collapse sidebar (icons only)',
    adminSidebar_expand: 'Expand sidebar',
    adminCurrentRole: 'Current role',
    adminLanguageLabel: 'Select language',
    adminMore: 'More',
    adminActivityLog: 'Activity Log',
    adminNotifications: 'Notifications',
    adminProfileSettings: 'Profile Settings',
    adminProfile: 'Profile',
    adminSettings_login_password: 'Login password',
    adminProfile_password_current: 'Current password',
    adminProfile_password_new: 'New password',
    adminProfile_password_confirm: 'Confirm new password',
    adminProfile_password_current_required: 'Enter your current password',
    adminProfile_password_min: 'New password must be at least 6 characters',
    adminProfile_password_mismatch: 'New password and confirmation do not match',
    adminProfile_password_invalid: 'Current password is incorrect',
    adminProfile_password_set_first: 'Set login password',
    adminProfile_phone_already_exists: 'This phone number is already registered to another user',
    save: 'Save',
    saving: 'Saving...',
    saved: 'Saved',
    edit: 'Edit',
    cancel: 'Cancel',
    roleSwitch_title: 'Switch role',
    roleSwitch_desc: 'Current role',
    roleSwitch_target: 'New role',
    roleSwitch_current: 'Current role',
    roleSwitch_pin_label: 'Enter PIN',
    roleSwitch_pin_required: 'Enter PIN',
    roleSwitch_pin_invalid: 'Invalid PIN',
    roleSwitch_pin_min: 'PIN at least 4 characters',
    roleSwitch_pin_mismatch: 'PIN does not match',
    roleSwitch_pin_new: 'New PIN',
    roleSwitch_pin_confirm: 'Confirm PIN',
    roleSwitch_pin_current: 'Current PIN',
    roleSwitch_set_pin: 'Save',
    roleSwitch_set_pin_first: 'Set PIN',
    roleSwitch_enter_pin_tenant_owner: 'Enter PIN to switch to client role',
    roleSwitch_enter_pin_kassir: 'Enter PIN to switch to cashier role',
    roleSwitch_choose_kassir: 'Switch to cashier (no PIN)',
    roleSwitch_choose_cashier: 'Switch to cashier role (cashier PIN required)',
    roleSwitch_choose_target: 'Which role to switch to?',
    roleSwitch_no_cashiers: 'No cashiers found',
    roleSwitch_no_pin: 'PIN is not set',
    roleSwitch_enter_tenant_owner_pin: 'Enter client (owner) PIN',
    roleSwitch_enter_kassir_pin: 'Enter cashier PIN',
    roleSwitch_pin_profile_label: 'Role switch PIN',
    roleSwitch_pin_change: 'Change',
    roleSwitch_confirm: 'Switch role',
    adminImpersonate_title: 'Sign in as another user',
    adminImpersonate_desc: 'Pick a user below your role, then enter your own account password to confirm.',
    adminImpersonate_search: 'Search (name, phone)',
    adminImpersonate_search_ph: 'Name or phone...',
    adminImpersonate_empty: 'No users found',
    adminImpersonate_your_password: 'Your password (confirmation)',
    adminImpersonate_submit: 'Continue',
    adminImpersonate_failed: 'Could not complete',
    adminImpersonate_select_user: 'Select a user',
    adminImpersonate_password_required: 'Enter your password',
    adminImpersonate_banner: 'You are signed in as another user. You can return to your own account.',
    adminImpersonate_exit: 'Back to my account',
    adminImpersonate_exit_error: 'Could not restore your session. Try again.',
    adminImpersonate_nested_blocked: 'Exit the current “sign in as” session first.',
    sidebar_impersonation_section: 'Sign in as role',
    sidebar_impersonation_load_error: 'Could not load the list. Check your connection.',
    sidebar_impersonation_empty: 'No accounts yet for lower roles. Add users in the admin, then refresh.',
    sidebar_impersonation_role_empty: 'No accounts for this role',
    sidebar_impersonation_refresh: 'Refresh',
    role_access_page_subtitle: 'Pick an account below you in the hierarchy and confirm with your own password.',
    role_access_accounts_total: 'Total accounts:',
    role_access_denied: 'You do not have access to this page.',
    role_access_row_action: 'Sign in',
    role_access_filters_label: 'Filters',
    role_access_search_placeholder: 'Search by name or phone...',
    role_access_region_filter: 'Filter by region',
    role_access_region_all: 'All regions',
    adminSettings: 'Settings',
    adminNoActivity: 'No recent activity',
    adminNoNotifications: 'No notifications',
    adminTopbar_chat_notifications: 'Chat messages',
    adminTopbar_currency_title: 'Rate',
    adminTopbar_currency_updated: 'Updated',
    adminTopbar_currency_select: 'Select currency',
    notif_chat_from_tenant_owner: 'New message from client',
    notif_chat_from_support: 'Support reply',
    support_new_message_title: 'New message from client',
    support_new_message_body: 'There is a new message in the chat — open it to reply.',
    support_reply_title: 'Reply from manager',
    support_reply_body: 'New reply in the support chat.',
    notif_chat_meta_tenant: 'Client',
    adminTheme: 'Theme',
    adminThemeLight: 'Light mode',
    adminThemeDark: 'Dark mode',
    adminMenuOpen: 'Open menu',
    adminMenuClose: 'Close menu',
    adminGoToPanel: 'Go to panel',
    adminComingSoon: 'Coming soon',
    adminPlaceholderFeature1: 'Full dashboard and reports',
    adminPlaceholderFeature2: 'Settings and integrations',
    adminPlaceholderFeature3: 'Export and detailed analytics',
    adminStat_period: 'Current month (static data)',
    adminStat_tenants: 'Clients',
    adminStat_tenants_active_short: 'active',
    adminStat_tenants_suspended_short: 'suspended',
    adminStat_tenants_trial_short: 'trial',
    adminStat_tariffCustomers: 'Clients by tariff',
    adminStat_tariffDistribution: 'Tariff distribution',
    adminStat_tariff_other: 'Other tariffs',
    adminStat_activeUsers: 'Active users',
    adminStat_ordersMonth: 'Orders (monthly)',
    adminStat_dispatcherOrdersCard: 'Orders assigned to dispatcher',
    adminStat_dispatcherOrdersConvertedShort: 'converted to client',
    adminStat_dispatcherOrdersRejectedShort: 'rejected',
    adminStat_revenueMonth: 'Revenue (monthly, UZS)',
    adminStat_growth: 'Growth (vs last month)',
    adminStat_summaryTitle: 'Summary',
    adminStat_topRegion: 'Top region',
    adminStat_fastestGrowingRegion: 'Fastest growing region',
    adminStat_newTenantsWeek: 'New clients (weekly)',
    adminStat_empty: 'No data',
    adminStat_note: 'Note',
    adminStat_noteText: 'Data is sample metrics. Full reports will be added in future updates.',
    adminStat_bm_overview: 'Executive overview',
    adminStat_bm_page_sub: 'Aggregate metrics across regions, managers, and clients.',
    adminStat_bm_hero_eyebrow: 'Chief manager',
    adminStat_bm_hero_title: 'Operational metrics',
    adminStat_bm_regions_short: 'regions',
    adminStat_chartTitle_bm: 'Orders — all regions (8 weeks)',
    adminStat_bm_managers: 'Managers',
    adminStat_bm_dispatchers: 'Dispatchers',
    adminStat_bm_regions: 'Regions',
    adminStat_bm_totalBranches: 'Branches (total)',
    adminStat_bm_topManager: 'Top manager',
    adminStat_bm_topDispatcher: 'Top dispatcher',
    adminStat_bm_bestRatingRegion: 'Best rating (region)',
    adminStat_bm_newLeadsMonth: 'New leads (month)',
    adminStat_vm_overview: 'Regional metrics',
    adminStat_vm_region: 'Region',
    adminStat_vm_topBranch: 'Top branch',
    adminStat_vm_topClientCategory: 'Top order category',
    adminStat_vm_tenants: 'Clients',
    adminStat_vm_operational_title: 'Regional operational metrics',
    adminStat_vm_monthlyRevenue: 'Regional revenue over 6 months',
    adminStat_chartTitle_vm: 'Orders — last 8 weeks (region)',
    adminStat_chart_axis_week: 'Week',
    adminStat_disp_overview: 'Personal metrics (sales and orders)',
    adminStat_disp_leadsToday: 'New sales today',
    adminStat_disp_leadsWeek: 'Sales this week',
    adminStat_disp_ordersInProgress: 'Orders in progress',
    adminStat_disp_ordersCompletedToday: 'Completed today',
    adminStat_disp_ordersCompletedWeek: 'Completed this week',
    adminStat_disp_leadsMonth: 'Sales this month',
    adminStat_disp_topManager: 'Partner manager',
    adminStat_disp_topLeadSource: 'Top sales source',
    adminStat_hours_short: 'h',
    adminStat_analitik_overview: 'Analytics (visits, conversion, revenue)',
    adminStat_analitik_visitors: 'Unique visitors (30 days)',
    adminStat_analitik_sessions: 'Sessions',
    adminStat_analitik_top_channel: 'Top channel',
    adminStat_analitik_new_customers: 'New customers (month)',
    adminStat_analitik_avg_session: 'Avg. session (min)',
    adminStat_analitik_bounce: 'Bounce rate (%)',
    adminStat_chartTitle_analitik: 'Weekly visitors',
    adminStat_overview: 'Key metrics',
    adminStat_tenant_owner_overview: 'Company metrics',
    adminStat_selected_period_prefix: 'Selected period',
    adminStat_davr_today: 'Today',
    adminStat_davr_week: 'Week',
    adminStat_davr_month: 'Month',
    adminStat_davr_year: 'Year',
    adminStat_davr_custom: 'Custom range',
    adminStat_custom_from: 'From',
    adminStat_custom_to: 'To',
    adminStat_tenant_owner_section_kpi: 'Sales and profitability',
    adminStat_tenant_owner_scope_period: 'Period',
    adminStat_tenant_owner_revenue_today: 'Sales today (income)',
    adminStat_tenant_owner_revenue_week: 'Weekly sales (income)',
    adminStat_tenant_owner_revenue_month: 'Monthly sales (income)',
    adminStat_tenant_owner_revenue_year: 'Yearly sales (income)',
    adminStat_tenant_owner_net_today: 'Net profit today (estimate)',
    adminStat_tenant_owner_net_week: 'Weekly net profit (estimate)',
    adminStat_tenant_owner_net_month: 'Monthly net profit',
    adminStat_tenant_owner_net_year: 'Yearly net profit (estimate)',
    adminStat_tenant_owner_orders_today: 'Operations today',
    adminStat_tenant_owner_orders_week: 'Weekly operations',
    adminStat_tenant_owner_orders_month: 'Monthly operations',
    adminStat_tenant_owner_orders_year: 'Yearly operations',
    adminStat_tenant_owner_orders_period: 'Operations (selected range)',
    adminStat_tenant_owner_revenue_period: 'Sales / income (selected range)',
    adminStat_tenant_owner_net_period: 'Net profit (selected range)',
    adminStat_tenant_owner_chart_custom_daily: 'Selected range — daily sales',
    adminStat_tenant_owner_trend_custom: 'growth (per report)',
    adminStat_tenant_owner_trend_mom: 'vs previous month (monthly trend)',
    adminStat_tenant_owner_trend_recent: 'recent months trend',
    adminStat_tenant_owner_trend_yoy: 'vs previous year (annual trend)',
    adminStat_tenant_owner_last7_title: 'Last 7 days — daily sales',
    adminStat_tenant_owner_weekday_title: 'Weekday distribution',
    adminStat_tenant_owner_payments_hint: 'Based on income matching the selected period and branch filter.',
    adminStat_expense_paid_title: 'Expenses covered',
    adminStat_expense_paid_badge: 'expense',
    adminStat_expense_paid_split: 'Expense payment split',
    adminStat_expense_paid_cash: 'Cash (from cashbox)',
    adminStat_expense_paid_product: 'By product',
    adminStat_expense_paid_other: 'Other',
    adminStat_expenses_title: 'Expense details',
    expenseMeta_productId: 'Product ID',
    expenseMeta_qty: 'Quantity',
    expenseMeta_supplier: 'Supplier',
    expenseMeta_supplierId: 'Supplier ID',
    expenseMeta_purchasePrice: 'Purchase price',
    adminStat_expenses_all: 'All',
    adminStat_expenses_active: 'Active',
    adminStat_expenses_archived: 'Fully settled',
    adminStat_expenses_total: 'Total expenses',
    adminStat_expenses_paid: 'Paid',
    adminStat_expenses_remaining: 'Remaining',
    adminStat_expenses_count: 'Count',
    adminStat_expenses_product: 'Product',
    adminStat_expenses_active_badge: 'Active',
    adminStat_expenses_archived_badge: 'Settled',
    adminStat_mijoz_branch_leaders: 'Top branches by sales',
    adminStat_nasiya_portfolio: 'Credit status',
    adminStat_nasiya_repaid_label: 'Repaid',
    adminStat_nasiya_remaining_label: 'Remaining',
    adminStat_tenant_owner_monthly_revenue: 'Last 6 months — sales',
    adminStat_top_products: 'Products — sales ranking',
    adminStat_top_products_unit: 'units',
    adminStat_top_sellers: 'Cashiers — sales ranking',
    adminStat_chartTitle: 'Orders by week',
    adminStat_insights: 'Summary',
    adminStat_unifiedRatingTitle: 'Consolidated rating statistics',
    adminStat_regionRatingTitle: 'Region rating',
    adminStat_dispatcherRatingTitle: 'Dispatcher rating',
    adminStat_managerRatingTitle: 'Manager rating',
    adminStat_byRegion_title: 'Statistics by region',
    adminStat_byRegion_region: 'Region',
    adminStat_byRegion_tenants: 'Tenants',
    adminStat_byRegion_orders: 'Orders (month)',
    adminStat_byRegion_revenue: 'Revenue (month)',
    adminStat_byRegion_growth: 'Growth %',
    adminStat_byRegion_branches: 'Branches',
    adminStat_byRegion_users: 'Active users',
    adminStat_byRegion_avgCheck: 'Avg. check',
    adminStat_byManager_title: 'Statistics by manager',
    adminStat_byManager_name: 'Manager',
    adminStat_byManager_region: 'Region',
    adminStat_byManager_role: 'Role',
    adminStat_byManager_orders: 'Orders (month)',
    adminStat_byManager_revenue: 'Revenue (month)',
    adminStat_byManager_rating: 'Rating',
    adminStat_byManager_satisfaction: 'Satisfaction %',
    adminStat_byManager_trend: 'Trend',
    adminStat_byManager_branches: 'Branches',
    adminStat_byManager_dispatchers: 'Dispatchers',
    adminStat_prevMonth: 'vs last month',
    adminStat_avgOrderValue: 'Avg. order value (UZS)',
    adminStat_conversionPercent: 'Conversion (lead → order)',
    adminStat_ordersToday: 'Orders today',
    adminStat_cancelledMonth: 'Cancelled (monthly)',
    adminStat_supportTicketsOpen: 'Open support tickets',
    adminStat_newRegistrationsMonth: 'New registrations (monthly)',
    adminStat_monthlyRevenue: 'Monthly revenue (6 months)',
    adminStat_weeklySalesByDay: 'Weekly sales volume',
    adminStat_weeklysalesbyday: 'Weekly sales volume',
    adminStat_topProductCategory: 'Top product category',
    adminStat_avgResponseHours: 'Avg. response time (hours)',
    adminStat_repeatOrdersPercent: 'Repeat orders (%)',
    month_jan: 'January',
    month_feb: 'February',
    month_mar: 'March',
    month_apr: 'April',
    month_may: 'May',
    month_jun: 'June',
    adminAdvice_subtitle: 'Quick guide and recommendations for business management, CRM and ERP. Below are practical tips for key areas.',
    adminAdvice_subtitle_mijoz: 'Practical recommendations for the client role: improve control of sales, profit, stock, and credit balance.',
    adminAdvice_subtitle_kassir: 'Practical recommendations for cashier role: checks, payments, printer stability, and shift discipline.',
    adminAdvice_subtitle_cashier: 'Practical recommendations for cashier role: checks, payments, printer stability, and shift discipline.',
    adminAdvice_subtitle_viloyat: 'Regional operations: orders, dispatchers, tenants, reports, and team performance.',
    maslahat_viloyat_title: 'Practical tips for regional managers',
    maslahat_viloyat_1: 'Review leads and orders daily—new, in progress, and delayed—and keep statuses up to date.',
    maslahat_viloyat_2: 'Short daily sync with dispatchers: open leads, late replies, and priority orders.',
    maslahat_viloyat_3: 'Monthly tenant overview: new sign-ups, activity, and support where needed.',
    maslahat_viloyat_4: 'Use internal chat for operational issues—decisions and ownership stay in one thread.',
    maslahat_viloyat_5: 'Export reports to Excel—archive files with date and region name.',
    maslahat_viloyat_6: 'Regional KPIs: order intake time, dispatcher ratings, client tickets—compare week over week.',
    maslahat_viloyat_7: 'Large amounts or special contracts—use a two-step approval to reduce errors.',
    maslahat_viloyat_8: 'Roles and access: for new staff or branches, grant only the menus they need.',
    adminAdvice_sales_title: 'Sales and orders',
    adminAdvice_sales_1: 'Review leads and orders by status regularly: new, re-contact, contract ready, closed. Update status at least once a day.',
    adminAdvice_sales_2: 'Shorten order handling time: dispatcher assigns lead to manager within 15 minutes, manager contacts client within 24 hours.',
    adminAdvice_sales_3: 'Assign an owner and deadline to each deal. Get a daily report on overdue orders.',
    adminAdvice_sales_4: 'Identify repeat orders — plan special terms or discounts for the most loyal customers.',
    adminAdvice_sales_5: 'Analyze the sales funnel: where customers drop off — improve the process there.',
    adminAdvice_warehouse_title: 'Warehouse and inventory',
    adminAdvice_warehouse_1: 'Set min (safety) and max stock levels per item. Enable automatic alerts in the system.',
    adminAdvice_warehouse_2: 'Plan stocktakes: for slow-moving items monthly, for fast-moving weekly or daily.',
    adminAdvice_warehouse_3: 'Standardize barcodes and SKUs — speeds up receiving and dispatch and reduces errors.',
    adminAdvice_warehouse_4: 'Track expiry dates: follow FEFO (first expiry, first out).',
    adminAdvice_warehouse_5: 'Record transfers and write-offs with document number and date — required for audit and reporting.',
    adminAdvice_finance_title: 'Finance and reporting',
    adminAdvice_finance_1: 'Group transactions by payment type and counterparty. Reconcile cash and bank with reports weekly.',
    adminAdvice_finance_2: 'Match invoices and payments: every payment linked to a document, maintain an overdue receivables list.',
    adminAdvice_finance_3: 'Set up tax and 1C integration — automatic report export reduces errors.',
    adminAdvice_finance_4: 'Review P&L and balance sheet monthly. Investigate causes of any sharp changes.',
    adminAdvice_finance_5: 'Export and archive regularly — all documents should be ready for audits.',
    adminAdvice_staff_title: 'Staff and performance',
    adminAdvice_staff_1: 'Define clear KPIs per role: sales — volume and new clients, dispatcher — order turnaround and complaints.',
    adminAdvice_staff_2: 'Keep ratings transparent and fair: motivate the team with weekly or monthly results.',
    adminAdvice_staff_3: 'Plan training and briefings — standard procedures help new staff get up to speed faster.',
    adminAdvice_staff_4: 'Distribute tasks by role: avoid overloading one person to prevent bottlenecks.',
    adminAdvice_staff_5: 'Capture feedback and complaints in writing and respond quickly — builds trust and efficiency.',
    adminAdvice_crm_title: 'Customers (CRM) and marketing',
    adminAdvice_crm_1: 'Segment customers: VIP, regular, new, dormant. Use different messaging and offers per segment.',
    adminAdvice_crm_2: 'Measure campaign results (SMS, push, email): opens, clicks, conversion. Optimize underperforming channels.',
    adminAdvice_crm_3: 'Run retention and churn analysis monthly — why they leave and how to win them back.',
    adminAdvice_crm_4: 'Use AI recommendations: test suggested segments and promotions.',
    adminAdvice_crm_5: 'Centralize complaints (e.g. support) and set a 24-hour response standard.',
    adminAdvice_general_title: 'General tips',
    adminAdvice_general_1: 'Back up data regularly and keep the system updated — for security and stability.',
    adminAdvice_general_2: 'Document settings and integrations: who uses which API keys and limits.',
    adminAdvice_general_3: 'Review audit and usage reports monthly — catch misuse early.',
    adminAdvice_general_4: 'Roll out new features in stages: pilot group first, then all users.',
    adminAdvice_general_5: 'Collect feedback and improve the help section — guides and support matter for full platform adoption.',
    adminAdvice_footer: 'The advice above is provided as a static guide. Priorities and settings may vary per business. Future updates will add AI-based personalised recommendations.',
    adminAdvice_developing: 'Under development',
    maslahat_top10_title: 'Top 10 tips',
    maslahat_mijoz_title: 'Recommendations for client role',
    maslahat_mijoz_1: 'Review daily sales, profit, and outstanding credit in one place.',
    maslahat_mijoz_2: 'Prioritize selling products with 3 days or less until expiry.',
    maslahat_mijoz_3: 'Compare stock and sales by branch to detect slow-moving items.',
    maslahat_mijoz_4: 'Before applying quick discount on a large check, verify margin.',
    maslahat_mijoz_5: 'At daily summary time, close cash, credit, and warehouse status.',
    maslahat_kassir_title: 'Recommendations for cashier role',
    maslahat_kassir_1: 'Before confirming sale, re-check product, quantity, and price in cart.',
    maslahat_kassir_2: 'Confirm payment method with customer before printing receipt.',
    maslahat_kassir_3: 'Use favorite products for speed; report out-of-stock items to warehouse quickly.',
    maslahat_kassir_4: 'If printer fails, verify connection and run a test receipt.',
    maslahat_kassir_5: 'At shift end, reconcile transactions and change before closing.',
    maslahat_level_zarur: 'Urgent',
    maslahat_level_muhim: 'Important',
    maslahat_level_keyinroq: 'Can do later',
    maslahat_top_1: 'Check leads and orders by status at least once a day. Update statuses in time.',
    maslahat_top_2: 'Dispatcher assigns lead to manager within 15 minutes; manager contacts client within 24 hours.',
    maslahat_top_3: 'Set min and max stock per item. Enable automatic alerts in the system.',
    maslahat_top_4: 'Match invoices and payments. Keep a weekly list of overdue receivables.',
    maslahat_top_5: 'Set clear KPIs per role. Keep ratings open and fair.',
    maslahat_top_6: 'Segment customers: VIP, regular, new. Tailor offers per segment.',
    maslahat_top_7: 'Back up data regularly and keep the system updated.',
    maslahat_top_8: 'Analyse the sales funnel — improve where customers drop off.',
    maslahat_top_9: 'Roll out new features to a pilot group first, then to everyone.',
    maslahat_top_10: 'Collect user feedback and improve the help section.',
    maslahat_chat_title: 'Ask AI',
    maslahat_ai_quota_monthly: 'Monthly questions: {used} / {max}',
    maslahat_ai_quota_exceeded: 'Monthly AI question limit reached. Continue next month or upgrade your plan.',
    maslahat_chat_placeholder: 'Type your question… Advice, reports or any other topic.',
    maslahat_chat_send: 'Send',
    maslahat_chat_you: 'You',
    maslahat_chat_demo_reply: 'Your question was received. AI reply will be shown when connected in a future update.',
    maslahat_chat_history_loading: 'Loading chat history…',
    maslahat_chat_thinking: 'Analyzing your data…',
    maslahat_chat_sending: 'Sending…',
    maslahat_chat_footer_hint: 'Answers use your ERP data (sales, orders, stock).',
    maslahat_chat_footer_hint_owner:
      'Answers use platform data (tenants, staff, credits, orders) via the SQL agent and JSON context. Do not paste secrets into chat.',
    maslahat_quick_platform_tenants: 'Active tenants + tariff',
    maslahat_quick_platform_tenants_prompt:
      'Show active subscription customers (tenants, status=active): Customer ID, name, tariff, and status as an SQL table.',
    maslahat_quick_platform_by_tariff: 'Count by tariff',
    maslahat_quick_platform_by_tariff_prompt:
      'Group active customers by tariff: tariff name and customer count (numbers only) as an SQL table.',
    maslahat_quick_platform_overview: 'Platform overview',
    maslahat_quick_platform_overview_prompt:
      'Platform overview metrics: active customers, trial, regional managers, open credits — SQL table.',
    maslahat_top10_loading: 'Loading recommendations…',
    maslahat_top10_error: 'Could not load recommendations. Fallback list below.',
    maslahat_top10_fallback_hint: 'Offline / fallback.',
    maslahat_chat_reply_empty: 'Empty reply. Please send again.',
    maslahat_chat_new: 'New chat',
    maslahat_chat_reload_history: 'Refresh history',
    maslahat_chat_load_more: 'Load more',
    maslahat_chat_offline: 'No network. Cannot send.',
    maslahat_quick_sales: 'Last 7 days sales and growth',
    maslahat_quick_stock: 'Zero or low stock SKUs',
    maslahat_quick_inventory_cost: 'Purchase price + stock',
    maslahat_quick_inventory_cost_prompt:
      'Show product purchase prices, current stock, and the 10 lowest-margin products from inventory.',
    maslahat_quick_debt: 'Receivables and open orders',
    maslahat_quick_orders: 'Orders in the last 30 days',
    maslahat_quick_summary: 'Short summary of today',
    maslahat_quick_data_scope: 'What data can you see in this chat?',
    maslahat_quick_stock_disabled_hint: 'No zero or negative stock SKUs in the current snapshot.',
    maslahat_quick_summary_disabled_hint: 'Not enough data for a meaningful summary.',
    maslahat_discuss_ai: 'Discuss with AI',
    maslahat_discuss_prefill: 'Expand recommendation #{rank}: «{text}». Answer only from my ERP JSON snapshot.',
    maslahat_snapshot_title: 'Data used for the reply',
    maslahat_snapshot_sales: '7-day sales (UZS)',
    maslahat_snapshot_growth: 'Week-over-week growth',
    maslahat_snapshot_orders: 'Orders (last 30 days)',
    maslahat_snapshot_top: 'Top products',
    maslahat_snapshot_oos: 'Out of stock',
    maslahat_snapshot_at: 'Updated',
    maslahat_snapshot_none: '—',
    maslahat_chat_typing: 'AI is typing…',
    maslahat_chat_loading_overlay: 'Preparing data and response…',
    maslahat_structured_reasons: 'Signals',
    maslahat_structured_actions: 'Next steps',
    maslahat_sql_query_btn: 'SQL Query',
    maslahat_sql_query_placeholder: 'Ask a precise question: "Which product sold most in the last 7 days?"',
    maslahat_sql_badge: 'Live data from DB',
    maslahat_sql_rows: 'rows returned',
    maslahat_sql_sending: 'Querying the database…',
    maslahat_sql_error_scope: 'The SQL agent does not apply to this question. Use the regular chat.',
    adminAdvice_subtitle_dispatcher: 'Sales, orders, and quick AI answers.',
    adminAdvice_subtitle_warehouse: 'Stock, turnover, and AI tips.',
    adminAdvice_subtitle_accountant: 'Finance metrics and reports.',
    adminAdvice_subtitle_analyst: 'Analytics, segments, and funnel with AI.',
    adminAdvice_subtitle_gm: 'KPI and strategic advice for leadership.',
    adminAdvice_subtitle_platform: 'Platform and project guidance.',
    adminAdvice_subtitle_owner_ai:
      'AI chat: tenants, plans and subscriptions, managers, dispatchers, credits and payments — answers using safe SQL SELECT and JSON context.',
    adminAdvice_subtitle_tenant_owner: 'Practical guidance for the store owner: branches, cashiers, sales, inventory, marketing, and finance workflows.',
    adminDashboard_subtitle: 'Jump to key areas in one click. System metrics load from the server when available.',
    adminDashboard_status_title: 'System status',
    adminDashboard_label_version: 'Version',
    adminDashboard_label_uptime: 'Uptime',
    adminDashboard_label_backup: 'Last backup',
    adminDashboard_label_db: 'Database',
    adminDashboard_quick_statistics_desc: 'Sales, branches, and KPI overview.',
    adminDashboard_quick_messages_desc: 'Client conversations and messages.',
    adminDashboard_quick_managers_desc: 'Regional and other manager administration.',
    adminDashboard_metrics_empty: 'No server data yet for system status cards. Other sections work as usual.',
    adminDashboard_help_hint: 'Commands and FAQs are in the Help section.',
    adminDashboard_quick_title: 'Quick access',
    adminDashboard_quick_settings_title: 'Settings',
    adminDashboard_quick_settings_desc: 'General settings, language, timezone and system parameters.',
    adminDashboard_quick_tariffs_title: 'Tariffs',
    adminDashboard_quick_tariffs_desc: 'Manage tariff plans, pricing and limits.',
    adminDashboard_quick_tenants_title: 'Clients',
    adminDashboard_quick_tenants_desc: 'Platform clients list, add and configure.',
    adminDashboard_quick_integrations_title: 'Integrations',
    adminDashboard_quick_integrations_desc: 'Connect external services, API and payment systems.',
    adminDashboard_quick_audit_title: 'Audit log',
    adminDashboard_quick_audit_desc: 'User actions and system events history.',
    adminDashboard_quick_apikeys_title: 'API keys',
    adminDashboard_quick_apikeys_desc: 'Create, update and limit API keys.',
    adminDashboard_activity_title: 'Recent activity',
    adminDashboard_activity_1: 'Login — 2025-02-05 09:15',
    adminDashboard_activity_2: 'Settings updated — tariff limits (2025-02-04 16:22)',
    adminDashboard_activity_3: 'New client added — "ABC MChJ" (2025-02-04 14:00)',
    adminDashboard_activity_4: 'Integration enabled — 1C (2025-02-03 11:30)',
    adminDashboard_activity_5: 'API key created — production (2025-02-02 10:15)',
    adminDashboard_activity_6: 'Audit export downloaded — 2025-02-01 17:45',
    adminDashboard_activity_7: 'Backup completed — 2025-02-05 03:00',
    adminDashboard_usage_title: 'Usage',
    adminDashboard_usage_requests: 'API requests (today)',
    adminDashboard_usage_sessions: 'Active sessions',
    adminDashboard_usage_storage: 'Storage used',
    adminDashboard_security_title: 'Security',
    adminDashboard_security_last_login: 'Last login',
    adminDashboard_security_failed: 'Failed attempts',
    adminDashboard_security_2fa: 'Two-factor authentication (2FA) is supported. Enabling it for all admins is recommended.',
    adminDashboard_docs_title: 'Documentation and support',
    adminDashboard_docs_text: 'Full administrator guide and API docs will be added in future updates. Contact support for questions.',
    adminHealth_subtitle: 'Detailed view of services, resources and recent events. All metrics are static sample data.',
    adminHealth_status_operational: 'Operational',
    adminHealth_status_degraded: 'Degraded',
    adminHealth_status_outage: 'Outage',
    adminHealth_overview_title: 'Overview',
    adminHealth_version: 'Version',
    adminHealth_uptime: 'Uptime',
    adminHealth_uptime_days: 'days',
    adminHealth_last_backup: 'Last backup',
    adminHealth_last_deploy: 'Last deploy',
    adminHealth_services_title: 'Services status',
    adminHealth_service_api: 'API server',
    adminHealth_service_database: 'Database',
    adminHealth_service_cache: 'Cache (Redis)',
    adminHealth_service_queue: 'Queue',
    adminHealth_service_storage: 'File storage',
    adminHealth_service_cdn: 'CDN',
    adminHealth_resources_title: 'Resources',
    adminHealth_resource_cpu: 'CPU',
    adminHealth_resource_memory: 'Memory (RAM)',
    adminHealth_resource_disk: 'Disk',
    adminHealth_incidents_title: 'Recent incidents',
    adminHealth_incidents_none: 'No incidents in the last 30 days. All systems are running normally.',
    adminHealth_resolved: 'Resolved',
    adminHealth_recommendations_title: 'Recommendations',
    adminHealth_recommend_1: 'Verify backups daily and run periodic restore tests.',
    adminHealth_recommend_2: 'Apply security updates on time and monitor logs.',
    adminHealth_recommend_3: 'Track disk and memory usage against plan; set alerts before hitting limits.',
    adminHealth_recommend_4: 'In case of incidents, check the audit log and error monitoring section.',
    adminHealth_footer: 'Data is static sample. Will update when monitoring backend is connected.',
    adminUsage_subtitle: 'Detailed metrics for API requests, active users, storage and tariff limits. All data is static sample.',
    adminUsage_period: 'Last 30 days',
    adminUsage_kpi_title: 'Key metrics',
    adminUsage_kpi_requests_total: 'API requests (total)',
    adminUsage_kpi_requests_today: 'Today',
    adminUsage_kpi_active_users: 'Active users',
    adminUsage_kpi_storage: 'Storage used',
    adminUsage_kpi_tenants: 'Clients',
    adminUsage_kpi_avg_response: 'Avg. response time',
    adminUsage_limits_title: 'Tariff limits',
    adminUsage_limit_api: 'API requests (monthly)',
    adminUsage_limit_storage: 'Storage',
    adminUsage_limit_users: 'Users',
    adminUsage_trend_title: 'Daily trend',
    adminUsage_trend_caption: 'Relative usage over the last 15 days (%).',
    adminUsage_endpoints_title: 'Top endpoints',
    adminUsage_endpoint_path: 'Endpoint',
    adminUsage_endpoint_method: 'Method',
    adminUsage_endpoint_count: 'Requests',
    adminUsage_footer: 'Metrics are static sample. Real reports and export will be added when backend is connected.',
    adminError_subtitle: 'System errors, their severity and source. All entries are static sample.',
    adminError_filter_all: 'All',
    adminError_severity_critical: 'Critical',
    adminError_severity_warning: 'Warning',
    adminError_severity_info: 'Info',
    adminError_summary_title: 'Summary (last 24h)',
    adminError_summary_24h: 'Errors (24h)',
    adminError_total: 'entries',
    adminError_time: 'Time',
    adminError_severity: 'Severity',
    adminError_message: 'Message',
    adminError_source: 'Source',
    adminError_endpoint: 'Endpoint',
    adminError_request_id: 'Request ID',
    adminError_status: 'Status',
    adminError_resolved: 'Resolved',
    adminError_new: 'New',
    adminError_source_api: 'API',
    adminError_source_auth: 'Auth',
    adminError_source_database: 'Database',
    adminError_source_worker: 'Worker',
    adminError_source_integration: 'Integration',
    adminError_msg_rate_limit: 'Request rate limit exceeded. Client temporarily throttled.',
    adminError_msg_validation: 'Validation error: invalid field values submitted.',
    adminError_msg_db_connection: 'Database connection timeout. Reconnection succeeded.',
    adminError_msg_token_expired: 'Access token expired. User re-authenticated.',
    adminError_msg_integration_timeout: 'External service (1C) did not respond. Timeout 30s.',
    adminError_msg_queue_delay: 'Queue delay: worker overload. Processed later.',
    adminError_msg_file_size: 'Uploaded file size exceeded limit (max 10 MB).',
    adminError_msg_payment_gateway: 'Payment gateway (Payme) temporarily unavailable. Payment confirmed later.',
    adminError_msg_memory_high: 'High server memory usage (85%+). Cache cleared.',
    adminError_msg_deprecated_api: 'Deprecated API version (v0) called. Migration to v1 recommended.',
    adminError_footer: 'Errors are static sample. Real monitoring and alerts when backend is connected.',
    adminApiKey_subtitle: 'Create, edit and manage API keys. Access for external systems and integrations.',
    adminApiKey_add: 'Add new',
    adminApiKey_name: 'Name',
    adminApiKey_key: 'Key',
    adminApiKey_environment: 'Environment',
    adminApiKey_scopes: 'Scopes',
    adminApiKey_created: 'Created',
    adminApiKey_expires: 'Expires',
    adminApiKey_status: 'Status',
    adminApiKey_actions: 'Actions',
    adminApiKey_edit: 'Edit',
    adminApiKey_delete: 'Delete',
    adminApiKey_empty: 'No API keys yet. Create the first one via "Add new".',
    adminApiKey_modal_add_title: 'New API key',
    adminApiKey_modal_edit_title: 'Edit API key',
    adminApiKey_name_placeholder: 'e.g. Production — main',
    adminApiKey_expires_placeholder: 'YYYY-MM-DD or empty (no expiry)',
    adminApiKey_cancel: 'Cancel',
    adminApiKey_save: 'Save',
    adminApiKey_confirm_delete_title: 'Delete API key',
    adminApiKey_confirm_delete_text: 'Delete this key',
    adminApiKey_env_production: 'Production',
    adminApiKey_env_staging: 'Staging',
    adminApiKey_status_active: 'Active',
    adminApiKey_status_revoked: 'Revoked',
    adminApiKey_scope_read: 'Read',
    adminApiKey_scope_write: 'Write',
    adminApiKey_scope_admin: 'Admin',
    adminManager_subtitle: 'List of head and regional managers. Responsible for branches, orders and reports.',
    adminManager_add: 'Add new',
    adminManager_total: 'managers',
    adminManager_name: 'Full name',
    adminManager_role: 'Role',
    adminManager_region: 'Region',
    adminManager_contact: 'Contact',
    adminManager_territory: 'Territory / branches',
    adminManager_status: 'Status',
    adminManager_joined: 'Joined',
    adminManager_actions: 'Actions',
    adminManager_edit: 'Edit',
    adminManager_delete: 'Delete',
    adminManager_empty: 'No managers yet. Add via "Add new".',
    adminManager_modal_add_title: 'New manager',
    adminManager_modal_edit_title: 'Edit manager',
    adminManager_name_placeholder: 'Full name',
    adminManager_region_placeholder: 'e.g. Tashkent, Samarkand',
    adminManager_territory_placeholder: 'e.g. Tashkent city — 12 branches',
    adminManager_note_placeholder: 'Additional note',
    adminManager_cancel: 'Cancel',
    adminManager_save: 'Save',
    adminManager_confirm_delete_title: 'Delete manager',
    adminManager_confirm_delete_text: 'Remove from list',
    adminManager_role_bosh_menejer: 'Head manager',
    adminManager_role_viloyat_menejer: 'Regional manager',
    adminManager_role_general_manager: 'Head manager',
    adminManager_role_regional_manager: 'Regional manager',
    adminManager_status_active: 'Active',
    adminManager_status_inactive: 'Inactive',
    adminManager_phone: 'Phone',
    adminManager_note: 'Note',
    adminBranch_subtitle: 'List of branches. Add, edit and delete.',
    adminBranch_add: 'Add branch',
    adminBranch_total: 'branches',
    adminBranch_name: 'Branch name',
    adminBranch_address: 'Address',
    adminBranch_responsible_name: 'Responsible employee',
    adminBranch_responsible_phone: 'Responsible phone',
    adminBranch_actions: 'Actions',
    adminBranch_edit: 'Edit',
    adminBranch_delete: 'Delete',
    adminBranch_empty: 'No branches yet. Add via "Add branch".',
    adminBranch_modal_add_title: 'New branch',
    adminBranch_modal_edit_title: 'Edit branch',
    adminBranch_name_placeholder: 'e.g. Tashkent branch',
    adminBranch_address_placeholder: 'Enter address',
    adminBranch_responsible_name_placeholder: 'Full name of responsible',
    adminBranch_responsible_phone_placeholder: '+998 90 123 45 67',
    adminBranch_cancel: 'Cancel',
    adminBranch_save: 'Save',
    adminBranch_confirm_delete_title: 'Delete branch',
    adminBranch_confirm_delete_text: 'Are you sure you want to delete branch',
    adminBranch_error_tenant_required: 'Client (tenant) is not set. Refresh your profile or sign in again.',
    adminBranch_yes: 'Yes',
    adminBranch_no: 'No',
    adminBranch_close: 'Close',
    adminCashier_subtitle: 'Cashiers list. Add, edit and delete. Cashier phone is used for login.',
    adminCashier_add: 'Add cashier',
    adminCashier_total: 'cashiers',
    adminCashier_name: 'Cashier name',
    adminCashier_fullName: 'Cashier',
    adminCashier_surname: 'Surname',
    adminCashier_phone: 'Cashier phone',
    adminCashier_name_placeholder: 'Full name',
    adminCashier_phone_placeholder: '+998 90 123 45 67',
    adminCashier_modal_add_title: 'New cashier',
    adminCashier_modal_edit_title: 'Edit cashier',
    adminCashier_confirm_delete_title: 'Delete cashier',
    adminCashier_confirm_delete_text: 'Are you sure you want to delete cashier',
    adminCashier_empty: 'No cashiers yet. Add via "Add cashier".',
    adminCashier_branch_placeholder: 'Select branch (required)',
    adminCashier_branches_empty_hint: 'No branches found. Add a branch under Branches first, or sign in again as the store owner.',
    adminCashier_my_branch: 'My branch',
    adminCashier_branch_products_scope: 'Add and edit actions apply only to this branch.',
    adminMarketing_cashier_lead:
      'Your branch: online shop link and online orders received for this branch.',
    adminMarketing_cashier_no_branch:
      'No branch is linked to your account. Contact an administrator — marketing orders are shown per branch.',
    adminMarketing_cashier_settings_note: 'Marketing settings (shop name, Telegram) are managed by the location owner.',
    adminMarketing_your_branch: 'Your branch',
    adminMarketing_no_branches: 'No branches found.',
    adminMarketing_orders_branch_title: 'Online orders (your branch)',
    adminMarketing_orders_hint_cashier: 'Only online (marketing) orders for this branch. Filter by date.',
    adminStaffWorkers_subtitle:
      'Staff: fixed monthly salary, branch and role. Each month KPIs are analyzed on the backend (AI) and a bonus percentage is proposed automatically.',
    adminStaffWorkers_add: 'Add employee',
    adminStaffWorkers_total: 'employees',
    adminStaffWorkers_name: 'Full name',
    adminStaffWorkers_position: 'Position',
    adminStaffWorkers_position_placeholder: 'e.g. sales, senior sales',
    adminStaffWorkers_monthly_salary: 'Fixed salary (UZS)',
    adminStaffWorkers_phone: 'Phone',
    adminStaffWorkers_phone_placeholder: '+998 …',
    adminStaffWorkers_modal_add: 'New employee',
    adminStaffWorkers_modal_edit: 'Edit employee',
    adminStaffWorkers_confirm_delete_title: 'Delete employee',
    adminStaffWorkers_confirm_delete_text: 'Remove this employee from the list',
    adminStaffWorkers_empty: 'No employees yet. Use “Add employee”.',
    adminStaffWorkers_empty_cashiers:
      'No cashiers found. Add cashiers in the Cashiers section — the staff list is built from them.',
    adminStaffWorkers_branch_placeholder: 'Select branch (required)',
    adminStaffWorkers_bonus_section: 'Monthly bonus (AI)',
    adminStaffWorkers_bonus_hint:
      'For the selected month the backend aggregates KPIs (sales, attendance, etc.); an LLM or rules engine suggests each employee’s bonus %. The button triggers a server-side recalculation.',
    adminStaffWorkers_year: 'Year',
    adminStaffWorkers_month: 'Month',
    adminStaffWorkers_run_ai: 'Run AI calculation',
    adminStaffWorkers_run_ai_loading: 'Calculating…',
    adminStaffWorkers_col_bonus_pct: 'Bonus %',
    adminStaffWorkers_col_bonus_amount: 'Bonus amount',
    adminStaffWorkers_col_monthly_sales: 'Monthly sales',
    adminStaffWorkers_ai_rationale: 'AI / rationale',
    adminStaffWorkers_status: 'Status',
    adminStaffWorkers_status_pending: 'Pending',
    adminStaffWorkers_status_ready: 'Ready',
    adminStaffWorkers_no_eval_yet: 'No evaluation for this month yet. Click “Run AI calculation”.',
    adminDispatcher_subtitle: 'List of dispatchers handling leads and orders. Assigned manager, rating and shift info.',
    adminDispatcher_subtitle_vm: 'Dispatchers in your region. Phone number is used as login.',
    adminDispatcher_phone_login: ' (login)',
    adminDispatcher_login_required: 'Enter dispatcher phone — it will be the login.',
    adminDispatcher_add: 'Add new',
    adminDispatcher_total: 'dispatchers',
    adminDispatcher_name: 'Full name',
    adminDispatcher_zone: 'Zone / area',
    adminDispatcher_contact: 'Contact',
    adminDispatcher_manager: 'Manager',
    adminDispatcher_orders: 'Orders (month)',
    adminDispatcher_status: 'Status',
    adminDispatcher_joined: 'Joined',
    adminDispatcher_actions: 'Actions',
    adminDispatcher_edit: 'Edit',
    adminDispatcher_delete: 'Delete',
    adminDispatcher_empty: 'No dispatchers yet. Add via "Add new".',
    adminDispatcher_modal_add_title: 'New dispatcher',
    adminDispatcher_modal_edit_title: 'Edit dispatcher',
    adminDispatcher_name_placeholder: 'Full name',
    adminDispatcher_zone_placeholder: 'e.g. Tashkent — center',
    adminDispatcher_manager_placeholder: 'Assigned manager full name',
    adminDispatcher_note_placeholder: 'Shift, task or other note',
    adminDispatcher_cancel: 'Cancel',
    adminDispatcher_save: 'Save',
    adminDispatcher_confirm_delete_title: 'Delete dispatcher',
    adminDispatcher_confirm_delete_text: 'Remove from list',
    adminDispatcher_status_active: 'Active',
    adminDispatcher_status_inactive: 'Inactive',
    adminDispatcher_phone: 'Phone',
    adminDispatcher_firstName: 'First name',
    adminDispatcher_lastName: 'Last name',
    adminDispatcher_firstName_ph: 'e.g. John',
    adminDispatcher_lastName_ph: 'e.g. Smith',
    adminDispatcher_select_manager: 'Regional manager',
    adminDispatcher_select_manager_ph: 'Select a manager',
    adminDispatcher_select_region: 'Region',
    adminDispatcher_select_region_ph: 'Select a region',
    adminDispatcher_manager_required: 'Select a regional manager first.',
    adminDispatcher_region_required: 'Select a region to link the dispatcher.',
    adminDispatcher_region_col: 'Region',
    adminDispatcher_note: 'Note',
    adminOrder_subtitle: 'List of orders across all regions. Track by client, manager, dispatcher and status.',
    adminOrder_subtitle_ega: 'List of all orders. Track by client, manager, dispatcher and status.',
    adminOrder_subtitle_vm: 'Orders for your region. Track by client, dispatcher and status.',
    adminOrder_subtitle_disp: 'Statuses: New, Rejected, or Sent to manager. «Convert to client» marks as sent to manager; otherwise only reject is available.',
    adminOrder_number: 'Number',
    adminOrder_client: 'Client',
    adminOrder_region: 'Region',
    adminOrder_manager: 'Manager',
    adminOrder_dispatcher: 'Dispatcher',
    adminOrder_business_type: 'Business Type',
    adminOrder_tariff: 'Tariff',
    adminOrder_amount: 'Amount',
    adminOrder_status: 'Status',
    adminOrder_created: 'Date',
    adminOrder_note: 'Note',
    adminOrder_summary_total: 'Total amount',
    adminOrder_summary_count: 'orders',
    adminOrder_period: 'Last 30 days',
    adminOrder_empty: 'No orders.',
    adminOrder_actions: 'Actions',
    adminOrder_convert_to_tenant: 'Convert to client',
    adminOrder_convert_title: 'Convert order to client',
    adminOrder_convert_subtitle: 'Creates a platform client from this main-site order.',
    adminOrder_convert_submit: 'Create client',
    adminOrder_convert_validation: 'Enter email, address, and a password of at least 6 characters.',
    adminOrder_disp_status_new: 'New',
    adminOrder_disp_status_rejected: 'Rejected',
    adminOrder_disp_status_sent: 'Sent to manager',
    adminOrder_reject_btn: 'Reject',
    adminOrder_reject_confirm: 'Reject this order?',
    adminOrder_company_short: 'Company',
    cashierKassa_subtitle: 'Add items, select payment, print.',
    cashierKassa_search_placeholder: 'Barcode, marking code or product name',
    cashierKassa_pos_qty_active: 'Quantity mode',
    cashierKassa_pos_amount_active: 'Free price mode',
    cashierKassa_pos_press_enter: 'press Enter',
    cashierKassa_pos_search_then_enter: 'search product first, then Enter',
    cashierKassa_pos_prefix_hint: 'Search product first (e.g. tea), then type 15+ or 19.000* and Enter',
    cashierKassa_pos_prefix_apply_failed: 'Could not update the last line. Check quantity or price.',
    cashierKassa_pos_not_found: 'Product not found. Check the name or pick from the list.',
    cashierKassa_scan_barcode: 'Scan barcode',
    cashierKassa_scan_title: 'Scan barcode',
    cashierKassa_scan_close: 'Close',
    cashierKassa_choose_variant: 'Choose unit or variant',
    cashierKassa_scan_added: 'Added to cart',
    cashierKassa_cart: 'Cart',
    cashierKassa_cart_empty: 'Cart is empty.',
    cashierKassa_cart_default: 'Cart 1',
    cashierKassa_cart_tab: 'Cart',
    cashierKassa_cart_current: 'Current cart',
    cashierKassa_col_variant_measure: 'Variant / unit',
    cashierKassa_new_cart: 'New cart',
    cashierKassa_other_carts: 'Other carts',
    cashierKassa_cart_select: 'Select',
    cashierKassa_more: 'more',
    cashierKassa_stock_empty: 'No stock in warehouse.',
    cashierKassa_stock_limit: 'Insufficient stock. Available: ',
    cashierKassa_stock_available: 'Available',
    cashierKassa_stock_total: 'Total stock',
    cashierKassa_stock_total_short: 'Stock',
    cashierKassa_stock_pcs: 'pcs',
    cashierKassa_total: 'Total',
    cashierKassa_no_discount: 'No discount',
    cashierKassa_discount_applied: 'Discount',
    cashierKassa_favorites_title: 'Favorite products',
    cashierKassa_favorites_empty: 'No favorite products yet. Star products in warehouse.',
    cashierKassa_search_results_title: 'Search results',
    cashierKassa_search_empty: 'No products found for your search.',
    cashierKassa_amount_qty_no_price: 'Unit price is required to add quantity by amount.',
    cashierKassa_amount_free_price_only: 'Amount (*) works only for free-price products.',
    cashierKassa_remove: 'Remove',
    cashierKassa_to_payment: 'Proceed to payment',
    cashierKassa_print_before_payment: 'Print receipt',
    cashierKassa_draft_receipt: 'Draft receipt',
    cashierKassa_select_payment: 'Select payment method',
    cashierKassa_cash: 'Cash',
    cashierKassa_card: 'Card',
    cashierKassa_click: 'Click',
    cashierKassa_discount_profit_blocked: 'This discount cannot be applied (exceeds profit and drops below cost).',
    cashierKassa_nasiya: 'Installment',
    cashierKassa_aralash: 'Split payment',
    cashierKassa_nasiya_client: 'Installment: customer name and phone (from cart)',
    cashierKassa_client_name: 'Customer name',
    cashierKassa_client_phone: 'Phone',
    cashierKassa_buyer_block_title: 'Customer on this cart',
    cashierKassa_buyer_hint: 'Search by name or phone; picking a row links this customer.',
    cashierKassa_buyer_new: 'New customer (saved by phone)',
    cashierKassa_supplier: 'Supplier',
    cashierKassa_supplier_suggest: 'Suppliers',
    cashierKassa_supplier_phone_missing: 'No phone number',
    cashierKassa_supplier_found: 'Supplier found',
    cashierKassa_supplier_balance: 'Outstanding balance',
    cashierKassa_supplier_cover_expense: 'Cover expense',
    cashierKassa_expense_cover_btn: 'Expense settlement',
    cashierKassa_supplier_as_retail: 'As retail customer',
    cashierKassa_supplier_no_account: 'Supplier account not found: edit the product and link the supplier to cover expenses.',
    cashierKassa_free_trade: 'Custom price',
    cashierKassa_free_trade_hint: 'When on, picking a product asks for a price (qty unchanged).',
    cashierKassa_price_modal_title: 'Sale price',
    cashierKassa_price_modal_label: 'Price (UZS)',
    cashierKassa_price_modal_add: 'Add to cart',
    cashierKassa_line_discount_label: 'Line discount (%)',
    cashierKassa_cart_edit_title_piece: 'Line: qty, price, discount',
    cashierKassa_cart_edit_piece_hint: 'Piece item: quantity, optional custom price, per-line discount (UZS).',
    cashierKassa_variable_price_total: 'Variable price',
    cashierKassa_cart_line_discount_badge: 'discount',
    cashierKassa_line_discount_too_high: 'Discount cannot exceed the line gross amount.',
    cashierKassa_back: 'Back',
    cashierKassa_confirm: 'Confirm',
    cashierKassa_confirm_print: 'Confirm and print',
    cashierKassa_payment_method: 'Payment method',
    cashierKassa_confirm_and_print: 'Confirm and print',
    cashierKassa_printing: 'Printing…',
    cashierKassa_order_saved: 'Order saved (offline).',
    cashierKassa_order_saved_synced: 'Order saved.',
    cashierKassa_sync_failed_title: 'Sync failed',
    cashierKassa_sync_failed_body: 'Order was saved offline. Please check your internet connection and try syncing again later.',
    cashierKassa_sync_error_403:
      'The server rejected this request for your role (403). Ask an admin to allow cashiers to POST /api/sync/orders.',
    cashierKassa_sync_error_detail: 'Details',
    cashierOrderHistory_subtitle: 'Recent transactions. Sync status.',
    cashierOrderHistory_refresh: 'Refresh',
    cashierOrderHistory_empty: 'No orders yet.',
    cashierOrderHistory_synced: 'Synced',
    cashierOrderHistory_pending: 'Pending',
    cashierPayments_subtitle: 'Daily shift, X/Z reports, cash and card.',
    cashierPayments_today: 'Today’s shift',
    cashierPayments_reports: 'Reports',
    cashierPayments_x_report_hint: 'X-Report — interim report without closing shift.',
    cashierPayments_z_report_hint: 'Z-Report — final report when closing shift.',
    cashierPayments_backend_note: 'Real data will appear when backend is connected.',
    cashierZReport_subtitle: 'Daily shift closing report — your sales only',
    cashierZReport_sales_total: 'Total sales',
    cashierZReport_sales_count: 'sales',
    cashierZReport_average_check: 'Average check',
    cashierZReport_payment_types: 'Payment types',
    cashierZReport_operations: 'operations',
    cashierZReport_nasiya_issued: 'Issued today',
    cashierZReport_nasiya_repaid: 'Repaid today',
    cashierZReport_active_credits: 'active credits',
    cashierZReport_footnote: 'Z-Report — end-of-shift summary. Data is scoped to the current cashier only.',
    cashierZReport_send_to_owner: 'Send to owner',
    cashierZReport_sent_success: 'Z-Report sent to owner',
    ownerZReport_subtitle: 'Daily Z-Reports submitted by cashiers — filter by date',
    ownerZReport_reports_count: 'Submitted reports',
    ownerZReport_empty: 'No Z-Report found for the selected date.',
    adminNav_owner_z_reports: 'Z-Report',
    adminRefresh: 'Refresh',
    adminCashier_permissions: 'Cashier permissions',
    adminCashier_perm_products: 'Add / edit / delete products',
    adminCashier_perm_barcode: 'Add barcode to existing product',
    adminCashier_perm_add_only: 'Add products only (new + stock to existing)',
    adminCashier_add_to_existing_product: 'Add to existing product',
    adminNav_product_audit: 'Product audit',
    adminProductAudit_subtitle: 'History of products added, edited, or removed by cashiers',
    adminProductAudit_action_created: 'Created',
    adminProductAudit_action_updated: 'Updated',
    adminProductAudit_action_deleted: 'Deleted',
    adminProductAudit_filter_action: 'Action type',
    adminProductAudit_all_actions: 'All actions',
    adminProductAudit_summary_added: 'Added',
    adminProductAudit_summary_updated: 'Updated',
    adminProductAudit_summary_deleted: 'Deleted',
    adminProductAudit_col_product: 'Product',
    adminProductAudit_col_action: 'Action',
    adminProductAudit_col_cashier: 'Cashier',
    adminProductAudit_col_branch: 'Branch',
    adminProductAudit_col_date: 'Date',
    adminProductAudit_empty: 'No records for the selected filters',
    adminProductAudit_date_from: 'From date',
    adminProductAudit_date_to: 'To date',
    adminProductAudit_total: 'Total records',
    adminProductAudit_filter_branch: 'Branch name',
    adminProductAudit_filter_cashier: 'Cashier full name',
    adminProductAudit_col_details: 'Details',
    adminProductAudit_qty: 'Quantity',
    adminProductAudit_purchase: 'Purchase price',
    adminProductAudit_sale: 'Sale price',
    adminTrans_all_branches: 'All branches',
    adminTrans_all_cashiers: 'All cashiers',
    cashierKassa_mixed_remaining: 'Remaining amount',
    cashierKassa_cashback_use: 'Use cashback balance',
    cashierKassa_cashback_balance: 'Balance',
    cashierKassa_cashback_amount_ph: 'Amount',
    cashierKassa_cashback_use_all: 'Use all',
    cashierKassa_cashback_applied: 'Cashback',
    cashierKassa_cashback_pay_remaining: 'To pay',
    cashierKassa_mixed_after_cashback: 'Remaining to pay',
    adminCashier_branch_products_view_only: 'View only — stock for your branch',
    adminOmbor_tenant_fav_select_all: 'Select all',
    adminOmbor_tenant_fav_clear_all: 'Clear all selections',
    adminOmbor_col_free_price: 'Free price',
    adminOmbor_free_price_enable_all: 'Enable free price for all',
    adminOmbor_free_price_disable_all: 'Disable free price for all',
    adminOmbor_free_price_enable_row: 'Enable free price',
    adminOmbor_free_price_disable_row: 'Disable free price',
    adminOmbor_free_price_toggle_error: 'Could not update free price',
    adminOmbor_free_price_bulk_partial: 'Partially updated',
    adminOmbor_free_price_bulk_skipped_hint: '{updated} updated. {skipped} skipped — no sale price.',
    cashierProducts_subtitle: 'Products: add, edit, delete. Barcode auto-generated if empty.',
    cashierProducts_search_placeholder: 'Search by name, barcode, marking code, ID',
    cashierProducts_add: 'Add product',
    cashierProducts_edit: 'Edit',
    cashierProducts_name: 'Name',
    cashierProducts_name_placeholder: 'Product name',
    cashierProducts_quantity: 'Quantity',
    cashierProducts_purchase_price: 'Purchase price',
    cashierProducts_sale_price: 'Sale price',
    cashierProducts_barcode: 'Barcode',
    cashierProducts_marking_code: 'Marking / traceability',
    cashierProducts_marking_hint: 'optional; Data Matrix / GS1 scan at POS',
    cashierProducts_barcode_auto: 'auto if empty',
    cashierProducts_empty: 'No products.',
    cashierProducts_free_trade_suffix: 'free price',
    cashierProducts_free_price: 'Free price',
    cashierProducts_sale_modes: 'Additional units and variants',
    cashierProducts_additional_sale_options: 'Additional units/variants',
    cashierProducts_add_sale_option: 'Add additional unit',
    cashierProducts_size_label: 'Size (e.g. 41)',
    cashierProducts_option_label_optional: 'Label (optional)',
    cashierProducts_add_variant: 'Add variant',
    cashierProducts_color_label: 'Color (e.g. black)',
    cashierProducts_variant_barcode: 'Variant barcode (optional)',
    cashierProducts_expense_paid: 'Paid',
    cashierProducts_unit_factor: 'How many to deduct per 1 sale (in base unit)',
    adminSettings_pwa_cashier: 'PWA / Cashier settings',
    adminSettings_pwa_cashier_desc: 'Printer and language — local settings.',
    adminSettings_printer: 'Printer',
    adminSettings_printer_browser: 'Browser (Print)',
    adminSettings_printer_default: 'System default',
    adminHelp_telegram: 'Telegram',
    adminHelp_telegram_link: 'Support bot',
    adminLead_subtitle: 'Leads assigned to you. Source, status and handover to manager.',
    adminLead_subtitle_dispatcher: 'Search clients (phone, etc.), send a request (complaint, suggestion) — it goes to the regional manager’s Requests section.',
    adminLead_subtitle_regional: 'Sales in your region. Dispatcher messages and escalation statuses are managed here.',
    adminLead_summary_total: 'Total leads',
    adminLead_summary_total_dispatcher: 'Total records',
    adminLead_summary_count: 'leads',
    adminLead_code: 'Code',
    adminLead_client: 'Client',
    adminLead_region: 'Region',
    adminLead_source: 'Source',
    adminLead_status: 'Status',
    adminLead_priority: 'Priority',
    adminLead_manager: 'Manager',
    adminLead_estimated: 'Est. amount',
    adminLead_created: 'Date',
    adminLead_note: 'Note',
    adminLead_create_title: 'Create lead',
    adminLead_create_subtitle: 'Also sends to orders when created.',
    adminLead_create_submit: 'Create lead',
    adminLead_create_submitting: 'Creating...',
    adminLead_create_error: 'Could not create lead.',
    adminLead_empty: 'No leads.',
    adminLead_empty_dispatcher: 'No records yet.',
    adminLead_filter_empty: 'No leads match the filters.',
    adminLead_filter_empty_dispatcher: 'No records match your search or filters.',
    adminLead_empty_regional: 'No sales records for your region.',
    adminLead_actions: 'Actions',
    adminLead_escalate_btn: 'Escalate',
    adminLead_escalate_modal_title: 'Message to regional manager',
    adminLead_escalate_message_label: 'Issue or message',
    adminLead_escalate_message_ph: 'Client situation, search result, or question that needs resolution...',
    adminLead_search_placeholder: 'Search by phone, code, name, note, region',
    adminLead_escalate_kind_label: 'Request type',
    adminLead_escalate_kind_general: 'Other / message',
    adminLead_escalate_kind_complaint: 'Complaint',
    adminLead_escalate_kind_suggestion: 'Suggestion',
    adminLead_escalate_kind_tariff_plan_change: 'Tariff change request',
    adminLead_tariff_change_intro: 'The client submitted a tariff plan change request.',
    adminLead_tariff_change_current: 'Current plan',
    adminLead_tariff_change_desired: 'Requested plan',
    adminLead_tariff_change_note: 'Note',
    adminLead_tariff_change_company: 'Organization',
    adminLead_tariff_change_phone: 'Phone',
    adminLead_tariff_change_dispatcher_note: 'Dispatcher note',
    adminLead_forward_tariff_hint: 'Client tariff change request. Review and forward to the regional manager.',
    adminLead_forward_to_manager: 'Send to manager',
    adminLead_forward_note_label: 'Note to manager (optional)',
    adminLead_forward_note_ph: 'E.g. contacted the client, confirmation needed…',
    notif_tenant_tariff_change_dispatcher_title: 'Client tariff change request',
    notif_tenant_tariff_change_dispatcher_body: 'Open Leads and forward to the manager.',
    adminLead_escalate_cancel: 'Cancel',
    adminLead_escalate_submit: 'Send to manager',
    adminLead_escalate_sending: 'Sending...',
    adminLead_escalations_review: 'Escalations',
    adminLead_escalations_modal_title: 'Escalations',
    adminLead_escalations_loading: 'Loading...',
    adminLead_escalations_none: 'No escalations for this sale.',
    adminLead_escalation_status_select: 'Escalation status',
    adminLead_escalation_resolution_ph: 'Resolution or note',
    adminLead_escalation_save: 'Save',
    adminLead_escalation_status_open: 'Open',
    adminLead_escalation_status_in_progress: 'In progress',
    adminLead_escalation_status_resolved: 'Resolved',
    adminLead_escalation_status_declined: 'Declined',
    adminLead_escalation_status_closed: 'Closed',
    adminLead_escalation_col_latest: 'Latest escalation',
    adminLead_escalation_view: 'View',
    adminLead_escalation_view_title: 'Escalations and manager replies',
    adminLead_escalation_view_close: 'Close',
    adminLead_escalation_dp_msg: 'Dispatcher',
    adminLead_escalation_manager_reply: 'Manager reply',
    adminLead_escalation_resolved_at: 'Resolved',
    adminLead_escalation_no_manager_reply_yet: 'No manager reply yet.',
    adminLead_escalation_open_hint: 'Open escalations count',
    adminLead_escalation_pending_banner:
      'Note: there is an open or in-progress escalation. Review the history and manager reply below before sending a new message.',
    adminLead_escalation_prior_title: 'Previous escalations',
    adminLead_status_new: 'New',
    adminLead_status_contacted: 'Contacted',
    adminLead_status_qualified: 'Qualified',
    adminLead_status_assigned: 'Assigned',
    adminLead_status_converted: 'Converted',
    adminLead_status_cancelled: 'Cancelled',
    adminLead_source_site: 'Site',
    adminLead_source_phone: 'Phone',
    adminLead_source_telegram: 'Telegram',
    adminLead_source_referral: 'Referral',
    adminLead_source_other: 'Other',
    adminLead_priority_low: 'Low',
    adminLead_priority_normal: 'Normal',
    adminLead_priority_high: 'High',
    adminOrder_status_new: 'New',
    adminOrder_status_contacted: 'Contacted',
    adminOrder_status_negotiation: 'Negotiation',
    adminOrder_status_confirmed: 'Confirmed',
    adminOrder_status_in_delivery: 'In delivery',
    adminOrder_status_completed: 'Completed',
    adminOrder_status_cancelled: 'Cancelled',
    adminNotif_subtitle: 'System and business notifications. Orders, reports and system messages.',
    adminNotif_subtitle_vm: 'Notifications for your region. Orders and reports.',
    adminNotif_subtitle_disp: 'Notifications for sales and orders assigned to you.',
    adminNotif_subtitle_mijoz: 'Chat and system notifications. Support replies also appear here.',
    adminNotif_unread: 'unread',
    adminNotif_total: 'total',
    adminNotif_empty: 'No notifications.',
    notif_order_new_title: 'New order',
    notif_order_new_body: 'A new order was received. Review and assign to a manager.',
    notif_order_status_title: 'Order status changed',
    notif_order_status_body: 'Order has moved to delivery. Keep in touch with the client.',
    notif_lead_escalation_title: 'Dispatcher escalation',
    notif_lead_escalation_body: 'New client request. Update the status in Requests.',
    notif_lead_assigned_title: 'Lead assigned to manager',
    notif_lead_assigned_body: 'New lead assigned to responsible manager. Contact within 24 hours.',
    notif_report_title: 'Report ready',
    notif_report_body: 'Monthly report is ready to download. Go to Reports section.',
    notif_system_title: 'System message',
    notif_system_body: 'Daily backup completed successfully. Data saved.',
    notif_reminder_title: 'Reminder: rating report',
    notif_reminder_body: 'Weekly managers and dispatchers rating is ready. See Rating section.',
    notif_alert_title: 'Order cancelled',
    notif_alert_body: 'Client cancelled the order. Find out the reason and record in report.',
    notif_order_completed_title: 'Order delivered',
    notif_order_completed_body: 'Order successfully delivered and accepted by client.',
    adminReports_subtitle: 'Report templates for sales, orders, managers and dispatchers. Download history.',
    adminReports_subtitle_vm: 'Regional report templates: sales, orders, dispatchers and KPI.',
    adminReports_subtitle_bm: 'Cross-regional reports: sales, orders, managers, and dispatchers.',
    adminReports_subtitle_mijoz: 'Analytics: sales, margin, branches, and products for the selected period.',
    adminReports_templates_title: 'Report templates',
    adminReports_templates_count: 'Templates',
    adminReports_last: 'Last download',
    adminReports_period: 'Period',
    adminReports_last_generated: 'Last generated',
    adminReports_status_ready: 'Ready',
    adminReports_status_generating: 'Generating',
    adminReports_status_failed: 'Failed',
    adminReports_history_title: 'Recent reports',
    adminReports_history_report: 'Report',
    adminReports_history_period: 'Period',
    adminReports_history_format: 'Format',
    adminReports_history_generated: 'Generated',
    adminReports_history_by: 'By',
    adminReports_history_size: 'Size',
    adminReports_em_dash: '—',
    adminReports_region_unknown: 'Region (not set on profile)',
    adminReports_vm_region_label: 'Your region:',
    adminReports_summary_vm_scope: 'All templates and history are scoped to your region. Data syncs from the backend.',
    report_vm_period_last_month: 'last month',
    report_vm_period_last_week: 'last week',
    report_vm_period_current_month: 'current month',
    report_vm_period_active_tenants: 'active clients',
    report_vm_period_last_30_days: 'last 30 days',
    adminReports_period_today: 'Today',
    adminReports_period_week: 'Week',
    adminReports_period_month: 'Month',
    adminRating_period_label: 'Period',
    adminReports_period_custom: 'Custom period',
    adminReports_mijoz_snapshot_hint: 'Sales, margin and products for the selected period and branch — data matches server filters.',
    adminReports_branch_unassigned: 'Branch not assigned',
    adminReports_payment_terminal: 'Terminal / transfer',
    adminReports_filter_all_branches: 'All branches',
    adminReports_download_excel: 'Excel (XLSX)',
    adminReports_download_pdf: 'PDF',
    adminReports_download_csv: 'CSV',
    adminReports_download_unavailable: 'This export format is not available',
    adminReports_download_pdf_only: 'This template is PDF-only for now — Excel export coming soon',
    adminReports_mijoz_download_csv: 'Download report as CSV (open in Excel)',
    adminReports_mijoz_download_xlsx: 'Download report as Excel (XLSX)',
    adminReports_mijoz_xlsx_title: 'Analytics report',
    adminReports_filter_period_aria: 'Report period',
    adminReports_filter_branch_aria: 'Branch filter',
    adminReports_filter_date_from: 'Start date',
    adminReports_filter_date_to: 'End date',
    adminReports_product_subtitle: 'Unit / variant',
    adminReports_total_sales: 'Total sales',
    adminReports_net_profit: 'Net profit',
    adminReports_net_profit_hint: 'Installment excluded',
    adminReports_net_profit_hint_nasiya: 'Installment sales margin',
    adminReports_net_profit_hint_all: 'Margin across all payment types',
    adminReports_nasiya_total: 'Credit sales',
    adminReports_nasiya_covered: 'Covered',
    adminReports_items_sold: 'Items sold',
    adminReports_branch_cashiers: 'Cashiers',
    adminReports_sales_amount: 'Sales amount',
    adminReports_by_payment: 'By payment type',
    report_sales_monthly_name: 'Monthly sales report',
    report_sales_monthly_desc: 'Sales, revenue and growth by region and category.',
    report_sales_monthly_region_desc: 'Monthly sales and revenue for your region.',
    report_orders_region_name: 'Orders by region',
    report_orders_region_desc: 'Order count, amount and status distribution by region.',
    report_orders_region_vm_desc: 'Orders, amount and status distribution for your region.',
    report_managers_name: 'Managers performance',
    report_managers_desc: 'Managers rating, orders and customer satisfaction metrics.',
    report_dispatchers_name: 'Dispatchers performance',
    report_dispatchers_desc: 'Dispatchers rating, response time and completed orders.',
    report_dispatchers_region_desc: 'Regional dispatchers rating, response time and orders.',
    report_revenue_name: 'Revenue summary',
    report_revenue_desc: 'Brief report on revenue, expenses and profit for the month.',
    report_revenue_region_desc: 'Monthly revenue and brief report for your region.',
    report_kpi_name: 'KPI dashboard',
    report_kpi_desc: 'Key KPI metrics: orders, revenue, conversion and more.',
    report_kpi_region_desc: 'Regional KPI: orders, revenue, conversion.',
    report_leads_region_name: 'Leads (region)',
    report_leads_region_desc: 'Regional leads: source, status, dispatcher.',
    report_tenants_dir_name: 'Client directory',
    report_tenants_dir_desc: 'Regional tenants: company, contact, status.',
    report_orders_detail_vm_name: 'Orders detail',
    report_orders_detail_vm_desc: 'Regional orders: client, dispatcher, amount, status.',
    adminRating_subtitle: 'Manager performance and customer satisfaction rating. Scores, orders and trend.',
    adminRating_summary_title: 'Summary',
    adminRating_best_score: 'Best score',
    adminRating_average_score: 'Average score',
    adminRating_total_evaluated: 'Evaluated',
    adminRating_managers: 'managers',
    adminRating_top_region: 'Top region',
    adminRating_out_of: 'out of 100',
    adminRating_table_title: 'Manager rating',
    adminRating_rank: 'Rank',
    adminRating_name: 'Manager',
    adminRating_region: 'Region',
    adminRating_score: 'Score',
    adminRating_orders: 'Orders',
    adminRating_satisfaction: 'Satisfaction',
    adminRating_change: 'Change',
    adminRating_trend_up: 'Up',
    adminRating_trend_down: 'Down',
    adminRating_trend_neutral: 'No change',
    adminRating_footer: 'Rating is static sample. Actual scores and reports when backend is connected.',
    adminRatingTenants_subtitle: 'Customer rating by sales volume',
    adminRatingTenants_summary_title: 'Summary statistics',
    adminRatingTenants_total_sales: 'Total sales volume',
    adminRatingTenants_average_sales: 'Average sales volume',
    adminRatingTenants_total_tenants: 'Total customers',
    adminRatingTenants_companies: 'companies',
    adminRatingTenants_top_region: 'Top region',
    adminRatingTenants_top_tenant: 'Top customer',
    adminRatingTenants_table_title: 'Customer rating',
    adminRatingTenants_rank: 'Rank',
    adminRatingTenants_company: 'Company',
    adminRatingTenants_region: 'Region',
    adminRatingTenants_district: 'District',
    adminRatingTenants_sales_volume: 'Sales volume',
    adminRatingTenants_orders_count: 'Orders count',
    adminRatingTenants_avg_order: 'Average order',
    adminRatingTenants_growth: 'Growth',
    adminRatingTenants_footer: 'Rating is calculated by sales volume',
    adminRatingDisp_subtitle: 'Dispatcher rating: lead and order handling, response time and customer satisfaction.',
    adminRatingDisp_summary_title: 'Summary',
    adminRatingDisp_best_score: 'Best score',
    adminRatingDisp_average_score: 'Average score',
    adminRatingDisp_total_evaluated: 'Evaluated',
    adminRatingDisp_dispatchers: 'dispatchers',
    adminRatingDisp_top_zone: 'Top zone',
    adminRatingDisp_out_of: 'out of 100',
    adminRatingDisp_table_title: 'Dispatcher rating',
    adminRatingDisp_rank: 'Rank',
    adminRatingDisp_name: 'Dispatcher',
    adminRatingDisp_zone: 'Zone',
    adminRatingDisp_manager: 'Manager',
    adminRatingDisp_score: 'Score',
    adminRatingDisp_orders: 'Orders (month)',
    adminRatingDisp_response: 'Response time',
    adminRatingDisp_satisfaction: 'Satisfaction',
    adminRatingDisp_change: 'Change',
    adminRatingDisp_min: 'min',
    adminRatingDisp_trend_up: 'Up',
    adminRatingDisp_trend_down: 'Down',
    adminRatingDisp_trend_neutral: 'No change',
    adminRatingDisp_footer: 'Dispatcher rating is static sample. Updates when backend is connected.',
    adminFinance_subtitle: 'Revenue, expenses, cash and bank balance, payment types and recent transactions. All data is static sample.',
    adminFinance_overview_title: 'Overview',
    adminFinance_revenue: 'Monthly revenue',
    adminFinance_expenses: 'Monthly expenses',
    adminFinance_profit: 'Net profit',
    adminFinance_cash: 'Cash balance',
    adminFinance_bank: 'Bank balance',
    adminFinance_vs_prev: 'vs previous month',
    adminFinance_payment_title: 'By payment type',
    adminFinance_payment_cash: 'Cash',
    adminFinance_payment_card: 'Card',
    adminFinance_payment_transfer: 'Transfer',
    adminFinance_transactions_title: 'Recent transactions',
    adminFinance_date: 'Date',
    adminFinance_type: 'Type',
    adminFinance_counterparty: 'Counterparty',
    adminFinance_amount: 'Amount',
    adminFinance_payment_type: 'Payment type',
    adminFinance_description: 'Description',
    adminFinance_income: 'Income',
    adminFinance_expense: 'Expense',
    adminFinance_footer: 'Finance data is static sample. 1C integration and export when backend is connected.',
    adminTrans_subtitle: 'All income and expense transactions, filtering and summary. Data is static sample.',
    adminTrans_subtitle_live: 'All income and expense transactions, filtering and summary. Live data from server.',
    adminTrans_filter_all: 'All',
    adminTrans_income: 'Income',
    adminTrans_expense: 'Expense',
    adminTrans_status_all: 'All statuses',
    adminTrans_status_completed: 'Completed',
    adminTrans_status_pending: 'Pending',
    adminTrans_status_failed: 'Failed',
    adminTrans_summary_title: 'Summary',
    adminTrans_total_income: 'Total income',
    adminTrans_total_expense: 'Total expense',
    adminTrans_count: 'Transaction count',
    adminTrans_transactions: 'transactions',
    adminTrans_shown: 'shown',
    adminTrans_group_legacy: 'Previous sales',
    adminTrans_group_today: 'Today',
    adminTrans_number: 'No.',
    adminTrans_date: 'Date',
    adminTrans_date_from: 'From date',
    adminTrans_date_to: 'To date',
    adminTrans_total: 'Total',
    adminTrans_type: 'Type',
    adminTrans_counterparty: 'Counterparty',
    adminTrans_amount: 'Amount',
    adminTrans_payment: 'Payment type',
    adminTrans_invoice: 'Invoice',
    adminTrans_description: 'Description',
    adminTrans_status: 'Status',
    adminTrans_payment_card: 'Card',
    adminTrans_payment_cash: 'Cash',
    adminTrans_payment_transfer: 'Transfer',
    adminTrans_empty: 'No transactions match the selected filters.',
    adminTrans_footer: 'Transactions are static sample. Real data will show when backend and 1C are connected.',
    adminTrans_footer_live:
      'Data is loaded from the backend. Branch payment labels follow the tenant operational settings.',
    adminInv_subtitle: 'All invoices, payment status, due date and VAT. Data is clear and detailed, static sample.',
    adminInv_filter_all: 'All',
    adminInv_status_paid: 'Paid',
    adminInv_status_partial: 'Partial',
    adminInv_status_overdue: 'Overdue',
    adminInv_status_draft: 'Draft',
    adminInv_summary_title: 'Summary',
    adminInv_total_invoiced: 'Total invoiced',
    adminInv_total_paid: 'Total paid',
    adminInv_total_outstanding: 'Outstanding',
    adminInv_count: 'Invoice count',
    adminInv_invoices: 'invoices',
    adminInv_shown: 'shown',
    adminInv_number: 'No.',
    adminInv_date: 'Date',
    adminInv_due_date: 'Due date',
    adminInv_client: 'Client',
    adminInv_amount: 'Amount (excl. VAT)',
    adminInv_vat: 'VAT',
    adminInv_total: 'Total',
    adminInv_paid: 'Paid',
    adminInv_status: 'Status',
    adminInv_description: 'Description',
    adminInv_empty: 'No invoices match the selected filter.',
    adminInv_footer: 'Invoices are static sample. Real documents will show when 1C and backend are connected.',
    adminTax_subtitle: 'Tax obligations, due dates, payment status and declarations. Data is clear and detailed, static sample.',
    adminTax_filter_all: 'All',
    adminTax_type_vat: 'VAT',
    adminTax_type_income: 'Income tax',
    adminTax_type_simplified: 'Simplified',
    adminTax_type_property: 'Property tax',
    adminTax_type_land: 'Land tax',
    adminTax_type_transport: 'Transport',
    adminTax_type_other: 'Other',
    adminTax_status_all: 'All statuses',
    adminTax_status_paid: 'Paid',
    adminTax_status_pending: 'Pending',
    adminTax_status_overdue: 'Overdue',
    adminTax_summary_title: 'Summary',
    adminTax_total_due: 'Total due',
    adminTax_total_paid: 'Total paid',
    adminTax_total_outstanding: 'Outstanding',
    adminTax_next_due: 'Next due',
    adminTax_shown: 'shown',
    adminTax_code: 'Code',
    adminTax_type: 'Tax type',
    adminTax_period: 'Period',
    adminTax_due_date: 'Due date',
    adminTax_amount: 'Amount',
    adminTax_paid: 'Paid',
    adminTax_status: 'Status',
    adminTax_description: 'Description',
    adminTax_period_monthly: 'monthly',
    adminTax_period_quarterly: 'quarterly',
    adminTax_period_annual: 'annual',
    adminTax_empty: 'No records match the selected filter.',
    adminTax_footer: 'Tax data is static sample. Real declarations will show when 1C and tax system are connected.',
    admin1c_subtitle: 'Connection to 1C: Accounting and Enterprise, sync and settings. Data is clear and detailed, static sample.',
    admin1c_connection_connected: 'Connected',
    admin1c_connection_disconnected: 'Disconnected',
    admin1c_connection_title: 'Connection',
    admin1c_base_url: 'Base URL',
    admin1c_version: '1C version',
    admin1c_database: 'Database name',
    admin1c_last_checked: 'Last checked',
    admin1c_entities_title: 'Sync entities',
    admin1c_entity_products: 'Products',
    admin1c_entity_invoices: 'Invoices',
    admin1c_entity_transactions: 'Transactions',
    admin1c_entity_contacts: 'Contacts',
    admin1c_entity_stock: 'Stock',
    admin1c_entity_prices: 'Prices',
    admin1c_records: 'records',
    admin1c_entity_status_synced: 'Synced',
    admin1c_entity_status_pending: 'Pending',
    admin1c_entity_status_error: 'Error',
    admin1c_sync_log_title: 'Sync history',
    admin1c_date: 'Date',
    admin1c_direction: 'Direction',
    admin1c_entity: 'Entity',
    admin1c_status: 'Status',
    admin1c_message: 'Message',
    admin1c_direction_import: 'Import',
    admin1c_direction_export: 'Export',
    admin1c_direction_both: 'Both',
    admin1c_sync_status_success: 'Success',
    admin1c_sync_status_partial: 'Partial',
    admin1c_sync_status_failed: 'Failed',
    admin1c_settings_title: 'Settings',
    admin1c_sync_interval: 'Sync interval',
    admin1c_auth_type: 'Auth type',
    admin1c_export_format: 'Export format',
    admin1c_auto_sync: 'Auto sync',
    admin1c_yes: 'Yes',
    admin1c_no: 'No',
    admin1c_footer: '1C integration data is static sample. Real connection when backend and 1C are configured.',
    adminPL_subtitle: 'Revenue, expenses, gross and net profit — detailed P&L report. Data is static sample.',
    adminPL_summary_title: 'Summary',
    adminPL_total_revenue: 'Total revenue',
    adminPL_gross_profit: 'Gross profit',
    adminPL_margin: 'margin',
    adminPL_operating_profit: 'Operating profit',
    adminPL_net_profit: 'Net profit',
    adminPL_net_margin: 'net margin',
    adminPL_detail_title: 'Profit and loss breakdown',
    adminPL_block_revenue: 'Revenue',
    adminPL_block_cogs: 'Cost of goods sold',
    adminPL_block_operating: 'Operating expenses',
    adminPL_block_other: 'Other income and expenses',
    adminPL_revenue_sales: 'Sales revenue',
    adminPL_revenue_services: 'Services',
    adminPL_revenue_orders: 'Orders revenue',
    adminPL_revenue_invoices: 'Invoices revenue',
    adminPL_revenue_other: 'Other income',
    adminPL_revenue_total: 'Total revenue',
    adminPL_cogs_goods: 'Cost of goods',
    adminPL_cogs_delivery: 'Delivery',
    adminPL_cogs_total: 'Total COGS',
    adminPL_op_salary: 'Salaries',
    adminPL_op_rent: 'Rent',
    adminPL_op_utilities: 'Utilities',
    adminPL_op_marketing: 'Marketing',
    adminPL_op_depreciation: 'Depreciation',
    adminPL_op_operating: 'Operating expenses',
    adminPL_op_other: 'Other expenses',
    adminPL_op_total: 'Total operating',
    adminPL_other_interest_income: 'Interest income',
    adminPL_other_interest_expense: 'Interest expense',
    adminPL_other_currency: 'Currency difference',
    adminPL_other_taxes: 'Taxes',
    adminPL_other_invoices_expenses: 'Invoices expenses',
    adminPL_other_net: 'Other (net)',
    adminPL_footer: 'Profit and loss data is static sample. Real report when 1C and accounting are connected.',
    adminBS_subtitle: 'Assets, liabilities and equity — balance sheet. Data is clear and detailed, static sample.',
    adminBS_summary_title: 'Summary',
    adminBS_total_assets: 'Total assets',
    adminBS_total_liabilities: 'Total liabilities',
    adminBS_total_equity: 'Total equity',
    adminBS_balance_check: 'Balance check (Liabilities + Equity = Assets)',
    adminBS_detail_title: 'Balance sheet breakdown',
    adminBS_assets: 'Assets',
    adminBS_liabilities_equity: 'Liabilities and equity',
    adminBS_assets_current: 'Current assets',
    adminBS_assets_noncurrent: 'Non-current assets',
    adminBS_liab_current: 'Current liabilities',
    adminBS_liab_longterm: 'Long-term liabilities',
    adminBS_equity: 'Equity',
    adminBS_total_liab_equity: 'Total liabilities and equity',
    adminBS_cash: 'Cash',
    adminBS_bank: 'Bank',
    adminBS_receivables: 'Receivables',
    adminBS_inventory: 'Inventory',
    adminBS_prepaid: 'Prepaid',
    adminBS_current_total: 'Total current assets',
    adminBS_fixed_assets: 'Fixed assets',
    adminBS_intangible: 'Intangible assets',
    adminBS_investments: 'Investments',
    adminBS_noncurrent_total: 'Total non-current',
    adminBS_payables: 'Payables',
    adminBS_short_term_debt: 'Short-term debt',
    adminBS_tax_payable: 'Tax payable',
    adminBS_other_current: 'Other current',
    adminBS_current_liab_total: 'Total current liabilities',
    adminBS_long_term_loans: 'Long-term loans',
    adminBS_long_term_total: 'Total long-term',
    adminBS_share_capital: 'Share capital',
    adminBS_retained_earnings: 'Retained earnings',
    adminBS_current_year_profit: 'Current year profit',
    adminBS_equity_total: 'Total equity',
    adminBS_footer: 'Balance sheet data is static sample. Real balance when 1C and accounting are connected.',
    adminExport_subtitle: 'Export reports to Excel, CSV and PDF. Report types, formats and recent exports — static sample.',
    adminExport_report_types_title: 'Report types',
    adminExport_type_transactions: 'Transactions',
    adminExport_type_invoices: 'Invoices',
    adminExport_type_taxes: 'Taxes',
    adminExport_type_profit_loss: 'Profit & Loss',
    adminExport_type_balance_sheet: 'Balance sheet',
    adminExport_formats: 'formats',
    adminExport_transactions_desc: 'All income and expense transactions, export by filters.',
    adminExport_invoices_desc: 'Invoice list, payment status and due dates.',
    adminExport_taxes_desc: 'Tax obligations and payments list.',
    adminExport_profit_loss_desc: 'P&L report — revenue, expenses and profit.',
    adminExport_balance_sheet_desc: 'Balance sheet — assets, liabilities and equity.',
    adminExport_max_rows: 'Max rows',
    adminExport_history_title: 'Recent exports',
    adminExport_date: 'Date',
    adminExport_report_type: 'Report',
    adminExport_format: 'Format',
    adminExport_rows: 'Rows',
    adminExport_status: 'Status',
    adminExport_file: 'File name',
    adminExport_format_xlsx: 'Excel (XLSX)',
    adminExport_format_csv: 'CSV',
    adminExport_format_pdf: 'PDF',
    adminExport_status_completed: 'Completed',
    adminExport_status_failed: 'Failed',
    adminExport_settings_title: 'Settings',
    adminExport_default_format: 'Default format',
    adminExport_max_rows_limit: 'Max rows limit',
    adminExport_date_range_default: 'Default period',
    adminExport_date_range_current_month: 'Current month',
    adminExport_footer: 'Export data is static sample. Real export when backend is connected.',
    adminHelp_subtitle: 'Contact details and support.',
    adminHelp_subtitle_kassir: 'Contact details and support.',
    adminHelp_subtitle_mijoz_chat: 'Support chat and contact details.',
    adminHelp_subtitle_mijoz_chat_only: 'Send your question in the support chat — a regional manager or platform support will reply.',
    adminHelp_mijoz_chat_title: 'Support chat',
    adminHelp_mijoz_chat_lead: 'Send text, an image, or a video. Your regional manager or the platform team will reply.',
    adminHelp_subtitle_tenant_owner_chat: 'Contact us via the support chat.',
    adminHelp_tenant_owner_chat_title: 'Support chat',
    adminHelp_tenant_owner_chat_lead:
      'Write your question or send an image, video, or audio. Your regional manager or platform support will reply.',
    adminHelp_quick_start_title: 'Quick start',
    adminHelp_step_1: 'Choose the section you need in the sidebar (Statistics, Finance, Settings, etc.).',
    adminHelp_step_2: 'Use filters in reports and tables to find data quickly.',
    adminHelp_step_3: 'In the Export section download reports as Excel, CSV or PDF.',
    adminHelp_step_4: 'For questions or issues — contact support using the details below.',
    adminHelp_kassir_step_1: 'In cashier screen, work with favorite products for fast service.',
    adminHelp_kassir_step_2: 'Select correct payment type and verify total with customer.',
    adminHelp_kassir_step_3: 'If receipt printer has issues, use printer connect section and test print.',
    adminHelp_kassir_step_4: 'Before ending shift, reconcile transactions and stock-facing totals.',
    adminHelp_faq_title: 'Frequently asked questions',
    adminHelp_faq_1_q: 'How do I change my password?',
    adminHelp_faq_1_a: 'In Profile or Settings click «Change password». New password must be at least 8 characters with a number and uppercase letter.',
    adminHelp_faq_2_q: 'Which sections are available for my role?',
    adminHelp_faq_2_a: 'The sidebar shows only sections allowed for your role. Owner sees platform management, tariffs, clients and operations; notifications are in the top bar bell; invoices and some monitoring sections are mainly for the accountant; client and cashier see their own sections.',
    adminHelp_faq_3_q: 'Is the data real or sample?',
    adminHelp_faq_3_a: 'Currently all reports, transactions, taxes and the like are static samples. Real data will show after backend and 1C are connected.',
    adminHelp_faq_4_q: 'When will export work?',
    adminHelp_faq_4_a: 'The Export section lists report types and formats (Excel, CSV, PDF). File download will be enabled when the backend is connected.',
    adminHelp_kassir_faq_1_q: 'What if printer does not print?',
    adminHelp_kassir_faq_1_a: 'Open printer connect section, restart local app, and run a test print.',
    adminHelp_kassir_faq_2_q: 'Why all products are not visible in cashier?',
    adminHelp_kassir_faq_2_a: 'Cashier shows only starred products selected in warehouse.',
    adminHelp_kassir_faq_3_q: 'What if mixed payment amount does not match total?',
    adminHelp_kassir_faq_3_a: 'System blocks confirmation until mixed amounts match total.',
    adminHelp_kassir_faq_4_q: 'Where do I see near-expiry products?',
    adminHelp_kassir_faq_4_a: 'In warehouse table expiry appears with color cues: green, yellow, red.',
    adminHelp_faq_5_q: 'Is 2FA (two-factor authentication) available?',
    adminHelp_faq_5_a: 'Yes. In Settings → Security enabling 2FA is recommended, especially for administrators.',
    adminHelp_faq_6_q: 'How do I contact support?',
    adminHelp_faq_6_a: 'Use the phone in the Contact section below. Response usually within 24 hours. Hours: Mon–Fri, 09:00–18:00.',
    adminHelp_contact_title: 'Contact',
    adminHelp_email: 'Email',
    adminHelp_phone: 'Phone',
    adminHelp_hours: 'Hours',
    adminHelp_response_time: 'Response time',
    adminHelp_contact_hours_val: '09:00 — 18:00 (Mon — Fri)',
    adminHelp_contact_response: 'Within 24 hours',
    adminHelp_links_title: 'Useful links',
    adminHelp_link_dashboard: 'Statistics',
    adminHelp_link_dashboard_desc: 'Key metrics and reports',
    adminHelp_link_finance: 'Finance',
    adminHelp_link_finance_desc: 'Revenue, expenses and transactions',
    adminHelp_link_settings: 'Settings',
    adminHelp_link_settings_desc: 'System and notifications',
    adminHelp_link_export: 'Export',
    adminHelp_link_export_desc: 'Download reports',
    adminHelp_footer: 'Help page content is static. Manual and video will be added in future updates.',
    adminPrinterConnect_subtitle: 'Connect printer and configure local app for receipt printing.',
    receiptSettings_title: 'Receipt layout',
    receiptSettings_desc: 'Choose what appears on printed receipts and the order of blocks. Drag rows using the handle on the right.',
    receiptSettings_preview: 'Preview',
    receiptSettings_blocks: 'Receipt blocks',
    receiptSettings_drag_hint: 'Grab the handle on the right to move a block up or down.',
    receiptSettings_drag_handle: 'Reorder',
    receiptSettings_logo_title: 'Receipt logo',
    receiptSettings_logo_upload: 'Upload logo',
    receiptSettings_logo_default: 'Use default logo',
    receiptSettings_logo_invalid: 'Only image files can be uploaded.',
    receiptSettings_logo_too_large: 'Logo size must not exceed 2MB.',
    receiptSettings_logo_failed: 'Failed to upload logo. Please try again.',
    receiptBlock_header_sale_number: 'Sale number',
    receiptBlock_header_store: 'Store / company name',
    receiptBlock_header_datetime: 'Date and time',
    receiptBlock_header_work_hours: 'Opening hours',
    receiptBlock_cashier: 'Cashier',
    receiptBlock_client: 'Customer',
    receiptBlock_contacts: 'Contacts',
    receiptBlock_tin: 'TIN',
    receiptBlock_legal_name: 'Legal entity name',
    receiptBlock_address: 'Address',
    receiptBlock_client_phone: 'Customer phone',
    receiptBlock_sale_note: 'Sale note / comment',
    receiptBlock_line_items: 'Line items',
    receiptBlock_line_discounts: 'Per-line discounts',
    receiptBlock_line_totals: 'Per-line amounts',
    receiptBlock_receipt_discounts: 'Receipt-level discounts',
    receiptBlock_receipt_totals: 'Receipt totals',
    receiptBlock_product_count: 'Number of items on receipt',
    receiptPreview_sale: 'Sale',
    receiptPreview_store_sample: 'Store: dilshod-market',
    receiptPreview_date: 'Date',
    receiptPreview_work_hours: 'Hours',
    receiptPreview_cashier: 'Cashier',
    receiptPreview_client: 'Customer',
    receiptPreview_contacts: 'Contacts',
    receiptPreview_tin: 'TIN',
    receiptPreview_legal: 'Legal name',
    receiptPreview_address: 'Address',
    receiptPreview_client_phone: 'Customer no.',
    receiptPreview_note: 'Note',
    receiptPreview_item_name: 'Product / brand',
    receiptPreview_discount_line: 'Discount',
    receiptPreview_product_count: 'Item count',
    receiptPreview_subtotal: 'Subtotal',
    receiptPreview_discount: 'Discount',
    receiptPreview_discount_pct: 'Discount %',
    receiptPreview_total: 'TOTAL',
    receiptPreview_balance: 'Customer balance',
    supportChat_placeholder: 'Type a message…',
    supportChat_send: 'Send',
    supportChat_attach_image: 'Image',
    supportChat_attach_video: 'Video',
    supportChat_remove_attach: 'Remove',
    supportChat_attach_too_large: 'File is too large (max ~12 MB).',
    supportChat_attach_error: 'Could not read the file.',
    supportChat_empty_thread: 'No messages yet. Write below or attach a file.',
    supportChat_no_tenant: 'Company (tenant) is not set — check your profile.',
    supportChat_label_mijoz: 'Client',
    supportChat_label_vm: 'Regional manager',
    supportChat_label_bm: 'Head manager',
    supportChat_label_platform_owner: 'Platform owner',
    supportChat_label_staff: 'Support',
    supportChat_backend_note: 'Messages are stored in the browser for now. After backend integration: realtime and notifications.',
    supportChat_persist_failed: 'Could not save the message (browser storage or private mode). Refresh the page and try again.',
    supportChat_thread_status: 'Chat open — awaiting reply',
    supportChat_sync_live: 'Live updates enabled',
    supportChat_sync_poll: 'Auto-refresh (about every 5 seconds)',
    supportChat_err_realtime: 'Live connection is temporarily unavailable — messages are still saved and the list will refresh.',
    supportChat_err_network: 'Could not reach the server. Check your connection and try again.',
    supportChat_err_forbidden: 'No permission or session expired. Please sign in again.',
    supportChat_err_unknown: 'Something went wrong. Please try again.',
    supportChat_banner_close: 'Dismiss',
    staffChat_subtitle: 'One shared chat for the platform owner and all managers. Messages are stored on the server and visible to every admin. Client chat is separate.',
    staffChat_thread_status: 'Team chat',
    staffChat_role_platform_owner: 'Platform owner',
    staffChat_role_general_manager: 'Head manager',
    staffChat_role_regional_manager: 'Regional manager',
    staffChat_role_dispatcher: 'Dispatcher',
    staffChat_label_unknown: 'Name not set',
    staffChat_empty_thread: 'No messages yet. Write below or attach a file.',
    staffChat_loading: 'Loading messages…',
    staffChat_sending: 'Sending…',
    staffChat_send_failed: 'Could not send. Please try again.',
    staffChat_edit: 'Edit',
    staffChat_delete: 'Delete',
    staffChat_save_edit: 'Save',
    staffChat_cancel_edit: 'Cancel',
    staffChat_edited_label: 'edited',
    staffChat_confirm_delete: 'Delete this message? Others will no longer see it.',
    staffChat_read_full: 'Full text',
    staffChat_expand_text: 'Show more',
    staffChat_collapse_text: 'Collapse',
    staffChat_open_preview: 'Open in chat',
    staffChat_backend_note: 'Messages sync via API (polling). WebSocket can be added for realtime.',
    chat_reply: 'Reply',
    chat_replying_to: 'Replying to',
    chat_reply_cancel: 'Cancel',
    supportChat_backend_note_api: 'Client chats are stored on the server; images/videos upload as files first. The same thread appears on every device.',
    supportChat_label_tenant_owner: 'Client',
    supportChat_attach_audio: 'Audio',
    supportChat_attach_file: 'File',
    supportChat_file_open: 'Open file',
    supportChat_file_ready: 'File ready to send',
    supportChat_recipient_all: 'All cashiers',
    supportChat_recipient_label: 'Recipient',
    cashierChat_subtitle_owner: 'Chat with cashiers one-by-one or broadcast to all.',
    cashierChat_subtitle_cashier: 'Chat with tenant owner in this section.',
    cashierChat_missing_tenant: 'Tenant was not resolved. Contact administrator.',
    tenantMessages_subtitle: 'One chat per client. Yellow dot means the last message is from the client.',
    tenantMessages_search: 'Search by company or phone',
    tenantMessages_no_messages: 'No messages',
    tenantMessages_preview_image: 'Image',
    tenantMessages_preview_video: 'Video',
    tenantMessages_needs_reply: 'Awaiting reply',
    tenantMessages_pick_tenant: 'Select a client on the left to open the chat.',
    adminSettings_subtitle: 'System parameters, notifications, security and data management. Current values are static sample.',
    adminSettings_mijoz_subtitle: 'Receipt layout (in browser), language, and operational parameters — pricing, branch payment methods.',
    adminSettings_tenant_owner_subtitle: 'For the store owner: receipt and language, operational settings, per-branch payment methods, and marketing shop options in one place.',
    adminSettings_tenant_owner_header_hint: 'Receipt options are stored on this device. Operational settings and per-branch payments are saved to the server when you tap Save.',
    adminSettings_mijoz_header_hint: 'Receipt options are stored on this device. Operational settings and per-branch payments are saved to the server when you tap Save.',
    adminSettings_reset_confirm: 'Reset all operational settings to defaults? Unsaved changes will be lost.',
    adminSettings_branches_load_failed: 'Could not load the branch list.',
    adminSettings_last_updated: 'Last updated',
    adminSettings_environment: 'Environment',
    adminSettings_env_production: 'Production',
    adminSettings_env_development: 'Development',
    adminSettings_section_general: 'General settings',
    adminSettings_section_notifications: 'Notifications',
    adminSettings_section_security: 'Security',
    adminSettings_section_appearance: 'Appearance',
    adminSettings_section_system: 'System',
    adminSettings_section_data: 'Data and backup',
    adminSettings_section_notes: 'Note',
    adminSettings_section_operational: 'Operational settings',
    adminSettings_section_operational_desc: 'Control cashier, pricing, measurement units, and daily summary time.',
    adminSettings_section_general_desc: 'Language, timezone, date format and currency — for all users.',
    adminSettings_section_notifications_desc: 'Email, push, SMS and daily digest — when and which notifications to send.',
    adminSettings_section_security_desc: 'Session lifetime, 2FA, password policy and IP whitelist.',
    adminSettings_section_appearance_desc: 'Theme (dark/light), UI density and font size.',
    adminSettings_section_system_desc: 'Version, API URL, sessions and log level — system parameters.',
    adminSettings_section_data_desc: 'Backup time, retention, export formats and backup folder.',
    adminSettings_lang: 'Interface language',
    adminSettings_pricing_mode: 'Pricing mode',
    adminSettings_pricing_mode_manual: 'Manual (per product)',
    adminSettings_pricing_mode_markup: 'Markup from cost (%)',
    adminSettings_default_markup: 'Default markup',
    adminSettings_daily_summary_time: 'Daily summary time',
    adminSettings_sale_units_manage: 'Measurement units management',
    adminSettings_quick_discount_enabled: 'Enable quick discounts',
    adminSettings_quick_discount_optional: 'Discount selection in cart is optional',
    adminSettings_quick_discounts: 'Quick discount values',
    adminSettings_retail_cashback_percent: 'Retail customer cashback (%)',
    adminSettings_retail_cashback_hint:
      'The percentage is calculated from net sale profit. Bonus is added to the customer balance; balance can be used at checkout.',
    adminSettings_reset_defaults: 'Reset to defaults',
    adminSettings_reset: 'Reset',
    adminSettings_save: 'Save',
    adminSettings_branch_payments: 'Branch payment methods',
    adminSettings_branch_payments_section_title: 'Branch payment labels',
    adminSettings_branch_payments_section_desc: 'Set cash, card, and transfer labels shown at the register for each branch. Saving writes operational settings to the server.',
    adminSettings_branch_payments_desc: 'Configure Cash, Card, and Transfer methods per branch.',
    adminSettings_branch_payments_cash: 'Cash methods',
    adminSettings_branch_payments_card: 'Card methods',
    adminSettings_branch_payments_transfer: 'Transfer methods',
    adminSettings_branch_payments_apply: 'Save to server',
    adminSettings_branch_payments_hint: 'Separate names with commas, semicolons, or new lines. Save writes operational settings to the server.',
    adminSettings_branch_payments_footer: 'Payment methods can be edited in Settings.',
    adminNav_expenses: 'Expenses',
    adminExpenses_subtitle: 'Expenses: create, pay, archive.',
    adminExpenses_active: 'Active expenses',
    adminExpenses_archive: 'Archive (fully covered)',
    adminExpenses_add_title: 'Add new expense',
    adminExpenses_name: 'Expense name',
    adminExpenses_total: 'Total amount',
    adminExpenses_person_name: 'Source person (optional)',
    adminExpenses_note_optional: 'Note (optional)',
    adminExpenses_recurring_on: 'Recurring: On (monthly)',
    adminExpenses_recurring_off: 'Recurring: Off',
    adminExpenses_recurring_hint: 'Create this expense automatically every month',
    adminExpenses_save: 'Save',
    adminExpenses_required: 'Enter expense name and amount.',
    adminExpenses_delete_confirm: 'Delete this expense?',
    adminExpenses_pay_invalid: 'Invalid payment amount.',
    adminExpenses_pay: 'Pay',
    adminExpenses_pay_amount: 'Payment amount',
    adminExpenses_pay_save: 'Save payment',
    adminExpenses_from_cashbox: 'From cashbox',
    adminExpenses_not_from_cashbox: 'Not from cashbox',
    adminExpenses_badge_product: 'Product expense',
    adminExpenses_created_at: 'Created at',
    adminExpenses_qty: 'Quantity',
    adminExpenses_unit_cost: 'Unit cost',
    adminExpenses_remaining: 'Remaining',
    adminExpenses_status: 'Status',
    adminExpenses_actions: 'Actions',
    adminExpenses_note: 'Note',
    adminExpenses_product_id_label: 'Product ID',
    adminExpenses_supplier_label: 'Supplier',
    adminExpenses_supplier_debts: 'Supplier debts',
    adminExpenses_supplier_day_products: '{n} products',
    adminExpenses_supplier_products_title: 'Received products',
    adminExpenses_view_details: 'Details',
    adminExpenses_pay_supplier_total: 'Total payment',
    adminExpenses_supplier_pay_hint: 'Maximum: {n}',
    adminExpenses_paid: 'Paid',
    adminExpenses_no_payments: 'No payments',
    adminExpenses_pay_mode_cash: 'Cash / Card',
    adminExpenses_pay_mode_product: 'Pay with product',
    adminExpenses_select_product: 'Select product',
    adminExpenses_pick_branch_for_product: 'Select branch for product payment',
    adminExpenses_pick_branch_placeholder: 'Select branch',
    adminExpenses_pick_branch_before_products: 'Select a branch to view products.',
    adminExpenses_no_products_in_branch: 'No in-stock products in this branch.',
    adminExpenses_cashier_no_branch: 'No branch linked.',
    adminExpenses_cashier_products_hint: 'Only products from this branch warehouse.',
    adminExpenses_cashier_wait_branch: 'Waiting for branch information.',
    adminExpenses_kassir_products_hint: 'Cashier can pay only with products from assigned branch.',
    adminExpenses_kassir_wait_branch: 'Waiting for branch information.',
    adminExpenses_pay_source: 'Payment source',
    adminExpenses_without_cashbox: 'Without cashbox',
    adminExpenses_without_cashbox_hint: 'This payment does not reduce cashbox funds.',
    adminExpenses_today_cash_sales: "Today's cash sales",
    adminExpenses_cashbox_available: 'Available for cashbox expense',
    adminExpenses_cashbox_need_branch: 'Branch is required for cashbox payment.',
    adminExpenses_cashbox_load_error: 'Failed to load cashbox limit.',
    adminExpenses_cashbox_cash_only: 'Cashbox payment must use cash type.',
    adminExpenses_cashbox_wait: 'Cashbox limit is loading or unavailable. Try again.',
    adminExpenses_cashbox_exceeds: 'Insufficient available cash for today. Available: {n}',
    adminExpenses_product_inventory_error: 'Failed to load product list.',
    adminExpenses_select_branch_first: 'Select a branch first.',
    adminExpenses_product_qty_required: 'Select product and quantity.',
    adminExpenses_product_not_in_list: 'Product is not in list. Check selected branch.',
    adminExpenses_insufficient_stock: 'Insufficient stock. Available: {n}',
    adminExpenses_pay_error: 'Failed to save payment.',
    adminExpenses_pay_with_product: 'Pay with product',
    adminExpenses_product_qty: 'Quantity',
    adminExpenses_product_total: 'Total',
    adminExpenses_product_remaining: 'Remaining',
    adminExpenses_stock_short: 'Stock',
    adminExpenses_product_search: 'Search products…',
    adminExpenses_product_max_qty: 'Maximum quantity: {n}',
    adminExpenses_product_pick_hint: 'Tap a product in the list',
    adminExpenses_restock_batches: 'Batches',
    adminStatistics_payments_block_title: 'Payment types',
    adminSettings_last_saved: 'Last saved time',
    adminSettings_operational_load_failed: 'Failed to load operational settings from backend. Local values are used.',
    adminSettings_purchase_currency: 'Purchase currency',
    adminSettings_sale_currency: 'Sale currency',
    adminSettings_currency_rate: 'NBU rate',
    adminSettings_currency_rate_failed: 'Failed to load NBU rates',
    adminSettings_lang_val: 'Uzbek',
    adminSettings_timezone: 'Timezone',
    adminSettings_timezone_val: 'Asia/Tashkent (UTC+5)',
    adminSettings_date_format: 'Date format',
    adminSettings_date_format_val: 'DD.MM.YYYY',
    adminSettings_currency: 'Default currency',
    adminSettings_currency_val: 'UZS (sum)',
    adminSettings_week_start: 'Week start',
    adminSettings_week_start_val: 'Monday',
    adminSettings_notif_email: 'Email notifications',
    adminSettings_notif_email_val: 'On',
    adminSettings_notif_push: 'Push notifications',
    adminSettings_notif_push_val: 'On',
    adminSettings_notif_sms: 'SMS notifications',
    adminSettings_notif_sms_val: 'Off',
    adminSettings_notif_digest: 'Daily digest',
    adminSettings_notif_digest_val: 'On — every day at 09:00',
    adminSettings_session_min: 'Session lifetime (idle)',
    adminSettings_2fa: 'Two-factor authentication (2FA)',
    adminSettings_2fa_val: 'Recommended (for admins)',
    adminSettings_password_policy: 'Password policy',
    adminSettings_password_policy_val: 'Min 8 characters, number and uppercase required',
    adminSettings_ip_whitelist: 'IP whitelist',
    adminSettings_ip_whitelist_val: 'Off',
    adminSettings_theme: 'Theme',
    adminSettings_theme_val: 'System (auto)',
    adminSettings_density: 'UI density',
    adminSettings_density_val: 'Comfortable',
    adminSettings_font_size: 'Font size',
    adminSettings_font_size_val: 'Standard (14px)',
    adminSettings_version: 'System version',
    adminSettings_api_base: 'API base URL',
    adminSettings_max_sessions: 'Max sessions per user',
    adminSettings_log_level: 'Log level',
    adminSettings_log_level_val: 'Info',
    adminSettings_backup: 'Automatic backup time',
    adminSettings_retention: 'Audit and log retention',
    adminSettings_export_format: 'Export format',
    adminSettings_export_format_val: 'CSV, Excel (XLSX), JSON',
    adminSettings_build_id: 'Build ID',
    adminSettings_backup_path: 'Backup folder',
    adminSettings_note_text: 'Editing settings will be available in future updates. Current values are display-only. Contact support for critical changes.',
    adminTariff_title: 'Tariff',
    adminTariff_subtitle: 'Manage site tariffs: prices, benefits and recommended plan. Changes persist until page refresh.',
    adminTariff_create_naming: 'Tariff type',
    adminTariff_create_preset: 'Standard template',
    adminTariff_create_custom: 'Custom name',
    adminTariff_template: 'Template',
    adminTariff_no_templates_left: 'All three standard types are already added. Create a tariff with a custom name.',
    adminTariff_validation_template: 'Please select a template.',
    adminTariff_validation_custom_name: 'Enter a tariff name.',
    adminTariff_validation_price: 'Price cannot be negative.',
    adminTariff_save_new: 'Create tariff',
    adminTariff_add: 'Add tariff',
    adminTariff_edit: 'Edit',
    adminTariff_delete: 'Delete',
    adminTariff_save: 'Save',
    adminTariff_cancel: 'Cancel',
    adminTariff_name: 'Tariff name',
    adminTariff_name_placeholder: 'e.g. Starter, Business',
    adminTariff_unnamed: 'Unnamed tariff',
    adminTariff_monthly_price: 'Monthly price (UZS)',
    adminTariff_recommended: 'Recommended',
    adminTariff_recommended_yes: 'Show as «Most popular»',
    adminTariff_benefits: 'Benefits',
    adminTariff_modal_add_title: 'New tariff',
    adminTariff_modal_edit_title: 'Edit tariff',
    adminTariff_confirm_delete_title: 'Delete tariff',
    adminTariff_confirm_delete_text: 'Are you sure you want to delete the tariff',
    adminTariff_empty: 'No tariffs yet. Add a new one.',
    adminInt_subtitle: 'External services, payment systems and API connections. Each integration has a clear description and status.',
    adminInt_add: 'Add integration',
    adminInt_edit: 'Edit',
    adminInt_delete: 'Delete',
    adminInt_save: 'Save',
    adminInt_cancel: 'Cancel',
    adminInt_name: 'Name',
    adminInt_name_placeholder: 'e.g. Stripe, SMS.uz',
    adminInt_description: 'Description',
    adminInt_description_placeholder: 'Brief: what it is for and how it is used.',
    adminInt_category: 'Category',
    adminInt_logo: 'Logo',
    adminInt_logo_choose: 'Choose logo',
    adminInt_logo_invalid: 'Only image files can be uploaded',
    adminInt_logo_too_large: 'Image size must not exceed 2MB',
    adminInt_status_label: 'Status',
    adminInt_status_active: 'Active',
    adminInt_status_inactive: 'Inactive',
    adminInt_modal_add_title: 'New integration',
    adminInt_modal_edit_title: 'Edit integration',
    adminInt_confirm_delete_title: 'Delete integration',
    adminInt_confirm_delete_text: 'Are you sure you want to delete the integration',
    adminInt_empty: 'No integrations yet. Add one.',
    adminInt_unnamed: 'Unnamed',
    adminInt_cat_payment: 'Payment',
    adminInt_cat_accounting: 'Accounting',
    adminInt_cat_export: 'Export',
    adminInt_cat_api: 'API',
    adminInt_cat_messaging: 'Messaging',
    adminInt_telegram_name: 'Telegram',
    adminInt_telegram_desc: 'Notifications, messages and customer communication via bot. Automatic order status updates and reminders.',
    adminInt_1c_name: '1C',
    adminInt_1c_desc: 'Data exchange with 1C:Accounting and 1C:Enterprise. Sync transactions, invoices and stock movements.',
    adminInt_payme_name: 'Payme',
    adminInt_payme_desc: 'Accept online payments via Payme. Card, click and mobile app payments.',
    adminInt_click_name: 'Click',
    adminInt_click_desc: 'Click payment system integration. Customers can pay for orders and services via Click.',
    adminInt_uzum_name: 'Uzum',
    adminInt_uzum_desc: 'Connect Uzum Bank and Uzum payment system. Accept payments by card and phone number.',
    adminInt_excel_name: 'Excel',
    adminInt_excel_desc: 'Export reports and tables to Excel (XLSX). For analysis and archiving.',
    adminInt_google_sheets_name: 'Google Sheets',
    adminInt_google_sheets_desc: 'Sync and export to Google Sheets. Store and share reports in the cloud.',
    adminInt_api_name: 'API',
    adminInt_api_desc: 'Connect external systems via REST API. Open endpoints for products, orders, customers and reports.',
    adminTenant_subtitle: 'Organizations registered on the platform. For each client: company, contact, plan and status.',
    adminTenant_add_via_orders_hint: 'New clients are only created from Orders — use “Convert to client” on a main-site order.',
    adminTenant_add: 'Add client',
    adminTenant_view: 'View',
    adminTenant_edit: 'Edit',
    adminTenant_delete: 'Delete',
    adminTenant_vm_stats_title: 'Regional manager KPI',
    adminTenant_vm_active: 'Active clients',
    adminTenant_vm_trial: 'Trial clients',
    adminTenant_vm_suspended: 'Suspended clients',
    adminTenant_vm_cashiers: 'Total cashiers',
    adminTenant_vm_orders_month: 'Monthly orders',
    adminTenant_vm_revenue_month: 'Monthly revenue',
    adminTenant_vm_trend_share: 'share',
    adminTenant_vm_trend_per_client: 'per client',
    adminTenant_vm_trend_vs_prev: 'vs previous period',
    adminTenant_save: 'Save',
    adminTenant_cancel: 'Cancel',
    adminTenant_total: 'clients',
    adminTenant_company: 'Company',
    adminTenant_company_placeholder: 'Company name',
    adminTenant_contact: 'Contact person',
    adminTenant_contact_placeholder: 'Full name',
    adminTenant_phone: 'Phone',
    adminTenant_owner_password: 'Password',
    adminTenant_owner_password_placeholder: 'At least 6 characters',
    adminTenant_owner_password_placeholder_edit: 'New password (optional)',
    adminTenant_owner_password_hint: 'Password for the contact phone login. User role must be owner (Ega), not retail customer.',
    adminTenant_owner_password_edit_hint: 'Leave empty to keep the current password. New password: at least 6 characters.',
    adminTenant_owner_password_required: 'Enter the password (at least 6 characters).',
    adminTenant_login_sms_2fa: 'SMS verification on login',
    adminTenant_login_sms_2fa_hint: 'Managed by the platform owner (Ega) and head manager. When enabled, the client and their cashiers enter an SMS code after phone and password. When disabled, password alone is enough.',
    adminTenant_login_sms_on: 'Enabled',
    adminTenant_login_sms_off: 'Disabled',
    adminLogin_password_label: 'Login password',
    adminLogin_password_placeholder: 'At least 6 characters',
    adminLogin_password_placeholder_edit: 'New password (optional)',
    adminLogin_password_hint: 'Password used with this phone number to sign in.',
    adminLogin_password_hint_edit: 'Leave empty to keep the current password. New password: at least 6 characters.',
    adminLogin_password_required: 'Enter a login password (at least 6 characters).',
    adminTenant_plan: 'Plan',
    adminTenant_status: 'Status',
    adminTenant_status_active: 'Active',
    adminTenant_status_trial: 'Trial',
    adminTenant_status_suspended: 'Suspended',
    adminTenant_status_payment_pending: 'Payment pending',
    adminTenant_region: 'Region',
    adminTenant_district: 'District / City',
    adminTenant_address: 'Address',
    adminTenant_address_placeholder: 'Full address (street, building, landmark)',
    adminTenant_address_required: 'Please enter the address.',
    adminTenant_businessType: 'Business type',
    adminTenant_cashiers: 'Cashiers',
    adminTenant_select_placeholder: 'Select',
    adminTenant_note: 'Note',
    adminTenant_note_placeholder: 'Additional info',
    adminTenant_actions: 'Actions',
    adminTenant_modal_add_title: 'New client',
    adminTenant_modal_edit_title: 'Edit client',
    adminTenant_confirm_delete_title: 'Delete client',
    adminTenant_confirm_delete_text: 'Are you sure you want to delete the client',
    adminTenant_empty: 'No clients yet. Add one.',
    adminTenant_search_placeholder: 'Search by company, name or number...',
    adminTenant_filter_all_business: 'All business types',
    adminTenant_filter_all_region: 'All regions',
    adminTenant_filter_all_district: 'All districts',
    adminTenant_filter_all_plan: 'All plans',
    adminTenant_filter_loading: 'Loading...',
    adminTenant_no_results: 'No results found for your search.',
    adminTenant_clear_filters: 'Clear filters',
    adminTenant_page_prev: 'Previous',
    adminTenant_page_next: 'Next',
    adminTenant_page_num: 'Page',
    adminTenant_view_title: 'Full client details',
    adminTenant_detail_info: 'Main info',
    adminTenant_detail_tariff: 'Tariff and subscription',
    adminTenant_detail_stats: 'Statistics',
    adminTenant_stat_orders: 'Total orders',
    adminTenant_stat_orders_month: 'Orders this month',
    adminTenant_stat_revenue_month: 'Revenue this month (UZS)',
    adminTenant_stat_revenue_total: 'Total revenue (UZS)',
    adminTenant_stat_branches: 'Branches',
    adminTenant_stat_last_order: 'Last order',
    adminTenant_created: 'Registered at',
    adminTenant_plan_since: 'Tariff start date',
    adminTenant_last_payment_date: 'Last payment date',
    adminTenant_tariff_end_date: 'Tariff end date',
    adminTenant_no_payment_yet: 'No payment yet',
    adminTenant_close: 'Close',
    adminTenant_detail_products: 'Products',
    adminTenant_products_count: 'Product types',
    adminTenant_products_total_sold: 'Total sold',
    adminTenant_products_total_stock: 'Total stock',
    adminTenant_products_list_title: 'Product names and stock',
    adminTenant_product_name: 'Product name',
    adminTenant_product_status: 'Status',
    adminTenant_product_sold: 'Sold',
    adminTenant_product_stock: 'Stock',
    adminTenant_product_purchase_price: 'Purchase price',
    adminTenant_product_sale_price: 'Sale price',
    adminTenant_products_empty: 'No product data available',
    adminFF_subtitle: 'Current and planned platform features. For each: status (enabled / planned) and short description.',
    adminFF_filter_all: 'All',
    adminFF_cat_admin: 'Admin',
    adminFF_cat_platform: 'Platform',
    adminFF_cat_analytics: 'Analytics',
    adminFF_cat_security: 'Security',
    adminFF_status_enabled: 'Enabled',
    adminFF_status_planned: 'Planned',
    adminFF_status_disabled: 'Disabled',
    adminFF_footer: 'Enabling/disabling features will be implemented via backend in future updates. Display-only for now.',
    adminFF_statistics_name: 'Statistics',
    adminFF_statistics_desc: 'KPI and weekly orders chart for owner role. Professional dashboard with static data.',
    adminFF_maslahat_name: 'Consultation',
    adminFF_maslahat_desc: 'Static business management guide: sales, warehouse, finance, staff, CRM and general tips.',
    adminFF_dashboard_name: 'Control panel',
    adminFF_dashboard_desc: 'System status, quick access, recent activity, usage and security sections.',
    adminFF_settings_name: 'Settings',
    adminFF_settings_desc: 'General settings, notifications, security, appearance, system and data parameters.',
    adminFF_tariffs_name: 'Tariffs',
    adminFF_tariffs_desc: 'Manage site tariffs: prices, benefits, recommended plan. Add, edit, delete.',
    adminFF_integrations_name: 'Integrations',
    adminFF_integrations_desc: 'Telegram, 1C, Payme, Click, Uzum, Excel, Google Sheets, API. Description per item and add new.',
    adminFF_tenants_name: 'Clients',
    adminFF_tenants_desc: 'Organizations on the platform: company, contact, plan, status. CRUD.',
    adminFF_dark_theme_name: 'Dark theme',
    adminFF_dark_theme_desc: 'Interface in dark mode. Toggle via button.',
    adminFF_i18n_name: 'Multi-language',
    adminFF_i18n_desc: 'Interface in Uzbek, Russian and English. All admin sections translated.',
    adminFF_audit_name: 'Audit log',
    adminFF_audit_desc: 'User actions and system events history. In future updates.',
    adminFF_health_name: 'System health',
    adminFF_health_desc: 'Server, database and services monitoring. In future updates.',
    adminFF_usage_name: 'Usage reports',
    adminFF_usage_desc: 'Reports on API requests, sessions and resources. In future updates.',
    adminFF_errors_name: 'Error monitoring',
    adminFF_errors_desc: 'Application errors and logs. In future updates.',
    adminFF_apikeys_name: 'API keys',
    adminFF_apikeys_desc: 'Create and manage API keys. Access for external systems. In future updates.',
    adminAudit_subtitle: 'Log of user actions and system events. Each entry: time, who, action, result and IP.',
    adminAudit_filter_all: 'All',
    adminAudit_result_success: 'Success',
    adminAudit_result_failure: 'Failure',
    adminAudit_total: 'entries',
    adminAudit_time: 'Date & time',
    adminAudit_user: 'User',
    adminAudit_action: 'Action',
    adminAudit_resource: 'Resource',
    adminAudit_details: 'Details',
    adminAudit_result: 'Result',
    adminAudit_ip: 'IP address',
    adminAudit_footer: 'Audit entries are static sample. Real log will be populated when backend and logging are connected. Export in future updates.',
    adminAudit_login: 'Login',
    adminAudit_settings_update: 'Settings updated',
    adminAudit_tenant_create: 'Client created',
    adminAudit_tenant_edit: 'Client updated',
    adminAudit_integration_enable: 'Integration enabled',
    adminAudit_tariff_edit: 'Tariff updated',
    adminAudit_api_key_create: 'API key created',
    adminAudit_export: 'Export',
    adminAudit_resource_settings: 'Settings',
    adminAudit_resource_tenants: 'Clients',
    adminAudit_resource_integrations: 'Integrations',
    adminAudit_resource_tariffs: 'Tariffs',
    adminAudit_resource_apikeys: 'API keys',
    adminAudit_resource_audit: 'Audit log',
    adminAudit_detail_tariff_limits: 'Tariff limits changed',
    adminAudit_detail_export_csv: 'Downloaded as CSV',
    adminAudit_detail_wrong_password: 'Wrong password',
    roleTitle_business_admin: 'Business Admin',
    roleTitle_manager: 'Manager / Seller',
    roleTitle_warehouse: 'Warehouse',
    roleTitle_accountant: 'Accountant',
    roleTitle_analytics: 'Analytics / Marketing',
    roleTitle_courier: 'Courier / Field Agent',
    roleTitle_customer: 'Customer',

    // Admin sidebar (nav) – professional
    adminNav_system_dashboard: 'Dashboard',
    adminNav_role_access: 'Sign in as role',
    adminNav_ai_chat: 'AI chat',
    adminNav_ai_advisor: 'AI Advisor',
    adminNav_managers: 'Managers',
    adminNav_rating: 'Rating',
    adminNav_rating_dispatchers: 'Rating (dispatchers)',
    adminNav_rating_tenants: 'Rating (customers)',
    adminNav_dispatchers: 'Dispatchers',
    adminNav_statistics: 'Statistics',
    adminNav_leads: 'Leads',
    adminNav_leads_dispatcher: 'Requests',
    adminNav_leads_vm: 'Requests',
    adminNav_to_managers: 'Assign to managers',
    adminNav_cashiers: 'Cashiers',
    adminNav_pos_access: 'POS cabinet access',
    adminPosAccess_subtitle: 'POS only — products from the assigned branch.',
    adminPosAccess_quota: 'POS access',
    adminPosAccess_quota_unavailable: 'not available on current plan (from 299,000 UZS)',
    adminPosAccess_quota_full: 'POS access limit reached',
    adminPosAccess_add_disabled: 'Cannot add a POS user — plan limit reached',
    adminPosAccess_total: 'POS users',
    adminPosAccess_col_name: 'Name',
    adminPosAccess_col_phone: 'Phone',
    adminPosAccess_col_branch: 'Branch',
    adminPosAccess_col_status: 'Status',
    adminPosAccess_status_active: 'Active',
    adminPosAccess_status_inactive: 'Inactive',
    adminPosAccess_scope_hint: 'User sees only products from the assigned branch and works at the POS.',
    adminPosAccess_branch_scope: 'POS cabinet operates within the selected branch only.',
    adminPosAccess_phone_hint: 'Phone number is used as the login for sign-in.',
    adminPosAccess_password_hint: 'At least 6 characters. Used with the phone number to sign in.',
    adminPosAccess_name_placeholder: 'Full name',
    adminPosAccess_error_plan: 'Your plan does not include POS access. Upgrade from 299,000 UZS.',
    adminPosAccess_error_limit: 'POS seat limit reached for your plan.',
    adminPosAccess_add: 'Add POS user',
    adminPosAccess_empty: 'No POS users yet. Click "Add POS user" to create the first one.',
    adminPosAccess_modal_add: 'Add POS user',
    adminPosAccess_modal_edit: 'Edit POS user',
    adminPosAccess_delete_title: 'Delete POS user',
    adminPosAccess_delete_text: 'Delete this user?',
    adminPosAccess_error_plan: 'POS cabinet access is not available on your current plan. Upgrade from 299,000 UZS.',
    adminPosAccess_error_limit: 'POS access limit for your plan has been reached.',
    cashierKassa_out_of_stock: '“{name}” — out of stock.',
    cashierKassa_branch_mix_forbidden: 'You cannot mix products from different branches in one cart.',
    cashierKassa_test_receipt_success: 'Test receipt sent successfully.',
    adminNav_staff_workers: 'Staff',
    adminNav_global_settings: 'Settings',
    adminNav_tariff_plans: 'Tariffs',
    adminNav_landing_team: 'Landing team',
    adminNav_tariff_plan: 'Subscription plan',
    adminLandingTeam_subtitle: 'Manage the landing page “Our team” section — photo, role, and short bio.',
    adminLandingTeam_add: 'Add member',
    adminLandingTeam_edit: 'Edit',
    adminLandingTeam_delete: 'Delete',
    adminLandingTeam_save: 'Save',
    adminLandingTeam_cancel: 'Cancel',
    adminLandingTeam_empty: 'No team members yet. Add the first one.',
    adminLandingTeam_col_photo: 'Photo',
    adminLandingTeam_col_name: 'Name',
    adminLandingTeam_col_role: 'Role',
    adminLandingTeam_col_order: 'Order',
    adminLandingTeam_col_status: 'Status',
    adminLandingTeam_col_actions: 'Actions',
    adminLandingTeam_active: 'Active',
    adminLandingTeam_inactive: 'Hidden',
    adminLandingTeam_field_name: 'Full name',
    adminLandingTeam_field_role: 'Role / title',
    adminLandingTeam_field_description: 'Short description',
    adminLandingTeam_field_sort: 'Display order',
    adminLandingTeam_field_active: 'Show on landing',
    adminLandingTeam_field_photo: 'Photo',
    adminLandingTeam_remove_photo: 'Remove photo',
    adminLandingTeam_validation_required: 'Name, role, and description are required.',
    adminLandingTeam_photo_invalid: 'Images only (JPEG, PNG, WebP).',
    adminLandingTeam_photo_too_large: 'Image must be under 4 MB.',
    adminLandingTeam_delete_confirm: 'Delete “{name}”?',
    tenant_tariff_no_tenant: 'Tenant could not be determined.',
    tenant_tariff_load_error: 'Could not load data.',
    tenant_tariff_cancel_error: 'Request failed. Please try again.',
    tenant_tariff_status: 'Subscription status',
    tenant_tariff_plan_key: 'Plan',
    tenant_tariff_status_field: 'Status',
    tenant_tariff_trial_ends: 'Trial ends',
    tenant_tariff_subscription_ends: 'Subscription ends',
    tenant_tariff_cancel_title: 'Cancel subscription',
    tenant_tariff_cancel_lead:
      'Your request goes to the team. You keep access until the paid period ends. You can add a reason (optional).',
    tenant_tariff_cancel_requested: 'Cancellation requested',
    tenant_tariff_cancel_note: 'Note (optional)',
    tenant_tariff_cancel_placeholder: 'Why do you want to cancel?',
    tenant_tariff_cancel_submit: 'Submit cancellation request',
    tenant_tariff_transactions: 'Subscription transactions',

    subscription_extend: 'Extend subscription (prepay)',
    subscription_status_label: 'Status',
    subscription_expired: 'Subscription expired',
    subscription_data_preserved_hint: 'Your data (products, orders, credit sales) is preserved. Renew your subscription for new operations.',
    subscription_trial: 'Trial',
    subscription_active: 'Active',
    subscription_days_remaining: 'Days left',
    subscription_days_unit: 'days',
    subscription_ends_at: 'End date',
    subscription_monthly_price: 'Monthly plan price',
    subscription_prepay_matches_tariff:
      'This amount matches your current plan (same as in «Tariff plans»). Prepay totals use this monthly price and the months you select.',
    subscription_months_unit: 'mo',
    subscription_prepay_base: 'Prepay (before discount)',
    subscription_prepay_discount_label: 'Discount',
    subscription_total: 'Amount to pay',
    subscription_provider: 'Payment provider',
    subscription_provider_new_tab: 'you will be redirected to pay',
    subscription_pay_btn: 'Pay now',
    subscription_cashback_balance: 'Cashback balance',
    subscription_cashback_apply: 'Apply cashback (once per year)',
    subscription_cashback_hint: 'Medium / enterprise plans: 5% of each payment to balance; redeem once per year toward renewal.',
    subscription_cashback_next: 'Next cashback redemption',
    subscription_click_sms_error_hint:
      'If Click shows “SMS service not enabled (-33006)”, it usually means SMS notifications are not enabled for this merchant/service in Click, or for the payer’s card. Merchants should enable SMS for the service in the Click cabinet or contact Click support; cardholders should enable SMS banking/alerts with their bank.',
    subscription_click_continue_checkout: 'Continue to Click payment',
    subscription_click_provider_error_hint:
      '“Provider unavailable (-21)” on Click’s page is usually a Prepare issue: Click could not get a valid merchant response (`error: 0`, JSON) — timeout, SSL, 404/500, bad signature, or empty `CLICK_SECRET_KEY`. In the merchant cabinet set Prepare/Complete to `https://…/api/webhooks/click` or `…/webhooks/click`; keep `API_PUBLIC_URL` on that same public host. Logs: `click.webhook.post_hit`, `click.webhook.received`, `click.webhook.sign_check_failed` (docs.click.uz/en/click-api-request/).',
    subscription_pay_tech_click:
      'Technical: POST /api/subscription/initiate → Click shop https://my.click.uz/services/pay — parameters per docs.click.uz/en/click-button/.',
    subscription_pay_tech_payme:
      'Technical: POST /api/subscription/initiate → Payme/Paycom checkout (domain from config, usually checkout.paycom.uz).',
    subscription_pay_err_no_url: 'Payment link not generated. Please try again.',
    subscription_pay_err_generic: 'Payment could not be started. Please try again.',
    subscription_pay_err_payme_test_merchant:
      'Payme test mode: server is missing PAYME_TEST_MERCHANT_ID (sandbox). Production merchant ID on test checkout shows “provider not found”.',
    subscription_pay_err_payme_not_configured: 'Payme merchant ID is not configured on the server (PAYME_MERCHANT_ID).',
    subscription_pay_err_payme_invalid_merchant:
      'Invalid Payme merchant ID (24 hex). Check the value in your Payme Business cabinet.',
    subscription_pay_err_payme_key_not_configured:
      'Payme production API key (PAYME_KEY) is not configured on the server.',
    subscription_pay_err_payme_production_checkout:
      'Production checkout required (checkout.paycom.uz). Set PAYME_USE_TEST=false on the server.',

    tenant_tariff_plan_change_title: 'Request a plan change',
    tenant_tariff_plan_change_lead:
      'If you need a different plan or capacity, select below and add a note. A manager will contact you.',
    tenant_tariff_plan_change_desired: 'Desired plan',
    tenant_tariff_plan_change_desired_placeholder: 'Choose…',
    tenant_tariff_plan_change_note: 'Note',
    tenant_tariff_plan_change_note_ph: 'E.g. opening a new branch, need more users…',
    tenant_tariff_plan_change_submit: 'Send request',
    tenant_tariff_plan_change_ok: 'Request received. We will contact you shortly.',
    tenant_tariff_plan_change_error: 'Could not send. Please try again.',

    tariff_type_start: 'Starter',
    tariff_type_businessSmall: 'Small business',
    tariff_type_businessMedium: 'Mid-size business',
    tariff_type_businessEnterprise: 'Enterprise',
    adminNav_integrations: 'Integrations',
    adminNav_tenant_management: 'Clients',
    adminNav_tenant_messages: 'Client chat',
    adminNav_cashier_chat: 'Cashier chat',
    adminNav_chat: 'Chat',
    adminNav_cashier_rating: 'Cashier rating',
    adminNav_ai_helper: 'AI assistant',
    adminNav_staff_chat: 'Staff chat',
    adminNav_branches: 'Branches',
    adminNav_ombor: 'Warehouse',
    adminAIAdvisor_subtitle: 'AI recommendations, forecasts and strategic advice.',
    adminAIAdvisor_coming: 'Sales forecast, KPI ratings and AI marketing recommendations coming soon.',
    adminNav_feature_flags: 'Feature flags',
    adminNav_audit_logs: 'Audit log',
    adminNav_system_health: 'System monitoring',
    adminNav_usage_metrics: 'Usage analytics',
    adminNav_error_monitoring: 'Incidents & errors',
    adminNav_api_keys: 'API keys',
    adminNav_company_dashboard: 'Executive overview',
    adminNav_branches: 'Branch network',
    adminNav_warehouses: 'Warehouses',
    adminNav_employees_roles: 'Staff & roles',
    adminNav_products: 'Products',
    adminNav_categories: 'Categories',
    adminNav_price_management: 'Price management',
    adminNav_customers: 'Customer directory',
    adminNav_orders: 'Order management',
    adminNav_deliveries: 'Deliveries',
    adminNav_reports: 'Management reports',
    adminNav_marketing: 'Marketing toolkit',
    adminNav_marketing_orders: 'Online orders',
    adminNav_desktop_apps: 'Apps',
    marketingAddon_modal_title: 'Marketing & online orders pack',
    marketingAddon_modal_intro:
      'On the Small business plan, unlock both modules with a single one-time payment.',
    marketingAddon_modal_amount_label: 'One-time payment',
    marketingAddon_modal_unlocks: 'Marketing tools and Online orders are enabled together.',
    marketingAddon_pay_click: 'Pay with Click',
    marketingAddon_pay_payme: 'Pay with Payme',
    marketingAddon_err_generic: 'Could not start payment. Please try again.',
    marketingAddon_refresh_hint: 'After paying, tap Refresh or reload the page.',
    marketingAddon_refresh_btn: 'Refresh profile',
    marketingAddon_close_btn: 'Go to another section',
    desktopApps_page_subtitle:
      'The Add-e Windows desktop build is stored on the server — see the file path and download endpoint here.',
    desktopApps_live_web_note:
      'UI updates load from the live website automatically — no need to re-download the .exe each time. Use Ctrl+R or Reload in the menu. Install the new .exe once (older builds do not support this).',
    desktopApps_card_title: 'Add-e Desktop App',
    desktopApps_card_platform: 'Windows',
    desktopApps_download_title: 'Add-e Desktop (Windows)',
    desktopApps_download_desc: 'ZIP or installer — download, extract or run setup.',
    desktopApps_download_btn: 'Start download',
    desktopApps_download_note: 'Watch your browser’s download progress at the bottom.',
    desktopApps_step_1: 'Download the file',
    desktopApps_step_2: 'Extract the archive or run the installer',
    desktopApps_step_3: 'Sign in from the desktop app',
    desktopApps_no_url: 'Download URL is not configured yet. Contact support.',
    desktopApps_info_loading: 'Loading server details…',
    desktopApps_info_load_error: 'Could not load desktop app info.',
    desktopApps_server_file_label: 'File on server',
    desktopApps_public_url_label: 'Download link (HTTPS)',
    desktopApps_file_size_label: 'File size',
    desktopApps_download_public_note: 'Your browser downloads the .exe from public (e.g. https://api.addegroup.uz/Adde-1.0.0-x64.exe).',
    desktopApps_download_error: 'Download failed. Try again or contact an administrator.',
    desktopApps_not_on_server:
      'No .exe found in public. Upload it as e.g. public/Adde-1.0.0-x64.exe (match ADDE_DESKTOP_PUBLIC_FILENAME in .env).',
    desktopApps_deploy_hint:
      'Admin: upload Adde-1.0.0-x64.exe to the API site’s public/ folder. For a different filename, set ADDE_DESKTOP_PUBLIC_FILENAME in .env.',
    subscription_force_renew_hint:
      'Your subscription has expired. Renew and complete payment. This dialog closes once payment is confirmed.',
    cashierSubscriptionReminder_title: 'Subscription payment reminder',
    cashierSubscriptionReminder_body:
      'The store owner’s monthly subscription has expired and payment has not been received. Please notify the owner — this dialog stays until payment is completed.',
    adminNav_notifications: 'Notification center',
    adminNav_company_settings: 'Company settings',
    adminNav_settings: 'Profile & system settings',
    adminNav_printer_connect: 'Receipt printers',
    adminNav_help: 'Help & support',
    adminNav_sessions: 'Sessions & devices',
    adminSessions_subtitle: 'Monitor active devices and revoke sessions when needed.',
    adminSessions_refresh: 'Refresh',
    adminSessions_revoke_others: 'Revoke all except current',
    adminSessions_revoke_selected: 'Revoke selected',
    adminSessions_total: 'Total sessions',
    adminSessions_selected: 'Selected',
    adminSessions_current: 'Current device',
    adminSessions_loading: 'Loading sessions...',
    adminSessions_empty: 'No active sessions found.',
    adminSessions_device: 'Device',
    adminSessions_type: 'Type',
    adminSessions_last_active: 'Last active',
    adminSessions_created: 'Created',
    adminSessions_device_unknown: 'Unknown device',
    adminSessions_current_badge: 'Current',
    adminSessions_current_session: 'Current session',
    adminSessions_select_session: 'Select session',
    adminSessions_confirm_selected: 'Revoke selected sessions?',
    adminSessions_confirm_others: 'Revoke all sessions except current?',
    adminSessions_load_error: 'Unable to load sessions.',
    adminSessions_action_error: 'Unable to revoke session.',
    adminNav_kassa: 'Point of sale (POS)',
    adminNav_retail_clients: 'Retail customer base',
    adminNav_pos_orders: 'POS orders',
    adminNav_manager_customers: 'Customer directory',
    adminNav_manager_payments: 'Payments & transactions',
    adminNav_cashier_z_report: 'Z-Report',
    adminNav_order_history: 'Order history',
    adminNav_ombor_products: 'Stock on hand',
    adminOmbor_col_measure_variant: 'Variant / unit',
    adminOmbor_tenant_fav: 'Favorites',
    adminOmbor_tenant_fav_hint: 'Mark for quick access in cashier',
    adminOmbor_tenant_fav_toggle: 'Favorite product (star)',
    adminOmbor_tenant_fav_add: 'Add to favorites',
    adminOmbor_tenant_fav_remove: 'Remove from favorites',
    adminOmbor_detail_variants_hint: 'Variants and units',
    adminOmbor_detail_col_variant: 'Variant',
    adminOmbor_detail_col_stock_value: 'Stock value',
    adminOmbor_supplier_name: 'Supplier',
    adminOmbor_supplier_placeholder: 'Enter supplier name',
    adminOmbor_supplier_phone: 'Supplier phone',
    adminOmbor_supplier_phone_placeholder: 'Enter supplier phone number',
    admininOmbor_supplier_name: 'Supplier',
    admininOmbor_supplier_placeholder: 'Enter supplier name',
    adminOmbor_bulk_intake_title: 'Supplier intake',
    adminOmbor_bulk_intake_hint:
      'Add multiple products from one supplier at once — supplier details apply to all rows.',
    adminOmbor_bulk_intake_add_row: 'Add row',
    adminOmbor_bulk_intake_remove_row: 'Remove row',
    adminOmbor_bulk_intake_submit: 'Save intake',
    adminOmbor_bulk_intake_product_select: 'Select product',
    adminOmbor_bulk_intake_product_search: 'Name, barcode, or ID',
    adminOmbor_bulk_intake_product_no_results: 'No products match your search',
    adminOmbor_bulk_intake_error_no_items: 'Enter at least one product and quantity.',
    adminOmbor_bulk_intake_error_qty: 'Invalid quantity.',
    adminOmbor_bulk_intake_error_qty_small: 'Quantity is too small.',
    adminOmbor_bulk_intake_error_product: 'Select a product in all filled rows.',
    adminNav_maslahat: 'Guidance & recommendations',
    adminNav_delivery_status: 'Delivery status',
    adminNav_product_catalog: 'Product catalog',
    adminNav_inventory_dashboard: 'Warehouse control',
    adminNav_stock_in: 'Goods receipt',
    adminNav_stock_out: 'Goods issue',
    adminNav_transfers: 'Inter-warehouse transfers',
    adminNav_barcode_scanner: 'Barcode scanner',
    adminNav_inventory_audit: 'Stocktake',
    adminNav_expiry_tracking: 'Shelf-life tracking',
    adminInventory_product_id: 'Product ID',
    adminInventory_stock_add: 'Add stock',
    adminInventory_stock_add_expense_hint:
      'If «Paid» is unchecked, the purchase amount (cost × quantity) is added to expenses or merged into the existing expense for this product.',
    adminOmbor_barcode: 'Barcode',
    adminOmbor_barcode_print: 'Print barcode',
    adminOmbor_barcode_copies: 'Copies',
    adminOmbor_barcode_size_mm: 'Size (mm)',
    adminOmbor_barcode_print_success: 'Barcode sent to printer',
    adminOmbor_purchase_price: 'Purchase price',
    adminOmbor_sale_price: 'Sale price',
    adminOmbor_additional_sale_price: 'Additional sale price (optional)',
    adminInventory_quantity: 'Quantity',
    adminInventory_expiry: 'Expiry date',
    adminInvDash_expiry_empty: 'Not set',
    adminTopbar_expiry_alerts: 'Products nearing expiry',
    adminTopbar_expiry_days: 'days',
    adminTopbar_expiry_left: 'left',
    adminTopbar_expiry_ago: 'ago',
    adminTopbar_expiry_today: 'Today',
    adminInventory_from_warehouse: 'From warehouse',
    adminInventory_to_warehouse: 'To warehouse',
    adminInventory_action_save: 'Save',
    adminInventory_action_loading: 'Saving...',
    adminInventory_action_success: 'Saved',
    adminBarcodeScan_title: 'Barcode',
    adminBarcodeScan_placeholder: 'Enter barcode',
    adminBarcodeScan_action: 'Scan',
    adminBarcodeScan_found: 'Found',
    adminPagination_prev: 'Prev',
    adminPagination_next: 'Next',
    adminPagination_page: 'Page',
    adminNav_finance_dashboard: 'Financial overview',
    adminNav_transactions: 'Cash flow & transactions',
    adminNav_invoices: 'Invoices & billing',
    adminNav_taxes: 'Tax compliance',
    adminNav_1c_integration: '1C integration',
    adminNav_profit_loss: 'Profit & loss',
    adminNav_balance_sheet: 'Balance sheet',
    adminNav_export_reports: 'Data export',
    adminNav_analytics_dashboard: 'Sales & marketing analytics',
    adminNav_sales_funnel: 'Sales funnel',
    adminNav_customer_segments: 'Customer segments',
    adminNav_campaigns: 'Marketing campaigns',
    adminNav_ai_recommendations: 'AI recommendations',
    adminNav_retention: 'Customer retention',
    adminNav_cohort_analysis: 'Cohort analysis',
    analytics_dash_subtitle: 'Key KPIs: visits, sessions, conversion and revenue.',
    analytics_dash_subtitle_pro: 'Goal vs actual, channel breakdown, trends and decision recommendations.',
    analytics_dash_exec_summary: 'Revenue up +12.4% vs last month. Top traffic source — Organic Search (45%). Conversion 4.2% — above target. Next month forecast positive.',
    analytics_dash_goals_title: 'Goal vs Actual (current month)',
    analytics_dash_goals_metric: 'Metric',
    analytics_dash_goals_target: 'Target',
    analytics_dash_goals_actual: 'Actual',
    analytics_dash_goals_achievement: 'Achievement',
    analytics_goal_revenue: 'Revenue (UZS)',
    analytics_goal_conversion: 'Conversion (%)',
    analytics_goal_new_customers: 'New customers',
    analytics_goal_visitors: 'Unique visitors',
    analytics_goal_sessions: 'Sessions',
    analytics_goal_avg_session: 'Avg. session (min)',
    analytics_dash_channels_title: 'Traffic by source',
    channel_organic: 'Organic search',
    channel_direct: 'Direct',
    channel_paid: 'Paid ads',
    analytics_dash_visitors_short: 'visits',
    analytics_dash_sessions_short: 'sessions',
    analytics_dash_conversion_short: 'conv.',
    analytics_week: 'Week',
    analytics_dash_trend_weekly: 'Weekly traffic (last 12 weeks)',
    analytics_dash_min: 'Min',
    analytics_dash_max: 'Max',
    analytics_dash_avg: 'Avg',
    analytics_dash_trend_growth: 'Growth',
    analytics_dash_forecast_title: 'Forecast & activity',
    analytics_dash_forecast_label: 'Next month revenue forecast',
    analytics_dash_peak_hours: 'Peak hours (traffic)',
    analytics_dash_insights_title: 'Key insights',
    analytics_insight_1: 'Organic channel continues to grow — maintain SEO and content strategy.',
    analytics_insight_2: 'Social traffic +15% vs last month — revisit paid social budget.',
    analytics_insight_3: 'Paid channel decline — A/B tests and landing optimization recommended.',
    analytics_insight_4: 'Weekly traffic has been growing steadily for the last 4 weeks — campaigns and content are effective.',
    analytics_insight_5: 'Direct traffic converts well — strengthen brand and reminders.',
    analytics_insight_6: 'Peak hours 10:00–14:00 — schedule ads and push notifications for this window.',
    analytics_dash_recommendations_title: 'Recommended actions',
    analytics_rec_1: 'Simplify CTA and forms on landings to improve conversion.',
    analytics_rec_2: 'Target at-risk segment with email campaign — reduce churn.',
    analytics_rec_3: 'Reset paid channel goals for next quarter and track ROI.',
    analytics_rec_4: 'Increase ad budget for 10:00–14:00 — highest conversion window.',
    analytics_rec_5: 'Automate weekly reports and short summary for managers.',
    analytics_priority_high: 'High',
    analytics_priority_medium: 'Medium',
    analytics_dash_kpi: 'Key metrics',
    analytics_dash_unique_visitors: 'Unique visitors (30 days)',
    analytics_dash_sessions: 'Sessions',
    analytics_dash_conversion_rate: 'Conversion (%)',
    analytics_dash_avg_session: 'Avg. session (min)',
    analytics_dash_bounce_rate: 'Bounce rate (%)',
    analytics_dash_revenue_month: 'Monthly revenue',
    analytics_dash_top_channel: 'Top channel',
    analytics_dash_new_customers: 'New customers (month)',
    analytics_dash_repeat_orders: 'Repeat orders (%)',
    analytics_dash_visitors_weekly: 'Weekly visitors',
    analytics_dash_revenue_6m: 'Monthly revenue (6 months)',
    analytics_funnel_subtitle: 'Sales funnel stages and conversion to next stage.',
    analytics_funnel_stage: 'Stage',
    analytics_funnel_count: 'Count',
    analytics_funnel_conversion_next: 'To next (%)',
    analytics_funnel_dropoff: 'Dropoff (%)',
    funnel_awareness: 'Awareness',
    funnel_interest: 'Interest',
    funnel_consideration: 'Consideration',
    funnel_intent: 'Intent',
    funnel_purchase: 'Purchase',
    funnel_loyalty: 'Loyalty',
    analytics_segments_subtitle: 'Revenue share and growth by customer segments.',
    analytics_segments_name: 'Segment',
    analytics_segments_count: 'Customers',
    analytics_segments_revenue_share: 'Revenue share (%)',
    analytics_segments_avg_order: 'Avg. order (UZS)',
    analytics_segments_growth: 'Growth (%)',
    analytics_segments_desc: 'Description',
    segment_vip: 'VIP',
    segment_active: 'Active',
    segment_regular: 'Regular',
    segment_new: 'New',
    segment_at_risk: 'At risk',
    segment_churned: 'Churned',
    segment_vip_desc: 'Highest revenue and purchase frequency.',
    segment_active_desc: 'Purchased in the last 3 months.',
    segment_regular_desc: 'Medium purchase frequency.',
    segment_new_desc: 'Registered less than 30 days ago.',
    segment_at_risk_desc: 'Declining activity, churn risk.',
    segment_churned_desc: 'No activity for a long time.',
    analytics_campaigns_subtitle: 'Marketing campaigns: budget, reach and ROI.',
    analytics_campaigns_name: 'Campaign',
    analytics_campaigns_status: 'Status',
    analytics_campaigns_channel: 'Channel',
    analytics_campaigns_budget: 'Budget',
    analytics_campaigns_spent: 'Spent',
    analytics_campaigns_reach: 'Reach',
    analytics_campaigns_conversions: 'Conversions',
    analytics_campaigns_roi: 'ROI (%)',
    analytics_campaigns_dates: 'Period',
    analytics_campaign_status_active: 'Active',
    analytics_campaign_status_paused: 'Paused',
    analytics_campaign_status_completed: 'Completed',
    analytics_campaign_status_draft: 'Draft',
    campaign_spring_sale: 'Spring sale 2025',
    campaign_email_retention: 'Email — retention',
    campaign_google_ads: 'Google Ads — January',
    campaign_telegram: 'Telegram — January',
    campaign_new_segment: 'New segment project',
    channel_social: 'Social',
    channel_email: 'Email',
    channel_google: 'Google Ads',
    channel_telegram: 'Telegram',
    analytics_ai_rec_subtitle: 'AI recommendations: product, pricing, marketing.',
    analytics_rec_priority_high: 'High',
    analytics_rec_priority_medium: 'Medium',
    analytics_rec_priority_low: 'Low',
    analytics_rec_estimated_lift: 'Estimated lift',
    rec_product_bundle: 'Bundle offer',
    rec_product_bundle_desc: 'Offer products A, B, C as a bundle to increase average order value.',
    rec_product_bundle_impact: 'Expected impact: sales volume +18%.',
    rec_retention_email: 'Email reminder',
    rec_retention_email_desc: 'Personalized offer to segment with no purchase in last 14 days.',
    rec_retention_email_impact: 'Reactivation and reduced churn.',
    rec_pricing_dynamic: 'Dynamic pricing',
    rec_pricing_dynamic_desc: 'Auto-adjust prices by demand and stock for selected categories.',
    rec_pricing_dynamic_impact: 'Margin and turnover optimization.',
    rec_marketing_segment: 'Segment-based campaigns',
    rec_marketing_segment_desc: 'Separate campaigns for VIP and at-risk segments.',
    rec_marketing_segment_impact: 'Higher ROI and conversion.',
    rec_inventory_stock: 'Stock optimization',
    rec_inventory_stock_desc: 'Order recommendations for low-stock items based on AI forecast.',
    rec_inventory_stock_impact: 'Reduce stockouts.',
    analytics_retention_subtitle: 'Customer retention: 1-, 7-, 30-, 90-day metrics.',
    analytics_retention_kpi: 'Retention rate',
    analytics_retention_day1: 'Day 1',
    analytics_retention_day7: 'Day 7',
    analytics_retention_day30: 'Day 30',
    analytics_retention_day90: 'Day 90',
    analytics_retention_chart_title: 'Weekly retention (cohort)',
    retention_week1: 'Week 1',
    retention_week2: 'Week 2',
    retention_week3: 'Week 3',
    retention_week4: 'Week 4',
    retention_week8: 'Week 8',
    retention_week12: 'Week 12',
    analytics_cohort_subtitle: 'Retention matrix by registration cohorts.',
    analytics_cohort_cohort: 'Cohort',
    analytics_cohort_size: 'Size',
    analytics_cohort_period0: 'Period 0 (%)',
    analytics_cohort_period1: 'Period 1 (%)',
    analytics_cohort_period2: 'Period 2 (%)',
    analytics_cohort_period3: 'Period 3 (%)',
    analytics_cohort_note: 'Percentages are active customers in each period vs cohort size.',
    adminNav_my_deliveries: 'Deliveries',
    adminNav_route_map: 'Routes',
    adminNav_courier_order_status: 'Order status',
    adminNav_offline_sync: 'Offline',
    adminNav_earnings: 'Earnings',
    adminNav_my_orders: 'My orders',
    adminNav_customer_payments: 'Payments',
    adminNav_profile: 'Profile',
    adminNav_locations: 'Locations',

    // Super Admin sections (promptga mos)
    adminSuper1Title: 'Manage system-wide settings',
    adminSuper1Desc: 'Manage system-wide settings. Role for developers or top-level administrators.',
    adminSuper2Title: 'Define tariff packages',
    adminSuper2Desc: 'Define tariff packages and manage pricing.',
    adminSuper3Title: 'Set up external integrations',
    adminSuper3Desc: 'Set up external integrations: API, payment systems and third-party services.',
    adminSuper4Title: 'Have full access to all data',
    adminSuper4Desc: 'Have full access to all data: users, reports, audit and export.',
    adminSuper5Title: 'Control other roles',
    adminSuper5Desc: 'This role also controls other roles: create roles, assign permissions and manage.',

    // Biznes Admin sections (promptga mos)
    adminBiznes1Title: 'Create and manage branches and warehouses',
    adminBiznes1Desc: 'Create and manage branches and warehouses. Role for business owners and managers.',
    adminBiznes2Title: 'Register staff and set permissions',
    adminBiznes2Desc: 'Register staff and set permissions.',
    adminBiznes3Title: 'Maintain product catalog',
    adminBiznes3Desc: 'Maintain product catalog: products, categories and prices.',
    adminBiznes4Title: 'Control sales processes',
    adminBiznes4Desc: 'Control sales processes.',
    adminBiznes5Title: 'Generate reports',
    adminBiznes5Desc: 'Generate reports. Role enables full control of company internal operations.',

    // Menejer/Sotuvchi sections (promptga mos)
    adminMenejer1Title: 'Create and manage orders',
    adminMenejer1Desc: 'Create and manage orders. Role for sales teams.',
    adminMenejer2Title: 'Maintain customer data',
    adminMenejer2Desc: 'Maintain customer data: database, search and purchase history.',
    adminMenejer3Title: 'Accept payments',
    adminMenejer3Desc: 'Accept payments.',
    adminMenejer4Title: 'Oversee delivery process',
    adminMenejer4Desc: 'Oversee delivery process. Helps carry out daily sales operations quickly and efficiently.',

    // Admin settings (sidebar sections)
    adminSettingsHeading: 'Settings',
    adminAdd: 'Add',
    adminFormSave: 'Save',
    adminFormClose: 'Close',
    adminSetPlaceholder: 'Enter',
    adminSetLang: 'Language',
    adminSetTimezone: 'Timezone',
    adminSetPanelName: 'Panel name',
    adminSetTariffName: 'Tariff name',
    adminSetPrice: 'Price (UZS)',
    adminSetPeriod: 'Validity period',
    adminSetApiKey: 'API key',
    adminSetWebhook: 'Webhook URL',
    adminSetExportFormat: 'Export format',
    adminSetMaxRows: 'Max rows',
    adminSetRoleName: 'Role name',
    adminSetPermissionType: 'Permission type',
    adminSetBranchName: 'Branch name',
    adminSetWarehouse: 'Warehouse',
    adminSetAddress: 'Address',
    adminSetStaffName: 'Staff name',
    adminSetPosition: 'Position',
    adminSetAccess: 'Access rights',
    adminSetProductName: 'Product name',
    adminSetCategory: 'Category',
    adminSetPaymentMethod: 'Payment method',
    adminSetReceiptType: 'Receipt type',
    adminSetReportType: 'Report type',
    adminSetDateRange: 'Date range',
    adminSetOrderNumber: 'Order number',
    adminSetOrderStatus: 'Order status',
    adminSetCustomer: 'Customer',
    adminSetCustomerName: 'Customer name',
    adminSetPhone: 'Phone',
    adminSetAmount: 'Amount',
    adminSetDeliveryAddress: 'Delivery address',
    adminSetDeliveryStatus: 'Delivery status',
    adminSetQuantity: 'Quantity',
    adminSetOperationType: 'Operation type',
    adminSetInventoryDate: 'Inventory date',
    adminSetBarcode: 'Barcode',
    adminSetTaxSystem: 'Tax system',
    adminSetTaxRate: 'Tax rate',
    adminSetCampaignName: 'Campaign name',
    adminSetSegmentName: 'Segment name',
    adminSetAiRecommendation: 'AI recommendation',
    adminSetOfflineMode: 'Offline mode',
    adminSetSyncInterval: 'Sync interval',
    adminSetRouteName: 'Route name',
    adminSetLocation: 'Location',

    // New roles
    roleTitle_warehouse_clerk: 'Warehouse worker',
    roleDesc_warehouse_clerk: 'Manage product in/out operations, conduct inventory and identify products by barcode. Role for warehouse staff, real-time stock and movement tracking.',
    roleTitle_accountant: 'Accountant',
    roleDesc_accountant: 'Integration with tax systems and 1C, manage payments and financial documents. Role for finance department, automate reports and tax declarations.',
    roleTitle_analitik_marketing: 'Analyst',
    roleDesc_analitik_marketing: 'Campaign and sales analysis, customer segments, reports and recommendations.',
    roleTitle_kuryer_field: 'Courier / Field agent',
    roleDesc_kuryer_field: 'Ability to work offline, update delivery statuses and track routes. Role for couriers, real-time updates from mobile devices.',
    roleTitle_tenant_owner: 'Client (Point owner)',
    roleDesc_tenant_owner: 'Run your business: cashiers, branches, sales, credit, finance and reports. Retail customers and Telegram notifications.',

    // Omborchi sections (promptga mos)
    adminOmborchi1Title: 'Manage product in/out operations',
    adminOmborchi1Desc: 'Manage product in/out operations.',
    adminOmborchi2Title: 'Conduct inventory',
    adminOmborchi2Desc: 'Conduct inventory.',
    adminOmborchi3Title: 'Identify products by barcode',
    adminOmborchi3Desc: 'Identify products by barcode.',
    adminOmborchi4Title: 'Real-time stock and movement tracking',
    adminOmborchi4Desc: 'Real-time stock and movement tracking. Role for warehouse staff.',
    adminOmborchi5Title: 'Settings for warehouse staff',
    adminOmborchi5Desc: 'Role for warehouse staff, enables real-time stock and movement tracking.',

    // Buxgalter sections (promptga mos)
    adminBuxgalter1Title: 'Integration with tax systems and 1C',
    adminBuxgalter1Desc: 'Integration with tax systems and 1C. Role for finance department staff.',
    adminBuxgalter2Title: 'Integration with 1C',
    adminBuxgalter2Desc: 'Data exchange and sync with 1C.',
    adminBuxgalter3Title: 'Manage payments and financial documents',
    adminBuxgalter3Desc: 'Manage payments and financial documents.',
    adminBuxgalter4Title: 'Automate reports and tax declarations',
    adminBuxgalter4Desc: 'Help automate reports and tax declarations.',
    adminBuxgalter5Title: 'Finance department settings',
    adminBuxgalter5Desc: 'Role for finance department staff, helps automate reports and tax declarations.',

    // Analitik/Marketing sections (promptga mos)
    adminAnalitik1Title: 'Campaign report',
    adminAnalitik1Desc: 'Campaign performance and cost reporting.',
    adminAnalitik2Title: 'Customer segments',
    adminAnalitik2Desc: 'Grouping customers, filters and segment management.',
    adminAnalitik3Title: 'Product recommendations',
    adminAnalitik3Desc: 'Configure recommendations based on sales and purchases.',
    adminAnalitik4Title: 'Customer analytics',
    adminAnalitik4Desc: 'Behavior and retention metrics.',
    adminAnalitik5Title: 'Analytics settings',
    adminAnalitik5Desc: 'Reports, export and integration parameters.',

    // Kuryer/Field sections (promptga mos)
    adminKuryer1Title: 'Ability to work offline',
    adminKuryer1Desc: 'Ability to work offline. Role for couriers.',
    adminKuryer2Title: 'Update delivery statuses',
    adminKuryer2Desc: 'Update delivery statuses.',
    adminKuryer3Title: 'Track routes',
    adminKuryer3Desc: 'Track routes.',
    adminKuryer4Title: 'Real-time updates from mobile devices',
    adminKuryer4Desc: 'Help update data in real time from mobile devices.',
    adminKuryer5Title: 'Courier settings',
    adminKuryer5Desc: 'Role for couriers, helps update data in real time from mobile devices.',

    // Mijoz sections (promptga mos, optional portal)
    adminMijoz1Title: 'View order history',
    adminMijoz1Desc: 'View order history. Role for customers.',
    adminMijoz2Title: 'Make payments',
    adminMijoz2Desc: 'Make payments.',
    adminMijoz3Title: 'Share location data',
    adminMijoz3Desc: 'Share location data.',
    adminMijoz4Title: 'Self-service portal',
    adminMijoz4Desc: 'Provides self-service portal and simplifies contact with business.',
    adminMijoz5Title: 'Customer portal (optional)',
    adminMijoz5Desc: 'Role for customers, provides self-service portal and simplifies contact with business.',

    // Credit sales (sidebar label: adminNav_credits in nav block above)
    adminCredits_cashier_subtitle: 'List of credit sales for the current cashier with repayment.',
    adminCredits_client_subtitle: 'All credit sales by branches and cashiers.',
    adminCredits_list_title: 'Credits list',
    adminCredits_archive_title: 'Credits archive',
    adminCredits_archive_btn: 'Archive',
    adminCredits_back_to_active: 'Active list',
    adminCredits_archive_empty: 'No records in archive.',
    adminCredits_empty: 'No credit sales yet.',
    adminCredits_products: 'Products',
    adminCredits_prices: 'Prices',
    adminCredits_client: 'Customer',
    adminCredits_branch: 'Branch',
    adminCredits_cashier: 'Cashier',
    adminCredits_total: 'Credit amount',
    adminCredits_remaining: 'Remaining amount',
    adminCredits_createdAt: 'Created at',
    adminCredits_actions: 'Actions',
    adminCredits_repay: 'Repay',
    adminCredits_closed: 'Closed',
    adminCredits_repay_title: 'Repay credit',
    adminCredits_repay_remaining: 'Remaining',
    adminCredits_repay_amount: 'Repayment amount',
    adminCredits_repay_method: 'Payment method',
    adminCredits_repay_saving: 'Saving…',
    adminCredits_repay_submit: 'Repay',
    adminCredits_repay_discount_optional: 'Discount (optional), UZS',
    adminCredits_repay_discount_hint:
      'Discount only reduces the credit balance; the register receives the repayment amount above. Cash + discount must not exceed the remaining balance.',
    adminCredits_repay_total_applied: 'Applied to credit (total)',
    adminCredits_telegram_reminder: 'Telegram reminder',
    adminCredits_telegram_reminder_sending: 'Sending…',
    adminCredits_telegram_reminder_hint: 'Send the customer a credit balance reminder via the retail Telegram bot',
    adminCredits_telegram_not_linked: 'Customer has not linked the bot yet (phone contact in bot required)',
    adminCredits_card_total: 'Total credits',
    adminCredits_card_repaid: 'Repaid credits',
    adminCredits_card_remaining: 'Remaining credits',
    adminCredits_card_outstanding: 'Outstanding total (credit)',
    adminCredits_card_issued_lifetime: 'Issued total',
    adminCredits_card_active_count: 'active',
    adminCredits_card_contracts: 'Credit contracts',
    adminCredits_card_all_time: 'All records',
    adminCredits_credit_number: 'Credit number',
    adminCredits_top_creation: 'Top by credit creation (branch, cashier)',
    adminCredits_top_repaid: 'Top by repaid credits (branch, cashier)',
    adminCredits_search_placeholder: 'Search…',
    adminCredits_filter_all_branches: 'All branches',
    adminCredits_filter_all_cashiers: 'All cashiers',
    adminCredits_no_results: 'No results found.',
    retailClients_subtitle: 'Customers from POS: name, phone, sale count, and outstanding credit balance.',
    retailClients_credit_banner: '{count} customer(s) have outstanding credit. Manage in:',
    retailClients_go_kassa: 'Open POS',
    retailClients_go_credits: 'Credits section',
    retailClients_go_list: 'Retail customer list',
    retailClients_empty: 'No entries yet. Enter a customer phone on the cart at POS.',
    retailClients_col_name: 'Name',
    retailClients_col_phone: 'Phone',
    retailClients_col_sales: 'Sales',
    retailClients_col_sales_total: 'Sales total',
    retailClients_col_balance: 'Cashback balance',
    retailClients_col_credit: 'Credit balance',
    retailClients_filter_month: 'Month',
    retailClients_filter_current_month: 'Current month',
    retailClients_filter_all_time: 'All time',
    retailClients_filter_month_hint: 'Sales for {month}. Balance is current.',
    retailClients_filter_all_time_hint: 'Sales for all time. Balance is current.',
    retailClients_repay: 'Reduce balance',
    retailClients_repay_amount: 'Amount (UZS)',
    retailClients_repay_confirm: 'Apply',
    retailClients_edit_balance: 'Edit balance',
    retailClients_edit_balance_save: 'Save',
    common_retry: 'Retry',
    common_loading: 'Loading...',
    common_error: 'Error',
    common_no_data: 'No data',
    common_yes: 'Yes',
    common_no: 'No',
    common_add: 'Add',
    common_today: 'Today',
    common_week: 'Week',
    common_month: 'Month',
    common_custom_period: 'Custom period'
  }
};

